(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

var progress = require('./progress'),
    util = require('./util');

var currentRequests = [];

/**
 * @function
 * @description Ajax request to get json response
 * @param {Boolean} async  Asynchronous or not
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 */
var getJson = function getJson(options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'json',
        url: options.url,
        async: typeof options.async === 'undefined' || options.async === null ? true : options.async,
        data: options.data || {}
    })
    // success
    .done(function (response) {
        if (options.callback) {
            options.callback(response);
        }
    })
    // failed
    .fail(function (xhr, textStatus) {
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        if (options.callback) {
            options.callback(null);
        }
    })
    // executed on success or fail
    .always(function () {
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};
/**
 * @function
 * @description ajax request to load html response in a given container
 * @param {String} url URI for the request
 * @param {Object} data Name/Value pair data request
 * @param {Function} callback  Callback function to be called
 * @param {Object} target Selector or element that will receive content
 */
var load = function load(options) {
    options.url = util.toAbsoluteUrl(options.url);
    // return if no url exists or url matches a current request
    if (!options.url || currentRequests[options.url]) {
        return;
    }

    currentRequests[options.url] = true;

    // make the server call
    $.ajax({
        dataType: 'html',
        url: util.appendParamToURL(options.url, 'format', 'ajax'),
        data: options.data,
        xhrFields: {
            withCredentials: true
        }
    }).done(function (response) {
        // success
        if (options.target) {
            $(options.target).empty().html(response);
        }
        if (options.callback) {
            options.callback(response);
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            window.alert(Resources.BAD_RESPONSE);
        }
        options.callback(null, textStatus);
    }).always(function () {
        progress.hide();
        // remove current request from hash
        if (currentRequests[options.url]) {
            delete currentRequests[options.url];
        }
    });
};

exports.getJson = getJson;
exports.load = load;

},{"./progress":56,"./util":69}],2:[function(require,module,exports){
"use strict";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var util = require("./util");
var unbind = 0;
var unbindcarousel = 0;
function getPageCategory() {
	//return window.pageContext.title || "Content"; ###### this throws product name
	switch (window.Resources.PAGE_CATEGORY) {
		case 'product-showincategory':
			return "Product Page";
			break;
		case 'product-show':
			return "Product Page";
			break;
		case 'search-show':
			return "Category Page";
			break;
		case 'home-show':
			return "Home Page";
			break;
		case 'cart-show':
			return "Cart Page";
			break;
		case 'cart-addtowishlist':
			return "Cart Page";
			break;
		case 'customerservice-contactus':
			return "KUNDENSERVICE KONTAKTIEREN";
			break;
		case 'customerservice-concierge':
			return "Ask An Expert";
			break;
		case 'account-startregister':
			return "Account Creation";
			break;
		case 'account-editprofile':
			return "My Account";
			break;
		case 'address-list':
			return "My Account";
			break;
		case 'paymentinstruments-list':
			return "My Account";
			break;
		case 'wishlist-show':
			return "My Account";
			break;
		case 'order-history':
			return "My Account";
			break;
		case 'orderreplenishment-show':
			return "My Account";
			break;
		case 'login-show':
			return "Account Registration";
			break;
		case 'coshipping-start':
			return "Checkout";
			break;
		case 'coshipping-singleshipping':
			return "Checkout";
			break;
		case 'cobilling-start':
			return "Checkout";
			break;
		case 'cobilling-billing':
			return "Checkout";
			break;
		case 'search-showcontent':
			return "Site Search";
			break;
		case 'giftcert-purchase':
			return "Gift Card Page";
			break;
		case 'cocustomer-loginform':
			return "Customer Login";
			break;
		case 'default-start':
			return "Home Page";
			break;
		case 'search-brandify':
			return "Store Locator Page";
			break;
		default:
			return "Content";
			break;
	}
}
// Specific for checkout and cart page only
function couponsubcategory() {
	switch (window.Resources.PAGE_CATEGORY) {
		case 'cart-show':
			return "Cart";
			break;
		case 'coshipping-start':
			return "Shipping";
			break;
		case 'coshipping-singleshipping':
			return "Payment";
			break;
		case 'cobilling-start':
			return "Payment";
			break;
		case 'cobilling-removegiftcertificate':
			return "Payment";
			break;
		case 'cobilling-billing':
			return "Review";
			break;
		case 'account-editprofile':
			return "Profile";
			break;
		case 'address-list':
			return "Addresses";
			break;
		case 'paymentinstruments-list':
			return "Payment Methods";
			break;
		case 'wishlist-show':
			return "Saved For Later";
			break;
		case 'order-history':
			return "Order History";
			break;
		case 'orderreplenishment-show':
			return "Replenishment";
			break;
		default:
			break;
	}
}

function isMobile() {
	return $(window).width() <= 640;
}
//Specific for PDP
function getProductName() {
	return $(".cpb-products-details .item-name").text().trim();
}
//Specific for PDP
function getProductBrand() {
	return "Shiseido"; //$(".product-detail .product-brand").text();
}
//Specific for PDP
function getProductID() {
	return $("#pid").val();
}
//Specific for PDP
function getProductCategory() {
	return $(".cmd-breadcrumb_container .cmd-breadcrumb_list").find("li:eq(0)").text().trim();
}
//Specific for PDP
function getProductsubCategory() {
	return $(".cmd-breadcrumb_container .cmd-breadcrumb_list").find("li:eq(1)").text().trim();
}
// Specific for PDP
function getProductsubsubCategory() {
	return $(".cmd-breadcrumb_container .cmd-breadcrumb_list").find("li:eq(2)").text().trim();
}
// Specific for PDP
function getProductOrederType() {
	var replen = $(".replenishmentCycle").val();
	if (replen > 0) {
		return "Replenishment";
	} else {
		return "Regular";
	}
}

function getPageSubcategory() {
	return window.pageContext.title || "Content";
}

function getLanguage() {
	if (window.User.locale.indexOf("en") >= 0) {
		return "English";
	} else if (window.User.locale.indexOf("cn") >= 0) {
		return "Chinese";
	} else if (window.User.locale.indexOf("es") >= 0) {
		return "Spanish";
	} else {
		return window.User.locale;
	}
}

// page-specific: Cart, Checkout
function getPageError() {
	var $errorMsg = $(".error-form");
	if ($errorMsg.length === 0) {
		return "";
	}

	return $errorMsg.html().trim();
}

function getActiveSortingRule() {
	var httpParams = util.getQueryStringParams(window.location.href);
	var sortParam = httpParams["srule"];

	if (!sortParam) {
		return null;
	}

	return sortParam.split("-").map(function (w) {
		return w[0].toUpperCase() + w.substr(1);
	}).join(" ");
}

function pushToDataLayer(o) {
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push(util.filterObj(o));
	//console.log(JSON.stringify(util.filterObj(o)));
}

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height() - 150;
	var elemTop = $(elem).offset().top;
	return elemTop <= docViewBottom && elemTop >= docViewTop;
}

function getpage() {
	var url = window.location.href;
	var splittedurl = url.split("?");
	var page = splittedurl[0].split("/");
	return page[page.length - 1];
}
//page-specific: PLP
function getRefinementsFromURL() {
	var str = "";
	if (window.location.href.split("?").length > 1) {
		var urlparam;
		if (window.location.href.split("?")[1].indexOf("&") > -1) {
			urlparam = window.location.href.split("?")[1].split("&");
			var length = urlparam.length;
			var prefnval, prefnkey, prefvval, prefvkey;
			for (var i = 0; i < length; i++) {
				var prefn = urlparam[i].indexOf("prefn");
				if (prefn > -1) {
					prefnkey = urlparam[i].split("=")[0];
					prefnval = urlparam[i].split("=")[1];
					console.log(prefnkey);
					var num = prefnkey.charAt(5);
					for (var a = 0; a < length; a++) {
						var prefv = urlparam[a].indexOf("prefv");
						prefvkey = urlparam[a].split("=")[0];
						if (prefvkey == "prefv" + num) {
							prefvval = urlparam[a].split("=")[1];
							str += "[" + prefnval + ":" + prefvval + "]";
						}
					}
				}
			}
		}
	}
	return str;
}

function trackConsultationEvent(data) {
	var TOOL_TYPES = {
		"skincareConsultation": "Skincare Consultation"
	};

	pushToDataLayer({
		"event": "consultation" + data.element[0].toUpperCase() + data.element.substr(1),
		"pageCategory": "Consultation Tool",
		"consultationToolType": TOOL_TYPES[data.toolname] || data.toolname,
		"consultationQuestion": data.question,
		"consultationResponse": data.answers[0]
	});
}

function trackConsultationPageview(data) {
	pushToDataLayer({
		"event": "consultationSteps",
		"pageCategory": "Consultation Tool",
		"consultationToolType": data.toolname,
		"consultationStep": data.pagename
	});
}

function trackInternalPromotionEvent(data) {

	var promotionURL = data.pageName;

	pushToDataLayer({
		"event": "eePromoClick",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	}), function () {
		setTimeout(function () {
			if (promotionURL != undefined) {
				document.location = promotionURL;
			}
		}, 1000);
	}();
}

function trackInternalPromotionPageView(data) {
	pushToDataLayer({
		"eeAction": "eePromoView",
		"event": "eePromoView",
		"pageSubCategory": data.pageSubCategory,
		"pageCategory": data.pageCategory,
		'promotions': [{
			"position": data.position,
			"id": data.id,
			"creative": data.creative,
			"name": data.name
		}]
	});
}

function initializeGlobalEvents() {
	var gtmNavData = "";

	$(document)

	// add to wishlist in pdp and quickview
	.on('click', "#save-for-later", function (e) {
		var data = $(this).data("catid");
		var productCategory = data.length > 0 ? data[0] : '';
		var productSubCategory = data.length > 1 ? data[1] : '';
		pushToDataLayer({
			"event": "clickSaveForLater",
			"productCategory": productCategory,
			"productSubCategory": productSubCategory,
			"productName": getProductName(),
			"productId": getProductID(),
			"pageCategory": getPageCategory(),
			"productOutOfStock": $(this).data("instock"),
			"productAutoReplen": $(this).data("replenishable"),
			"productColor": $(".cpb-products-color_list .c-list-color-panel.is-current").length > 0 ? $(".cpb-products-color_list .c-list-color-panel.is-current").data('description') : null,
			"collectionName": productCategory.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": "Product"
		});
	})

	// add to wishlist in cart
	.on('click', ".add-to-wishlist", function (e) {
		var index = $(this).parents(".cpb-cart-bag_box").index();
		pushToDataLayer({
			"event": "clickSaveForLater",
			"productCategory": basketConfirmation.productLineItems[index].category,
			"productSubCategory": basketConfirmation.productLineItems[index].subCategory,
			"productName": basketConfirmation.productLineItems[index].name,
			"productId": basketConfirmation.productLineItems[index].id,
			"pageCategory": getPageCategory(),
			"productOutOfStock": $(this).data("instock"),
			"productAutoReplen": $(this).data("replenishable"),
			"productColor": $(this).parents('.cpb-cart-bag_box').first().find(".item-detail .color+dd").length > 0 ? $(this).parents('.cpb-cart-bag_box').first().find(".item-detail .color+dd").text().trim() : null,
			"collectionName": basketConfirmation.productLineItems[index].category.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": "Product"
		});
	})

	// remove to wishlist PDP
	.on('click', ".remove-from-wishlist", function (e) {
		var data = $(this).data("catid");
		var productCategory = data.length > 0 ? data[0] : '';
		var productSubCategory = data.length > 1 ? data[1] : '';
		pushToDataLayer({
			"event": "removeFromWishlist",
			"productCategory": productCategory,
			"productSubCategory": productSubCategory,
			"productName": getProductName(),
			"productId": getProductID(),
			"pageCategory": getPageCategory(),
			"productOutOfStock": $(this).data("instock"),
			"productAutoReplen": $(this).data("replenishable"),
			"productColor": $(".cpb-products-color_list .c-list-color-panel.is-current").length > 0 ? $(".cpb-products-color_list .c-list-color-panel.is-current").data('description') : null,
			"collectionName": productCategory.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": "Product"
		});
	})

	// remove to wishlist from my account
	.on('click', ".c-list-products-full-item .delete-item", function (e) {
		var $target = $(this).parents('.c-list-products-full-item-text').find('button[id^="delete-item"]');
		var data = $target.data("catid");
		var productCategory = data.length > 0 ? data[0] : '';
		var productSubCategory = data.length > 1 ? data[1] : '';
		pushToDataLayer({
			"event": "removeFromWishlist",
			"productCategory": productCategory,
			"productSubCategory": productSubCategory,
			"productName": $target.data("productname"),
			"productId": $target.data("productid"),
			"pageCategory": getPageCategory(),
			"productOutOfStock": $target.data("instock"),
			"productAutoReplen": $target.data("replenishable"),
			"productColor": $(".c-list-color .c-list-color-panel.is-current").length > 0 ? $(".c-list-color .c-list-color-panel.is-current").data('description') : null,
			"collectionName": productCategory.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": "Product"
		});
	})

	// newsletter in navigation;
	.on("clicknewsletter", function (e, data) {
		pushToDataLayer({
			"event": "newsletterSubscription",
			"siteLocation": data.siteloc
		});
	})

	// click ask question in pdp
	.on("click", ".bv-ask-question", function (e) {
		pushToDataLayer({
			page: getpage(),
			"event": "askQuestion",
			productCategory: getProductCategory(),
			pageSubCategory: "Ask a Question",
			productName: getProductName(),
			pageCategory: "Product Page"
		});
	})

	// Scroll on reviews in pdp
	.scroll(function () {
		if ($(".bv-section-summary").length) {
			if (isScrolledIntoView(".bv-section-summary") && unbind < 1) {
				unbind = 1;
				pushToDataLayer({
					event: "productReviewsView",
					page: getpage(),
					pageCategory: "Product Page",
					productColor: window.productCache.productColor,
					productType: "Product",
					collectionName: window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null
				});
			}
		}

		// for recommendation in pdp and cart, Best Seller and Recently Viewed in Homepage
		if ($(".pi .carousel-recommendations").length > 0 || $(".cross-sell .carousel-recommendations").length > 0) {
			if (isScrolledIntoView(".carousel-recommendations") && unbindcarousel < 1) {
				unbindcarousel = 1;
				pushToDataLayer({
					"currencyCode": window.User.currencyCode,
					"eeAction": "eeListView",
					"event": "eeListView",
					"pageCategory": getPageCategory(),
					"products": window.forpageload.product });
			}
		}
	})

	// Click on Reviews in PDP
	.on("click", ".bv-inline-histogram-ratings-star-container", function () {
		pushToDataLayer({
			event: "productReviewsView",
			page: getpage(),
			pageCategory: "Product Page",
			productColor: window.productCache.productColor,
			productType: "Product",
			collectionName: window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null
		});
	})

	// Check balance giftcard in gift card page
	.on('click', "#CheckBalanceButton", function () {
		if ($("#dwfrm_giftcert_balance_giftCertID").val() != "" && $("#dwfrm_giftcert_balance_giftCertPIN").val() != "") {
			pushToDataLayer({
				"event": "checkBalance",
				"giftCardNumber": $("#dwfrm_giftcert_balance_giftCertID").val()
				//					"pageSubCategory": "Gift Card",
				//					"pageCategory": "My Account"
			});
		}
	})

	// Check balance giftcard in checkout modal
	.on('click', "#check-giftcert-modal", function (e) {
		if ($("#giftcardbalancemodal #dwfrm_billing_giftCertCode").val() != "" && $("#giftcardbalancemodal #dwfrm_giftcert_balance_giftCertPIN").val() != "") {
			pushToDataLayer({
				"event": "checkBalance",
				"giftCardNumber": $("#giftcardbalancemodal #dwfrm_billing_giftCertCode").val()
				//					"pageSubCategory": "Payment",
				//					"pageCategory": "Checkout"
			});
		}
	})

	// Redeem gift card in checkout page
	.on('click', '.pt_checkout #add-giftcert', function () {
		if ($(".gift-card-form #dwfrm_billing_giftCertCode").val() != "" && $(".gift-card-form #dwfrm_giftcert_balance_giftCertPIN").val() != "") {
			pushToDataLayer({
				"event": "redeemGiftCard",
				"giftCardNumber": $(".gift-card-form #dwfrm_billing_giftCertCode").val()
			});
		}
	})

	// Redeem gift card in checkout modal
	.on('click', '#add-giftcert-modal', function () {
		if ($("#giftcardbalancemodal #dwfrm_billing_giftCertCode").val() != "" && $("#giftcardbalancemodal #dwfrm_giftcert_balance_giftCertPIN").val() != "") {
			pushToDataLayer({
				"event": "redeemGiftCard",
				"giftCardNumber": $("#giftcardbalancemodal #dwfrm_billing_giftCertCode").val()
			});
		}
	})

	// add to cart from PDP
	.on('click', '#add-to-cart, .cpb-products-cart_fixed .cpb-products-cart_submit button', function (e) {
		if (getPageCategory() == "Cart Page") {
			if (sessionStorage.getItem("cartupdate")) {
				sessionStorage.setItem("productUpdate", "1");
			}
		} else {
			window.productCache = window.productCache || {};
			pushToDataLayer({
				"event": "addToCart",
				//"productOrderType": getProductOrederType(),
				"currencyCode": window.Resources.CURRENCY,
				"addToCartType": $(this).parents('.quick-view').length ? "Quick Shop" : "Product Page",
				//"pageCategory": getPageCategory(),
				'products': [{
					"name": getProductName(),
					"id": getProductID(),
					"price": Number($("#add-to-cart").data("price")),
					"brand": getProductBrand(),
					"category": window.productCache.category,
					"variant": $(".cpb-products-size_list input[type='radio']:checked+.label span").text().trim(),
					"quantity": '1',
					"productAutoReplen": $("#add-to-cart").data("replenishable"),
					"productColor": $(".cpb-products-color_list .c-list-color-panel.is-current").data('description'),
					"productOutOfStock": $("#add-to-cart").data("instock"),
					"collectionName": window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
					"productType": "Product",
					"productStarRating": "",
					"productVariantID": $(".cpb-products-size_list input[type='radio']:checked+.label span").text().trim() != '' && $(".cpb-products-color_list .c-list-color-panel.is-current").data('description') != '' ? getProductID() : null,
					"numberOfProductReview": ""
					//"subCategory" : window.productCache.subcategory,
					//"subSubCategory" : window.productCache.subsubcategory,
					//"productNumReviews":"",
				}]
			});
		}
	})

	//Click at '+' on cart page
	.on('click', '.cpb-cart-bag_box .js-num-drop_up', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-cart-bag_box").index();
		var product = basketConfirmation.productLineItems[index];

		pushToDataLayer({
			"event": "addToCart",
			"addToCartType": 'Cart Page',
			"currencyCode": basketConfirmation.currencyCode,
			'products': [{
				"name": product.name,
				"id": product.id,
				"price": product.price,
				"brand": product.brand,
				"category": product.category,
				"variant": product.size,
				"quantity": 1,
				"productAutoReplen": product.productAutoReplen,
				"productColor": product.color,
				"productOutOfStock": product.productOutOfStock,
				"collectionName": product.collectionName,
				"productType": product.productType,
				"productStarRating": product.productStarRating,
				"productVariantID": product.productVariantID,
				"numberOfProductReview": product.numberOfProductReview
			}]
		});
	})

	// click at '+' on minicart
	.on('click', '.cpb-products_list_box .js-num-drop_up', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-products_list_box").index();
		var product = basketConfirmation.productLineItems[index];

		pushToDataLayer({
			"event": "addToCart",
			"addToCartType": 'Cart Page',
			"currencyCode": basketConfirmation.currencyCode,
			'products': [{
				"name": product.name,
				"id": product.id,
				"price": product.price,
				"brand": product.brand,
				"category": product.category,
				"variant": product.size,
				"quantity": 1,
				"productAutoReplen": product.productAutoReplen,
				"productColor": product.color,
				"productOutOfStock": product.productOutOfStock,
				"collectionName": product.collectionName,
				"productType": product.productType,
				"productStarRating": product.productStarRating,
				"productVariantID": product.productVariantID,
				"numberOfProductReview": product.numberOfProductReview
			}]
		});
	})

	//Click at '-' on cart page
	.on('click', '.cpb-cart-bag_box .js-num-drop_down', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-cart-bag_box").index();
		var product = basketConfirmation.productLineItems[index];
		if (product.quantity > 1) {
			pushToDataLayer({
				"event": "removeFromCart",
				"addToCartType": 'Cart Page',
				"currencyCode": basketConfirmation.currencyCode,
				'products': [{
					"name": product.name,
					"id": product.id,
					"price": product.price,
					"brand": product.brand,
					"category": product.category,
					"variant": product.size,
					"quantity": 1,
					"productAutoReplen": product.productAutoReplen,
					"productColor": product.color,
					"productOutOfStock": product.productOutOfStock,
					"collectionName": product.collectionName,
					"productType": product.productType,
					"productStarRating": product.productStarRating,
					"productVariantID": product.productVariantID,
					"numberOfProductReview": product.numberOfProductReview
				}]
			});
		}
	})

	//Click at '-' on minicart
	.on('click', '.cpb-products_list_box .js-num-drop_down', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-products_list_box").index();
		var product = basketConfirmation.productLineItems[index];
		if (product.quantity > 1) {
			pushToDataLayer({
				"event": "removeFromCart",
				"addToCartType": 'Cart Page',
				"currencyCode": basketConfirmation.currencyCode,
				'products': [{
					"name": product.name,
					"id": product.id,
					"price": product.price,
					"brand": product.brand,
					"category": product.category,
					"variant": product.size,
					"quantity": 1,
					"productAutoReplen": product.productAutoReplen,
					"productColor": product.color,
					"productOutOfStock": product.productOutOfStock,
					"collectionName": product.collectionName,
					"productType": product.productType,
					"productStarRating": product.productStarRating,
					"productVariantID": product.productVariantID,
					"numberOfProductReview": product.numberOfProductReview
				}]
			});
		}
	})

	//Click change quantity on cart page
	.on('click', '.cpb-cart-bag_box .cmd-num_list .js-num-drop_select a', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-cart-bag_box").index();
		var product = basketConfirmation.productLineItems[index];
		if ($(this).text() != '') {
			pushToDataLayer({
				"event": Number($(this).text().trim()) - product.quantity > 0 ? "addToCart" : "removeFromCart",
				"addToCartType": 'Cart Page',
				"currencyCode": basketConfirmation.currencyCode,
				'products': [{
					"name": product.name,
					"id": product.id,
					"price": product.price,
					"brand": product.brand,
					"category": product.category,
					"variant": product.size,
					"quantity": Math.abs(Number($(this).text().trim()) - product.quantity),
					"productAutoReplen": product.productAutoReplen,
					"productColor": product.color,
					"productOutOfStock": product.productOutOfStock,
					"collectionName": product.collectionName,
					"productType": product.productType,
					"productStarRating": product.productStarRating,
					"productVariantID": product.productVariantID,
					"numberOfProductReview": product.numberOfProductReview
				}]
			});
		}
	})

	//Click change quantity on minicart
	.on('click', '.cpb-products_list_box .cmd-num_list .js-num-drop_select a', function () {
		sessionStorage.setItem("productUpdate", "1");
		var index = $(this).parents(".cpb-products_list_box").index();
		var product = basketConfirmation.productLineItems[index];
		if ($(this).text() != '') {
			pushToDataLayer({
				"event": Number($(this).text().trim()) - product.quantity > 0 ? "addToCart" : "removeFromCart",
				"addToCartType": 'Cart Page',
				"currencyCode": basketConfirmation.currencyCode,
				'products': [{
					"name": product.name,
					"id": product.id,
					"price": product.price,
					"brand": product.brand,
					"category": product.category,
					"variant": product.size,
					"quantity": Math.abs(Number($(this).text().trim()) - product.quantity),
					"productAutoReplen": product.productAutoReplen,
					"productColor": product.color,
					"productOutOfStock": product.productOutOfStock,
					"collectionName": product.collectionName,
					"productType": product.productType,
					"productStarRating": product.productStarRating,
					"productVariantID": product.productVariantID,
					"numberOfProductReview": product.numberOfProductReview
				}]
			});
		}
	})

	// Submit ask a question
	.on('click', ".bv-submission-section button:contains('Post Question')", function (e) {
		pushToDataLayer({
			//"page": getpage(),
			"event": "submitQuestion",
			//"productCategory": getProductCategory(),
			"question": $("#bv-textarea-field-questionsummary").val(),
			//"productName": getProductName(),
			//"pageSubCategory": "Ask a Question",
			"pageCategory": getPageCategory()
		});
	})

	// remove from cart
	.on('click', ".cpb-cart-bag_box .item-remove", function (e) {
		var index = $(this).parents(".cpb-cart-bag_box").index();
		pushToDataLayer({
			"event": "removeFromCart",
			"currencyCode": window.Resources.CURRENCY,
			"addToCartType": getPageCategory(),
			//"productOrderType": ($(this).parents(".cart-row").find(".replenishment .replenishmentDays").length > 0) ? "Replenishment" : "Regular",
			//"pageCategory": getPageCategory(),
			'products': [{
				"name": basketConfirmation.productLineItems[index].name,
				"id": basketConfirmation.productLineItems[index].id,
				"price": basketConfirmation.productLineItems[index].price,
				"brand": getProductBrand(),
				"category": basketConfirmation.productLineItems[index].category,
				"variant": basketConfirmation.productLineItems[index].size,
				"quantity": basketConfirmation.productLineItems[index].quantity,
				"productAutoReplen": basketConfirmation.productLineItems[index].productAutoReplen,
				"productColor": basketConfirmation.productLineItems[index].productColor,
				"productType": basketConfirmation.productLineItems[index].productType,
				"productOutOfStock": basketConfirmation.productLineItems[index].productAutoReplen.productOutOfStock,
				"collectionName": basketConfirmation.productLineItems[index].category == "Synactif" ? "Synactif" : null,
				"productStarRating": "",
				"productVariantID": "",
				"numberOfProductReview": basketConfirmation.productLineItems[index].size != '' && basketConfirmation.productLineItems[index].productColor != '' ? basketConfirmation.productLineItems[index].id : null
			}]
		});
	})
	// click zoom in pdp
	.on('click', ".c-block-shopingmodal-main-image .c-modal-img", function (e) {
		pushToDataLayer({
			"event": "productInteraction",
			"interactionType": "Zoom",
			"productCategory": getProductCategory(),
			"productSubCategory": getProductsubCategory(),
			"productName": getProductName(),
			"productId": getProductID(),
			"pageCategory": getPageCategory(),
			"productOutOfStock": window.productCache.productOutOfStock,
			"productAutoReplen": window.productCache.productautoreplenish,
			"productColor": window.productCache.productColor,
			"collectionName": window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": window.productCache.master ? "master" : window.productCache.variant ? "variant" : window.productCache.bundle ? "bundle" : window.productCache.productSet ? "productSet" : "product"
		});
	})

	// click full ingredients in pdp
	.on('click', ".cpb-products-summary_contents .cpb-products_article a[data-tab-contents='content4'], .cpb-products-summary_tab_list li a[data-tab-target='content4']", function (e) {
		pushToDataLayer({
			"event": "productInteraction",
			"interactionType": "View Full Product Ingredients",
			"productCategory": getProductCategory(),
			"productSubCategory": getProductsubCategory(),
			"productName": getProductName(),
			"productId": getProductID(),
			"pageCategory": getPageCategory(),
			"productOutOfStock": window.productCache.productOutOfStock,
			"productAutoReplen": window.productCache.productautoreplenish,
			"productColor": window.productCache.productColor,
			"collectionName": window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": window.productCache.master ? "master" : window.productCache.variant ? "variant" : window.productCache.bundle ? "bundle" : window.productCache.productSet ? "productSet" : "product"
		});
	}).on("click", ".cart-promo-approaching", function () {
		pushToDataLayer({
			"event": "eePromoClick",
			"pageSubCategory": "Internal marketing",
			"pageCategory": "Cart Page",
			'promotions': [{
				"position": "Cart",
				"id": $(".cart-promo-approaching").data("promoid"),
				"creative": "Cart-Banner",
				"name": $(".cart-promo-approaching").data("promoname")
			}]
		});
	}).on("click", ".input-code_box #add-coupon", function () {
		localStorage.removeItem('couponvalidation');
	})

	// track share button on PDP
	.on("click", ".item-link_sns_box .item-link_sns_list li a", function () {
		pushToDataLayer({
			"socialAction": "Share",
			"event": "socialShare",
			"siteLocation": "product page",
			"pageCategory": getPageCategory(),
			"socialNetwork": $(this).data("share")
		});
	})

	// Track Follow button on Footer
	.on("click", ".cpb-footer-sns_box .cpb-footer-sns_list li a", function () {
		pushToDataLayer({
			"event": "socialClick",
			"socialNetwork": $(this).find('svg').attr('aria-label').length > 0 ? $(this).find('svg').attr('aria-label').trim() : null,
			"socialAction": "Follow",
			"siteLocation": "footer",
			"pageCategory": getPageCategory()
		});
	})

	// Add to Cart in Save for later
	.on("click", ".wishlist-item .add-to-cart", function () {
		var index = $(this).parents('form').index();
		pushToDataLayer({
			"currencyCode": window.Resources.CURRENCY,
			"event": "addToCart",
			//"productOrderType": getProductOrederType(),
			"addToCartType": getPageCategory(),
			"pageSubCategory": getProductsubCategory(),
			"pageCategory": getPageCategory(),
			'products': [{
				"id": wishlistItem.product[index].id,
				"category": wishlistItem.product[index].category,
				"price": wishlistItem.product[index].price,
				"name": wishlistItem.product[index].name,
				"brand": wishlistItem.product[index].brand,
				"quantity": wishlistItem.product[index].quantity,
				"size": wishlistItem.product[index].size,
				"subCategory": wishlistItem.product[index].subcategory,
				"subSubCategory": wishlistItem.product[index].subcategory,
				"productAutoReplen": wishlistItem.product[index].productAutoReplen,
				"productOutOfStock": wishlistItem.product[index].productOutOfStock,
				"productColor": wishlistItem.product[index].color,
				"productType": "Product",
				"productNumReviews": "",
				"productStarRating": "" }]
		});
	})

	// Add to all to Cart
	.on("click", ".add-all-to-cart", function () {
		pushToDataLayer({
			"currencyCode": window.Resources.CURRENCY,
			"event": "addToCart",
			//"productOrderType": getProductOrederType(),
			"addToCartType": getPageCategory(),
			"pageSubCategory": getProductsubCategory(),
			"pageCategory": getPageCategory(),
			'products': wishlistItem.product
		});
	})

	// click email hyper link in navigation
	.on('click', '#header .emailcsr-nav', function () {
		if (window.Resources.PAGE_CATEGORY == "page-show") {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": "Header",
				//					"pageSubCategory": couponsubcategory(),
				"pageCategory": getProductCategory()
			});
		} else {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Email",
				"siteLocation": "Header",
				"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		}
	})
	// Click email link in the customer care
	//		.on("click",".content-asset a:contains('customercare@cledepeaubeaute.com')",function(){
	//			pushToDataLayer({
	//				"event": "contactRequest",
	//				"contactType": "Email",
	//				"siteLocation": window.Resources.PAGE_CATEGORY=="cart-show" ? "Right Nav":"Body",
	////				"pageSubCategory": couponsubcategory(),
	//				"pageCategory": window.Resources.PAGE_CATEGORY=="cart-show" ? getPageCategory(): getProductCategory()
	//			});
	//		})

	.on("gtmcontactus", function () {
		pushToDataLayer({
			"event": "contactRequest",
			"contactType": "Contact Customer Care Submission",
			"siteLocation": "Body",
			"pageCategory": getPageCategory()
		});
	}).on("askanexpert", function () {
		pushToDataLayer({
			"event": "contactRequest",
			"contactType": "Ask An Expert Submission",
			"siteLocation": "Body",
			"pageSubCategory": couponsubcategory(),
			"pageCategory": "Ask An Expert"
		});
	}).on("click", "#header .live-chat", function () {
		pushToDataLayer({
			"event": "contactRequest",
			"contactType": "Live Chat",
			"siteLocation": "Header",
			"pageSubCategory": couponsubcategory(),
			"pageCategory": getPageCategory()
		});
	}).on("click", "#header .call-us", function () {
		pushToDataLayer({
			"event": "contactRequest",
			"contactType": "Call Us",
			"siteLocation": "Header",
			"pageSubCategory": couponsubcategory(),
			"pageCategory": getPageCategory()
		});
	}).on("click", ".LPMimage", function () {
		var id = $(this).attr("id");
		var chk = id.charAt(id.length - 1);
		if (chk == 1) {
			pushToDataLayer({
				"event": "contactRequest",
				"contactType": "Live Chat",
				"siteLocation": "Pop-up",
				"pageSubCategory": couponsubcategory(),
				"pageCategory": getPageCategory()
			});
		}
	}).on("click", ".footer-container .products ul li:nth-child(4)", function () {
		pushToDataLayer({
			"event": "contactRequest",
			"contactType": "Phone",
			"siteLocation": "Footer",
			"pageSubCategory": window.Resources.PAGE_CATEGORY == "cart-show" ? "" : couponsubcategory(),
			"pageCategory": getPageCategory()
		});
	})

	// click on recommendation
	.on("click", ".recommendation-item", function () {
		if (getPageCategory() == "Product Page") {
			sessionStorage.setItem('listType', "Recommended Product List");
			sessionStorage.setItem('listName', "Product Page");
		} else if (getPageCategory() == "Home Page") {
			sessionStorage.setItem('listType', "Recently Viewed List");
			sessionStorage.setItem('listName', "Home Page");
		}
	}).on("click", ".gnav-item_btn", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData);
		sessionStorage.setItem("menuloc", "topmenu");
		util.setCookie('navdata', gtmNavData, .20);
	}).on("click", ".cpb-gnav_container.is-cpb .cpb-gnav_list:first li a", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData);
		sessionStorage.setItem("menuloc", "topmenu");
		util.setCookie('navdata', gtmNavData, .20);
	}).on("click", ".refinement-header", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData);
		sessionStorage.setItem("menuloc", "leftmenu");
	}).on("click", ".refinement-link", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData);
		sessionStorage.setItem("menuloc", "leftmenu");
	}).on("click", ".cmd-breadcrumb_container .cmd-breadcrumb_list li", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("breadcrumbs", gtmNavData);
		sessionStorage.setItem("menuloc", "leftmenu");
	}).on("change", "#quantity", function (e) {
		if (getPageCategory() == "Cart Page") {
			if ($(".edit-modal").length > 0) {
				sessionStorage.setItem("cartupdate", "1");
			} else {
				sessionStorage.setItem("productUpdate", "1");
			}
		}
	}).on("change", ".quantity-select", function (e) {
		if (window.Resources.PAGE_CATEGORY == "wishlist-show") {
			sessionStorage.setItem("productUpdate", "1");
		}
	}).on("click", ".account-left-nav li", function (e) {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData);
		sessionStorage.setItem("menuloc", "leftmenu");
	})

	// Remove uservalidation attribute for userlogin validation and product update
	.on('click', ".user-logout", function (e) {
		localStorage.removeItem('uservalidation');
		sessionStorage.removeItem('productUpdate');
	}).on("click", "#pdp-swatches.c-block-shopingmodal-side-color a, .c-block-shopingmodal-side-colorSelect .c-select-list-item", function () {
		if (getPageCategory() == "Cart Page") {
			sessionStorage.setItem("cartupdate", "1");
		}
	}).on("click", ".mfp-close", function () {
		if (getPageCategory() == "Cart Page") {
			sessionStorage.setItem("cartupdate", "");
		}
	}).on("click", "#save-for-later", function () {
		if (getPageCategory() == "Cart Page") {
			sessionStorage.setItem("cartupdate", "");
		}
	}).on("click", "#pdp-swatches .selectable", function () {
		if (getPageCategory() == "Cart Page") {
			if (!$(this).hasClass("selected")) {
				sessionStorage.setItem("cartupdate", "1");
			}
		}
	}).on("click", ".search-suggestion-wrapper .hit", function () {
		gtmNavData = $(this).text().trim();
		sessionStorage.setItem("navlink", gtmNavData.replace(/\s\s+/g, ' '));
		sessionStorage.setItem("menuloc", "site search pop-in");
	}).on("click", ".search-suggestion-wrapper .product-suggestion", function () {
		gtmNavData = $(this).text().trim();
		var rep = gtmNavData.replace(/\n/g, " ");
		sessionStorage.setItem("navlink", rep.replace(/ +/g, " "));
		sessionStorage.setItem("menuloc", "site search pop-in");
	})

	// PLP click in list
	.on("click", ".c-product-cards-list .c-product-cards-list-item a.c-product-cards-photo-img", function () {
		var index = $(this).parents(".c-product-cards-list-item").index(".c-product-cards-list-item");
		var url = $(this).attr('href');
		if (index >= 0) {
			if (productData.page >= 1) {
				pushToDataLayer({
					"event": "eeListClick",
					"eeAction": "eeListClick",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"page": url ? url : null,
					'products': [prodholder[index]]
				}), function () {
					setTimeout(function () {
						if (url != undefined && url != null) {
							document.location = url;
						}
					}, 1000);
				}();
				sessionStorage.setItem('listType', prodholder[index].listType);
				sessionStorage.setItem('listName', prodholder[index].listName);
			} else {
				pushToDataLayer({
					"event": "eeListClick",
					"eeAction": "eeListClick",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"page": url ? url : null,
					'products': [prodholder[0][index]]
				}), function () {
					setTimeout(function () {
						if (url != undefined && url != null) {
							document.location = url;
						}
					}, 1000);
				}();
				sessionStorage.setItem('listType', prodholder[0][index].listType);
				sessionStorage.setItem('listName', prodholder[0][index].listName);
			}
		}
	})

	// PLP click in list
	.on("click", ".c-product-cards-list .c-product-cards-list-item .c-product-cards-text a", function () {
		var index = $(this).parents(".c-product-cards-list-item").index(".c-product-cards-list-item");
		var url = $(this).attr('href');
		if (index >= 0) {
			if (productData.page > 0) {
				pushToDataLayer({
					"event": "eeListClick",
					"eeAction": "eeListClick",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"page": url ? url : null,
					'products': [prodholder[index]]
				}), function () {
					setTimeout(function () {
						if (url != undefined && url != null) {
							document.location = url;
						}
					}, 1000);
				}();
				sessionStorage.setItem('listType', prodholder[index].listType);
				sessionStorage.setItem('listName', prodholder[index].listName);
			} else {
				pushToDataLayer({
					"event": "eeListClick",
					"eeAction": "eeListClick",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"page": url ? url : null,
					'products': [prodholder[0][index]]
				}), function () {
					setTimeout(function () {
						if (url != undefined && url != null) {
							document.location = url;
						}
					}, 1000);
				}();
				sessionStorage.setItem('listType', prodholder[0][index].listType);
				sessionStorage.setItem('listName', prodholder[0][index].listName);
			}
		}
	})

	// Recommendation, bestseller eelistclick in homepage,pdp,cart
	.on("click", ".pi .carousel-recommendations .recommendation-item", function (e) {
		var index = $(this).index() - 3;
		if (_typeof(prodData.product[index]) != undefined && prodData.product[index] != null) {
			pushToDataLayer({
				"event": "eeListClick",
				"pageSubCategory": "",
				"pageCategory": getPageCategory(),
				"filterChoice": "",
				"dropDown": "",
				'products': [{
					"listType": prodData.product[index].listType,
					"listName": prodData.product[index].listName,
					"position": prodData.product[index].position,
					"id": prodData.product[index].id,
					"category": getProductCategory(),
					"price": prodData.product[index].price,
					"name": prodData.product[index].name,
					"brand": getProductBrand(),
					"quantity": prodData.product[index].quantity,
					"size": prodData.product[index].size,
					"subCategory": prodData.product[index].subCategory,
					"subSubCategory": prodData.product[index].subSubCategory,
					"productAutoReplen": prodData.product[index].productAutoReplen,
					"productOutOfStock": prodData.product[index].productOutOfStock,
					"productColor": prodData.product[index].productColor,
					"productType": prodData.product[index].productType,
					"productNumReviews": "",
					"productStarRating": "" }]
			});
			sessionStorage.setItem('listType', prodData.product[index].listType);
			sessionStorage.setItem('listName', prodData.product[index].listName);
		}
	})

	// Recently viewed eelistclick in homepage
	.on("click", ".cross-sell .carousel-recommendations ul .recommendation-item", function (e) {
		var index = $(this).index() - 3;
		if (_typeof(prodData.product[index]) != undefined && prodData.product[index] != null) {
			pushToDataLayer({
				"event": "eeListClick",
				"pageSubCategory": "",
				"pageCategory": getPageCategory(),
				"filterChoice": "",
				"dropDown": "",
				'products': [{
					"listType": prodData.product[index].listType,
					"listName": prodData.product[index].listName,
					"position": prodData.product[index].position,
					"id": prodData.product[index].id,
					"category": getProductCategory(),
					"price": prodData.product[index].price,
					"name": prodData.product[index].name,
					"brand": getProductBrand(),
					"quantity": prodData.product[index].quantity,
					"size": prodData.product[index].size,
					"subCategory": prodData.product[index].subCategory,
					"subSubCategory": prodData.product[index].subSubCategory,
					"productAutoReplen": prodData.product[index].productAutoReplen,
					"productOutOfStock": prodData.product[index].productOutOfStock,
					"productColor": prodData.product[index].productColor,
					"productType": prodData.product[index].productType,
					"productNumReviews": "",
					"productStarRating": "" }]
			});
			sessionStorage.setItem('listType', prodData.product[index].listType);
			sessionStorage.setItem('listName', prodData.product[index].listName);
		}
	})

	// click on viewmore button
	.on("plpviewmore", function (e) {
		if (getPageCategory() == "Category Page") {
			if (prodholder && _typeof(productData.product) != undefined) {
				if (productData.page > 1) {
					prodholder = prodholder.concat(productData.product);
				} else {
					prodholder = prodholder[0].concat(productData.product);
				}

				for (var i = 0; i < prodholder.length; i++) {
					prodholder[i].position = i + 1;
				}
				for (var a = 0; a < productData.product.length; a++) {
					var diff = productData.product.length - a;
					productData.product[a].position = prodholder.length - diff + 1;
				}
				pushDtLayer({
					"event": "eeListView",
					"eeAction": "eeListView",
					"pageCategory": searchItems.search ? "Site Search" : "Product List Page",
					"dropDown": "",
					"filterChoice": "",
					"currencyCode": window.User.currencyCode,
					"products": productData.product || new Array()
				});
			}
		}
	}).on('click', '.c-block-shopingmodal-main-thumbnail .slick-slide', function () {
		$(document).trigger("clickproductthumbnail");
	})

	// tracking change on image in
	.on("clickproductthumbnail", function () {
		pushToDataLayer({
			"event": "productInteraction",
			"interactionType": "Image Change",
			"productCategory": window.productCache.catid,
			"productSubCategory": window.productCache.subcategory,
			"productName": getProductName(),
			"productId": getProductID(),
			"pageCategory": getPageCategory(),
			"productOutOfStock": window.productCache.productOutOfStock,
			"productAutoReplen": window.productCache.productautoreplenish,
			"productColor": window.productCache.productColor,
			"collectionName": window.productCache.catid && window.productCache.catid.toLowerCase().search('synactif') > -1 ? "Synactif" : null,
			"productType": window.productCache.master ? "master" : window.productCache.variant ? "variant" : window.productCache.bundle ? "bundle" : window.productCache.productSet ? "productSet" : "product"
		});
	})
	// click on next arrow recommendation carousel and best seller
	.on("click", ".pi .carousel-recommendations .slick-next", function (e) {
		if ((typeof prodData === "undefined" ? "undefined" : _typeof(prodData)) != undefined && prodData != null) {
			var array = new Array();
			var listholder = new Array();
			var listchecker = false;
			var listctr = 0;
			$(".recommendation-item").each(function (index) {
				if ($(".recommendation-item").filter(".slick-active").length == 3) {
					if (index > 2 && $(this).hasClass("slick-active")) {
						array.push(index - 3);
					}
				} else {
					if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
						listctr = 2;
						if (prodData.product.length > 3) {
							listchecker = true;
							listctr = 0;
						}
						array.push(index - 3);
					} else {
						if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
							if (array[array.length] != index - 3) {
								listctr += 1;
								array.push(index - 3);
							}
						} else {
							listchecker = false;
						}
					}
				}
			});
			for (var i = 0; i < prodData.product.length; i++) {
				for (var a = 0; a < array.length; a++) {
					if (i == array[a]) {
						listholder.push(prodData.product[i]);
					}
				}
			}
			pushToDataLayer({
				"currencyCode": window.User.currencyCode,
				"eeAction": "eeListView",
				"event": "eeListView",
				"pageCategory": getPageCategory(),
				"products": listholder });
		}
	})

	// click on next arrow recommendation carousel and best seller
	.on("click", ".pi .carousel-recommendations .slick-prev", function (e) {

		if ((typeof prodData === "undefined" ? "undefined" : _typeof(prodData)) != undefined && prodData != null) {
			var array = new Array();
			var listholder = new Array();
			var listchecker = false;
			var listctr = 0;
			$(".recommendation-item").each(function (index) {
				if ($(".recommendation-item").filter(".slick-active").length == 3) {
					if (index > 2 && $(this).hasClass("slick-active")) {
						array.push(index - 3);
					}
				} else {
					if (index > 2 && ($(this).hasClass("slick-active") || $(this).hasClass("slick-current"))) {
						listctr = 2;
						if (prodData.product.length > 3) {
							listchecker = true;
							listctr = 0;
						}
						array.push(index - 3);
					} else {
						if (listchecker && listctr < 2 && index > 2 && array.length <= 3) {
							if (array[array.length] != index - 3) {
								listctr += 1;
								array.push(index - 3);
							}
						} else {
							listchecker = false;
						}
					}
				}
			});
			for (var i = 0; i < prodData.product.length; i++) {
				for (var a = 0; a < array.length; a++) {
					if (i == array[a]) {
						listholder.push(prodData.product[i]);
					}
				}
			}
			pushToDataLayer({
				"currencyCode": window.User.currencyCode,
				"eeAction": "eeListView",
				"event": "eeListView",
				"pageCategory": getPageCategory(),
				"products": listholder });
		}
	})

	// click on next arrow recently viewed
	.on("click", ".cross-sell .carousel-recommendations .slick-next", function (e) {

		if ((typeof prodData === "undefined" ? "undefined" : _typeof(prodData)) != undefined && prodData != null) {
			var array = new Array();
			var listholder = new Array();
			$(".recommendation-item").each(function (index) {
				if (index > 2 && $(this).hasClass("slick-active")) {
					array.push(index - 3);
				}
			});
			for (var i = 0; i < prodData.product.length; i++) {
				for (var a = 0; a < array.length; a++) {
					if (i == array[a]) {
						listholder.push(prodData.product[i]);
					}
				}
			}
			pushToDataLayer({
				"currencyCode": window.User.currencyCode,
				"eeAction": "eeListView",
				"event": "eeListView",
				"pageCategory": getPageCategory(),
				"products": listholder });
		}
	})

	// click on next arrow recently viewed
	.on("click", ".cross-sell .carousel-recommendations .slick-prev", function (e) {

		if ((typeof prodData === "undefined" ? "undefined" : _typeof(prodData)) != undefined && prodData != null) {
			var array = new Array();
			var listholder = new Array();
			$(".recommendation-item").each(function (index) {
				if (index > 2 && $(this).hasClass("slick-active")) {
					array.push(index - 3);
				}
			});
			for (var i = 0; i < prodData.product.length; i++) {
				for (var a = 0; a < array.length; a++) {
					if (i == array[a]) {
						listholder.push(prodData.product[i]);
					}
				}
			}
			pushToDataLayer({
				"currencyCode": window.User.currencyCode,
				"eeAction": "eeListView",
				"event": "eeListView",
				"pageCategory": getPageCategory(),
				"products": listholder });
		}
	})

	// pdp fire when variation was change
	.on("gtvariationchange", function (e) {
		if (getPageCategory() == "Product Page") {
			pushToDataLayer({
				"eeAction": "eeProductDetail",
				"event": "eeProductDetail",
				"pageCategory": "Product Page",
				'products': [{
					"listType": sessionStorage.getItem('listType'),
					"listName": sessionStorage.getItem('listName'),
					"id": pdpdata.defalutvariant ? pdpdata.defalutvariant : pdpdata.ID,
					"category": pdpdata.category,
					"price": pdpdata.pricing.sale ? pdpdata.pricing.sale : pdpdata.pricing.minprice,
					"name": pdpdata.name,
					"brand": pdpdata.brand,
					"quantity": pdpdata.quantity,
					"size": pdpdata.size,
					"subCategory": pdpdata.subcategory,
					"subSubCategory": pdpdata.subsubcategory,
					"productAutoReplen": pdpdata.productautoreplenish,
					"productOutOfStock": pdpdata.productOutOfStock,
					"productColor": pdpdata.productColor,
					"productType": "Product",
					"productNumReviews": "",
					"productStarRating": "" }]
			});
		}
	})

	// quickview action
	.on('click', '.c-product-cards-quickshop-toggle', function () {
		var index = $(this).parents(".c-product-cards-list-item").index(".c-product-cards-list-item");
		if (productData.product.length > 0 && prodholder[0].length > index) {
			pushToDataLayer({
				"eeAction": "eeProductDetail",
				"event": "eeProductDetail",
				"pageCategory": "Category Page",
				'products': [prodholder[0][index]]
			});
		}
	})

	// filter
	.on('click', '.c-block-products-search-panel--filter .c-select .c-select-list-item a', function () {
		pushToDataLayer({
			"event": "dropDownChoice",
			"dropDownType": "Filter",
			"listType": "product category list",
			"listName": $('.c-title-pageHeading-title').length > 0 ? $('.c-title-pageHeading-title').text().trim() : null,
			"filterChoice": $(this).length > 0 ? $(this).text().trim() : null
		});
	})

	// sort
	.on('click', '.c-block-products-search-panel--sort .c-select .c-select-list-item a', function () {
		pushToDataLayer({
			"event": "dropDownChoice",
			"dropDownType": "Sort",
			"listType": "product category list",
			"listName": $('.c-title-pageHeading-title').length > 0 ? $('.c-title-pageHeading-title').text().trim() : null,
			"filterChoice": $(this).length > 0 ? $(this).text().trim() : null
		});
	})

	// Transaction funnel steps - shipping to payment
	.on('click', 'button[name="dwfrm_singleshipping_shippingAddress_save"]', function () {
		pushToDataLayer({
			"event": "eeCheckoutOption",
			"checkoutStep": "1",
			"checkoutOption": sessionStorage.getItem("productUpdate") != "" ? sessionStorage.getItem("productUpdate") : "0"
		});
	})

	// Transaction funnel step - payment to review
	.on('click', 'button[name="dwfrm_billing_save"]', function () {
		pushToDataLayer({
			"event": "eeCheckoutOption",
			"checkoutStep": "2",
			"checkoutOption": basketConfirmation.defaultShipping
		});
	})

	// Transaction funnel step - review to confirmation
	.on('click', '.pt_checkout #summary-place-order', function () {
		pushToDataLayer({
			"event": "eeCheckoutOption",
			"checkoutStep": "3",
			"checkoutOption": basketConfirmation.paymentMethod
		});

		sessionStorage.setItem("productUpdate", "");
	})

	// subscription on account registration page
	.on('click', '.pt_account #register-new-account', function () {
		if ($('input[name="dwfrm_profile_customer_addtoemaillist"]').prop('checked')) {
			$(document).trigger("clicknewsletter", { "siteloc": "account registration page" });
			sessionStorage.setItem("subscription", true);
		} else {
			sessionStorage.setItem("subscription", false);
		}
	})

	// subscription on profile page
	.on('click', '.pt_account #profile-save-changes', function () {
		if ($('input[name="dwfrm_profile_customer_addtoemaillist"]').prop('checked') && sessionStorage.getItem("subscription") == 'false') {
			$(document).trigger("clicknewsletter", { "siteloc": "profile page" });
			sessionStorage.setItem("subscription", true);
		}
	}).on('click', '.c-block-languagselection li a', function () {
		pushToDataLayer({
			"event": "changeLanguage",
			"language": $(this).length > 0 ? $(this).text().trim() : null
		});
	});
}

module.exports = {
	init: function init() {
		initializeGlobalEvents();
	},
	tagmanager: {
		click: function click(data) {
			return trackConsultationEvent(data);
		},

		pageview: function pageview(data) {
			return trackConsultationPageview(data);
		}
	},
	gtmInternalPromotion: {
		click: function click(data) {
			return trackInternalPromotionEvent(data);
		},

		pageview: function pageview(data) {
			return trackInternalPromotionPageView(data);
		}
	}
};

},{"./util":69}],3:[function(require,module,exports){
'use strict';

var analytics = require('./analytics'),
    countries = require('./countries'),
    dialog = require('./dialog'),
    quickview = require("./quickview"),
    minicart = require('./minicart'),
    page = require('./page'),
    rating = require('./rating'),
    searchplaceholder = require('./searchplaceholder'),
    searchsuggest = require('./searchsuggest'),
    tooltip = require('./tooltip'),
    util = require('./util'),
    validator = require('./validator'),
    slick = require('./slick'),
    tls = require('./tls'),
    video = require("./video"),
    headerMenu = require('./header-menu'),
    footerSelector = require('./footer-selector'),
    newsletter = require('./newsletter'),
    orderreplenishment = require('./order-replenishment'),
    inputEntry = require('./input-entry'),
    producttile = require('./product-tile'),
    design = require('./design'),
    newDesign = require('./new-design'),
    login = require('./login');

//if jQuery has not been loaded, load from google cdn
if (!window.jQuery) {
    var s = document.createElement('script');

    s.setAttribute('src', 'https://ajax.googleapis.com/ajax/libs/jquery/1.7.1/jquery.min.js');
    s.setAttribute('type', 'text/javascript');

    document.getElementsByTagName('head')[0].appendChild(s);
}

require('./jquery-ext')();
require('./cookieprivacy')();
//require('./captcha')();

function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body').on('keydown', 'textarea[data-character-limit]', function (e) {
        var text = $.trim($(this).val()),
            charsLimit = $(this).data('character-limit'),
            charsUsed = text.length;

        if (charsUsed >= charsLimit && controlKeys.indexOf(e.which.toString()) < 0) {
            e.preventDefault();
        }
    }).on('change keyup mouseup', 'textarea[data-character-limit]', function () {
        var text = $(this).val(),
            charsLimit = $(this).data('character-limit'),
            charsUsed = text.length,
            charsRemain = charsLimit - charsUsed;

        if (charsRemain < 0) {
            $(this).val(text.slice(0, charsRemain));
            charsRemain = 0;
        }

        $(this).closest('.field-wrapper').find('.char-remain-count').html(charsRemain);
    });

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    var $searchContainer = $('.utility-nav .header-search');

    searchsuggest.init($searchContainer, Resources.SIMPLE_SEARCH);

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').next('.toggle-content').hide();
    $('.toggle').click(function () {
        $(this).toggleClass('expanded').next('.toggle-content').toggle();
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');

    if ($subscribeEmail.length > 0) {
        $subscribeEmail.focus(function () {
            var val = $(this.val());

            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({
                color: '#999999'
            }, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));

            if (val.length > 0) {
                return; // do not animate when contains value
            }

            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT).css('color', '#999999').animate({
                color: '#333333'
            }, 500, 'linear');
        });
    }

    if (SitePreferences.MOTIONPOINT_ENABLED) {

        $('#chooseLanguage').on('click', function (e) {
            e.preventDefault();

            var script = document.createElement('script');

            //MP.SrcUrl = unescape('mp_js_orgin_url'); - commented out per MotionPoint
            MP.UrlLang = 'mp_js_current_lang';
            MP.oSite = decodeURIComponent('mp_js_origin_baseUrl');
            MP.tSite = decodeURIComponent('mp_js_translated_baseUrl');

            MP.init();

            script.src = 'https://shiseidoamericas.mpeasylink.com/mpel/mpel_chooser.js';

            document.body.appendChild(script);

            return false;
        });
    }

    $('.privacy-policy').on('click', function (e) {
        e.preventDefault();

        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    if ($('.order-confirmation-details').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }

    var url = Urls.passwordReset;

    if ($('.reset-password-link').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.reset-password-link').each(function () {
            $(this).find('a').attr('href', url);
        });
    }

    if ($('.user-recognized').length) {
        if (location.protocol === 'https:') {
            url = Urls.securePasswordReset;
        }

        $('.user-recognized').find('a').attr('href', url);
    }

    // checkout checkout minicart on right side event handling
    addSummaryScrollbar();
    //quick view
    producttile.initQuickViewButtons();
    producttile.initColorChange();
}

/**
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');

    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }

    // load js specific styles
    util.limitCharacters();
}

function backToTopHandler() {
    $(document).on('scroll', function () {
        if ($(window).scrollTop() > 100) {
            $('.scroll-top-wrapper').addClass('show');
        } else {
            $('.scroll-top-wrapper').removeClass('show');
        }
    });

    $('.scroll-top-wrapper').on('click', scrollToTop);
}

function scrollToTop(e) {
    e.preventDefault();
    var verticalOffset = typeof verticalOffset != 'undefined' ? verticalOffset : 0;
    var element = $('body');
    var offset = element.offset();
    var offsetTop = offset.top;

    $('html, body').animate({
        scrollTop: offsetTop
    }, 500, 'linear');
}

// Minimize header and make it stick to the top
function minimizedHeaderHandler() {
    checkScrolledDown();

    $(window).scroll(function () {
        checkScrolledDown();
    });
}

function checkScrolledDown() {

    var $stickyHeader = $('#minimized-header-container');
    var $headerScrollOffset = $('.header-banner').outerHeight();
    var $wrapper = $('#wrapper');

    if ($('body').hasClass('is-reveal-open')) {
        return false;
    }

    if ($(window).scrollTop() > $headerScrollOffset) {
        $stickyHeader.addClass('sticky-header');
        $wrapper.css('padding-top', $stickyHeader.outerHeight());
    } else {
        $stickyHeader.removeClass('sticky-header');
        $wrapper.css('padding-top', 0);
    }
}

function responsiveMegaMenu() {
    var $dropdowns = $('.level-1 li.has-sub-menu');

    $dropdowns.on('keydown', function (e) {
        var $this = $(this);

        if (e.keyCode === 13) {

            if (!$this.hasClass('hover')) {
                e.preventDefault();

                $dropdowns.removeClass('hover');
                $this.addClass('hover');
            }
        }

        if (e.keyCode === 32) {
            e.preventDefault();
            $dropdowns.removeClass('hover');
        }
    });

    $dropdowns.hover(function () {
        var $this = $(this);
        if ($this.prop('hoverTimeout')) {
            $this.prop('hoverTimeout', clearTimeout($this.prop('hoverTimeout')));
        }
        $this.prop('hoverIntent', setTimeout(function () {
            $this.addClass('hover');
        }, 200));
    }, function () {
        var $this = $(this);
        if ($this.prop('hoverIntent')) {
            $this.prop('hoverIntent', clearTimeout($this.prop('hoverIntent')));
        }
        $this.prop('hoverTimeout', setTimeout(function () {
            $this.removeClass('hover');
        }, 200));
    });

    if ('ontouchstart' in document.documentElement && window.innerWidth >= 640) {

        $dropdowns.each(function () {
            var $this = $(this);

            this.addEventListener('touchstart', function (e) {
                if (e.touches.length === 1) {
                    e.stopPropagation();

                    if (!$this.hasClass('hover')) {
                        if (e.target === this || e.target.parentNode === this) {
                            e.preventDefault();
                        }

                        $dropdowns.removeClass('hover');
                        $this.addClass('hover');

                        document.addEventListener('touchstart', function closeDropdown(e) {
                            e.stopPropagation();

                            $this.removeClass('hover');
                            document.removeEventListener('touchstart', closeDropdown);
                        });
                    }
                }
            }, false);
        });
    }

    $('a.no-link, span.category-header').on('click', function (e) {
        if (window.innerWidth < 640) {
            $(this).next($('.menu-item-toggle')).trigger('click');
        } else {
            e.preventDefault();
        }
    });

    var ogMenuHeight = $('ul.level-1').height();
    // main menu toggle
    $('.menu-toggle').on('click', function () {
        $('#wrapper').toggleClass('menu-active');
        ogMenuHeight = $('ul.level-1').height();
    });

    $('.main-nav li .menu-item-toggle').on('click', function (e) {
        e.preventDefault();

        var $parentLi = $(e.target).closest('li');
        var menuHeight = $parentLi.find('.sub-level-wrapper').height();

        if (ogMenuHeight <= menuHeight) {
            $('ul.level-1').css('height', menuHeight);
        }

        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle');
        $parentLi.toggleClass('active');

        $(e.target).toggleClass('active');
    });

    $('.mobile-menu-back').on('click', function () {

        var $closestActiveMenu = $(this).closest('.active');
        var prevMenuHeight = $closestActiveMenu.parent().parent().height();

        $closestActiveMenu.removeClass('active');

        if (ogMenuHeight <= prevMenuHeight) {
            $('ul.level-1').css('height', prevMenuHeight);
        }
    });

    $('.user-account').on('click', function (e) {
        e.preventDefault();

        $(this).parent('.user-info').toggleClass('active');
    });
}

function searchMenuEvent() {
    // Search for mobile view
    $('.quick-access-menu [title="Search"]').on('click', function (e) {
        e.preventDefault();

        $('.header-search').slideToggle(200);
    });

    // show the search button when the user switches to desktop view
    $(window).on("resize", function (e) {
        if (window.innerWidth > 639) {
            $('.header-search').show();
        }
    });
}

//add class for scrollbar on miniline summary
function addSummaryScrollbar() {
    var itemCount = $('.pt_checkout .checkout-mini-cart .accordion-content .mini-cart-product').length;

    if (itemCount > 4) {
        $('.checkout-mini-cart .accordion-content').addClass('scroll-items');
    }
}

function playVideoHandler() {
    var MAIN_VIDEO_SELECTOR = ".main-video";
    var CAROUSEL_VIDEO_SELECTOR = ".modal-video";
    $(document)
    // main video (inline)
    .on("click", MAIN_VIDEO_SELECTOR, function () {
        var $this = $(this);

        var $inlineEle = $this.parent("div"),
            videoId = $this.data("video-id");

        video.playInline($inlineEle, videoId);
    })

    // carousel videos (launched in modal)
    .on("click", CAROUSEL_VIDEO_SELECTOR, function () {
        var videoId = $(this).data("video-id");

        video.playInModal(videoId);
    });
}

function resetFooterError() {
    $('.store-locator-form input[type="text"]').val('');

    if ($('.store-locator-form .field-button-container div').hasClass('error')) {
        $('.store-locator-form .field-button-container div').removeClass('error');
        $('.store-locator-form .field-button-container .error-message').remove();
    }
}

/**
 * Dropdown event for quantity change
 * @returns
 */
function dropDownEvents() {
    $(document).on('click', '.js-num-drop_up', function (e) {
        e.preventDefault();
        var $box = $(this).closest('.js-num-drop_container');
        var limit = $box.find('.js-num-drop_select').children().length;
        var currentNum = $box.find('.js-num-drop_cnt').html();

        if (currentNum < limit) {
            currentNum++;
            $box.find('.js-num-drop_cnt').html(currentNum);
            $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
            $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
            $box.find('.js-num-drop_input').val(currentNum);
        }

        if ($(this).parents('.cpb-products_list_box').length > 0) {
            $(this).trigger('dropUpMinicart');
        } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
            $(this).trigger('dropUpCart');
        } else if ($(this).parents('.cpb-products-conut').length > 0) {
            $(this).trigger('dropUpProduct');
        }
    });
    $(document).on('click', '.js-num-drop_down', function (e) {
        e.preventDefault();
        var $box = $(this).closest('.js-num-drop_container');
        var limit = $box.find('.js-num-drop_select').children().length;
        var currentNum = $box.find('.js-num-drop_cnt').html();

        if (currentNum > 1) {
            currentNum--;
            $box.find('.js-num-drop_cnt').html(currentNum);
            $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
            $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
            $box.find('.js-num-drop_input').val(currentNum);
        }

        if ($(this).parents('.cpb-products_list_box').length > 0) {
            $(this).trigger('dropDownMinicart');
        } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
            $(this).trigger('dropDownCart');
        } else if ($(this).parents('.cpb-products-conut').length > 0) {
            $(this).trigger('dropDownProduct');
        }
    });
    $(document).on('click', '.js-num-drop_select a', function (e) {
        e.preventDefault();
        var $box = $(this).closest('.js-num-drop_container');
        var num = $(this).html();
        $box.find('.js-num-drop_cnt').html(num);
        $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
        $box.find('.js-num-drop_select').children().eq(num - 1).find('a').addClass('is-current');
        $box.find('.js-num-drop_input').val(num);
        $box.find('.js-num-drop_select').removeClass('is-active');

        if ($(this).parents('.cpb-products_list_box').length > 0) {
            $(this).trigger('dropSelectMinicart');
        } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
            $(this).trigger('dropSelectCart');
        } else if ($(this).parents('.cpb-products-conut').length > 0) {
            $(this).trigger('dropSelectProduct');
        }
    });
    $(document).on('click', '.js-num-drop_drop', function (e) {
        e.preventDefault();
        var $box = $(this).closest('.js-num-drop_container');
        var eventName = '.event' + new Date().getTime();

        if ($box.find('.js-num-drop_select').hasClass('is-active')) {
            $box.find('.js-num-drop_select').removeClass('is-active');
            $(document).off(eventName);
        } else {
            var offset = $(this).offset();
            var posY = offset.top - $(window).scrollTop();
            var height = $(window).height();
            if (posY * 2 > height) {
                $box.find('.js-num-drop_select').addClass('is-up');
            } else {
                $box.find('.js-num-drop_select').removeClass('is-up');
            }

            $box.find('.js-num-drop_select').addClass('is-active');

            $(document).on('click' + eventName + ' touchend' + eventName, function (e) {
                if (!$.contains($box[0], e.target)) {
                    $box.find('.js-num-drop_select').removeClass('is-active');
                    $(document).off(eventName);
                }
            });
        }

        if ($(this).parents('.cpb-products_list_box').length > 0) {
            $(this).trigger('dropDropMinicart');
        } else if ($(this).parents('.cpb-cart-bag_box').length > 0) {
            $(this).trigger('dropDropCart');
        } else if ($(this).parents('.cpb-products-conut').length > 0) {
            $(this).trigger('dropDropProduct');
        }
    });
}

var pages = {
    account: require('./pages/account'),
    cart: require('./pages/cart'),
    checkout: require('./pages/checkout'),
    compare: require('./pages/compare'),
    product: require('./pages/product'),
    registry: require('./pages/registry'),
    orderconfirmation: require('./pages/order-confirm'),
    search: require('./pages/search'),
    tutorial: require('./pages/tutorial'),
    storefront: require('./pages/storefront'),
    wishlist: require('./pages/wishlist'),
    storelocator: require('./pages/storelocator'),
    checkorder: require('./pages/checkorder'),
    content: require('./pages/content'),
    promotionlanding: require('./pages/promotionlanding'),
    contentproduct: require('./pages/contentproduct')
};

function initWindow() {
    var existedPageContext = typeof window.pageContext !== 'undefined' && window.pageContext !== null;
    var isContentProductPage = existedPageContext && window.pageContext['ns'] === 'contentproduct';
    var isProductPage = existedPageContext && window.pageContext['ns'] === 'product';

    if (isContentProductPage || isProductPage) {
        pages['contentproduct'].init_window();
    }
}

/**
 * Events of contact us form
 */
function contactUsEvents() {
    $('input[name="dwfrm_contactus_gender"]').on('change', function () {
        $('.contact-gender').removeClass('is-error');
        $('#dwfrm_contactus_gender-error').remove();
        if ($(this).val() == '') {
            $('.contact-gender').addClass('is-error');
            $('input[name="dwfrm_contactus_gender"]').prev().append('<p id="dwfrm_contactus_gender-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }
    });

    $('input[name="dwfrm_contactus_countries_country"]').on('change', function () {
        $('.contact-region').removeClass('is-error');
        $('#dwfrm_contactus_countries_country-error').remove();
        if ($(this).val() == '') {
            $('.contact-region').addClass('is-error');
            $('input[name="dwfrm_contactus_countries_country"]').prev().append('<p id="dwfrm_contactus_countries_country-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }
    });

    $('input[name="dwfrm_contactus_myquestion"]').on('change', function () {
        $('.contact-myquestion').removeClass('is-error');
        $('#dwfrm_contactus_myquestion-error').remove();
        if ($(this).val() == '') {
            $('.contact-myquestion').addClass('is-error');
            $('input[name="dwfrm_contactus_myquestion"]').prev().append('<p id="dwfrm_contactus_myquestion-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }
    });

    $('#ContactForm').on('submit', function (e) {
        if ($('input[name="dwfrm_contactus_gender"]').val() == '') {
            e.preventDefault();
            $('input[name="dwfrm_contactus_gender"]').prev().addClass('is-error');
            $('#dwfrm_contactus_gender-error').remove();
            $('input[name="dwfrm_contactus_gender"]').prev().append('<p id="dwfrm_contactus_gender-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }

        if ($('input[name="dwfrm_contactus_countries_country"]').val() == '') {
            e.preventDefault();
            $('input[name="dwfrm_contactus_countries_country"]').prev().addClass('is-error');
            $('#dwfrm_contactus_countries_country-error').remove();
            $('input[name="dwfrm_contactus_countries_country"]').prev().append('<p id="dwfrm_contactus_countries_country-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }

        if ($('input[name="dwfrm_contactus_myquestion"]').val() == '') {
            e.preventDefault();
            $('input[name="dwfrm_contactus_myquestion"]').prev().addClass('is-error');
            $('#dwfrm_contactus_myquestion-error').remove();
            $('input[name="dwfrm_contactus_myquestion"]').prev().append('<p id="dwfrm_contactus_myquestion-error" class="is-error cmd-form_err _simple">' + Resources.VALIDATE_REQUIRED + '</p>');
        }
    });
}

initWindow();

var app = {
    init: function init() {

        $(document).foundation();

        if (document.cookie.length === 0) {
            $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
        }

        initializeDom();
        // init events for design
        design.init();
        initializeEvents();
        backToTopHandler();
        minimizedHeaderHandler();
        resetFooterError();
        responsiveMegaMenu();
        searchMenuEvent();

        // init specific global components
        analytics.init();
        countries.init();
        tooltip.init();
        minicart.init();
        validator.init();
        orderreplenishment.init();
        rating.init();
        slick.init();
        searchplaceholder.init();
        headerMenu.init();
        video.init();
        //checkoutLogin.init();
        footerSelector.countrySelector();
        newsletter.newsletterHeader();
        newsletter.isNewsletterEnabled();
        inputEntry.entry();
        playVideoHandler();
        login.init();
        quickview.init();
        dropDownEvents();
        contactUsEvents();

        // execute page specific initializations
        $.extend(page, window.pageContext);

        var ns = page.ns;

        if (ns && pages[ns] && pages[ns].init) {
            pages[ns].init();
        }

        // Check TLS status if indicated by site preference
        if (SitePreferences.CHECK_TLS === true) {
            tls.getUserAgent();
        }
    }
};

//general extension functions
(function () {
    String.format = function () {
        var s = arguments[0];
        var i,
            len = arguments.length - 1;

        for (i = 0; i < len; i++) {
            var reg = new RegExp('\\{' + i + '\\}', 'gm');

            s = s.replace(reg, arguments[i + 1]);
        }

        return s;
    };
})();

// initialize app
$(document).ready(function () {
    app.init();
    // fixed button cart
    $('.cpb-cart-checkout_fixed .cpb-cart_submit .button').on('click', function () {
        $('.cpb-cart-side_submit .button').trigger('click');
    });
});

// expose global app obj for 3rd party integrations
window.app = {
    quickView: quickview,
    minicart: minicart,
    user: window.User,
    SCemailUrl: window.Urls.SCemailUrl,
    Product: {},
    tagmanager: analytics.tagmanager,
    gtmInternalPromotion: analytics.gtmInternalPromotion
};

// expose global saveURL to support legacy Composed integration
window.saveURL = window.Urls.saveConsultationURL;
// summary scroll bar global scope
window.addSummaryScrollbar = addSummaryScrollbar;
window.scrollToTop = scrollToTop;

},{"./analytics":2,"./cookieprivacy":6,"./countries":7,"./design":8,"./dialog":9,"./footer-selector":10,"./header-menu":14,"./input-entry":15,"./jquery-ext":16,"./login":17,"./minicart":18,"./new-design":20,"./newsletter":21,"./order-replenishment":22,"./page":23,"./pages/account":24,"./pages/cart":25,"./pages/checkorder":26,"./pages/checkout":31,"./pages/compare":35,"./pages/content":36,"./pages/contentproduct":37,"./pages/order-confirm":38,"./pages/product":43,"./pages/promotionlanding":48,"./pages/registry":49,"./pages/search":50,"./pages/storefront":51,"./pages/storelocator":52,"./pages/tutorial":53,"./pages/wishlist":54,"./product-tile":55,"./quickview":58,"./rating":59,"./searchplaceholder":61,"./searchsuggest":62,"./slick":63,"./tls":67,"./tooltip":68,"./util":69,"./validator":70,"./video":71}],4:[function(require,module,exports){
'use strict';

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    modal = require('./modal').global;

var selectedList = [];
var maxItems = 1;
var bliUUID = '';

/**
 * @private
 * @function
 * description Gets a list of bonus products related to a promoted product
 */
function getBonusProducts() {
    var bonusproducts = [];

    var i, len;
    for (i = 0, len = selectedList.length; i < len; i++) {
        var p = {
            pid: selectedList[i].pid,
            qty: selectedList[i].qty,
            options: {}
        };
        var a,
            alen,
            bp = selectedList[i];
        if (bp.options) {
            for (a = 0, alen = bp.options.length; a < alen; a++) {
                var opt = bp.options[a];
                p.options = { optionName: opt.name, optionValue: opt.value };
            }
        }
        bonusproducts.push({ product: p });
    }
    return { bonusproducts: bonusproducts };
}

var selectedItemTemplate = function selectedItemTemplate(data) {
    var attributes = '';
    for (var attrID in data.attributes) {
        var attr = data.attributes[attrID];
        attributes += '<li data-attribute-id="' + attrID + '">\n';
        attributes += '<span class="display-name">' + attr.displayName + '</span>: ';
        attributes += '<span class="display-value">' + attr.displayValue + '</span>\n';
        attributes += '</li>';
    }
    attributes += '<li class="item-qty">\n';
    attributes += '<span class="display-name">Qty</span>: ';
    attributes += '<span class="display-value">' + data.qty + '</span>';
    return ['<li class="selected-bonus-item" data-uuid="' + data.uuid + '" data-pid="' + data.pid + '">', '<i class="remove-link fa fa-remove" title="Remove this product" href="#"></i>', '<div class="item-name">' + data.name + '</div>', '<ul class="item-attributes">', attributes, '<ul>', '<li>'].join('\n');
};

// hide swatches that are not selected or not part of a Product Variation Group
var hideSwatches = function hideSwatches() {
    $('.bonus-product-item:not([data-producttype="master"]) .swatches li').not('.selected').not('.variation-group-value').hide();
    // prevent unselecting the selected variant
    $('.bonus-product-item .swatches .selected').on('click', function () {
        return false;
    });
};

/**
 * @private
 * @function
 * @description Updates the summary page with the selected bonus product
 */
function updateSummary() {
    var $bonusProductList = $('#bonus-product-list');
    if (!selectedList.length) {
        $bonusProductList.find('li.selected-bonus-item').remove();
    } else {
        var ulList = $bonusProductList.find('ul.selected-bonus-items').first();
        var i, len;
        for (i = 0, len = selectedList.length; i < len; i++) {
            var item = selectedList[i];
            var li = selectedItemTemplate(item);
            $(li).appendTo(ulList);
        }
    }

    // get remaining item count
    var remain = maxItems - selectedList.length;
    $bonusProductList.find('.bonus-items-available').text(remain);
    if (remain <= 0) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    } else {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
    }
}

function initializeGrid() {
    var $bonusProduct = $('#bonus-product-dialog'),
        $bonusProductList = $('#bonus-product-list'),
        bliData = $bonusProductList.data('line-item-detail');
    maxItems = bliData.maxItems;
    bliUUID = bliData.uuid;

    if (bliData.itemCount >= maxItems) {
        $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
    }

    var cartItems = $bonusProductList.find('.selected-bonus-item');
    cartItems.each(function () {
        var ci = $(this);
        var product = {
            uuid: ci.data('uuid'),
            pid: ci.data('pid'),
            qty: ci.find('.item-qty').text(),
            name: ci.find('.item-name').html(),
            attributes: {}
        };
        var attributes = ci.find('ul.item-attributes li');
        attributes.each(function () {
            var li = $(this);
            product.attributes[li.data('attributeId')] = {
                displayName: li.children('.display-name').html(),
                displayValue: li.children('.display-value').html()
            };
        });
        selectedList.push(product);
    });

    $bonusProductList.on('click', '.bonus-product-item a[href].swatchanchor', function (e) {
        e.preventDefault();
        var url = this.href,
            $this = $(this);
        url = util.appendParamsToUrl(url, {
            'source': 'bonus',
            'format': 'ajax'
        });
        $.ajax({
            url: url,
            success: function success(response) {
                $this.closest('.bonus-product-item').empty().html(response);
                hideSwatches();
            }
        });
    }).on('change', '.input-text', function () {
        $bonusProductList.find('.select-bonus-item').removeAttr('disabled');
        $(this).closest('.bonus-product-form').find('.quantity-error').text('');
    }).on('click', '.select-bonus-item', function (e) {
        e.preventDefault();
        if (selectedList.length >= maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            $bonusProductList.find('.bonus-items-available').text('0');
            return;
        }

        var form = $(this).closest('.bonus-product-form'),
            detail = $(this).closest('.product-detail'),
            uuid = form.find('input[name="productUUID"]').val(),
            qtyVal = form.find('input[name="Quantity"]').val(),
            qty = isNaN(qtyVal) ? 1 : +qtyVal;

        if (qty > maxItems) {
            $bonusProductList.find('.select-bonus-item').attr('disabled', 'disabled');
            form.find('.quantity-error').text(Resources.BONUS_PRODUCT_TOOMANY);
            return;
        }

        var product = {
            uuid: uuid,
            pid: form.find('input[name="pid"]').val(),
            qty: qty,
            name: detail.find('.product-name').text(),
            attributes: detail.find('.product-variations').data('attributes'),
            options: []
        };

        var optionSelects = form.find('.product-option');

        optionSelects.each(function () {
            product.options.push({
                name: this.name,
                value: $(this).val(),
                display: $(this).children(':selected').first().html()
            });
        });
        selectedList.push(product);
        updateSummary();
    }).on('click', '.remove-link', function (e) {
        e.preventDefault();
        var container = $(this).closest('.selected-bonus-item');
        if (!container.data('uuid')) {
            return;
        }

        var uuid = container.data('uuid');
        var i,
            len = selectedList.length;
        for (i = 0; i < len; i++) {
            if (selectedList[i].uuid === uuid) {
                selectedList.splice(i, 1);
                break;
            }
        }
        updateSummary();
    }).on('click', '.add-to-cart-bonus', function (e) {
        e.preventDefault();
        var url = util.appendParamsToUrl(Urls.addBonusProduct, { bonusDiscountLineItemUUID: bliUUID });
        var bonusProducts = getBonusProducts();
        if (bonusProducts.bonusproducts[0].product.qty > maxItems) {
            bonusProducts.bonusproducts[0].product.qty = maxItems;
        }
        // make the server call
        $.ajax({
            type: 'POST',
            dataType: 'json',
            cache: false,
            contentType: 'application/json',
            url: url,
            data: JSON.stringify(bonusProducts)
        }).done(function () {
            // success
            page.refresh();
        }).fail(function (xhr, textStatus) {
            // failed
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        }).always(function () {
            $bonusProduct.dialog('close');
        });
    }).on('click', '#more-bonus-products', function (e) {
        e.preventDefault();
        var uuid = $('#bonus-product-list').data().lineItemDetail.uuid;

        //get the next page of choice of bonus products
        var lineItemDetail = JSON.parse($('#bonus-product-list').attr('data-line-item-detail'));
        lineItemDetail.pageStart = lineItemDetail.pageStart + lineItemDetail.pageSize;
        $('#bonus-product-list').attr('data-line-item-detail', JSON.stringify(lineItemDetail));

        var url = util.appendParamsToUrl(Urls.getBonusProducts, {
            bonusDiscountLineItemUUID: uuid,
            format: 'ajax',
            lazyLoad: 'true',
            pageStart: lineItemDetail.pageStart,
            pageSize: $('#bonus-product-list').data().lineItemDetail.pageSize,
            bonusProductsTotal: $('#bonus-product-list').data().lineItemDetail.bpTotal
        });

        $.ajax({
            type: 'GET',
            cache: false,
            contentType: 'application/json',
            url: url
        }).done(function (data) {
            //add the new page to DOM and remove 'More' link if it is the last page of results
            $('#more-bonus-products').before(data);
            if (lineItemDetail.pageStart + lineItemDetail.pageSize >= $('#bonus-product-list').data().lineItemDetail.bpTotal) {
                $('#more-bonus-products').remove();
            }
        }).fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

var bonusProductsView = {
    /**
     * @function
     * @description Open the list of bonus products selection dialog
     */
    show: function show(url) {
        var $bonusProduct = $('#bonus-product-dialog');
        // create the dialog
        dialog.open({
            target: $bonusProduct,
            url: url,
            options: {
                width: 795,
                title: Resources.BONUS_PRODUCTS
            },
            callback: function callback() {
                initializeGrid();
                hideSwatches();
            }
        });
    },
    /**
     * @function
     * @description Open bonus product promo prompt dialog
     */
    loadBonusOption: function loadBonusOption() {
        var self = this,
            bonusDiscountContainer = document.querySelector('.bonus-discount-container');
        if (!bonusDiscountContainer) {
            return;
        }

        // get the html from minicart, then trash it
        var bonusDiscountContainerHtml = bonusDiscountContainer.outerHTML;
        bonusDiscountContainer.parentNode.removeChild(bonusDiscountContainer);

        dialog.open({
            html: bonusDiscountContainerHtml,
            options: {
                width: 'auto',
                title: Resources.BONUS_PRODUCT,
                dialogClass: 'bonus-eligibility-modal',
                buttons: [{
                    text: Resources.SELECT_BONUS_PRODUCTS,
                    click: function click() {
                        var uuid = $('.bonus-product-promo').data('lineitemid'),
                            url = util.appendParamsToUrl(Urls.showBonusProducts, {
                            bonusDiscountLineItemUUID: uuid,
                            source: 'bonus',
                            format: 'ajax',
                            lazyLoad: 'false',
                            pageStart: 0,
                            pageSize: 0,
                            bonusProductsTotal: -1
                        });
                        $(this).dialog('close');
                        //self.show(url);
                        modal.addCustomClass('bonus-item-modal');
                        modal.renderByUrl(url);
                    }
                }, {
                    text: Resources.NO_THANKS,
                    click: function click() {
                        $(this).dialog('close');
                    }
                }]
            },
            callback: function callback() {
                // show hide promo details
                $('.show-promo-details').on('click', function () {
                    $('.promo-details').toggleClass('visible');
                });
            }
        });
    },

    hasBonusOptions: function hasBonusOptions() {
        return $(".bonus-discount-container").length > 0;
    }
};

module.exports = bonusProductsView;

},{"./dialog":9,"./modal":19,"./page":23,"./util":69}],5:[function(require,module,exports){
'use strict';

var page = require('./page'),
    util = require('./util'),
    TPromise = require('promise');

var _currentCategory = '',
    MAX_ACTIVE = 6;

/**
 * @private
 * @function
 * @description Verifies the number of elements in the compare container and updates it with sequential classes for ui targeting
 */
function refreshContainer() {
    var $compareContainer = $('.compare-items');
    var $compareItems = $compareContainer.find('.compare-item');
    var numActive = $compareItems.filter('.active').length;

    if (numActive < 2) {
        $('#compare-items-button').attr('disabled', 'disabled');
    } else {
        $('#compare-items-button').removeAttr('disabled');
    }

    $compareContainer.toggle(numActive > 0);
}
/**
 * @private
 * @function
 * @description Adds an item to the compare container and refreshes it
 */
function addToList(data) {
    // get the first compare-item not currently active
    var $item = $('.compare-items .compare-item').not('.active').first(),
        $productTile = $('#' + data.uuid);

    if ($item.length === 0) {
        if ($productTile.length > 0) {
            $productTile.find('.compare-check')[0].checked = false;
        }
        window.alert(Resources.COMPARE_ADD_FAIL);
        return;
    }

    // if already added somehow, return
    if ($('[data-uuid="' + data.uuid + '"]').length > 0) {
        return;
    }
    // set as active item
    $item.addClass('active').attr('data-uuid', data.uuid).attr('data-itemid', data.itemid).data('uuid', data.uuid).data('itemid', data.itemid).append($(data.img).clone().addClass('compare-item-image'));
}
/**
 * @private
 * @function
 * description Removes an item from the compare container and refreshes it
 */
function removeFromList($item) {
    if ($item.length === 0) {
        return;
    }
    // remove class, data and id from item
    $item.removeClass('active').removeAttr('data-uuid').removeAttr('data-itemid').data('uuid', '').data('itemid', '')
    // remove the image
    .find('.compare-item-image').remove();
}

function addProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareAdd,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_ADD_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function removeProductAjax(args) {
    var promise = new TPromise(function (resolve, reject) {
        $.ajax({
            url: Urls.compareRemove,
            data: {
                pid: args.itemid,
                category: _currentCategory
            },
            dataType: 'json'
        }).done(function (response) {
            if (!response || !response.success) {
                reject(new Error(Resources.COMPARE_REMOVE_FAIL));
            } else {
                resolve(response);
            }
        }).fail(function (jqxhr, status, err) {
            reject(new Error(err));
        });
    });
    return promise;
}

function shiftImages() {
    return new TPromise(function (resolve) {
        var $items = $('.compare-items .compare-item');
        $items.each(function (i, item) {
            var $item = $(item);
            // last item
            if (i === $items.length - 1) {
                return removeFromList($item);
            }
            var $next = $items.eq(i + 1);
            if ($next.hasClass('active')) {
                // remove its own image
                $next.find('.compare-item-image').detach().appendTo($item);
                $item.addClass('active').attr('data-uuid', $next.data('uuid')).attr('data-itemid', $next.data('itemid')).data('uuid', $next.data('uuid')).data('itemid', $next.data('itemid'));
            }
        });
        resolve();
    });
}

/**
 * @function
 * @description Adds product to the compare table
 */
function addProduct(args) {
    var promise;
    var $items = $('.compare-items .compare-item');
    var $cb = $(args.cb);
    var numActive = $items.filter('.active').length;
    if (numActive === MAX_ACTIVE) {
        if (!window.confirm(Resources.COMPARE_CONFIRMATION)) {
            $cb[0].checked = false;
            return;
        }

        // remove product using id
        var $firstItem = $items.first();
        promise = removeItem($firstItem).then(function () {
            return shiftImages();
        });
    } else {
        promise = TPromise.resolve(0);
    }
    return promise.then(function () {
        return addProductAjax(args).then(function () {
            addToList(args);
            if ($cb && $cb.length > 0) {
                $cb[0].checked = true;
            }
            refreshContainer();
        });
    }).then(null, function () {
        if ($cb && $cb.length > 0) {
            $cb[0].checked = false;
        }
    });
}

/**
 * @function
 * @description Removes product from the compare table
 * @param {object} args - the arguments object should have the following properties: itemid, uuid and cb (checkbox)
 */
function removeProduct(args) {
    var $cb = args.cb ? $(args.cb) : null;
    return removeProductAjax(args).then(function () {
        var $item = $('[data-uuid="' + args.uuid + '"]');
        removeFromList($item);
        if ($cb && $cb.length > 0) {
            $cb[0].checked = false;
        }
        refreshContainer();
    }, function () {
        if ($cb && $cb.length > 0) {
            $cb[0].checked = true;
        }
    });
}

function removeItem($item) {
    var uuid = $item.data('uuid'),
        $productTile = $('#' + uuid);
    return removeProduct({
        itemid: $item.data('itemid'),
        uuid: uuid,
        cb: $productTile.length === 0 ? null : $productTile.find('.compare-check')
    });
}

/**
 * @private
 * @function
 * @description Initializes the DOM-Object of the compare container
 */
function initializeDom() {
    var $compareContainer = $('.compare-items');
    _currentCategory = $compareContainer.data('category') || '';
    var $active = $compareContainer.find('.compare-item').filter('.active');
    $active.each(function () {
        var $productTile = $('#' + $(this).data('uuid'));
        if ($productTile.length === 0) {
            return;
        }
        $productTile.find('.compare-check')[0].checked = true;
    });
    // set container state
    refreshContainer();
}

/**
 * @private
 * @function
 * @description Initializes the events on the compare container
 */
function initializeEvents() {
    // add event to buttons to remove products
    $('.compare-item').on('click', '.compare-item-remove', function () {
        removeItem($(this).closest('.compare-item'));
    });

    // Button to go to compare page
    $('#compare-items-button').on('click', function () {
        page.redirect(util.appendParamToURL(Urls.compareShow, 'category', _currentCategory));
    });

    // Button to clear all compared items
    // rely on refreshContainer to take care of hiding the container
    $('#clear-compared-items').on('click', function () {
        $('.compare-items .active').each(function () {
            removeItem($(this));
        });
    });
}

exports.init = function () {
    initializeDom();
    initializeEvents();
};

exports.addProduct = addProduct;
exports.removeProduct = removeProduct;

},{"./page":23,"./util":69,"promise":77}],6:[function(require,module,exports){
'use strict';

var dialog = require('./dialog');

/**
 * @function cookieprivacy    Used to display/control the scrim containing the cookie privacy code
 **/
module.exports = function () {
    /**
     * If we have not accepted cookies AND we're not on the Privacy Policy page, then show the notification
     * NOTE: You will probably want to adjust the Privacy Page test to match your site's specific privacy / cookie page
     */
    if (SitePreferences.COOKIE_HINT === true && document.cookie.indexOf('dw_cookies_accepted') < 0) {
        // check for privacy policy page
        if ($('.privacy-policy').length === 0) {
            dialog.open({
                url: Urls.cookieHint,
                options: {
                    closeOnEscape: false,
                    dialogClass: 'no-close',
                    buttons: [{
                        text: Resources.I_AGREE,
                        click: function click() {
                            $(this).dialog('close');
                            enableCookies();
                        }
                    }]
                }
            });
        }
    } else {
        // Otherwise, we don't need to show the asset, just enable the cookies
        enableCookies();
    }

    function enableCookies() {
        if (document.cookie.indexOf('dw=1') < 0) {
            document.cookie = 'dw=1; path=/';
        }
        if (document.cookie.indexOf('dw_cookies_accepted') < 0) {
            document.cookie = 'dw_cookies_accepted=1; path=/';
        }
    }
};

},{"./dialog":9}],7:[function(require,module,exports){
'use strict';

exports.init = function init() {
    $('.country-selector .current-country').on('click', function () {
        $('.country-selector .selector').toggleClass('active');
        $(this).toggleClass('selector-active');
    });
    // set currency first before reload
    $('.country-selector .selector .locale').on('click', function (e) {
        e.preventDefault();
        var url = this.href;
        var currency = this.getAttribute('data-currency');
        $.ajax({
            dataType: 'json',
            url: Urls.setSessionCurrency,
            data: {
                format: 'ajax',
                currencyMnemonic: currency
            }
        }).done(function (response) {
            if (!response.success) {
                throw new Error('Unable to set currency');
            }
            window.location.href = url;
        });
    });
};

},{}],8:[function(require,module,exports){
'use strict';

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var design = {
    init: function init() {
        //product search
        this.productSearchInit();

        //product list
        this.plpInit();

        //PDP
        this.pdpInit();

        //tmp_video
        this.tmpVideoInit();

        //tmp_recently
        this.tmpRecentlyInit();

        //tmp_image
        this.tmpImageInit();

        this.commonInit();
    },
    tmpImageInit: function tmpImageInit() {
        $(function () {
            $('.c-block-template_02-slider-main').slick({
                asNavFor: ".c-block-template_02-slider-thumbnail",
                arrows: false,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        dots: true
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: false
                    }
                }]
            });
            $('.c-block-template_02-slider-thumbnail').slick({
                asNavFor: ".c-block-template_02-slider-main",
                slidesToShow: 4,
                slidesToScroll: 1,
                focusOnSelect: true
            });
        });
    },
    plpInit: function plpInit() {
        $(function () {
            $('.c-product-cards-color-more>a').off('click').on('click', function () {
                $(this).closest('.c-product-cards-color').addClass('is-active');
                $(this).closest('.c-product-cards-color').find('.c-list-color.is-hidden').removeClass('is-hidden');
                $(this).parent().addClass('is-hidden');
                matchHeightProducts();
                return false;
            });

            $('.c-list-color li > a').on('click mousehover', function () {
                if (window.innerWidth > 767) {
                    var thumbIndex = $(this).closest('.c-product-cards-color-list').find('a').index(this);
                    $(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').stop().hide();
                    $(this).closest('.c-product-cards').find('.c-list-color-panel').removeClass('is-current');
                    if ($(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').eq(thumbIndex).is(':hidden')) {
                        $(this).closest('.c-product-cards').find('.c-product-cards-photo-img > img').eq(thumbIndex).fadeIn("slow");
                        $(this).children('.c-list-color-panel').addClass('is-current');
                    }
                    return false;
                }
            });

            // SP size When there is nothing to display on Filter "Filter" itself is not displayed.
            if (window.innerWidth < 991 && $('.c-block-products-search-panel--filter li').length == 0) {
                $('.c-block-products-search-tabs--filter').remove();
                $('.c-block-products-search-panel--filter').remove();
            }

            // $('.c-list-color li > a').hover(function(){
            // 	if(window.innerWidth>991) {
            // 		$(this).trigger('mousehover');
            // 	}
            // });
        });
    },
    selectGiftInit: function selectGiftInit() {
        $(function () {
            $('.c-block-shopingmodal .c-list-color a').on('colorSelect', function () {
                var element = $(this).closest('.c-list-color').find('a').index(this);
                $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-change-image').each(function () {
                    $(this).children().stop().hide(), $(this).children().eq(element).fadeIn();
                });
                $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').removeClass('is-selected');
                $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').eq(element).addClass('is-selected');
                var text = $(this).closest('.c-block-shopingmodal').find('.c-select-list-item>a.is-selected .c-select-list-item-text').html();
                $(this).closest('.c-block-shopingmodal').find('.c-block-shopingmodal-side-colorSelect .c-select-current').html(text);
                $(this).closest(".c-list-color").find(".c-list-color-panel").removeClass("is-current");
                $(this).children(".c-list-color-panel").addClass("is-current");
            });

            $('.c-block-shopingmodal .c-list-color a').on('click', function () {
                if (767 < window.innerWidth) {
                    var element = $(this).closest('.c-list-color').find('a').index(this);
                    $('.c-block-shopingmodal .c-list-color a').eq(element).trigger('colorSelect');
                }
            });

            $('.c-block-shopingmodal-side-colorSelect .c-select-list-item a').on('click', function () {
                var element = $(this).closest('.c-select-list').find('a').index(this);
                $('.c-block-shopingmodal .c-list-color a').eq(element).trigger('colorSelect');
                return false;
            });
        });
    },
    selectQuantityInit: function selectQuantityInit() {
        $(function () {
            //countup
            $('.c-quantitySelection-btn-plus a').off('click').on('click', function () {
                var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
                var currentNum = current.html();
                var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
                var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();
                currentNum++;
                var qtyReal = limit;
                if (currentNum <= limit) {
                    current.html(currentNum);
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
                    qtyReal = currentNum;
                }

                $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
                return false;
            });

            //countdown
            $('.c-quantitySelection-btn-minus a').off('click').on('click', function () {
                var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
                var currentNum = current.html();
                var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
                var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();

                var qtyReal = 1;
                if (currentNum > 1) {
                    currentNum--;
                    current.html(currentNum);
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
                    qtyReal = currentNum;
                } else if (currentNum == 0) {
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                }

                $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
                return false;
            });

            // Change quantity on cart
            $('.c-list-products-full-item--cart .c-quantitySelection-btn-plus a').off('click').on('click', function () {
                var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
                var currentNum = current.html();
                var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
                var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();
                currentNum++;
                var qtyReal = limit;
                if (currentNum <= limit) {
                    current.html(currentNum);
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
                    qtyReal = currentNum;
                }

                $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
                $(this).parents(".c-quantitySelection").find('input[type="hidden"]').val(qtyReal);
                $('input[name$=_deleteGiftCertificate]').remove();
                $('input[name$=_deleteProduct]').remove();
                $(this).closest('form').submit();
            });

            $('.c-list-products-full-item--cart .c-quantitySelection-btn-minus a').off('click').on('click', function () {
                var current = $(this).closest('.c-quantitySelection').find('.c-select-current');
                var currentNum = current.html();
                var limit = $(this).closest('.c-quantitySelection').find('.c-select-list-item').length;
                var index = $(this).closest('.c-quantitySelection').find('.c-select-list-item').index();

                var qtyReal = 1;
                if (currentNum > 1) {
                    currentNum--;
                    current.html(currentNum);
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').eq(currentNum - 1).children('a').addClass('is-selected');
                    qtyReal = currentNum;
                } else if (currentNum == 0) {
                    $(this).closest('.c-quantitySelection').find('.c-select-list-item').children('a').removeClass('is-selected');
                }

                $(this).closest('.c-quantitySelection-btn-gather').prev().val(qtyReal);
                $(this).parents(".c-quantitySelection").find('input[type="hidden"]').val(qtyReal);
                $('input[name$=_deleteGiftCertificate]').remove();
                $('input[name$=_deleteProduct]').remove();
                $(this).closest('form').submit();
            });
        });
    },
    toggleSelectInit: function toggleSelectInit(eventContinue) {
        $(function () {
            // select open
            $('.c-dropdown-toggle').off('click').on('click', function () {
                if (!$(this).parents('.c-block-review').length) {
                    if ($(this).parents('.c-dropdown').find('.c-select-list').is(':hidden')) {
                        $('.c-select-list').hide();
                        $(this).parents('.c-dropdown').find('.c-select-list').show();
                    } else {
                        $(this).parents('.c-dropdown').find('.c-select-list').hide();
                    }
                    return false;
                }
            });
        });

        $(function () {
            eventContinue = eventContinue || false;

            // select
            $('.c-select-toggle').off('click').on('click', function () {
                if ($(this).next('.c-select-list').is(':hidden') && !$(this).hasClass('is-noselect')) {
                    $('.c-select-list').hide();
                    $(this).next('.c-select-list').show();

                    // Auto up down display
                    var offset = $(this).offset();
                    var posY = offset.top - $(window).scrollTop();
                    var heightS = $(window).height();
                    if (posY * 2 > heightS) {
                        $(this).next('.c-select-list').addClass('up');
                    } else {
                        $(this).next('.c-select-list').removeClass('up');
                    }
                } else {
                    $(this).next('.c-select-list').hide();
                }
            });

            $('.c-select-list-item a').off('click').on('click', function (e) {
                e.preventDefault();
                var current = $(this).closest('.c-select').find('.c-select-current');
                var value = $(this).data('v') || $(this).find('span').data('num'); // form field and quantity selector
                var displayValue = $(this).children('.c-select-list-item-text').html();
                $(this).closest('.c-select-list').find('.c-select-list-item').children('a').removeClass('is-selected');
                $(this).addClass('is-selected');
                current.html(displayValue);
                $(this).closest('.c-select-list').hide();
                $(this).closest('.c-select').nextAll('input').val(value);
                $(this).closest('.c-select').nextAll('input').change();

                if ($(this).closest('.c-block-shopingmodal-side-colorSelect').length > 0 || $(this).closest('.c-block-shoppingDock').length > 0) {
                    var index = $(this).closest('.c-select-list').find('a').index(this);
                    if ($(this).closest('.c-block-shopingmodal-set-item').length > 0) {
                        $(this).closest('.c-block-shopingmodal-set-item').find('.c-list-color a').eq(index).trigger('colorSelect');
                    }

                    if ($(this).closest('.product-variations').length > 0) {
                        $(this).closest('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
                    }

                    if ($(this).closest('.c-block-shoppingDock').length > 0) {
                        $('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
                    }
                }
                return eventContinue;
            });

            $('.c-list-products-full-item--cart .c-select-list-item a').off('click').on('click', function (e) {
                e.preventDefault();
                var current = $(this).closest('.c-select').find('.c-select-current');
                var value = $(this).data('v') || $(this).find('span').data('num'); // form field and quantity selector
                var displayValue = $(this).children('.c-select-list-item-text').html();
                $(this).closest('.c-select-list').find('.c-select-list-item').children('a').removeClass('is-selected');
                $(this).addClass('is-selected');
                current.html(displayValue);
                $(this).closest('.c-select-list').hide();
                $(this).closest('.c-select').next().val(value);
                $(this).closest('.c-select').next().change();

                if ($(this).closest('.c-block-shopingmodal-side-colorSelect')) {
                    var index = $(this).closest('.c-select-list').find('a').index(this);
                    if ($(this).closest('.c-block-shopingmodal-set-item')) {
                        $(this).closest('.c-block-shopingmodal-set-item').find('.c-list-color a').eq(index).trigger('colorSelect');
                    }

                    if ($(this).closest('.product-variations')) {
                        $(this).closest('.product-variations').find('.c-list-color a').eq(index).trigger('colorSelect');
                    }
                }
                var quantity = $(this).closest('.c-quantitySelection').find('.c-select-current').text();
                $(this).closest('.c-quantitySelection').find('input[type="hidden"]').val(quantity);
                $('input[name$=_deleteGiftCertificate]').remove();
                $('input[name$=_deleteProduct]').remove();
                $(this).closest('form').submit();
            });

            $(document).on('touchstart click', function (e) {
                if (!$(e.target).closest('.c-select').length && !$(e.target).closest('.c-dropdown').length) {
                    $('.c-select-list').hide();
                }
            });
        });
    },
    productSearchInit: function productSearchInit() {
        $(window).on('load resize', function () {
            if (window.innerWidth > 767) {
                setTimeout(function () {
                    matchHeightProducts();
                }, 50);
            }
        });

        $(function () {
            $('.c-block-products-search-tabs .tab').off('click').on('click', function () {
                if (window.innerWidth < 991) {
                    var num = $(this).closest('.c-block-products-search-tabs').find('.tab').index(this);
                    if ($(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).is(':hidden')) {
                        $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').removeClass('is-active');
                        $('.c-block-products-search-tabs .tab').removeClass('is-active');
                        $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).addClass('is-active');
                        $(this).addClass('is-active');
                    } else {
                        $(this).closest('.c-block-products-search-tabs').next('.c-block-products-search-panels').find('.c-block-products-search-panel').eq(num).removeClass('is-active');
                        $(this).removeClass('is-active');
                    }
                    return false;
                }
            });
        });
    },
    modalInit: function modalInit() {
        $.extend(true, $.magnificPopup.defaults, {
            tClose: Resources.POPUP_CLOSE,
            tLoading: Resources.POPUP_LOADING,
            gallery: {
                tPrev: Resources.POPUP_PREVIOUS,
                tNext: Resources.POPUP_NEXT,
                tCounter: Resources.POPUP_COUNTER
            },
            image: {
                tError: Resources.POPUP_ERROR
            }
        });

        $('.c-modal-img').magnificPopup({
            type: 'image',
            removalDelay: 500,
            fixedContentPos: true,
            callbacks: {
                open: function open() {
                    $(".mfp-container").addClass("row");
                    $.magnificPopup.instance.close = function () {
                        if (window.innerWidth < 992) {
                            var scrollpos = $('body').attr('data-scroll');
                            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                        }
                        $.magnificPopup.proto.close.call(this);
                    };
                }
            }

        });

        $('.c-modal-video').each(function () {
            var link = $(this).attr('href');
            $(this).magnificPopup({
                type: 'iframe',
                removalDelay: 600,
                fixedContentPos: true,
                iframe: {
                    patterns: {
                        youtube: {
                            src: link
                        }
                    }
                },
                callbacks: {
                    open: function open() {
                        $(".mfp-container").addClass("row");
                        $.magnificPopup.instance.close = function () {
                            if (window.innerWidth < 992) {
                                var scrollpos = $('body').attr('data-scroll');
                                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                            }
                            $.magnificPopup.proto.close.call(this);
                        };
                    }
                }
            });
        });

        $('.c-modal-video-fullscreen').each(function () {
            var link = $(this).attr('href');
            $(this).magnificPopup({
                type: 'iframe',
                removalDelay: 600,
                fixedContentPos: true,
                iframe: {
                    patterns: {
                        youtube: {
                            src: link
                        }
                    }
                },
                callbacks: {
                    open: function open() {
                        $(".mfp-container").addClass("row mfp-iframe-holder-fullscreen");
                        $.magnificPopup.instance.close = function () {
                            if (window.innerWidth < 992) {
                                var scrollpos = $('body').attr('data-scroll');
                                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                            }
                            $.magnificPopup.proto.close.call(this);
                        };
                    }
                }
            });
        });

        $('.c-modal-inline').magnificPopup({
            type: 'inline',
            removalDelay: 500,
            preloader: false,
            fixedContentPos: true,
            callbacks: {
                open: function open() {
                    $(".mfp-container").addClass("row");
                    $(".mfp-content > div").addClass("row");
                    $('.slick-slider').slick('setPosition');
                    $('.c-slider-products-landscape').slick('setPosition');
                    $('.c-slider-products-vertical').slick('setPosition');
                    matchHeightProducts();
                    if ($('.c-block-sampleselection-body').length) {
                        $('.c-block-sampleselection-body').getNiceScroll().resize();
                    }
                    $.magnificPopup.instance.close = function () {
                        if (window.innerWidth < 992) {
                            var scrollpos = $('body').attr('data-scroll');
                            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                        }
                        $.magnificPopup.proto.close.call(this);
                    };
                }
            }
        });

        $('.c-modal-autoreplenishment').on("click", function (e) {
            if ($.magnificPopup.instance.st !== undefined) {
                e.stopPropagation();
                $.magnificPopup.instance.st.callbacks = {
                    afterClose: function afterClose() {
                        if ($('#shopingmodal').length > 0) {
                            e.stopPropagation();
                            $.magnificPopup.open({
                                items: {
                                    src: '#shopingmodal',
                                    type: 'inline',
                                    removalDelay: 500
                                }
                            });
                        }
                    }
                };
            }

            $.magnificPopup.open({
                items: {
                    src: '#autoreplenishmentmodal',
                    type: 'inline',
                    removalDelay: 500
                }
            });
        });

        $(document).on("click", '.c-block-share-toggle.c-modal', function (e) {
            if ($.magnificPopup.instance.st !== undefined) {
                e.stopPropagation();
                $.magnificPopup.instance.st.callbacks = {
                    afterClose: function afterClose() {
                        if ($('#shopingmodal').length > 0) {
                            e.stopPropagation();
                            $.magnificPopup.open({
                                items: {
                                    src: '#shopingmodal',
                                    type: 'inline',
                                    removalDelay: 500
                                }
                            });
                        }
                    }
                };
            }

            $.magnificPopup.open({
                items: {
                    src: '#sharemodal',
                    type: 'inline',
                    removalDelay: 500
                }
            });
        });

        $('.c-modal-inline--noclose').magnificPopup({
            type: 'inline',
            removalDelay: 500,
            preloader: false,
            fixedContentPos: true,
            showCloseBtn: false,
            closeOnBgClick: false,
            callbacks: {
                open: function open() {
                    $(".mfp-container").addClass("row");
                    $(".mfp-content > div").addClass("row");
                    matchHeightProducts();
                    $.magnificPopup.instance.close = function () {
                        if (window.innerWidth < 992) {
                            var scrollpos = $('body').attr('data-scroll');
                            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                        }
                        $.magnificPopup.proto.close.call(this);
                    };
                }
            }
        });

        $('.c-modal-finish').click(function (e) {
            $.magnificPopup.open({
                items: {
                    src: $('#finishmodal')
                },
                type: 'inline',
                removalDelay: 500,
                preloader: false,
                fixedContentPos: true,
                showCloseBtn: false,
                closeOnBgClick: false,
                callbacks: {
                    open: function open() {
                        $(".mfp-container").addClass("row");
                        $(".mfp-content > div").addClass("row");
                        matchHeightProducts();
                        $.magnificPopup.instance.close = function () {
                            if (window.innerWidth < 992) {
                                var scrollpos = $('body').attr('data-scroll');
                                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                            }
                            $.magnificPopup.proto.close.call(this);
                        };
                    }
                }

            });
            return e.preventDefault();
        });

        $('.c-modal-gallery').magnificPopup({
            delegate: 'a',
            type: 'image',
            removalDelay: 500,
            fixedContentPos: true,
            gallery: {
                enabled: true
            },
            image: {
                titleSrc: function titleSrc(item) {
                    return item.el.attr('title') || item.el.find('img').attr('alt');
                }
            },
            callbacks: {
                open: function open() {
                    $(".mfp-container").addClass("row");
                    $.magnificPopup.instance.close = function () {
                        if (window.innerWidth < 992) {
                            var scrollpos = $('body').attr('data-scroll');
                            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                        }
                        $.magnificPopup.proto.close.call(this);
                    };
                }
            }
        });

        $('.c-modal-iframe').magnificPopup({
            type: 'iframe',
            removalDelay: 500,
            fixedContentPos: true,
            preloader: false
        });

        $('.c-modal-cart-alert').magnificPopup({
            type: 'inline',
            removalDelay: 500,
            fixedContentPos: true,
            preloader: false
        });

        $(document).off('click', '.c-modal').on('click', '.c-modal', function (e) {
            if (window.innerWidth < 992) {
                var scrollpos = $(window).scrollTop();
                $('body').attr('data-scroll', scrollpos);
                $('body').addClass('is-noscroll').css({ 'top': -scrollpos });
            }
        });
        $('.c-modal-close').off('click').on('click', function (e) {
            e.preventDefault();
            $.magnificPopup.instance.close = function () {
                if (window.innerWidth < 992) {
                    var scrollpos = $('body').attr('data-scroll');
                    $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                }
                $.magnificPopup.proto.close.call(this);
            };
            var magnificPopup = $.magnificPopup.instance;
            magnificPopup.close();
        });
        $('.c-modal-cart-alert-close').off('click').on('click', function (e) {
            e.preventDefault();
            $.magnificPopup.instance.close = function () {
                if (window.innerWidth < 992) {
                    var scrollpos = $('body').attr('data-scroll');
                    $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                }
                $.magnificPopup.proto.close.call(this);
            };
        });
    },
    footerInit: function footerInit() {
        $(function () {
            $('.ge-changeregion-toggle').off('click').on('click', function () {
                var scrollpos;
                if ($('.ge-changeregion').is(':hidden')) {
                    var scroll_bar = window.innerWidth - $(window).width();
                    if ($('.ge-navi-list').is(':visible') || window.innerWidth < 992) {
                        var scrollpos = $('body').attr('data-scroll');
                        $('body').attr('data-scroll', scrollpos);
                        $('body').addClass('is-noscroll').css({ 'top': -scrollpos });
                    } else {
                        var scrollpos = $(window).scrollTop();
                        $('body').attr('data-scroll', scrollpos);
                        $('body').addClass('is-noscroll').css({ 'top': -scrollpos });
                    }

                    $('.ge-changeregion').fadeIn();
                    $('.slick-slider').slick('setPosition');
                    $('.ge-changeregion-close').css('padding-right', scroll_bar);
                    if ($('.ge-changeregion-results-list').length) {
                        $('.ge-changeregion').addClass('is-result');
                    } else {
                        $('.ge-changeregion').removeClass('is-result');
                    }
                    if (window.innerWidth < 992) {
                        $('.ge-naviSpToggle').removeClass('is-active');
                        $('.ge-header').removeClass('is-active');
                        $('.ge-navi').fadeOut();
                    }
                }
                return false;
            });
            $('.ge-changeregion-close a').off('click').on('click', function () {
                var scrollpos = $('body').attr('data-scroll');
                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                $('.ge-changeregion').fadeOut();
                $('.ge-changeregion').removeClass('is-result');
                return false;
            });
        });
    },
    headerInit: function headerInit() {
        $(function () {
            $('.js-navi-toggle a').off('click').on('click', function (e) {
                $('.ge-header').toggleClass('is-naviOpen');
                $(this).parent().toggleClass('is-active');
                $('.js-navi-list').slideToggle();
                return false;
            });

            //PC MEGA MENU item hover
            $('.ge-navi-list-first-text > a').hover(function () {
                if (window.innerWidth > 992) {
                    $('.ge-navi-list-first-panel').not(this).stop().fadeOut();
                    $('.ge-navi-list-first-text > a').not(this).removeClass('is-active');
                    $(this).addClass('is-active');
                    $(this).parent('.ge-navi-list-first-text ').next('.ge-navi-list-first-panel').stop().fadeIn();
                }
            });

            //TABLET, MOBILE Navi open
            $('.ge-naviSpToggle > a').off('click').on('click', function () {
                var scrollpos = 0;
                if ($('.ge-navi').is(':hidden')) {
                    $('.ge-navi').fadeIn();
                    $('.ge-header').addClass('is-active');
                    if (window.innerWidth < 992 || $('body').hasClass('is-noscroll')) {
                        var scrollpos = $(window).scrollTop();
                        $('body').attr('data-scroll', scrollpos);
                        $(this).parent().addClass('is-active');
                        $('body').addClass('is-noscroll').css({ 'top': -scrollpos });
                    }
                } else {
                    $('.ge-navi').fadeOut();
                    $('.ge-header').removeClass('is-active');
                    if (window.innerWidth < 992) {
                        var scrollpos = $('body').attr('data-scroll');
                        $(this).parent().removeClass('is-active');
                        $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                    }
                }
                return false;
            });

            $(document).on('click', function (e) {
                if (!$(e.target).closest('.ge-header').length) {
                    $('.js-navi-toggle').removeClass('is-active');
                    $('.ge-header').removeClass('is-naviOpen');
                    $('.ge-navi-gather>li').removeClass('is-active');
                    $('.ge-naviSpToggle').removeClass('is-active');
                    if (window.innerWidth > 992) {
                        $('.js-navi-list').slideUp();
                    } else {
                        $('.ge-navi').slideUp();
                    }
                }
            });
        });

        this.dropdownToggleInit();

        $(function () {
            $('.ge-navi-list-dropdown-toggle,.ge-navi-list-dropdown-toggleText').off('click').on('click', function () {
                if (window.innerWidth < 992) {
                    if ($(this).parent().next('.ge-navi-list-dropdown-panel').is(':hidden')) {
                        $(this).parent().next('.ge-navi-list-dropdown-panel').slideDown();
                        $(this).parent().addClass('is-active');
                    } else {
                        $(this).parent().next('.ge-navi-list-dropdown-panel').slideUp();
                        $(this).parent().removeClass('is-active');
                    }
                }
            });
            //TABLET, MOBILE Navi item open
            $('.ge-naviSp-dropdown-toggle').off('click').on('click', function () {
                if ($(this).next('.ge-naviSp-dropdown-panel').is(':hidden')) {
                    $(this).next('.ge-naviSp-dropdown-panel').slideDown();
                    $(this).parent().addClass('is-active');
                } else {
                    $(this).next('.ge-naviSp-dropdown-panel').slideUp();
                    $(this).parent().removeClass('is-active');
                }
            });

            //public header scroll
            geHeaderScroll();
            $(document).on('scroll', function () {
                geHeaderScroll();
            });
            function geHeaderScroll() {
                var scroll = $(window).scrollTop();
                if (scroll >= 1) {
                    $('.ge-header').addClass('is-scroll');
                } else {
                    if (!$('body').hasClass('is-noscroll')) {
                        $('.ge-header').removeClass('is-scroll');
                    }
                }
            }
        });
    },
    dropdownToggleInit: function dropdownToggleInit() {
        function headerNavScroll() {
            $('.ge-dropdown-cart-list').niceScroll({
                cursorcolor: "#D7D7D7",
                cursoropacitymin: 0.3,
                cursorwidth: 6,
                autohidemode: false
            });
            $(document).ready(function () {
                setTimeout(function () {
                    if ($('.c-block-sampleselection-body').length) {
                        $('.c-block-sampleselection-body').niceScroll("ul", {
                            cursorcolor: "#D7D7D7",
                            cursoropacitymin: 0.3,
                            cursorwidth: 6,
                            autohidemode: false
                        });
                    }
                }, 50);
            });
        }
        headerNavScroll();
        $(window).on('resize', function () {
            headerNavScroll();
        });
        $(function () {
            $('.ge-dropdown:not(.ge-dropdown--cart) > a').off('click').on('click', function () {
                if (window.innerWidth > 767) {
                    if ($(this).next('.ge-dropdown-box').is(':hidden')) {
                        $('.ge-dropdown').removeClass('is-active');
                        $('.ge-dropdown-box').fadeOut();
                        $(this).next('.ge-dropdown-box').fadeIn();
                        $(this).parent().addClass('is-active');
                        if ($(this).closest('.ge-dropdown').find('.ge-dropdown-cart-list').length) {
                            $('.ge-dropdown-cart-list').getNiceScroll().resize();
                        }
                    } else {
                        $(this).next('.ge-dropdown-box').fadeOut(0);
                        $(this).parent().removeClass('is-active');
                    }
                    return false;
                } else {
                    if ($(this).parent()[0].id === 'mini-cart') {
                        location.href = $(this).next('div').children('.ge-dropdown-cart-button').children('ul').children('li').children('a')[0].href;
                    }
                }
            });
            var getDevice = function () {
                var ua = navigator.userAgent;
                if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
                    return 'sp';
                } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
                    return 'tab';
                } else {
                    return 'other';
                }
            }();
            $('.ge-dropdown--cart').mouseenter(function () {
                if (window.innerWidth > 992 && getDevice == 'other') {
                    if ($(this).find('.ge-dropdown-box').is(':hidden')) {
                        $('.ge-dropdown').stop().removeClass('is-active');
                        $('.ge-dropdown-box').stop().fadeOut();
                        $(this).stop().addClass('is-active');
                        $(this).find('.ge-dropdown-box').stop().fadeIn(0);
                        $('.ge-dropdown-cart-list').niceScroll({
                            cursorcolor: "#D7D7D7",
                            cursoropacitymin: 0.3,
                            cursorwidth: 6,
                            autohidemode: false
                        });
                        $('.ge-dropdown-cart-list').getNiceScroll().resize();
                        headerNavScroll();
                    }
                }
            });
            $('.ge-dropdown--cart').mouseleave(function () {
                if (window.innerWidth > 992 && getDevice == 'other') {
                    if (!$(this).find('.ge-dropdown-box').is(':hidden')) {
                        $(this).find('.ge-dropdown-box').stop('true', 'true').fadeOut(0);
                        $(this).stop().removeClass('is-active');
                        headerNavScroll();
                    }
                }
            });
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.ge-dropdown').length && !$(e.target).closest('.ge-search').length && !$(e.target).hasClass('.c-modal') && !$(e.target).closest('.mfp-wrap').length) {
                    if (window.innerWidth > 992) {
                        var scrollpos = $('body').attr('data-scroll');
                        $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                    }
                    $('.ge-dropdown').removeClass('is-active');
                    $('.ge-dropdown-box').fadeOut();
                }
            });
        });
    },
    searchInit: function searchInit() {
        $(function () {
            //search open
            $('.ge-search-toggle').off('click').on('click', function () {
                var scrollpos;
                if ($('.ge-search').is(':hidden')) {
                    var scrollpos = $(window).scrollTop();
                    var scroll_bar = window.innerWidth - $(window).width();
                    $('body').attr('data-scroll', scrollpos);
                    $('body').addClass('is-noscroll').css({ 'top': -scrollpos });
                    $('.ge-search').fadeIn();
                    $('.slick-slider').slick('setPosition');
                    $('.ge-search-close').css('padding-right', scroll_bar);
                    if ($('.ge-search-results-list').length) {
                        $('.ge-search').addClass('is-result');
                    } else {
                        $('.ge-search').removeClass('is-result');
                    }
                }
                return false;
            });

            //search close
            $('.ge-search-close a').off('click').on('click', function () {
                var scrollpos = $('body').attr('data-scroll');
                $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                $('.ge-search').fadeOut();
                $('.ge-search').removeClass('is-result');
                return false;
            });

            //search reset
            $('.ge-search-input .c-input-btn-reset').off('click').on('click', function () {
                $(this).closest('.ge-search-input').find('.c-input-box').attr('value', '');
                $(this).closest('.ge-search-input').find('.c-input-btn-search').prop('disabled', true);
                $(this).fadeOut();
                $(this).closest('.ge-search-input').find('.c-input-btn-search').fadeIn();
                return false;
            });

            $(window).on('load', function () {
                $('.ge-search-input').each(function () {
                    var value = $(this).find('.c-input-box').val();
                    if (value == "" && value != value) {
                        $(this).find('.c-input-btn-reset').fadeOut();
                        $(this).find('.c-input-btn-search').fadeIn();
                    }
                });
            });
            $('.ge-search-input .c-input-box').on('change keypress keyup', function () {
                $('.ge-search-input').each(function () {
                    var value = $(this).find('.c-input-box').val();
                    $(this).find('.c-input-btn-reset').fadeOut();
                    $(this).find('.c-input-btn-search').fadeIn();
                });
            });
            //search disabled
            $('input[type="search"]').on('change keypress keyup', function () {
                if ($(this).val() == "") {
                    $(this).parent().find('.c-input-btn-search').prop('disabled', true);
                } else {
                    $(this).parent().find('.c-input-btn-search').prop('disabled', false);
                }
            });
            matchHeightProducts();
        });
    },
    tmpRecentlyInit: function tmpRecentlyInit() {
        $(function () {
            $('.c-slider-recently').on('init', function () {
                $('.c-modal-inline').magnificPopup({
                    type: 'inline',
                    removalDelay: 500,
                    preloader: false,
                    fixedContentPos: true,
                    callbacks: {
                        open: function open() {
                            $(".mfp-container").addClass("row");
                            $(".mfp-content > div").addClass("row");
                            $('.slick-slider').slick('setPosition');
                            $('.c-slider-products-landscape').slick('setPosition');
                            $('.c-slider-products-vertical').slick('setPosition');
                            matchHeightProducts();
                            $.magnificPopup.instance.close = function () {
                                if (window.innerWidth < 992) {
                                    var scrollpos = $('body').attr('data-scroll');
                                    $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                                }
                                $.magnificPopup.proto.close.call(this);
                            };
                        }
                    }
                });
            });

            $('.c-slider-recently').slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                        dots: true
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                }]
            });
        });
    },
    tmpVideoInit: function tmpVideoInit() {
        $(function () {
            $('.c-slider-videocarousel').on('init', function () {
                $('.c-modal-video-fullscreen').each(function () {
                    var link = $(this).attr('href');
                    $(this).magnificPopup({
                        type: 'iframe',
                        removalDelay: 600,
                        fixedContentPos: true,
                        iframe: {
                            patterns: {
                                youtube: {
                                    src: link
                                }
                            }
                        },
                        callbacks: {
                            open: function open() {
                                $(".mfp-container").addClass("row mfp-iframe-holder-fullscreen");
                            }
                        }
                    });
                });
            });
            $('.c-slider-videocarousel').slick({
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                pauseOnHover: false,
                responsive: [{
                    breakpoint: 991,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        arrows: false,
                        dots: true
                    }
                }, {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                }]
            });
        });
    },

    //WOW init
    wowInit: function wowInit() {
        $('template').each(function () {
            var $t = $(this),
                toId = $t.attr('data-forid'),
                inHtml = $t.html(),
                $box = $('#' + toId);

            if ($box.length) {
                $box.html(inHtml);
            }
        });

        $(function () {
            function wowstart() {
                if (window.innerWidth > 992) {
                    new WOW().init();
                }
            }
            wowstart();
            var timer = false;
            var windowW = window.innerWidth;
            $(window).on('resize', function (e) {
                if (windowW != window.innerWidth) {
                    if (timer !== false) {
                        clearTimeout(timer);
                    }
                    timer = setTimeout(function () {
                        wowstart();
                    }, 200);
                    windowW = window.innerWidth;
                }
            });
        });
    },

    commonInit: function commonInit() {
        //search
        this.searchInit();

        //header
        this.headerInit();

        //footer
        this.footerInit();

        //modal
        this.modalInit();

        //toggle select
        this.toggleSelectInit();

        //WOW init
        this.wowInit();

        if ($('.c-list-instagram01').length) {
            var accessToken = "2680730803.d5ced9a.da86b2583a87427e8818b35ad0b3af39";
            var count = 7; // 取得件数

            $.ajax({
                url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + accessToken + '&count=' + count,
                dataType: 'jsonp',
                success: function success(data) {
                    var insert = "";
                    for (var i = 0; i < data['data'].length; i++) {
                        insert += "<li class='c-list-instagram01-item'>";
                        insert += '<a  href="' + data['data'][i]['link'] + '" title="' + data['data'][i]['caption']['text'] + '" target="_blank">';
                        insert += '<span style="background-image:url(' + data['data'][i]['images']['standard_resolution']['url'] + ')"></span>';
                        insert += '</a>';

                        insert += '</li>';
                    };
                    $('.c-list-instagram01').append(insert);
                }
            });
        }
        if ($('.c-list-instagram02').length) {
            var accessToken = "2680730803.d5ced9a.da86b2583a87427e8818b35ad0b3af39";
            var count = 3; // 取得件数

            $.ajax({
                url: 'https://api.instagram.com/v1/users/self/media/recent/?access_token=' + accessToken + '&count=' + count,
                dataType: 'jsonp',
                success: function success(data) {
                    var insert = "";
                    for (var i = 0; i < data['data'].length; i++) {
                        insert += "<li class='c-list-instagram02-item'>";
                        insert += '<a  href="' + data['data'][i]['link'] + '" title="' + data['data'][i]['caption']['text'] + '" target="_blank">';
                        insert += '<span style="background-image:url(' + data['data'][i]['images']['standard_resolution']['url'] + ')"></span>';
                        insert += '</a>';

                        insert += '</li>';
                    };
                    $('.c-list-instagram02').append(insert);
                }
            });
        }

        $(function () {
            $('.c-underColumn-toggle >a ').off('click').on('click', function () {
                var main = $(this).closest('.c-underColumn').find('.c-underColumn-main'),
                    side = $(this).closest('.c-underColumn').find('.c-underColumn-side');
                if (window.innerWidth < 767 || side.is(':hidden')) {
                    main.hide();
                    side.show();
                } else {
                    main.show();
                    side.hide();
                }
                return false;
            });
        });

        $(function () {
            //textarea count
            $(".c-textarea").keyup(function () {
                var txtcount = $(this).val().length,
                    txtlimit = $(this).maxlength;
                $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtcount);
                if (txtcount == 0) {
                    $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text("0");
                }
                if (txtcount >= txtlimit) {
                    $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtlimit);
                }
            });

            $('.c-dlist-dropdown-link-toggle').off('click').on('click', function () {
                if ($(this).parent().next('dd').is(':hidden')) {
                    $(this).parent().addClass('is-active');
                    $(this).parent().next('dd').slideDown();
                } else {
                    $(this).parent().removeClass('is-active');
                    $(this).parent().next('dd').slideUp();
                }
                return false;
            });
            $('.c-dlist-dropdown > dt').off('click').on('click', function () {
                if ($(this).next('dd').is(':hidden')) {
                    $(this).addClass('is-active');
                    $(this).next('dd').slideDown();
                    if ($(this).next('dd').find('.ge-dropdown-cart-list').length) {
                        $('.ge-dropdown-cart-list').getNiceScroll().resize();
                        $('.ge-dropdown-cart-list').niceScroll({
                            cursorcolor: "#D7D7D7",
                            cursoropacitymin: 0.3,
                            cursorwidth: 6,
                            autohidemode: false
                        });
                    }
                } else {
                    $(this).removeClass('is-active');
                    $(this).next('dd').slideUp();
                    if ($(this).next('dd').find('.ge-dropdown-cart-list').length) {
                        $('.ge-dropdown-cart-list').getNiceScroll().remove();
                    }
                }
                return false;
            });
        });

        this.selectQuantityInit();

        // JavaScript Document
        var getDevice = function () {
            var ua = navigator.userAgent;
            if (ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
                return 'sp';
            } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
                return 'tab';
            } else {
                return 'other';
            }
        }();
        $(function () {
            $(document).on("click", "[href^='#']:not(.c-modal)" + "[href!='#']", scroll_func);
            $(document).on("click", "#pageTop", function () {
                scroll_func("top");
            });

            $('form').submit(function () {
                loading_func('on');
            });
        });

        $(function () {
            $("[href^='#']:not(.c-modal)" + "[href!='#']").off('click').on('click', function () {
                var headerH = $('.ge-header').height();
                var messageH = $('.ge-header-fixedMessage').height();
                var headerHight = headerH + messageH;
                var href = $(this).attr("href");
                var target = $(href == "#" || href == "" ? 'html' : href);
                var position = target.offset().top - headerHight;
                $("html, body").animate({ scrollTop: position }, 550, "swing");
                return false;
            });
        });

        /* ページTOPへスクロール */
        var scroll_func = function scroll_func(top) {
            if (top == "top") {
                $('html,body').scrollTop(800).stop().animate({ scrollTop: 0 }, 'slow', 'easeOutQuart');
            } else {
                $('html,body').animate({ scrollTop: $($(this).attr("href")).offset().top }, 'slow', 'easeOutQuart');
            }
            return false;
        };
        /* /ページTOPへスクロール */

        var loading_func = function loading_func(mode) {
            if (mode == 'on') {
                $('.modLoading').remove();
                $('body').append('<div class="modLoading"><i class="fa fa-spinner fa-spin"></i></div>');
            }
            if (mode == 'off') {
                $('.modLoading').fadeOut(function () {
                    $(this).remove();
                });
            }
        };

        //modLoadingに対するBack Forward Cache 対策
        window.onpageshow = function (event) {
            if (event.persisted) {
                var elements = document.getElementsByClassName("modLoading");
                var length = elements.length;
                if (length) {
                    window.location.reload();
                }
            }
        };

        $(function () {
            $(window).on('load resize', function () {
                matchHeightAction();
            });
        });
        function matchHeightAction() {
            $('.js-height_01').matchHeight();
            $('.js-height_02').matchHeight();
            $('.js-height_03').matchHeight();
            $('.js-height_04').matchHeight();
            $('.js-height_05').matchHeight();
            $('.js-height_06').matchHeight();
            $('.js-height_07').matchHeight();
            $('.js-height_08').matchHeight();
            $('.js-height_09').matchHeight();
            $('.js-height_10').matchHeight();
        }

        $(function () {
            if ($('.js-top-carousel')[0]) {
                var isPC = function isPC() {
                    return matchMediaPC.matches;
                };

                // sliderInit
                // YouTubeの埋め込み
                var onPlayerReady = function onPlayerReady(event) {
                    event.target.mute();
                    event.target.getPlaybackQuality('highres');
                    sliderReady(event);
                };

                var onPlayerStateChange = function onPlayerStateChange(event) {
                    if (event.data === YT.PlayerState.ENDED) {
                        // $('.js-top-carousel').slick('slickNext');
                    }
                };

                var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
                    $('.js-top-carousel').find('.c-topCarousel-item').each(function (index) {
                        var $el = $(this).find('.c-topCarousel-iframe-wrap');
                        if ($el[0]) {
                            $('.js-top-carousel').removeClass('is-loading');
                            $el.attr('id', 'c-topCarousel-movieid' + index);
                            movieList.push({
                                index: index,
                                videoId: $el.attr('data-yt-id')
                            });
                            ytPlayers.push('');
                        }
                    });

                    if (movieList.length) {
                        for (var i = 0; i < movieList.length; i++) {
                            var playerVars = {
                                // 'autoplay': 1,
                                'controls': 0,
                                // 'loop': 1,
                                // 'playlist': movieList[i].videoId,
                                'disablekb': 1,
                                'rel': 0,
                                'playsinline': 1
                            };

                            isSingleAndMovie = $('.js-top-carousel').find('.c-topCarousel-item').length === 1;

                            if (isSingleAndMovie) {
                                playerVars.playlist = movieList[i].videoId;
                                playerVars.loop = 1;
                            }

                            var ytPlayer = new YT.Player('c-topCarousel-movieid' + movieList[i].index, {
                                width: 640,
                                height: 480,
                                videoId: movieList[i].videoId,
                                playerVars: playerVars,
                                events: {
                                    'onReady': onPlayerReady,
                                    'onStateChange': onPlayerStateChange
                                }
                            });
                            ytPlayers[movieList[i].index] = ytPlayer;
                        }
                    } else {
                        sliderReady();
                    }
                };

                var sliderReady = function sliderReady(event) {
                    if (event && $(event.target.getIframe()).attr('id') === 'c-topCarousel-movieid0') {
                        if (isPC() && ytPlayers[0] && ytPlayers[0].playVideo) {
                            ytPlayers[0].playVideo();

                            setTimeout(function () {
                                $('.js-top-carousel').removeClass('is-loading');
                                $('.js-top-carousel').addClass('is-loaded');
                            }, 100);
                        }
                    } else {
                        setTimeout(function () {
                            $('.js-top-carousel').removeClass('is-loading');

                            setTimeout(function () {
                                $('.js-top-carousel').addClass('is-loaded');
                            }, 2500);
                        }, 500);
                    }
                    slideStart(null, 0);
                };

                var getBgMovieSize = function getBgMovieSize() {
                    var aspectW = 16;
                    var aspectH = 9;
                    var videoRatio = (aspectW / aspectH).toFixed(2);
                    var minWidth = window.innerWidth ? window.innerWidth : $(window).width();
                    var minHeight = $(window).height() + 100;
                    var widthRatio = minWidth / aspectW;
                    var heightRatio = minHeight / aspectH;
                    var size = {};
                    if (widthRatio > heightRatio) {
                        size.width = minWidth;
                        size.height = Math.ceil(minWidth / videoRatio);
                    } else {
                        size.height = minHeight;
                        size.width = Math.ceil(minHeight * videoRatio);
                    }
                    return size;
                };

                var sliderInit = function sliderInit() {
                    $('.js-top-carousel').on('init', function (event, slick) {
                        if (!$(slick.$slides[0]).find('.type-video')[0]) {
                            $('.js-top-carousel').removeClass('is-loading');
                        }
                        if ($(slick.$slides[0]).find('.type-video')[0]) {
                            $(slick.$slides[0]).addClass('is-wait');
                        }

                        matchMediaPC.addListener(function (e) {
                            if (e.matches) {
                                var index = $('.js-top-carousel').find('.slick-active').attr('data-slick-index');
                                if (ytPlayers[index] && ytPlayers[index].playVideo) {
                                    ytPlayers[index].playVideo();
                                }
                            } else {
                                for (var i = 0; i < ytPlayers.length; i++) {
                                    if (ytPlayers[i].stopVideo) {
                                        ytPlayers[i].stopVideo();
                                    }
                                }
                            }
                        });
                    });

                    $('.js-top-carousel').slick({
                        fade: true,
                        infinite: true,
                        dots: true,
                        arrows: false
                    });

                    $('.js-top-carousel').find('.slick-dots').find('button').append('<span class="bar"></span>');

                    $('.js-top-carousel').on('beforeChange', function (event, slick, currentSlide, nextSlide) {});

                    $('.js-top-carousel').on('afterChange', function (event, slick, currentSlide) {
                        slideStart(slick, currentSlide);
                    });
                };

                var slideStart = function slideStart(slick, currentSlide) {
                    clearTimeout(nextTimer);
                    clearInterval(seekbarTimer);
                    clearTimeout(loadingTimer);

                    for (var i = 0; i < ytPlayers.length; i++) {
                        if (ytPlayers[i].stopVideo) {
                            ytPlayers[i].stopVideo();
                        }
                    }

                    var $currentSlide = $('.js-top-carousel').find('.slick-slide[data-slick-index="' + currentSlide + '"]');

                    // 動画コンテンツはすべてwait
                    $('.js-top-carousel').find('.slick-slide').each(function () {
                        if ($(this).find('.type-video')[0]) {
                            if (isPC()) {
                                $(this).addClass('is-wait');
                            }
                        }
                    });

                    // 動画が再生開始したらwait解除
                    var loop = function loop() {
                        if (ytPlayers[currentSlide] && ytPlayers[currentSlide].getPlayerState() === YT.PlayerState.PLAYING) {
                            clearTimeout(loadingTimer);
                            $currentSlide.removeClass('is-wait');
                        }
                        loadingTimer = setTimeout(loop, 50);
                    };
                    if (isPC()) {
                        loop();
                    } else {
                        $currentSlide.removeClass('is-wait');
                    }

                    $('.js-top-carousel').find('.slick-dots').find('.bar').css('width', 0);

                    if (ytPlayers[currentSlide] && isPC()) {
                        ytPlayers[currentSlide].playVideo();
                    }

                    seekbarPlay($currentSlide, currentSlide);
                };

                var seekbarPlay = function seekbarPlay($currentSlide, currentSlide) {
                    var cnt = 0;
                    var step = 10;
                    var subtract = 500;
                    var $dotsBar = $('.js-top-carousel').find('.slick-dots').find('li').eq(currentSlide).find('.bar');

                    seekbarTimer = setInterval(function () {
                        var duration = carouselDuration;

                        if (!$currentSlide.find('.type-video')[0] || !isPC()) {
                            cnt += 10;
                        } else {
                            var movieDuration = ytPlayers[currentSlide].getDuration() * 1000 - subtract;
                            duration = carouselDuration > movieDuration ? movieDuration : carouselDuration;
                            cnt = ytPlayers[currentSlide].getCurrentTime() * 1000;
                        }

                        $dotsBar.css('width', cnt / duration * 100 + '%');

                        if (duration > 0 && duration < cnt) {
                            // 再生終了0.5秒前に次ぎスライドへ移動
                            // 関連動画表示対処
                            clearInterval(seekbarTimer);

                            if (isSingleAndMovie) {
                                slideStart(null, 0);
                            } else {
                                $('.js-top-carousel').slick('slickNext');
                            }
                        }
                    }, 10);
                };

                var carouselDuration = 15000;
                var movieList = [];
                var ytPlayers = [];
                var nextTimer;
                var seekbarTimer;
                var loadingTimer;
                var isSingleAndMovie = false;
                window.ytPlayers = ytPlayers;

                var matchMediaPC = window.matchMedia('screen and (min-width: 1025px)');

                if (!isPC()) {
                    $('.js-top-carousel').removeClass('is-loading');
                }

                var tag = document.createElement('script');
                tag.src = "https://www.youtube.com/iframe_api";
                var firstScriptTag = document.getElementsByTagName('script')[0];
                firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

                window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;

                $(function () {
                    var movieSize = getBgMovieSize();
                    $('.type-video').each(function () {
                        $(this).css(movieSize);
                    });
                    $(window).on('resize', function (e) {
                        var movieSize = getBgMovieSize();
                        $('.type-video').each(function () {
                            $(this).css(movieSize);
                        });
                    });

                    sliderInit();
                });
            }

            /*
            if ($('.js-fullscreen')[0] && $('.js-top-carousel')[0]) {
            	var interval = 200;
            	var last_time = 0;
            	var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
            	var isMoving = false;
            			$('.js-fullscreen').on(mousewheelevent, function(e) {
            		if (isMoving) {
            			return false;
            }
            				if(window.innerWidth > 1024 && $('.ge-search').is(':hidden')) {
            			var now = new Date().getTime();
            			if (now - last_time < interval) return;
            					var delta = e.originalEvent.deltaY ? -(e.originalEvent.deltaY) : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -(e.originalEvent.detail);
            			var scrollTop = $(window).scrollTop();
            			var mvHeight = $('.js-top-carousel').innerHeight();
            			var hHeight = $('#header').innerHeight();
            			var mHeight = 0;
            			var fixHeight = mvHeight - hHeight;
            			if($('.ge-header-fixedMessage')[0]) {
            				mHeight = $('.ge-header-fixedMessage').innerHeight();
            }
            					fixHeight = fixHeight - mHeight;
            					if (delta < 0){
            				if (scrollTop + 10 < fixHeight) {
            					isMoving = true;
            					if (scrollTop >= 5) {
            						$('html, body').stop().animate({scrollTop: fixHeight}, 1000, 'easeOutQuad', function() {
            							isMoving = false;
            			});
            		} else {
            			$('html, body').stop().animate({scrollTop: 5}, 450, 'easeOutQuad', function() {
            				hHeight = $('#header').innerHeight();
            				fixHeight = mvHeight - hHeight - mHeight;
            				$('html, body').stop().animate({scrollTop: fixHeight}, 1000, 'easeOutQuad', function() {
            					isMoving = false;
            				});
            			});
            		}
            		last_time = now;
            		return false;
            	}
            } else {
            	if (scrollTop <= fixHeight) {
            		isMoving = true;
            		$('html, body').stop().animate({scrollTop: 0}, 1000, 'easeOutQuad', function() {
            			isMoving = false;
            		});
            		last_time = now;
            		return false;
            	}
            }
            }
            });
            }
            */
        });

        $(function () {
            $('.c-block-fullscreenModules--overlay .img source').each(function () {
                var srcset = $(this).attr('srcset');
                $(this).closest('.img').css('background-image', 'url(' + srcset + ')').addClass('isFinish');
            });

            if ($('.js-fullscreen')[0] && $('.c-block-fullscreenModules--overlay')[0] && $('.c-block-fullscreenModules--overlay-blanc-block')[0]) {
                var timer;
                var index = 0;
                var interval = 200;
                var last_time = 0;
                var mousewheelevent = 'onwheel' in document ? 'wheel' : 'onmousewheel' in document ? 'mousewheel' : 'DOMMouseScroll';
                var isMoving = false;

                $('.js-fullscreen').on(mousewheelevent, function (e) {
                    if (isMoving) {
                        return;
                    }

                    if (window.innerWidth > 992 && $('.ge-search').is(':hidden')) {
                        var now = new Date().getTime();
                        if (now - last_time > interval) {
                            var delta = e.originalEvent.deltaY ? -e.originalEvent.deltaY : e.originalEvent.wheelDelta ? e.originalEvent.wheelDelta : -e.originalEvent.detail;
                            var scrollTop = $(window).scrollTop();
                            var wHeight = window.innerHeight;
                            var vHeight = $('.c-block-fullscreenModules--overlay').innerHeight();
                            var hHeight = $('#header').innerHeight();
                            var vTop = $('.c-block-fullscreenModules--overlay').offset().top;
                            var nTop = $('.c-block-fullscreenModules--overlay-blanc-block').next().offset().top;
                            if ($('.ge-header-fixedMessage').length) {
                                var mHeight = $('.ge-header-fixedMessage').innerHeight();
                                var pos = nTop + hHeight + mHeight;
                            } else {
                                var pos = nTop + hHeight;
                            }

                            /*
                            if (delta < 0){
                            	if(scrollTop < nTop ) {
                            		isMoving = true;
                            		$("html,body").stop().animate({scrollTop:nTop + 5},1000,"easeOutQuad", function() {
                            			isMoving = false;
                            		});
                            		return false;
                            	}
                            } else {
                            	if(1 < scrollTop && scrollTop < pos ) {
                            		isMoving = true;
                            		$("html,body").stop().animate({scrollTop:0},1000,"easeOutQuad", function() {
                            			isMoving = false;
                            		});
                            		return false;
                            	}
                            }
                            */
                            if (scrollTop > nTop) {
                                $('.c-block-fullscreenModules--overlay').css({
                                    'z-index': -2,
                                    'opacity': 0,
                                    'display': 'none'
                                }).addClass('is-hidden');
                            } else {
                                $('.c-block-fullscreenModules--overlay').css({
                                    'z-index': 0,
                                    'opacity': 1,
                                    'display': 'block'
                                }).removeClass('is-hidden');
                            }
                        }
                        last_time = now;
                    }
                });

                $(window).on('load scroll resize', function (e) {
                    if ($('.js-fullscreen').length) {
                        if (window.innerWidth > 992) {
                            var scrollTop = $(window).scrollTop();
                            var wHeight = window.innerHeight;
                            var vHeight = $('.c-block-fullscreenModules--overlay').innerHeight();
                            var hHeight = $('#header').innerHeight();
                            var vTop = $('.c-block-fullscreenModules--overlay').offset().top;
                            var nTop = $('.c-block-fullscreenModules--overlay-blanc-block').next().offset().top;
                            if ($('.ge-header-fixedMessage').length) {
                                var mHeight = $('.ge-header-fixedMessage').innerHeight();
                                var pos = nTop + hHeight + mHeight;
                            } else {
                                var pos = nTop + hHeight;
                            }
                            if (scrollTop > nTop) {
                                $('.c-block-fullscreenModules--overlay').css({
                                    'z-index': -2,
                                    'opacity': 0,
                                    'display': 'none'
                                }).addClass('is-hidden');
                            } else {
                                $('.c-block-fullscreenModules--overlay').css({
                                    'z-index': 0,
                                    'opacity': 1,
                                    'display': 'block'
                                }).removeClass('is-hidden');
                            }
                        }
                    }
                });
            }
        });

        $(function () {
            var targetList;

            function btnCheck() {
                list = $('.js-order-list .js-order-list-item').length, visiblelist = $('.js-order-list .js-order-list-item:visible').length;
                if (visiblelist >= list) {
                    $('.js-order-btn').hide();
                }
            }
            $('.js-order-btn-more').off('click').on('click', function () {
                var i = 0,
                    list = $('.js-order-list .js-order-list-item').length,
                    visiblelist = $('.js-order-list .js-order-list-item:visible').length,
                    btnT = $('.js-order-btn').offset().top,
                    winT = $(window).scrollTop();
                console.log(winT);
                $('.js-order-list .js-order-list-item:hidden').eq(i).fadeIn();
                i++;
                btnCheck();
                $("html, body").animate({ scrollTop: winT }, 0, "swing");
                return false;
            });

            $('.js-order-btn-all').off('click').on('click', function () {
                var i = 0,
                    list = $('.js-order-list .js-order-list-item').length,
                    visiblelist = $('.js-order-list .js-order-list-item:visible').length,
                    btnT = $('.js-order-btn').offset().top,
                    winT = $(window).scrollTop();
                $('.js-order-list .js-order-list-item:hidden').fadeIn();
                btnCheck();
                var listH = $('.js-order-list'),
                    position = btnT + listH;
                if (window.innerWidth > 767) {
                    $("html, body").animate({ scrollTop: position }, 0, "swing");
                }
                $("html, body").animate({ scrollTop: winT }, 0, "swing");
                return false;
            });
        });
    },
    pdpInit: function pdpInit() {

        $(function () {
            //AUTO-REPLENISHMENT
            $(".js-autoreplenishment").change(function () {
                if ($(this).is(':checked')) {
                    $(this).closest('li').find(".js-autoreplenishment-text").fadeIn();
                } else {
                    $(this).closest('li').find(".js-autoreplenishment-text").fadeOut();
                }
            });
        });

        $(function () {

            function videoControl(action, target) {
                if ($('.c-slider-rich-video').find('iframe').length) {
                    var currentSlide = target.find(".slick-current");
                    var iframe = $('iframe', currentSlide);
                    var $playerWindow = iframe[0].contentWindow;
                    $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
                }
            }

            $('.c-slider-rich-video').on('afterChange', function (event, slick, currentSlide, nextSlide) {
                slick = $(slick.$slider);
                videoControl("playVideo", slick);
            });

            $('.c-slider-rich-video').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                slick = $(slick.$slider);
                videoControl("stopVideo", slick);
            });

            $('.c-slider-rich-video').each(function (i) {
                $(this).addClass('c-slider-rich-video' + i);
                $('.c-slider-rich-video' + i).on('init', function () {
                    $(this).find('.c-modal-video').each(function () {
                        var link = $(this).attr('href');
                        console.log(link);
                        $(this).find('.c-modal-video').magnificPopup({
                            type: 'iframe',
                            removalDelay: 600,
                            fixedContentPos: true,
                            iframe: {
                                patterns: {
                                    youtube: {
                                        src: link
                                    }
                                }
                            },
                            callbacks: {
                                open: function open() {
                                    $(".mfp-container").addClass("row");
                                    $.magnificPopup.instance.close = function () {
                                        if (window.innerWidth < 992) {
                                            var scrollpos = $('body').attr('data-scroll');
                                            $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                                        }
                                        $.magnificPopup.proto.close.call(this);
                                    };
                                }
                            }
                        });
                    });
                });
                $('.c-slider-rich-video' + i).not('.slick-initialized').slick({
                    centerMode: true,
                    centerPadding: '17.5%',
                    arrows: false,
                    slidesToShow: 1,
                    asNavFor: ".c-slider-rich-description" + i,
                    variableWidth: true,
                    responsive: [{
                        breakpoint: 992,
                        settings: {
                            centerPadding: '20%',
                            variableWidth: false
                        }
                    }, {
                        breakpoint: 767,
                        settings: {
                            centerPadding: '10%',
                            variableWidth: false
                        }
                    }]
                });
            });
            $('.c-slider-rich-description').each(function (i) {
                $(this).addClass('c-slider-rich-description' + i);
                $('.c-slider-rich-description' + i).not('.slick-initialized').slick({
                    asNavFor: ".c-slider-rich-video" + i,
                    touchMove: false
                });
            });
        });

        $(function () {
            if ($('.c-block-shoppingDock').length) {
                var shoppingDockHide = function shoppingDockHide() {
                    $('.c-block-shoppingDock').hide();
                };

                var shoppingDockShow = function shoppingDockShow() {
                    $('.c-block-shoppingDock').fadeIn();
                };

                shoppingDockHide();
                $(window).scroll(function () {
                    var winT = $(window).scrollTop();
                    var winH = $(window).height();
                    var varH = $('.c-block-shoppingDock').innerHeight();
                    var varTop = $('.c-block-shoppingDock').offset().top;
                    var varPos = varH + varTop;
                    var footT = $('#footer').offset().top;
                    if (winT > 100) {
                        shoppingDockShow();
                    } else {
                        shoppingDockHide();
                    }
                    if (varPos >= footT) {
                        $('.c-block-shoppingDock').addClass('nofixed');
                    } else {
                        $('.c-block-shoppingDock').removeClass('nofixed');
                    }
                });
            }
        });

        $(function () {
            function sliderMobile() {
                var width = window.innerWidth;
                if (width <= 767) {
                    $('.c-slider-mobile').not('.slick-initialized').slick({
                        arrows: false,
                        dots: true
                    });
                } else {
                    $('.c-slider-mobile.slick-initialized').slick('unslick');
                }
            }
            sliderMobile();
            $(window).resize(function () {
                sliderMobile();
            });

            var timer;
            function sliderMobileArrow() {
                var width = window.innerWidth;
                if (width <= 767) {
                    $('.c-block-richcontent01-content-list').not('.slick-initialized').slick({
                        arrows: true
                    });
                    sliderArrowPositionSet();
                } else {
                    $('.c-block-richcontent01-content-list.slick-initialized').slick('unslick');
                }
            }
            function sliderArrowPositionSet() {
                clearTimeout(timer);
                timer = setTimeout(function () {
                    $('.c-block-richcontent01-content-list').each(function () {
                        var $_t = $(this);
                        var $photo = $_t.find('.slick-active').find('.c-block-richcontent01-content-list-item').find('.photo');
                        var $arrow = $_t.find('.slick-arrow');
                        if ($arrow[0] && $photo[0]) {
                            var top = $photo.position().top;
                            var height = $photo.height();
                            var center = top + height / 2;
                            $arrow.css({
                                top: center
                            });
                        }
                    });
                }, 100);
            }
            sliderMobileArrow();
            $(window).on('load', function () {
                if (window.innerWidth <= 767) {
                    sliderArrowPositionSet();
                }
            });
            $(window).on('resize', function () {
                sliderMobileArrow();
            });
        });
        $(function () {
            $('.c-slider-fullscreenModulesImage').not('.slick-initialized').slick({
                asNavFor: ".c-slider-fullscreenModulesList",
                arrows: false
            });
            $('.c-slider-fullscreenModulesList').not('.slick-initialized').slick({
                asNavFor: ".c-slider-fullscreenModulesImage"
            });

            if ($(".c-slider-products-vertical").length > 0) {
                $('.c-slider-products-landscape').not('.slick-initialized').slick({
                    asNavFor: ".c-slider-products-vertical",
                    arrows: false,
                    responsive: [{
                        breakpoint: 991,
                        settings: {
                            dots: true
                        }
                    }]
                });
            } else {
                $('.c-slider-products-landscape').not('.slick-initialized').slick();
            }
        });
        $(function () {
            $('.c-slider-products-vertical').on('init', function () {
                $('.c-modal-img').magnificPopup({
                    type: 'image',
                    removalDelay: 500,
                    fixedContentPos: true,
                    callbacks: {
                        open: function open() {
                            $(".mfp-container").addClass("row");
                            $.magnificPopup.instance.close = function () {
                                if (window.innerWidth < 992) {
                                    var scrollpos = $('body').attr('data-scroll');
                                    $('html,body').removeAttr('data-scroll').removeClass('is-noscroll').css({ 'top': 0 }).scrollTop(scrollpos);
                                }
                                $.magnificPopup.proto.close.call(this);
                            };
                        }
                    }

                });
                if ($(this).find('.c-block-shopingmodal-change-image').length < 5) {
                    $(this).addClass('is-nobutton');
                }
            });
            if ($('.c-slider-products-vertical').hasClass('is-standard')) {
                var thumbnail = 3;
            } else {
                var thumbnail = 5;
            }
            $('.c-slider-products-vertical').not('.slick-initialized').slick({
                asNavFor: ".c-slider-products-landscape",
                vertical: true,
                verticalSwiping: true,
                slidesToShow: thumbnail,
                focusOnSelect: true
            });
            $('.c-slider-products-landscape').on('afterChange', function (event, slick, currentSlide) {
                $('.c-slider-products-vertical').find('.slick-current').removeClass('slick-current');
                $('.c-slider-products-vertical').find('.slick-slide').eq(currentSlide).addClass('slick-current');
            });
        });

        $(function () {
            //SHARE
            $('.c-block-share-toggle').off('click').on('click', function () {
                if ($(this).closest('.c-block-share').find('.c-block-share-box').is(':hidden')) {
                    $(this).closest('.c-block-share').find('.c-block-share-box').fadeIn().removeClass('mfp-hide');
                } else {
                    $(this).closest('.c-block-share').find('.c-block-share-box').fadeOut(function () {
                        $(this).addClass('mfp-hide');
                    });
                }
                if (window.innerWidth >= 767) {
                    return false;
                }
            });
            $('.c-block-share-close').off('click').on('click', function () {
                $(this).closest('.c-block-share').find('.c-block-share-box').fadeOut(function () {
                    $(this).addClass('mfp-hide');
                });
                return false;
            });
            $(document).on('click touchstart', function (e) {
                if (!$(e.target).closest('.c-block-share-box').length) {
                    if (window.innerWidth >= 767) {
                        if ($('.c-block-share-box').is(':visible')) {
                            $('.c-block-share-box').fadeOut(function () {
                                $(this).addClass('mfp-hide');
                            });
                        }
                    }
                }
            });
            //textarea count
            $(".c-textarea").keyup(function () {
                var txtcount = $(this).val().length,
                    txtlimit = $(this).attr('maxlength'),
                    txtDown = txtlimit - txtcount;
                $(this).closest('.c-textarea-box').find('.c-textarea-count:not(.js-countDown) .countnow').text(txtcount);
                $(this).closest('.c-textarea-box').find('.c-textarea-count.js-countDown .countlimit').text(txtDown);
                if (txtcount == 0) {
                    $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text("0");
                }
                if (txtcount >= txtlimit) {
                    $(this).closest('.c-textarea-box').find('.c-textarea-count .countnow').text(txtlimit);
                }
            });
            // Cut out character string of textarea when above limitting text is submited.
            $('button#sendBtn').on('mousedown', function () {
                var textareaElm = $(".c-textarea");
                if (textareaElm.length > 0 && textareaElm.val().length > textareaElm[0].dataset.characterLimit) {
                    textareaElm.val(textareaElm.val().substr(0, textareaElm[0].dataset.characterLimit));
                }
            });

            //AUTO-REPLENISHMENT
            $(".js-autoreplenishment").change(function () {
                if ($(this).is(':checked')) {
                    $(this).closest('li').find(".js-autoreplenishment-text").fadeIn();
                } else {
                    $(this).closest('li').find(".js-autoreplenishment-text").fadeOut();
                }
            });
        });
        $(function () {
            $('.c-underColumn-toggle >a ').on('click', function () {
                var main = $(this).closest('.c-underColumn').find('.c-underColumn-main'),
                    side = $(this).closest('.c-underColumn').find('.c-underColumn-side');
                if (window.innerWidth < 767 || side.is(':hidden')) {
                    main.hide();
                    side.show();
                } else {
                    main.show();
                    side.hide();
                }
                return false;
            });
        });
        $(function () {
            $('.c-dlist_01 dt').off('click').on('click', function () {
                if (window.innerWidth < 991) {
                    if ($(this).next('dd').is(':hidden')) {
                        $(this).addClass('is-active');
                        $(this).next('dd').slideDown();
                    } else {
                        $(this).removeClass('is-active');
                        $(this).next('dd').slideUp();
                    }
                }
                return false;
            });
            $('.c-dlist-dropdown-link-toggle').on('click', function () {
                if ($(this).parent().next('dd').is(':hidden')) {
                    $(this).parent().addClass('is-active');
                    $(this).parent().next('dd').slideDown();
                } else {
                    $(this).parent().removeClass('is-active');
                    $(this).parent().next('dd').slideUp();
                }
                return false;
            });
            $('.c-dlist-dropdown > dt').on('click', function () {
                if ($(this).next('dd').is(':hidden')) {
                    $(this).addClass('is-active');
                    $(this).next('dd').slideDown();
                } else {
                    $(this).removeClass('is-active');
                    $(this).next('dd').slideUp();
                }
                return false;
            });
        });
        $(function () {
            if ($('.c-block-shoppingDock').length) {
                var shoppingDockHide = function shoppingDockHide() {
                    $('.c-block-shoppingDock').hide();
                };

                var shoppingDockShow = function shoppingDockShow() {
                    $('.c-block-shoppingDock').fadeIn();
                };

                shoppingDockHide();
                $(window).scroll(function () {
                    var winT = $(window).scrollTop();
                    var winH = $(window).height();
                    var varH = $('.c-block-shoppingDock').innerHeight();
                    var varTop = $('.c-block-shoppingDock').offset().top;
                    var varPos = varH + varTop;
                    var footT = $('#footer').offset().top;
                    if (winT > 100) {
                        shoppingDockShow();
                    } else {
                        shoppingDockHide();
                    }
                    if (varPos >= footT) {
                        $('.c-block-shoppingDock').addClass('nofixed');
                    } else {
                        $('.c-block-shoppingDock').removeClass('nofixed');
                    }
                });
            }
        });

        $(function () {
            if ($(".c-block-lineBox").length) {
                var t = function t() {
                    $(".c-block-lineBox-wrapper").find(".c-block-lineBox").each(function (e) {
                        var t = $(this).offset().top,
                            i = ($(this).index(), $(this).children(".c-block-lineBox-circle").offset().top);
                        o.push(t), n.push(i);
                    }), $(".c-block-lineBox-circleMove").css("top", n[0] + "px");
                };

                var e,
                    o = [],
                    n = [],
                    s = $(window).scrollTop(),
                    r = 0;

                t(), $(window).on("load resize", function () {
                    t();
                }), $(window).on("scroll", function () {
                    i();
                });
                var i = function i() {
                    clearTimeout(e), e = setTimeout(function () {
                        var e = $(window).scrollTop(),
                            t = $(window).height(),
                            i = ($("#header").innerHeight(), []);
                        $(".c-block-lineBox").each(function (e) {
                            var t = $(this);
                            i[e] = t.find(".c-block-lineBox-circle").offset().top;
                        }), e < s ? i[r - 1] >= e && ($(".c-block-lineBox-circleMove").stop().css("top", i[r - 1] + "px"), $(".c-block-lineBox").children(".c-block-lineBox-circle").removeClass("is-active is-first"), $(".c-block-lineBox").eq(r - 1).children(".c-block-lineBox-circle").addClass("is-active"), 0 != r && r--) : i[r + 1] < e + t - t / 5 && ($(".c-block-lineBox-circleMove").stop().css("top", i[r + 1] + "px"), $(".c-block-lineBox").children(".c-block-lineBox-circle").removeClass("is-active is-first"), $(".c-block-lineBox").eq(r + 1).children(".c-block-lineBox-circle").addClass("is-active"), r++), s = e;
                    }, 30);
                };
            }
        }), $(function () {
            $('.js-giftcardbalancemodal-send').on('click', function () {
                if ($('.c-block-giftcardbalance-block-send').length) {
                    $('.c-block-giftcardbalance-block-send').hide();
                    $('.c-block-giftcardbalance-block-receive').show();
                }
                return false;
            });
        });

        // JavaScript Document
        $(function () {
            $(document).on("click", "[href^='#']:not(.c-modal)" + "[href!='#']", scroll_func);
            $(document).on("click", "#pageTop", function () {
                scroll_func("top");
            });

            $('form').submit(function () {
                loading_func('on');
            });
        });

        $(function () {
            $("[href^='#']:not(.c-modal)" + "[href!='#']").on('click', function () {
                var headerH = $('.ge-header').height();
                var messageH = $('.ge-header-fixedMessage').height();
                var headerHight = headerH + messageH;
                var href = $(this).attr("href");
                var target = $(href == "#" || href == "" ? 'html' : href);
                if (target[0]) {
                    var position = target.offset().top - headerHight;
                    $("html, body").animate({ scrollTop: position }, 550, "swing");
                    return false;
                }
            });
        });

        /* ページTOPへスクロール */
        var scroll_func = function scroll_func(top) {
            if (top == "top") {
                $('html,body').scrollTop(800).stop().animate({ scrollTop: 0 }, 'slow', 'easeOutQuart');
            } else {
                var $target = $($(this).attr("href"));
                if ($target[0]) {
                    $('html,body').animate({ scrollTop: $target.offset().top }, 'slow', 'easeOutQuart');
                }
            }
            return false;
        };
        /* /ページTOPへスクロール */

        var loading_func = function loading_func(mode) {
            if (mode == 'on') {
                $('.modLoading').remove();
                $('body').append('<div class="modLoading"><i class="fa fa-spinner fa-spin"></i></div>');
            }
            if (mode == 'off') {
                $('.modLoading').fadeOut(function () {
                    $(this).remove();
                });
            }
        };

        //modLoadingに対するBack Forward Cache 対策
        window.onpageshow = function (event) {
            if (event.persisted) {
                var elements = document.getElementsByClassName("modLoading");
                var length = elements.length;
                if (length) {
                    window.location.reload();
                }
            }
        };

        $(function () {
            function btnCheck() {
                list = $('.js-order-list .js-order-list-item').length, visiblelist = $('.js-order-list .js-order-list-item:visible').length;
                if (visiblelist >= list) {
                    $('.js-order-btn').hide();
                }
            }
            $('.js-order-btn-more').on('click', function () {
                var i = 0,
                    list = $('.js-order-list .js-order-list-item').length,
                    visiblelist = $('.js-order-list .js-order-list-item:visible').length;
                $('.js-order-list .js-order-list-item:hidden').eq(i).fadeIn();
                i++;
                btnCheck();
                return false;
            });

            $('.js-order-btn-all').on('click', function () {
                var i = 0,
                    list = $('.js-order-list .js-order-list-item').length,
                    visiblelist = $('.js-order-list .js-order-list-item:visible').length;
                $('.js-order-list .js-order-list-item:hidden').fadeIn();
                btnCheck();
                return false;
            });
        });
        $(function () {
            if ($('#topics-video').length) {
                var resizeMovie = function resizeMovie() {
                    var adjustWidth = $(window).width();
                    var adjustHeight = $(window).height();
                    if (adjustHeight > adjustWidth / movieRatio) {
                        adjustWidth = adjustHeight * movieRatio;
                    }
                    $('#topics-video').css({ width: adjustWidth * 1.4, height: adjustWidth / movieRatio * 1.4 });
                    // console.log(w, h, mw, mh);
                };

                var onPlayerReady = function onPlayerReady(event) {
                    $('#topics-video').fadeIn(1000);
                    player.setVolume(0);
                };

                var onPlayerStateChange = function onPlayerStateChange(event) {
                    if (event.data == YT.PlayerState.ENDED) {
                        player.playVideo();
                        player.setVolume(0);
                    }
                };

                $('body').append('<script src="https://www.youtube.com/iframe_api">');
                $('#topics-video').hide();
                $(window).on('load resize', function () {
                    if (navigator.userAgent.indexOf(/iPhone/) > 0 || navigator.userAgent.indexOf(/iPad/) > 0 || navigator.userAgent.indexOf(/Android/) > 0 || navigator.userAgent.indexOf('Mobile') > 0) {
                        $('#topics-video').remove();
                    }
                });
                var player;
                var movieRatio = 16 / 9;

                resizeMovie();
                $(window).resize(resizeMovie);

                var onYouTubeIframeAPIReady = function onYouTubeIframeAPIReady() {
                    var _playerVars;

                    player = new YT.Player('topics-video', {
                        videoId: '2uK6I6R6yVw',
                        playerVars: (_playerVars = {
                            'autoplay': 1,
                            'version': 3,
                            'controls': 0,
                            'playlist': 'Fm-DQAE5vWM',
                            'enablejsapi': 1,
                            'iv_load_policy': 3,
                            'modestbranding': 1,
                            'disablekb': 1,
                            'showinfo': 0,
                            'rel': 0,
                            'start': 0
                        }, _defineProperty(_playerVars, 'iv_load_policy', 3), _defineProperty(_playerVars, 'start', 6), _playerVars),
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                };
                window.onYouTubeIframeAPIReady = onYouTubeIframeAPIReady;
            }
        });

        $(function () {
            $(document).on('load scroll', function () {
                if ($('.synactif-fixedNavi').length) {
                    var scroll = $(window).scrollTop();
                    if (scroll >= 1) {
                        $('.synactif-fixedNavi').show();
                    } else {
                        $('.synactif-fixedNavi').hide();
                    }
                }
            });
            $('.synactif-fixedNavi-list-item-dropdown-toggle').off('click').on('click', function () {
                if ($(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').is(':hidden')) {
                    $(this).addClass('is-active');
                    $(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').slideDown();
                } else {
                    $(this).removeClass('is-active');
                    $(this).parent('.synactif-fixedNavi-list-item-text').next('.synactif-fixedNavi-list-item-dropdown').slideUp();
                }
                return false;
            });
            $('.synactif-fixedNavi-toggle a').off().on('click', function () {
                if ($(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').is(':hidden')) {
                    $(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').slideDown();
                } else {
                    $(this).closest('.synactif-fixedNavi').find('.synactif-fixedNavi-list').slideUp();
                }
                return false;
            });
            $(document).on('click', function (e) {
                if (!$(e.target).closest('.synactif-fixedNavi').length && window.innerWidth < 992) {
                    $('.synactif-fixedNavi-list').fadeOut();
                }
            });
        });

        $(function () {
            $('.js-appointment-next').on('click', function () {
                if ($(this).closest('.appointment-block').next('.appointment-block').is(':hidden')) {
                    $(this).closest('.appointment-block').hide();
                    $(this).closest('.appointment-block').next('.appointment-block').show();
                    var headerH = $('.ge-header').height();
                    var position = $(this).closest('.appointment-block').next('.appointment-block').offset().top - headerH;
                    $("html, body").animate({ scrollTop: position }, 550, "swing");
                }
                return false;
            });
            $('.js-appointment-select').on('change click', function () {
                if ($(this).closest('.appointment-block').next('.appointment-block').is(':hidden')) {
                    $(this).closest('.appointment-block').hide();
                    $(this).closest('.appointment-block').next('.appointment-block').show();
                    var headerH = $('.ge-header').height();
                    var position = $(this).closest('.appointment-block').next('.appointment-block').offset().top - headerH;
                    $("html, body").animate({ scrollTop: position }, 550, "swing");
                }
            });
            $('.js-appointment-prev').on('click', function () {
                if ($(this).closest('.appointment-block').prev('.appointment-block').is(':hidden')) {
                    $(this).closest('.appointment-block').hide();
                    $(this).closest('.appointment-block').prev('.appointment-block').show();
                    var headerH = $('.ge-header').height();
                    var position = $(this).closest('.appointment-block').prev('.appointment-block').offset().top - headerH;
                    $("html, body").animate({ scrollTop: position }, 550, "swing");
                }
                return false;
            });

            $('.js-appointment-calendar .day:not(.dayOff)').on('click', function () {
                $('.js-appointment-calendar .day:not(.dayOff)').removeClass('is-active');
                $(this).addClass('is-active');
                if ($('.js-appointment-time').is(':hidden')) {
                    $('.js-appointment-time').show();
                }
            });
        });

        $(function () {
            $('.js-checkout-ApplyGiftcard-toggle').on('click', function () {
                $(this).hide();
                $(this).next('a').show();
                $('.js-checkout-ApplyGiftcard-box').slideDown();
                return false;
            });
        });
    }
};

function matchHeightProducts() {
    if ($('.c-product-cards-step-header').length) {
        $('.c-product-cards-list .c-product-cards-step-header').matchHeight();
    }
    $('.c-product-cards-list .c-product-cards-list-item').matchHeight();
}

module.exports = design;

},{}],9:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util'),
    _ = require('lodash'),
    imagesLoaded = require('imagesloaded');

var dialog = {
    /**
     * @function
     * @description Appends a dialog to a given container (target)
     * @param {Object} params  params.target can be an id selector or an jquery object
     */
    create: function create(params) {
        var $target, id;

        if (_.isString(params.target)) {
            if (params.target.charAt(0) === '#') {
                $target = $(params.target);
            } else {
                $target = $('#' + params.target);
            }
        } else if (params.target instanceof jQuery) {
            $target = params.target;
        } else {
            $target = $('#dialog-container');
        }

        // if no element found, create one
        if ($target.length === 0) {
            if ($target.selector && $target.selector.charAt(0) === '#') {
                id = $target.selector.substr(1);
                $target = $('<div>').attr('id', id).addClass('dialog-content').appendTo('body');
            }
        }

        // create the dialog
        this.$container = $target;
        this.$container.dialog(_.merge({}, this.settings, params.options || {}));
    },
    /**
     * @function
     * @description Opens a dialog using the given url (params.url) or html (params.html)
     * @param {Object} params
     * @param {Object} params.url should contain the url
     * @param {String} params.html contains the html of the dialog content
     */
    open: function open(params) {
        // close any open dialog
        this.close();
        this.create(params);
        this.replace(params);
    },
    /**
     * @description populate the dialog with html content, then open it
     **/
    openWithContent: function openWithContent(params) {
        var content, position, callback;

        if (!this.$container) {
            return;
        }
        content = params.content || params.html;
        if (!content) {
            return;
        }
        this.$container.empty().html(content);
        if (!this.$container.dialog('isOpen')) {
            this.$container.dialog('open');
        }

        if (params.options) {
            position = params.options.position;
        }
        if (!position) {
            position = this.settings.position;
        }
        imagesLoaded(this.$container).on('done', function () {
            this.$container.dialog('option', 'position', position);
        }.bind(this));

        callback = typeof params.callback === 'function' ? params.callback : function () {};
        callback();
    },
    /**
     * @description Replace the content of current dialog
     * @param {object} params
     * @param {string} params.url - If the url property is provided, an ajax call is performed to get the content to replace
     * @param {string} params.html - If no url property is provided, use html provided to replace
     */
    replace: function replace(params) {
        if (!this.$container) {
            return;
        }
        if (params.url) {
            params.url = util.appendParamToURL(params.url, 'format', 'ajax');
            ajax.load({
                url: params.url,
                data: params.data,
                callback: function (response) {
                    params.content = response;
                    this.openWithContent(params);
                }.bind(this)
            });
        } else if (params.html) {
            this.openWithContent(params);
        }
    },
    /**
     * @function
     * @description Closes the dialog
     */
    close: function close() {
        if (!this.$container) {
            return;
        }
        this.$container.dialog('close');
    },
    exists: function exists() {
        return this.$container && this.$container.length > 0;
    },
    isActive: function isActive() {
        return this.exists() && this.$container.children.length > 0;
    },
    settings: {
        autoOpen: false,
        height: 'auto',
        modal: true,
        overlay: {
            opacity: 0.5,
            background: 'black'
        },
        resizable: false,
        title: '',
        width: '800',
        close: function close() {
            $(this).dialog('close');
        },
        position: {
            my: 'center',
            at: 'center',
            of: window,
            collision: 'flipfit'
        }
    }
};

module.exports = dialog;

},{"./ajax":1,"./util":69,"imagesloaded":75,"lodash":76}],10:[function(require,module,exports){
'use strict';

var util = require('./util');

function countrySelector() {

    $('.countries-selector').on('change', function (e) {
        e.preventDefault();

        var countrySelected = $(this).find(':selected').text().toLowerCase();
        if (countrySelected == 'us' || countrySelected == 'united states') {
            return false;
        }

        var countryUrl = countrySelected.indexOf('other') >= 0 ? Urls.countrySelectorUrl : $(this).find(':selected').val();

        if (window.open(countryUrl, '_blank') == null) {
            document.location.href = countryUrl;
        }
    });
}

exports.countrySelector = countrySelector;

},{"./util":69}],11:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    util = require('./util');
/**
 * @function
 * @description Load details to a given gift certificate
 * @param {String} id The ID of the gift certificate
 * @param {Function} callback A function to called
 */
exports.checkBalance = function (id, pin, callback) {
    // load gift certificate details
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.giftCardCheckBalance, { 'giftCertCode': id, 'giftCertPIN': pin }),
        callback: callback
    });
};

},{"./ajax":1,"./util":69}],12:[function(require,module,exports){
'use strict';

var util = require('./util');
var giftcert = require('./giftcert');
var modal = require('./modal').global;
var validator = require('./validator');

function updateCart() {
    $('#AddToBasketButton').on('click', function () {
        $('#GiftCertificateForm').submit();
    });
}

exports.init = function () {
    $('.gift-cert-edit').on('click', function (e) {
        e.preventDefault();

        modal.addCustomClass('edit-modal quickview-modal');
        modal.renderByUrl($(this).attr('href'));
        modal.setCallback(function () {
            updateCart();
            giftcert.init();
            util.limitCharacters();
            validator.initForm('form#GiftCertificateForm');
        });
    });
};

exports.initModal = function () {
    updateCart();
    giftcert.init();
    util.limitCharacters();
    validator.initForm('form#GiftCertificateForm');
};

},{"./giftcert":13,"./modal":19,"./util":69,"./validator":70}],13:[function(require,module,exports){
'use strict';

var ajax = require('./ajax'),
    minicart = require('./minicart'),
    util = require('./util'),
    design = require('./design');

var setAddToCartHandler = function setAddToCartHandler(e) {
    e.preventDefault();
    if ($(".termsandconditions").hasClass("error")) {
        return false;
    }

    if ($("input").hasClass("is-error") || $("textarea").hasClass("is-error")) {
        return false;
    }

    setGiftCard();

    var form = $(this).closest('form');
    var options = {
        url: util.ajaxUrl(form.attr('action')),
        method: 'POST',
        cache: false,
        data: form.serialize()
    };

    $.ajax(options).done(function (response) {
        if (response.success) {
            ajax.load({
                url: Urls.minicartGC,
                data: {
                    lineItemId: response.result.lineItemId
                },
                callback: function callback(response) {
                    minicart.show(response);
                    form.find('input,textarea').val('');
                    setGiftCard();
                    design.dropdownToggleInit();
                }
            });

            if (response.result.device === 'mobile') {
                var popup = new Foundation.Reveal($('#giftcertpurchase-notification'));

                popup.open();

                setTimeout(function () {
                    popup.close();
                }, 3000);
            }
        }
    }).fail(function (xhr, textStatus) {
        // failed
        if (textStatus === 'parsererror') {
            return window.alert(Resources.BAD_RESPONSE);
        }

        window.alert(Resources.SERVER_CONNECTION_ERROR);
    });
};

function initializeEvents() {
    design.selectGiftInit();

    $('.c-block-shopingmodal .c-list-color').on('colorSelect', function () {
        setGiftCard();
    });
}

function setGiftCard() {
    var imageSource = $('.c-block-shopingmodal .c-list-color a .is-current').find('img').attr('src') || $('.img-source input').val();
    var imageAlt = $('.c-block-shopingmodal .c-list-color a .is-current').find('img').attr('alt') || $('.img-alt input').val();

    setGiftCardImage(imageSource);
    setGiftCardName(imageAlt);
}

function setGiftCardImage(imageSource) {
    $('#GiftCertificateForm .imagesource').val(imageSource);
}

function setGiftCardName(imageAlt) {
    $('#GiftCertificateForm .imagealt').val(imageAlt);
}

exports.init = function () {
    $('#AddToBasketButton').on('click', setAddToCartHandler);

    initializeEvents();
};

},{"./ajax":1,"./design":8,"./minicart":18,"./util":69}],14:[function(require,module,exports){
'use strict';

var util = require('./util'),
    minicart = require('./minicart');

exports.init = function () {
	$('.menu-utility-user .contact, .menu-utility-user .newsletter').hover(function () {
		$(this).find('.menu-utility-content').show();
	});

	// 'tap' doesn't work as expected so using touchstart instead
	$(document).on('touchstart', function (e) {
		// the tapped element
		var $target = $(e.target);

		// check if it's not the menu or the dropdown itself
		if ($target.closest('.dropdown-menu').length == 0) {
			// check if some dropdown menu is open, otherwise foundation will return an error 
			if ($('.dropdown-pane.is-open').length) {
				$('.dropdown-pane.is-open').foundation('close');
			}
		}
	});

	$('a.utility-link').click(function (evt) {
		evt.preventDefault();
	});

	// overwrite foundation Enter key event 
	$('.menu-utility-user input').each(function (i, input) {
		var $input = $(input);

		// overwrite only on input type text, email and password
		if ($input.attr('type') == 'text' || $input.attr('type') == 'email' || $input.attr('type') == 'password') {

			$input.keydown(function (e) {
				Foundation.Keyboard.handleKey(e, "DropdownMenu", {
					submit: function submit() {
						var $form = $input.closest('form');

						// simulate blur event to check if it has error or not
						$input.blur();

						// prevent submit if there are errors
						if ($form.find('span.error').length == 0) {

							// $form.submit() doesn't work on login so it has to be this *sigh*
							$form.find('button[type="submit"]').click();
						}
					}
				});
			});
		}
	});

	/** Search SP
  * Please make sure content asset `header-navigation` like
  * <a href="javascript:;" class="search-sp">サイト内検索</a> 
  */
	$('.search-sp').on('click', function () {
		// close global navigation
		$('.js-gnav_close').trigger('click');
		// open search box
		$('.ge-search-toggle').trigger('click');
	});
};
Foundation.Keyboard.register("DropdownMenu", {
	"ENTER": 'submit'
});

},{"./minicart":18,"./util":69}],15:[function(require,module,exports){
'use strict';

function entry() {
    $(document).on('keyup blur', '#q, .checkout-shoping-side-code input', function () {
        if ($(this).val().trim().length) {
            return $(this).siblings('button').prop('disabled', false);
        }

        $(this).siblings('button').prop('disabled', true);
    });
}

exports.entry = entry;

},{}],16:[function(require,module,exports){
'use strict';
// jQuery extensions

module.exports = function () {
    // params
    // toggleClass - required
    // triggerSelector - optional. the selector for the element that triggers the event handler. defaults to the child elements of the list.
    // eventName - optional. defaults to 'click'
    $.fn.toggledList = function (options) {
        if (!options.toggleClass) {
            return this;
        }
        var list = this;
        return list.on(options.eventName || 'click', options.triggerSelector || list.children(), function (e) {
            e.preventDefault();
            var classTarget = options.triggerSelector ? $(this).parent() : $(this);
            classTarget.toggleClass(options.toggleClass);
            // execute callback if exists
            if (options.callback) {
                options.callback();
            }
        });
    };

    $.fn.syncHeight = function () {
        var arr = $.makeArray(this);
        arr.sort(function (a, b) {
            return $(a).height() - $(b).height();
        });
        return this.height($(arr[arr.length - 1]).height());
    };
};

},{}],17:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dialog = require('./dialog'),
    page = require('./page'),
    util = require('./util'),
    validator = require('./validator'),
    ajax = require('./ajax');

var login = {
  /**
   * @private
   * @function
   * @description init events for the loginPage
   */
  init: function init() {
    //o-auth binding for which icon is clicked
    $('.oAuthIcon').bind('click', function () {
      $('#OAuthProvider').val(this.id);
    });

    //toggle the value of the rememberme checkbox
    $('#dwfrm_login_rememberme').bind('change', function () {
      if ($('#dwfrm_login_rememberme').attr('checked')) {
        $('#rememberme').val('true');
      } else {
        $('#rememberme').val('false');
      }
    });

    //Reset Password
    $('.n-password-reset').on('click', function (e) {
      e.preventDefault();

      ajax.load({
        url: $(e.target).attr('href'),
        callback: function callback(data) {
          $('.cpb-modal_reminder').html(data);

          validator.init();

          var $requestPasswordForm = $('[name$="_requestpassword"]');
          var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
          $($submit).on('click', function (e) {
            if (!$requestPasswordForm.valid()) {
              return;
            }
            e.preventDefault();

            var dataToPost = $requestPasswordForm.serialize();
            // add form action to data
            dataToPost += '&' + $submit.attr('name') + '=';
            // make sure the server knows this is an ajax request
            if (dataToPost.indexOf('ajax') === -1) {
              dataToPost += '&format=ajax';
            }

            updateContentPopup($('.cpb-modal_reminder_send'), $requestPasswordForm.attr('action'), dataToPost);
          });
        }
      });
    });

    //Reset Password
    $('.password-reset').on('click', function (e) {
      e.preventDefault();

      if (!$('.ge-subNavi-item.is-active .ge-dropdown-box--right').is(':hidden')) {
        $('.ge-subNavi-item.is-active .ge-dropdown-box--right').hide();
      }

      ajax.load({
        url: $(e.target).attr('href'),
        callback: function callback(data) {
          $('#forgetpasswordmodal').html(data);

          $.magnificPopup.open({
            items: {
              src: '#forgetpasswordmodal', // can be a HTML string, jQuery object, or CSS selector
              type: 'inline'
            }
          });

          validator.init();

          var $requestPasswordForm = $('[name$="_requestpassword"]');
          var $submit = $requestPasswordForm.find('[name$="_requestpassword_send"]');
          $($submit).on('click', function (e) {
            if (!$requestPasswordForm.valid()) {
              return;
            }
            e.preventDefault();

            var dataToPost = $requestPasswordForm.serialize();
            // add form action to data
            dataToPost += '&' + $submit.attr('name') + '=';
            // make sure the server knows this is an ajax request
            if (dataToPost.indexOf('ajax') === -1) {
              dataToPost += '&format=ajax';
            }

            updateContentPopup($('#forgetpasswordmodal'), $requestPasswordForm.attr('action'), dataToPost);
          });
        }
      });
    });
  }
};

function updateContentPopup($element, href, data) {
  $.ajax({
    type: 'POST',
    url: href,
    data: data,
    success: function success(response) {
      if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success && response.error === 'CSRF Token Mismatch') {
        page.redirect(Urls.csrffailed);
      } else if (typeof response === 'string') {
        $element.html(response);
      }
    },
    failure: function failure() {
      $element.html('<h1>' + Resources.SERVER_ERROR + '</h1>');
    }
  });
}

module.exports = login;

///Login Greetings
if (window.User.isCustomerAuthenticated != false || window.User.isRegistered == true) {
  var myDate = new Date();
  var hrs = myDate.getHours();
  var mins = myDate.getMinutes();
  var time;
  var greeting;

  mins = ('0' + mins).slice(-2);
  time = hrs + mins;
  time = Number(time);

  if (time >= 300 && time <= 1159) {
    greeting = window.Resources.GREETINGS_MORNING;
  } else if (time >= 1200 && time <= 1700) {
    greeting = window.Resources.GREETINGS_AFTERNOON;
  } else {
    greeting = window.Resources.GREETINGS_EVENING;
  }

  $('#login-greetings').text(greeting);
  $('.menu-greeting #login-greetings').text(greeting);
}

},{"./ajax":1,"./dialog":9,"./page":23,"./util":69,"./validator":70}],18:[function(require,module,exports){
'use strict';

var util = require('./util'),
    bonusProductsView = require('./bonus-products-view'),
    samples = require('./samples'),
    design = require('./design');

var timer = {
    id: null,
    clear: function clear() {
        if (this.id) {
            window.clearTimeout(this.id);
            delete this.id;
        }
    },
    start: function start(duration, callback) {
        this.id = setTimeout(callback, duration);
    }
};

var minicart = {
    init: function init() {
        initEvents();
    },

    addProduct: function addProduct(data) {
        var show = this.show.bind(this);

        return new Promise(function (resolve, reject) {
            if (data.hasOwnProperty("pid") === false) {
                return reject();
            }

            $.post(util.appendParamsToUrl(Urls.addProduct, {
                "format": "ajax",
                "pid": encodeURIComponent(data.pid),
                "Quantity": data.hasOwnProperty("Quantity") ? data.Quantity : "1"
            }), function (data) {
                if (data.success === false) {
                    return reject(data.error);
                }

                show(data);
                resolve();
            }).fail(function (err) {
                reject(err.error);
            });
        });
    },

    addAllToWishlistFromContent: function addAllToWishlistFromContent(pids) {
        return window.location.href = Urls.addAllFromContent + "?pid=" + pids.join(":1,") // pass qty of one
        + "&cid=" + window.contentAssetID + "&hashparam=" + window.location.hash.split('#')[1];
    },

    addAllProducts: function addAllProducts(pids, to) {
        if (!pids || pids.length === 0) {
            return;
        }

        var isWishlist = to && to.toLowerCase() === "wishlist";
        if (isWishlist && !window.User.isCustomerAuthenticated) {
            if (window.contentAssetID) {
                return this.addAllToWishlistFromContent(pids);
            } else {
                var footerURL = $('footer') ? $('footer').data('url') : null;
                window.location = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
                return;
            }
        }

        var show = this.show.bind(this);
        var showAddToCartPopup = this.showAddToCartPopup.bind(this);
        var urlName = Urls.addMultipleProducts;

        if (isWishlist) {
            urlName = Urls.wishlistAddAll.split(window.location.hostname)[1];
        }

        $.post(util.appendParamsToUrl(urlName, {
            format: 'ajax',
            pid: pids
        }), function (data) {
            if (isWishlist) {
                window.location.href = window.location.href;
                return;
            }

            if (data) {
                show(data);
                showAddToCartPopup('#minicart-notification');
            }
        });
    },

    /**
     * @function
     * @description Shows the given content in the mini cart
     * @param {String} A HTML string with the content which will be shown
     */
    show: function show(html) {
        var quantity = $(html).find('.quantity_box').find('.num').data('quantity');
        if (quantity > 0) {
            $('.header-cart_btn .minicart-quantity').text(quantity);
        }
        if (!$('.header-cart_btn').hasClass('_in') && quantity > 0) {
            $('.header-cart_btn').addClass('_in');
        }
        $('.js-modal-r_content[data-modal-type="cart"] .cpb-modalR_contents').html(html);
        this.init();

        this.slide();

        // identify if we can show the sample overlay
        var canShowSamples = false;
        $(document).find('#mini-cart input[name="eligible-for-sample"]').each(function () {
            if (!canShowSamples && $(this).val() == 'true') {
                canShowSamples = true;
            }
        });

        if (bonusProductsView.hasBonusOptions() === false && samples.canShowSelection() && canShowSamples) {
            setTimeout(function () {
                samples.showSelection();
            }, 1000);
        }

        bonusProductsView.loadBonusOption();
    },
    /**
     * @function
     * @description Slides down and show the contents of the mini cart
     */
    slide: function slide() {
        // show the item
        cpbUi.util.rightModalOpen.call($('.header-cart_btn'), undefined, function (target) {
            cpbUi.niceScroll.ready();
        });
    },
    /**
     * @function
     * @description Closes the mini cart with given delay
     * @param {Number} delay The delay in milliseconds
     */
    close: function close(delay) {
        // close modal
        cpbUi.util.rightModalClose.call($('.js-modal-r_content[data-modal-type="cart"] .js-modal-r_close'), undefined, function (target) {});
    },
    /**
     * @function
     * @description Show mini popup when add to cart in SP
     */
    showAddToCartPopup: function showAddToCartPopup(src) {
        if (window.innerWidth <= 768 && $(src).length) {
            $.magnificPopup.open({
                items: {
                    src: src, // can be a HTML string, jQuery object, or CSS selector
                    type: 'inline'
                }
            });
        }
    }
};

/**
 * Init events
 * @returns
 */
function initEvents() {
    // Remove an item in minicart
    var removeItemEvent = false;
    $('.cpb-products_list_box .item-remove a').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
            var deleteHtml = $(this).closest('.cpb-products_list_box').find('input[name$=_deleteProduct]')[0].outerHTML;
            var $form = $(this).closest('form');
            $form.find('input[name$=_deleteGiftCertificate]').remove();
            $form.find('input[name$=_deleteProduct]').remove();
            $form.find('input[name$=_deleteCoupon]').remove();
            $(this).parent().append(deleteHtml);
            $form.submit();
        }
    });

    // Click '+' in minicart
    $('.cpb-products_list_box .js-num-drop_down').on('dropDownMinicart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Click '-' in minicart
    $('.cpb-products_list_box .js-num-drop_up').on('dropUpMinicart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Select quantity in minicart
    $('.cpb-products_list_box .js-num-drop_select').on('dropSelectMinicart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Click drop quantity in minicart
    $('.cpb-products_list_box .js-num-drop_drop').on('dropDropMinicart', function () {
        // write something here
    });
}

module.exports = minicart;

},{"./bonus-products-view":4,"./design":8,"./samples":60,"./util":69}],19:[function(require,module,exports){
'use strict';

var util = require('./util');

function Modal(modalCntr, modalBody, option) {
    this.$cntr = $(modalCntr);
    this.$body = $(modalBody);

    if ($.isEmptyObject(option) === false) {
        this.modal = new Foundation.Reveal($(modalCntr), option);
    } else {
        this.modal = new Foundation.Reveal($(modalCntr));
    }
    this.callbackFn = null;

    this.events = {
        onOpen: function onOpen(cb) {
            $(document).off('open.zf.reveal').on('open.zf.reveal', function () {
                cb();
                $(document).off('open.zf.reveal');
            });
        },

        onClose: function onClose(cb) {
            $(document).off('closed.zf.reveal').on('closed.zf.reveal', function () {
                cb();
                $(document).off('closed.zf.reveal');
            });
        }
    };
}

Modal.prototype.open = function () {
    this.modal.open();
};

Modal.prototype.close = function () {
    this.modal.close();
};

Modal.prototype.restoreDefaultClass = function () {
    this.$cntr.removeAttr('class');
    this.$cntr.attr('class', 'reveal');
};

Modal.prototype.addCustomClass = function (customClass) {
    this.restoreDefaultClass();
    this.$cntr.addClass(customClass);
};

Modal.prototype.setContent = function (content) {
    return this.$body.html(content);
};

Modal.prototype.renderContent = function (content, type) {
    var classType = type || '';

    this.$body.html('<div id="modal-content" class="modal-content ' + classType + '">' + content + '</div>');
    this.modal.open();

    if (typeof this.callbackFn === 'function') {
        this.callbackFn();
        this.callbackFn = null; // clear after each use
    }
};

Modal.prototype.renderByUrl = function (contentUrl) {
    return $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(this.renderContent.bind(this));
};

Modal.prototype.setCallback = function (cb) {
    this.callbackFn = cb;
};

module.exports.global = new Modal("#modal-cntr", ".modal-body", {}); // global modal
module.exports.create = function (modalCntr, modalBody, option) {
    return new Modal(modalCntr, modalBody, option);
};

},{"./util":69}],20:[function(require,module,exports){
'use strict';

var cpbUi = cpbUi || {};
var product = require('./pages/product');

/**
 *
 * Variables
 *
 */
var transitionEndEvents = ['webkitTransitionEnd.transitionend', 'mozTransitionEnd.transitionend', 'oTransitionEnd.transitionend', 'transitionend.transitionend'].join(' ');

cpbUi.isDomReady = false;
cpbUi.isHeaderFixed = false;
cpbUi.isPdp = false;
cpbUi.scrollDirection = '';
cpbUi.scrollbarSize;

/**
 * Header
 */
var initHeader = function () {
    return {
        init: function init() {
            $(window).on('scroll', function (e) {
                if (!cpbUi.isDomReady) return;
                var ghH = $('.js-grobal-header').height();
                if (!cpbUi.isHeaderFixed && window.pageYOffset > ghH) {
                    $('html').addClass('is-scroll');
                    cpbUi.isHeaderFixed = true;
                } else if (cpbUi.isHeaderFixed && window.pageYOffset <= ghH) {
                    $('html').removeClass('is-scroll');
                    cpbUi.isHeaderFixed = false;
                }
            });
        },
        ready: function ready() {}
    };
}();

/**
 * Footer
 */
var initFooter = function () {
    return {
        init: function init() {},
        ready: function ready() {}
    };
}();

/**
 * Global Navigation Toggle
 */
var initGlobalNavigation = function () {
    var gnavOpen = function gnavOpen(e) {
        e.preventDefault();
        var targetName = $(this).attr('data-target');
        var $gnav = $('.cpb-gnav_container.is-' + targetName);
        $gnav.addClass('is-active');
        setTimeout(function () {
            util.setModalScrollbarFix();
            $('html').addClass('is-gnav-open');
            $gnav.find('.js-gnav_overlay').fadeIn(200, function () {
                $gnav.find('.js-gnav_close').eq(0).focus();
            });
            $gnav.find('.cpb-gnav_wrap').css({
                transform: 'translateX(0)'
            });
            cpbUi.niceScroll.resize($gnav);
        }, 10);
    };
    var gnavClose = function gnavClose(e) {
        e.preventDefault();
        var $gnav = $(this).closest('.cpb-gnav_container');
        var $gnavWrap = $gnav.find('.cpb-gnav_wrap');
        $gnavWrap.on(transitionEndEvents, function () {
            $gnav.find('.js-gnav_overlay').fadeOut(200, function () {
                util.removeModalScrollbarFix();
                $('html').removeClass('is-gnav-open');
                $gnav.removeClass('is-active');
                $gnav.find('.js-gnav_btn').eq(0).focus();
            });
            $gnavWrap.off('.transitionend');
        });
        $gnavWrap.css({
            transform: 'translateX(-100%)'
        });
    };

    var gnavChildOpen = function gnavChildOpen(e) {
        e.preventDefault();
        var $gnav = $(this).closest('.cpb-gnav_container');
        var $box = $(this).closest('.js-gnav-item_contents');
        var target = $(this).attr('data-gnav-target');
        var $target = $gnav.find('.js-gnav-item_contents').filter('[data-gnav-name="' + target + '"]');
        if ($target[0]) {
            $target.on(transitionEndEvents, function () {
                $box.removeClass('is-visible');
                $target.off('.transitionend');
            });
            $target.addClass('is-visible');
            setTimeout(function () {
                $target.css({
                    transform: 'translateX(0)'
                });
            }, 10);
            cpbUi.niceScroll.resize($target);
        }
    };

    var gnavChildClose = function gnavChildClose(e) {
        e.preventDefault();
        var $gnav = $(this).closest('.cpb-gnav_container');
        var $box = $(this).closest('.js-gnav-item_contents');
        var target = $(this).attr('data-gnav-target');
        var $target = $gnav.find('.js-gnav-item_contents').filter('[data-gnav-name="' + target + '"]');
        if ($target[0]) {
            $box.on(transitionEndEvents, function () {
                $box.removeClass('is-visible');
                $box.off('.transitionend');
            });
            $box.css({
                transform: 'translateX(-100%)'
            });

            $target.addClass('is-visible');
            setTimeout(function () {
                $target.css({
                    transform: 'translateX(0)'
                });
            }, 10);
        }
    };

    return {
        init: function init() {
            $(document).on('click', '.js-gnav_btn', gnavOpen);
            $(document).on('click', '.js-gnav_close', gnavClose);
            $(document).on('click', '.js-gnav_overlay', gnavClose);
            $(document).on('click', '.js-gnav-item_btn', gnavChildOpen);
            $(document).on('click', '.js-gnav_back', gnavChildClose);
        },
        ready: function ready() {}
    };
}();

/**
 * Right Modal
 */
var initRightModal = function () {
    var loginCallback = function loginCallback() {};
    var accountCallback = function accountCallback() {};
    var cartCallback = function cartCallback() {};

    return {
        init: function init() {
            $(document).on('click', '.js-modal-r_open', function (e) {
                e.preventDefault();
                util.rightModalOpen.call(this, undefined, function (target) {
                    if (target === 'login') {
                        loginCallback();
                    }
                    if (target === 'account') {
                        accountCallback();
                    }
                    if (target === 'cart') {
                        cartCallback();
                    }
                });
            });
            $(document).on('click', '.js-modal-r_close', function (e) {
                e.preventDefault();
                util.rightModalClose.call(this, undefined, function (target) {});
            });
            $(document).on('click', '.js-modal-r_overlay', function (e) {
                e.preventDefault();
                util.rightModalClose.call(this, undefined, function (target) {});
            });
        },
        ready: function ready() {}
    };
}();

/**
 * Center Modal
 */
var initCenterModal = function () {
    return {
        init: function init() {
            $(document).on('click', '.js-modal-c_open', function (e) {
                e.preventDefault();
                util.centerModalOpen.call(this, undefined, function (target) {});
            });
            $(document).on('click', '.js-modal-c_close', function (e) {
                e.preventDefault();
                util.centerModalClose.call(this, undefined, function (target) {});
            });
            $(document).on('click', '.js-modal-c_overlay', function (e) {
                e.preventDefault();
                util.centerModalClose.call(this, undefined, function (target) {});
            });
        },
        ready: function ready() {}
    };
}();

/**
 * Right Modal Login
 */
var initRightModalLoginResetPassword = function () {
    return {
        init: function init() {
            $(document).on('click', '.js-reset-password-recerived', function (e) {
                e.preventDefault();
                util.rightModalScreenChange.call(this, undefined, function (target) {});
            });
            $(document).on('click', '.js-reset-password-request', function (e) {
                e.preventDefault();
                util.rightModalScreenChange.call(this, undefined, function (target) {});
            });
            $(document).on('click', '.js-reset-password-gotohome', function (e) {
                e.preventDefault();
                util.rightModalClose.call(this, undefined, function (target) {});
            });
        },
        ready: function ready() {}
    };
}();

/**
 * QuickView
 */
cpbUi.directQuickView = function (href, callback) {
    var modalHtml = '<div id="cpb-modal-quickview" class="cpb-modalR_container js-quickview_content" data-modal-type="quickview">\
        <div class="cpb-modalR_wrap">\
            <div class="cpb-modalR_contents cpb-cart_style">\
                <form action="#">\
                    <div class="cpb-modalR_scroll_cover">\
                        <div class="cpb-modalR_inner cpb-modal_scroll js-modal_scroll">\
                            <div class="cpb-modal_quickview">\
                                <button class="cpb-modalR_close js-quickview_close"><span class="invisible">CLOSE</span></button>\
                                <!-- pdp -->\
                                <div class="cpb-modal_quickview-inner"></div>\
                                <!-- /pdp -->\
                            </div><!-- / cpb-modal_quickview -->\
                        </div><!-- / cpb-modalR_inner -->\
                        <div class="cpb-modalR_bottom">\
                            <!-- price -->\
                            <div class="quantity_box"></div>\
                            <!-- /price -->\
                            <!-- button -->\
                            <div class="cmd-button_container"></div>\
                            <!-- /button -->\
                        </div><!-- / cpb-modalR_bottom -->\
                    </div><!-- / cpb-modalR_scroll_cover -->\
                </form>\
            </div><!-- / cpb-modalR_contents" -->\
        </div><!-- / cpb-modalR_wrap -->\
        <div class="cpb-modal_overlay js-quickview_overlay"></div>\
    </div><!-- / cpb-modalR_container -->';

    $.ajax({
        type: 'GET',
        url: href,
        dataType: 'html'
    }).done(function (data, textStatus, jqXHR) {
        var $pdpHtml = $(data);
        var $modal = $(modalHtml);

        $modal.find('.cpb-modalR_bottom .quantity_box').append($pdpHtml.find('#cpb-products_price').prop('outerHTML'));
        $modal.find('.cpb-modalR_bottom .cmd-button_container').append($pdpHtml.find('#cpb-products_submit').prop('outerHTML'));
        $modal.find('.cpb-modal_quickview-inner').append($pdpHtml.find('.cpb-products-details'));

        $('body').append($modal);

        if (typeof callback === 'function') callback();
    }).fail(function (jqXHR, textStatus, errorThrown) {});
};

var initQuickView = function () {
    var _init = function _init() {
        $(document).on('click', '.js-quickview-btn', function (e) {
            e.preventDefault();
            cpbUi.directQuickView($(this).attr('href'), function () {
                cpbUi.pdp.ready();

                util.rightModalOpen.call(this, 'quickview', function () {
                    cpbUi.niceScroll.ready();
                    cpbUi.sliderControl.resize();
                    // init product's events
                    product.initializeEvents();
                });
            });
        });
        $(document).on('click', '.js-quickview_close', function (e) {
            e.preventDefault();
            util.rightModalClose.call(this, 'quickview', function () {
                $("#cpb-modal-quickview").find('.js-modal_scroll').getNiceScroll().remove();
                $('#cpb-modal-quickview').remove();
            });
        });
        $(document).on('click', '.js-quickview_overlay', function (e) {
            e.preventDefault();
            util.rightModalClose.call(this, 'quickview', function () {
                $("#cpb-modal-quickview").find('.js-modal_scroll').getNiceScroll().remove();
                $('#cpb-modal-quickview').remove();
            });
        });
    };

    return {
        init: function init() {
            _init();
        },
        ready: function ready() {}
    };
}();

/**
 * PDP
 */
cpbUi.pdp = function () {

    var initPdpFooterNav = function initPdpFooterNav() {
        if (!$('.cpb-products_details_area')[0] || $('.cpb-products_details_area').hasClass('is-initialized')) return;

        var pdpFooterShow = false;

        $('.cpb-products_details_area').addClass('is-initialized');

        $(window).on('scroll', function (e) {
            if (!cpbUi.isDomReady) return;

            var pdpMainHeight = $('.cpb-products_details_area').offset().top + $('.cpb-products_details_area').height();
            var scrollTop = window.pageYOffset;

            if ($('#footer').offset().top <= scrollTop + $(window).height()) {
                $('.cpb-products-cart_fixed').removeClass('is-show');

                if (cpbUi.scrollDirection === 'up') {
                    $('.cpb-grobal-header').removeClass('is-hide');
                }
            } else {
                if (cpbUi.scrollDirection === 'down') {
                    if (!pdpFooterShow && pdpMainHeight <= scrollTop) {
                        pdpFooterShow = true;
                        $('.cpb-products-cart_fixed').addClass('is-show');
                        $('.cpb-grobal-header').addClass('is-hide');
                    } else if (pdpFooterShow && pdpMainHeight > scrollTop) {
                        pdpFooterShow = false;
                        $('.cpb-products-cart_fixed').removeClass('is-show');
                        $('.cpb-grobal-header').removeClass('is-hide');
                    }
                } else if (cpbUi.scrollDirection === 'up' && pdpFooterShow) {
                    pdpFooterShow = false;
                    $('.cpb-products-cart_fixed').removeClass('is-show');
                    $('.cpb-grobal-header').removeClass('is-hide');
                }
            }
        });
    };

    var sliderOptions = {
        productsPhoto: {
            dots: true,
            infinite: false,
            slidesToScroll: 1
        },
        swatches: {
            dots: false,
            slidesToShow: 5,
            slidesToScroll: 5,
            infinite: false,
            responsive: [{
                breakpoint: 1120,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            }]
        }
    };

    var initSlider = function initSlider() {
        if (!$('.js-products-photo_slider').hasClass('slick-initialized')) {
            $('.js-products-photo_slider').slick(sliderOptions.productsPhoto);
        }
        if (!$('.js-swatches_slider').hasClass('slick-initialized')) {
            $('.js-swatches_slider').slick(sliderOptions.swatches);
        }
    };

    var productsColorSelect = function productsColorSelect(list) {
        var $pdp = $('.cpb-products-details');
        var $slider = $pdp.find('.js-products-photo_slider');
        $slider.slick('destroy');
        $slider.empty();

        var html = '';
        for (var i = 0; i < list.length; i++) {
            list[i];
            html += '<div class="cpb-products-photo_box cmd-slide">';
            html += '<img src="' + list[i] + '" alt="">';
            html += '</div>';
        }

        $slider.append(html);
        $slider.slick(sliderOptions.productsPhoto);
    };

    var initSelectColorChip = function initSelectColorChip() {
        $(document).on('click', '.cpb-products-color_list .selectable', function (e) {
            e.preventDefault();

            $('.cpb-products-color_list').find('.selectable').removeClass('selected');
            $('.cpb-products-color_list').find('.c-list-color-panel').removeClass('is-current');

            var $box = $(this).closest('.cpb-products-color_list');
            var index = $box.find('.selectable').index($(this));
            $('.cpb-products-color_list').each(function () {
                var $btn = $(this).find('.selectable').eq(index);
                $btn.addClass('selected');
                $btn.find('.c-list-color-panel').addClass('is-current');
            });

            /*
            画像リストを取得する処理
            */
            var tempList = ['https://www.cledepeau-beaute.com/dw/image/v2/BBSC_PRD/on/demandware.static/-/Sites-master-catalog-cpb/default/dw3ee84eec/products/images/rouge/product-detail-cmk-pic-99a-3-0003.png?sw=580&sh=580&sm=fit', 'https://www.cledepeau-beaute.com/dw/image/v2/BBSC_PRD/on/demandware.static/-/Sites-master-catalog-cpb/default/dwcd0dd4ef/products/images/rouge/product-detail-cmk-pic-99b-3-0003.png?sw=580&sh=580&sm=fit'];

            cpbUi.pdp.productsColorSelect(tempList);
        });
    };

    return {
        init: function init() {},
        productsColorSelect: productsColorSelect,
        ready: function ready() {
            initSlider();
            initPdpFooterNav();
            initSelectColorChip();
        }
    };
}();

/**
 * Nice Scroll
 */
cpbUi.niceScroll = function () {
    return {
        ready: function ready() {
            $('.js-modal_scroll').each(function () {
                var $ns = $(this);
                if (!$ns.hasClass('scroll-initialized')) {
                    $ns.niceScroll({
                        cursorcolor: 'rgba(0,0,0, .3)',
                        cursoropacitymin: 0.3,
                        cursorwidth: 3,
                        autohidemode: false,
                        zindex: '10000',
                        cursorborder: 'none'
                    });
                    $ns.addClass('scroll-initialized');
                }
            });
        },
        resize: function resize($wrap) {
            var $target = $wrap && $wrap[0] ? $wrap.find('.js-modal_scroll') : $('.js-modal_scroll');
            return $target.getNiceScroll().resize();
        }
    };
}();

/**
 * Slider Control
 */
cpbUi.sliderControl = function () {
    return {
        ready: function ready() {},
        resize: function resize($wrap) {
            var $target = $wrap && $wrap[0] ? $wrap.find('.js-slider_control') : $('.js-slider_control');
            return $target.slick('setPosition');
        }
    };
}();

/**
 * Recommend Slider
 */
cpbUi.recommendSlider = function () {
    var sliderOption = {
        dots: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        infinite: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3
            }
        }, {
            breakpoint: 768,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1
            }
        }]
    };

    return {
        init: function init() {},
        ready: function ready($slider) {
            if ($slider && $slider[0]) {
                if (!$slider.hasClass('slick-initialized')) {
                    $slider.slick(sliderOption);
                }
            } else {
                if (!$('.js-reco_slider').hasClass('slick-initialized')) {
                    $('.js-reco_slider').slick(sliderOption);
                }
            }
        }
    };
}();

/**
 * Select Change Content
 */
var selectChangeContent = function () {
    return {
        init: function init() {
            $(document).on('change', '.js-select-change_tab', function (e) {
                var $box = $(this).closest('.js-select-change_tab_container');
                var val = $(this).val();
                var $target = $box.find('.js-select-change_tab_box').filter('[data-target="' + val + '"]');

                if ($target[0]) {
                    /*$box.find('.js-select-change_tab_box').fadeOut(200, function() {
                      $target.fadeIn(200);
                    });*/
                    $box.find('.js-select-change_tab_box').removeClass('is-active');
                    $target.addClass('is-active');
                }
            });
        },
        ready: function ready() {
            $('.js-select-change_tab').trigger('change');
        }
    };
}();

/**
 * Standard Toggle
 */
var standardToggle = function () {
    var _init2 = function _init2() {
        $(document).on('click', '.js-toggle_btn', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-toggle_container');

            if ($box.hasClass('is-active')) {
                util.toggleClose($(this), $box, function () {});
            } else {
                util.toggleOpen($(this), $box, function () {});
            }
        });

        $(document).on('click', '.js-togge_close', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-toggle_container');
            var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'slide';
            if ($box.hasClass('is-active')) {
                util.toggleClose($(this), $box, function () {});
            }
        });
    };

    return {
        init: function init() {
            _init2();
        },
        ready: function ready() {}
    };
}();

/**
 * SNS Toggle
 */
var snsToggle = function () {
    var _init3 = function _init3() {
        $(document).on('click', '.js-toggle-sns_btn', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-toggle_container');
            var $this = $(this);

            if ($box.hasClass('is-active')) {
                util.toggleClose($this, $box, function () {});
            } else {
                util.toggleOpen($this, $box, function () {});
            }

            $(document).on('click.toggle-sns', function (e) {
                if (!$(e.target).closest('.js-toggle_container')[0]) {
                    util.toggleClose($this, $box, function () {});
                    $(document).off('.toggle-sns');
                }
            });
        });

        $(document).on('click', '.js-togge-sns_close', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-toggle_container');
            if ($box.hasClass('is-active')) {
                util.toggleClose($(this), $box, function () {});
                $(document).off('.toggle-sns');
            }
        });
    };

    return {
        init: function init() {
            _init3();
        },
        ready: function ready() {}
    };
}();

/**
 * Input Toggle
 */
var inputToggle = function () {
    var toggle = function toggle() {
        var type = $(this).attr('type');
        type = type ? type.toLowerCase() : '';
        var target = $(this).attr('data-target');
        var $target = $(target);

        if ($target[0]) {
            if (type === 'checkbox') {
                if ($(this).prop('checked')) {
                    $target.addClass('is-active');
                } else {
                    $target.removeClass('is-active');
                }
            } else if (type === 'radio') {}
        }
    };

    var _init4 = function _init4() {
        $(document).on('change', '.js-input-toggle_btn', function (e) {
            toggle.call(this);
        });
    };

    var initDisp = function initDisp() {
        $('.js-input-toggle_btn').each(function () {
            toggle.call(this);
        });
    };

    return {
        init: function init() {
            _init4();
        },
        ready: function ready() {
            initDisp();
        }
    };
}();

/**
 * Standard Tab
 */
var standardTab = function () {
    return {
        init: function init() {
            $(document).on('click', '.js-tab_btn', function (e) {
                e.preventDefault();
                var $box = $(this).closest('.js-tab_container');
                var target = $(this).attr('data-tab-target');
                util.tabOpen($(this), $box, target, function () {});
            });
        },
        ready: function ready() {}
    };
}();

/**
 * Tab Accordion
 */
var tabAccordion = function () {
    var initClickEvent = function initClickEvent() {
        $(document).on('click', '.js-tab-acc_btn', function (e) {
            e.preventDefault();
            var $container = $(this).closest('.js-tab-acc_container');
            var target = $(this).attr('data-tab-target');

            $container.find('.js-tab-acc_inner').removeClass('is-active');
            $container.find('.js-tab-acc_btn').removeClass('is-active');
            $container.find('.js-tab-acc_drawer_btn').removeClass('is-active');
            $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
            $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');

            $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').fadeIn(function () {
                $(this).addClass('is-active');
                $(this).css({
                    display: ''
                });
            });
        });

        $(document).on('click', '.js-tab-acc_drawer_btn', function (e) {
            e.preventDefault();
            var $container = $(this).closest('.js-tab-acc_container');
            var target = $(this).attr('data-tab-target');

            if ($(this).hasClass('is-active')) {
                $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
                $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
                $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideUp(function () {
                    $(this).removeClass('is-active');
                    $(this).css({
                        display: ''
                    });
                });
            } else {
                $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
                $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');

                $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideDown(function () {
                    $(this).addClass('is-active');
                    $(this).css({
                        display: ''
                    });
                });

                // var $box = $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').closest('.js-tab-acc_box');
                // var position = $box.offset().top - $('.js-grobal-header').height();
                // $('html, body').animate({scrollTop:position}, 500);
            }
        });

        $(document).on('click', '.js-tab-acc_close', function (e) {
            e.preventDefault();
            var $container = $(this).closest('.js-tab-acc_container');
            var $box = $(this).closest('.js-tab-acc_box');
            var target = $box.find('.js-tab-acc_drawer_btn').attr('data-tab-target');

            $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
            $container.find('.js-tab-acc_drawer_btn').filter('[data-tab-target="' + target + '"]').removeClass('is-active');
            $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').slideUp(function () {
                $(this).removeClass('is-active');
                $(this).css({
                    display: ''
                });
            });
        });
    };

    var initMatchMedia = function initMatchMedia() {
        window.matchMedia('(min-width:769px)').addListener(function () {
            if (window.matchMedia('(min-width:769px)').matches) {
                $('.js-tab-acc_container').each(function () {
                    var $container = $(this);

                    var $selectedBtns = $container.find('.js-tab-acc_drawer_btn.is-active');
                    var $selectBtnFirst = $selectedBtns.length === 0 ? $container.find('.js-tab-acc_drawer_btn').eq(0) : $selectedBtns.first();

                    if ($selectedBtns.length === 1) return;

                    // reset
                    $container.find('.js-tab-acc_drawer_btn').removeClass('is-active');
                    $container.find('.js-tab-acc_btn').removeClass('is-active');
                    $container.find('.js-tab-acc_inner').removeClass('is-active');

                    // set
                    var target = $selectBtnFirst.attr('data-tab-target');
                    $selectBtnFirst.addClass('is-active');
                    $container.find('.js-tab-acc_btn').filter('[data-tab-target="' + target + '"]').addClass('is-active');
                    $container.find('.js-tab-acc_inner').filter('[data-tab-contents="' + target + '"]').addClass('is-active');
                });
            }
        });
    };

    return {
        init: function init() {
            initClickEvent();
            initMatchMedia();
        },
        ready: function ready() {}
    };
}();

/**
 * Number Drop Down
 */
var numDropDown = function () {
    var initClickEvent = function initClickEvent() {
        $(document).on('click', '.js-num-drop_up', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-num-drop_container');
            var limit = $box.find('.js-num-drop_select').children().length;
            var currentNum = $box.find('.js-num-drop_cnt').html();

            if (currentNum < limit) {
                currentNum++;
                $box.find('.js-num-drop_cnt').html(currentNum);
                $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
                $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
                $box.find('.js-num-drop_input').val(currentNum);
            }
        });
        $(document).on('click', '.js-num-drop_down', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-num-drop_container');
            var limit = $box.find('.js-num-drop_select').children().length;
            var currentNum = $box.find('.js-num-drop_cnt').html();

            if (currentNum > 1) {
                currentNum--;
                $box.find('.js-num-drop_cnt').html(currentNum);
                $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
                $box.find('.js-num-drop_select').children().eq(currentNum - 1).find('a').addClass('is-current');
                $box.find('.js-num-drop_input').val(currentNum);
            }
        });
        $(document).on('click', '.js-num-drop_select a', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-num-drop_container');
            var num = $(this).html();
            $box.find('.js-num-drop_cnt').html(num);
            $box.find('.js-num-drop_select').children().find('a').removeClass('is-current');
            $box.find('.js-num-drop_select').children().eq(num - 1).find('a').addClass('is-current');
            $box.find('.js-num-drop_input').val(num);
            $box.find('.js-num-drop_select').removeClass('is-active');
        });
        $(document).on('click', '.js-num-drop_drop', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-num-drop_container');
            var eventName = '.event' + new Date().getTime();

            if ($box.find('.js-num-drop_select').hasClass('is-active')) {
                $box.find('.js-num-drop_select').removeClass('is-active');
                $(document).off(eventName);
            } else {
                var offset = $(this).offset();
                var posY = offset.top - $(window).scrollTop();
                var height = $(window).height();
                if (posY * 2 > height) {
                    $box.find('.js-num-drop_select').addClass('is-up');
                } else {
                    $box.find('.js-num-drop_select').removeClass('is-up');
                }

                $box.find('.js-num-drop_select').addClass('is-active');

                $(document).on('click' + eventName + ' touchend' + eventName, function (e) {
                    if (!$.contains($box[0], e.target)) {
                        $box.find('.js-num-drop_select').removeClass('is-active');
                        $(document).off(eventName);
                    }
                });
            }
        });
    };

    return {
        init: function init() {
            initClickEvent();
        },
        ready: function ready() {}
    };
}();

/**
 * Cart
 */
var cart = function () {

    var initCartFooterNavNormal = function initCartFooterNavNormal() {
        if (!$('.cpb-cart-checkout_fixed')[0] || !$('.cpb-cart-side_submit')[0]) return;

        var cartFooterShow = false;

        $(window).on('scroll', function (e) {
            if (!cpbUi.isDomReady) return;

            // var targetHeight = $('.cpb-cart-side_submit').offset().top + $('.cpb-cart-side_submit').height();
            var ghHeight = $('.js-grobal-header').height();
            var scrollTop = window.pageYOffset;

            if (cpbUi.scrollDirection === 'down') {
                if (!cartFooterShow && ghHeight <= scrollTop) {
                    cartFooterShow = true;
                    $('.cpb-cart-checkout_fixed').addClass('is-show');
                    $('.cpb-grobal-header').addClass('is-hide');
                } else if (cartFooterShow && ghHeight > scrollTop) {
                    cartFooterShow = false;
                    $('.cpb-cart-checkout_fixed').removeClass('is-show');
                    $('.cpb-grobal-header').removeClass('is-hide');
                }
            } else if (cpbUi.scrollDirection === 'up' && cartFooterShow) {
                cartFooterShow = false;
                $('.cpb-cart-checkout_fixed').removeClass('is-show');
                $('.cpb-grobal-header').removeClass('is-hide');
            }

            if ($('#footer').offset().top <= scrollTop + $(window).height()) {
                $('.cpb-cart-checkout_fixed').removeClass('is-show');

                if (cpbUi.scrollDirection === 'up') {
                    $('.cpb-grobal-header').removeClass('is-hide');
                }
            } else {}
        });
    };

    var initCartFooterNavSimple = function initCartFooterNavSimple() {
        if (!$('.cpb-cart-checkout_fixed')[0]) return;

        var cartFooterShow = false;

        $(window).on('scroll', function (e) {
            if (!cpbUi.isDomReady) return;

            var scrollTop = window.pageYOffset;

            if ($('#footer').offset().top <= scrollTop + $(window).height()) {
                $('.cpb-cart-checkout_fixed').addClass('is-bottom');
            } else {
                $('.cpb-cart-checkout_fixed').removeClass('is-bottom');
            }
        });
    };

    var initCreditCardSecurityInputCheck = function initCreditCardSecurityInputCheck() {
        $(document).on('focusin', '.js-security-code-check input[type="text"]', function (e) {
            var $box = $(this).closest('.js-security-code-check');
            $box.find('input[type="radio"]').prop('checked', true);
        });
    };

    var initInnerCheckboxTrigger = function initInnerCheckboxTrigger() {
        $(document).on('click', '.js-inner-checkbox-trigger', function (e) {
            var $checkbox = $(this).find('input[type="checkbox"]');
            var flg = $checkbox.prop('checked');
            $checkbox.prop('checked', !flg);
        });
    };

    var initCreditTypeSelectImage = function initCreditTypeSelectImage() {
        $(document).on('change', '.js-credit-type-select', function (e) {
            if ($(this).val()) {
                var path = $(this).find('option:selected').attr('data-image');
                var alt = $(this).find('option:selected').text();
                $('.js-credit-type-image').html('<img src="' + path + '" alt="' + alt + '">');
            } else {
                $('.js-credit-type-image').html('');
            }
        });
    };

    var initRadioTab = function initRadioTab() {
        $(document).on('change', '.js-tab_radio', function (e) {
            e.preventDefault();
            var $box = $(this).closest('.js-tab_container');
            var $contents = $box.find('.js-tab_contents');
            var target = $(this).attr('data-tab-target');
            var $target = $contents.filter('[data-tab-contents="' + target + '"]');

            $contents.removeClass('is-active');

            if ($target[0]) {
                $target.addClass('is-active');
            }

            cpbUi.niceScroll.resize();
        });
    };

    return {
        init: function init() {
            initCreditCardSecurityInputCheck();
            initRadioTab();
            initInnerCheckboxTrigger();
            initCreditTypeSelectImage();
        },
        ready: function ready() {
            if ($('.cpb-grobal-header').hasClass('is-simple')) {
                initCartFooterNavSimple();
            } else {
                initCartFooterNavNormal();
            }
        }
    };
}();

/**
 * Utility Functions
 */
var util = {
    toggleOpen: function toggleOpen($btn, $box, callback) {
        var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'fade';
        if (toggleType === 'fade') {
            $box.find('.js-toggle_contents').eq(0).fadeIn(200, function () {
                $box.addClass('is-active');
                $(this).css('display', '');
                if (typeof callback === 'function') callback();
            });
        } else if (toggleType === 'slide') {
            $box.find('.js-toggle_contents').eq(0).slideDown(200, function () {
                $box.addClass('is-active');
                $(this).css('display', '');
                if (typeof callback === 'function') callback();
            });
        }
    },
    toggleClose: function toggleClose($btn, $box, callback) {
        var toggleType = $box.attr('data-toggle-type') ? $box.attr('data-toggle-type') : 'fade';
        if (toggleType === 'fade') {
            $box.find('.js-toggle_contents').eq(0).fadeOut(200, function () {
                $box.removeClass('is-active');
                $(this).css('display', '');
                if (typeof callback === 'function') callback();
            });
        } else if (toggleType === 'slide') {
            $box.find('.js-toggle_contents').eq(0).slideUp(200, function () {
                $box.removeClass('is-active');
                $(this).css('display', '');
                if (typeof callback === 'function') callback();
            });
        }
    },
    tabOpen: function tabOpen($btn, $box, target, callback) {
        var $btns = $box.find('.js-tab_btn');
        var $contents = $box.find('.js-tab_contents');
        var $target = $contents.filter('[data-tab-contents="' + target + '"]');

        if ($target[0] && !$btn.hasClass('is-active')) {
            $btns.removeClass('is-active');
            $contents.removeClass('is-active');
            $btn.addClass('is-active');
            $target.addClass('is-active');

            // scrollbar & slider reset
            cpbUi.niceScroll.resize($target);
            cpbUi.sliderControl.resize($target);
        }
    },
    rightModalOpen: function rightModalOpen(target, callback) {
        var baseClass = target ? target : 'modal-r';
        target = target || $(this).attr('data-modal-target');

        var $modal = $('.js-' + baseClass + '_content[data-modal-type="' + target + '"]');
        if ($modal[0]) {
            util.setModalScrollbarFix();
            $modal.addClass('is-active');
            $('html').addClass('is-modal-open');
            setTimeout(function () {
                $modal.find('.js-' + baseClass + '_overlay').fadeIn(200, function () {
                    if (typeof callback === 'function') {
                        callback(target);
                    }
                });
                $modal.find('.cpb-modalR_wrap').css({
                    transform: 'translateX(0)'
                });
                cpbUi.niceScroll.resize($modal);
            }, 10);
        }
    },
    rightModalClose: function rightModalClose(target, callback) {
        var baseClass = target ? target : 'modal-r';
        var $modal = $(this).closest('.js-' + baseClass + '_content');
        if ($modal[0]) {
            var target = $modal.attr('data-modal-type');
            var $modalWrap = $modal.find('.cpb-modalR_wrap');
            $modalWrap.on(transitionEndEvents, function () {
                $modal.find('.js-' + baseClass + '_overlay').fadeOut(200, function () {
                    $('html').removeClass('is-modal-open');
                    util.removeModalScrollbarFix();
                    $modal.removeClass('is-active');
                    if (typeof callback === 'function') {
                        callback(target);
                    }
                });
                $modalWrap.off();
            });
            $modal.find('.cpb-modalR_wrap').css({
                transform: 'translateX(100%)'
            });
        }
    },
    centerModalOpen: function centerModalOpen(target, callback) {
        var baseClass = target ? target : 'modal-c';
        target = target || $(this).attr('data-modal-target');

        var $modal = $('.js-' + baseClass + '_content[data-modal-type="' + target + '"]');
        if ($modal[0]) {
            util.setModalScrollbarFix();
            $('html').addClass('is-modal-open');
            $modal.fadeIn(200, function () {
                $modal.addClass('is-active');
                $modal.css({
                    display: ''
                });
                if (typeof callback === 'function') {
                    callback(target);
                }
            });
            cpbUi.niceScroll.resize($modal);
        }
    },
    centerModalClose: function centerModalClose(target, callback) {
        var baseClass = target ? target : 'modal-c';
        var $modal = $(this).closest('.js-' + baseClass + '_content');
        if ($modal[0]) {
            var target = $modal.attr('data-modal-type');
            $modal.fadeOut(200, function () {
                $('html').removeClass('is-modal-open');
                util.removeModalScrollbarFix();
                $modal.removeClass('is-active');
                $modal.css({
                    display: ''
                });
                if (typeof callback === 'function') {
                    callback(target);
                }
            });
        }
    },
    rightModalScreenChange: function rightModalScreenChange(target, callback) {
        var baseClass = target ? target : 'modal-r';
        var $modal = $(this).closest('.js-' + baseClass + '_content');
        if ($modal[0]) {
            var targetName = $(this).attr('data-target');
            var $target = $modal.find('.js-screen[data-name="' + targetName + '"]');
            $modal.find('.js-screen').addClass('is-hide');
            $target.removeClass('is-hide');

            if (typeof callback === 'function') {
                callback(target);
            }
        }
    },
    hasScrollbar: function hasScrollbar(windowHeight) {
        return document.body.scrollHeight > (windowHeight || $(window).height());
    },
    getScrollbarSize: function getScrollbarSize() {
        if (cpbUi.scrollbarSize === undefined) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.cssText = 'width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;';
            document.body.appendChild(scrollDiv);
            cpbUi.scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
        return cpbUi.scrollbarSize;
    },
    setModalScrollbarFix: function setModalScrollbarFix(windowHeight) {
        if (util.hasScrollbar(windowHeight)) {
            var ss = util.getScrollbarSize();
            if (ss) {
                $('html').css({
                    marginRight: ss + 'px'
                });
            }
        }
    },
    removeModalScrollbarFix: function removeModalScrollbarFix() {
        $('html').css({
            marginRight: ''
        });
    },
    getUniqueStr: function getUniqueStr(myStrong) {
        var strong = 1000;
        if (myStrong) strong = myStrong;
        return new Date().getTime().toString(16) + Math.floor(strong * Math.random()).toString(16);
    }
};

cpbUi.util = util;

/**
 * Other
 */
var setDirectionCheck = function setDirectionCheck() {
    var defDirectionCheck = window.pageYOffset;
    var $html = $('html');
    $(window).on('scroll', function (e) {
        var scrollTop = window.pageYOffset;
        var flg = '';
        if (defDirectionCheck < scrollTop) {
            flg = 'down';
            if ($html.hasClass('is-up')) $html.removeClass('is-up');
        } else if (defDirectionCheck > scrollTop) {
            flg = 'up';
            if (!$html.hasClass('is-up')) $html.addClass('is-up');
        }

        if (scrollTop === 0 && !$html.hasClass('is-pos-top')) {
            $html.addClass('is-pos-top');
        } else if (scrollTop !== 0 && $html.hasClass('is-pos-top')) {
            $html.removeClass('is-pos-top');
        }

        cpbUi.scrollDirection = flg;
        defDirectionCheck = scrollTop;
    });
};

/**
 * PDP SKINCOLOR
 */
cpbUi.pdpSkinColor = function () {
    var itemSort = function itemSort(array) {
        array.sort(function (a, b) {
            return a[0].skincolor_num - b[0].skincolor_num;
        });
        for (var i = 0; i < array.length; i++) {
            array[i].sort(function (a, b) {
                return a.no - b.no;
            });
        }
        return array;
    };

    var getSkincolorDefaultNum = function getSkincolorDefaultNum(array) {
        var defaultNum;
        for (var i = 0; i < array.length; i++) {
            for (var j = 0; j < array[i].length; j++) {
                if (array[i][j].default && array[i][j].default === '1') {
                    defaultNum = array[i][j].skincolor_num;
                    break;
                }
            }
        }
        return defaultNum - 1;
    };

    var skinColorMount = function skinColorMount() {
        var SkinColorComponent = Vue.extend({
            props: ['skincolorData', 'skinColorDefaultNum', 'skinColorDefaultView'],
            template: '<div class="pdp-skincolor">\
                   <h3 class="pdp-skincolor_ttl"><span>EXAMPLE OF USE</span></h3>\
\
                   <div class="pdp-skincolor_container cmd-tabAcc_container">\
                     <ul class="pdp-skincolor_skincolor-tabs cpb-products-summary_tab_list cmd-tabAcc_list cmd-md-4">\
                       <li class="pdp-skincolor_skincolor-tab" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorTab\' + skinIndex">\
                         <a href="javascript:void(0);" class="pdp-skincolor_skincolor-btn cmd-tabAcc_btn js-skincolor_skincolor-btn" :class="[{\'is-active\': isDefault(skinIndex)}]" :data-skincolor-num="skinIndex" data-type="pc">\
                           <span v-text="\'SKIN TONE \' + skincolor[0].skincolor_num"></span>\
                         </a>\
                       </li>\
                     </ul>\
\
                     <div class="pdp-skincolor_view-tabs">\
                       <div class="pdp-skincolor_view-tab _image-view">\
                         <a href="javascript:void(0);" class="pdp-skincolor_view-btn icoset js-skincolor_view-btn" :class="[{\'is-active\': isDefaultView(\'image\')}]" data-view-type="image"><span>Image VIEW</span></a>\
                       </div>\
                       <div class="pdp-skincolor_view-tab _grid-view">\
                         <a href="javascript:void(0);" class="pdp-skincolor_view-btn icoset js-skincolor_view-btn" :class="[{\'is-active\': isDefaultView(\'grid\')}]" data-view-type="grid"><span>Grid VIEW</span></a>\
                       </div>\
                     </div>\
\
                     <div class="pdp-skincolor_contents">\
                       <ul class="pdp-skincolor_content _image-view cmd-tabAcc_contents" :class="[{\'is-active\': isDefaultView(\'image\')}]" data-view-type="image">\
                         <li class="pdp-skincolor_content-skincolor cmd-tabAcc_box" :class="[{\'is-active\': isDefault(skinIndex)}]" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorContent\' + skinIndex" :data-skincolor-num="skinIndex">\
\
                           <div class="pdp-skincolor_sp-toggle cmd-tabAcc-in_btn">\
                             <a href="javascript:void(0);" class="pdp-skincolor_skincolor-btn cmd-tabAcc_drawer_btn js-skincolor_skincolor-btn" :class="[{\'is-active\': isDefault(skinIndex)}]" :data-skincolor-num="skinIndex" data-type="sp"><span v-text="\'SKIN TONE \' + skincolor[0].skincolor_num"></span></a>\
                           </div>\
\
                           <div class="pdp-skincolor_items js-skincolor-slider">\
                             <div class="pdp-skincolor_item" v-for="(item, itemIndex) in skincolor" :key="\'skincolorItem\' + item.no">\
                               <div class="item-row">\
                                 <div class="item-column _image">\
                                   <div class="item_color-image">\
                                     <img :src="getImagePath(item)" alt="">\
                                   </div>\
                                 </div>\
                                 <div class="item-column _color">\
                                   <div class="item-column_inner">\
                                     <div class="item_name" v-text="item.name"></div>\
                                     <div class="item_colorchip"><img :src="item.colorchip_path" alt=""></div>\
                                     <div class="item_colorchip-name">\
                                       <span v-text="item.color_code"></span>\
                                       <span v-text="\' \' + item.color_name" v-if="item.color_name"></span>\
                                     </div>\
                                   </div>\
                                 </div>\
                               </div>\
                             </div>\
                           </div>\
                         </li>\
                       </ul>\
\
                       <ul class="pdp-skincolor_content _grid-view cmd-tabAcc_contents" :class="[{\'is-active\': isDefaultView(\'grid\')}]" data-view-type="grid">\
                         <li class="pdp-skincolor_content-skincolor" :class="[{\'is-active\': isDefault(skinIndex)}]" v-for="(skincolor, skinIndex) in skincolorData" :key="\'skincolorContent\' + skinIndex" :data-skincolor-num="skinIndex">\
                           <ul class="pdp-skincolor_items">\
                             <li class="pdp-skincolor_item" v-for="(item, itemIndex) in skincolor" :key="\'skincolorItem\' + item.no">\
                               <div class="item_color-image">\
                                 <img :src="getImagePath(item)" alt="">\
                               </div>\
                               <div class="item_colorchip-name">\
                                 <span v-text="item.color_code"></span>\
                                 <span v-text="\' \' + item.color_name" v-if="item.color_name"></span>\
                               </div>\
                             </li>\
                           </ul>\
                         </li>\
                       </ul>\
                     </div>\
                   </div>\
                 </div>'
        });

        var skinColorItemData = itemSort(skinColorData);
        var skinColorDefaultNum = getSkincolorDefaultNum(skinColorItemData);
        var skinColorDefaultView = $('#skincolor-app').attr('data-default-view') || 'image';
        var skinColorComponent = new SkinColorComponent({
            propsData: {
                skincolorData: skinColorItemData,
                skinColorDefaultNum: skinColorDefaultNum,
                skinColorDefaultView: skinColorDefaultView
            },
            methods: {
                getImagePath: function getImagePath(item) {
                    return '/on/demandware.static/Sites-cpb_' + item.country + '-Site/pdp/skincolor/images/' + item.product_code + '/' + item.filename;
                },
                isDefault: function isDefault(skinIndex) {
                    return skinIndex === this.skinColorDefaultNum;
                },
                isDefaultView: function isDefaultView(view) {
                    return this.skinColorDefaultView === view;
                }
            }
        }).$mount();

        var $skincolorApp = $('#skincolor-app');
        $skincolorApp.html(skinColorComponent.$el.outerHTML);

        var $skincolor = $skincolorApp.find('.pdp-skincolor');
        $skincolor.addClass('initialize');
        $skincolor.find('.js-skincolor-slider').slick();

        var setSkincolorHandler = function setSkincolorHandler(e) {
            e.preventDefault();
            var skincolorNum = $(this).attr('data-skincolor-num');
            var $skincolorContent = $skincolor.find('.pdp-skincolor_content-skincolor');
            var $skincolorBtn = $skincolor.find('.js-skincolor_skincolor-btn');
            var $skincolorSelectBtn = $skincolorBtn.filter('[data-skincolor-num="' + skincolorNum + '"]');
            var $skincolorContentSelect = $skincolorContent.filter('[data-skincolor-num="' + skincolorNum + '"]');
            var $skincolorContentSelectItems = $skincolorContentSelect.find('.pdp-skincolor_items');
            var isActive = $(this).hasClass('is-active');

            if ($(this).attr('data-type') === 'sp') {
                if (isActive) {
                    $skincolorSelectBtn.removeClass('is-active');
                    $skincolorContentSelectItems.find('.slick-arrow').hide();
                    $skincolorContentSelectItems.slideUp(300, function () {
                        $skincolorContentSelect.removeClass('is-active');
                        $skincolorContentSelectItems.css({
                            display: ''
                        });
                        $skincolorContentSelectItems.find('.slick-arrow').css({
                            display: ''
                        });
                    });
                } else {
                    $skincolor.find('.js-skincolor_skincolor-btn').filter('[data-skincolor-num="' + skincolorNum + '"]').addClass('is-active');

                    // slider setposition
                    $skincolorContentSelectItems.show().height(0);
                    $skincolorContentSelect.find('.js-skincolor-slider').slick('setPosition');
                    $skincolorContentSelectItems.hide().css({
                        'height': ''
                    });

                    $skincolorContentSelect.find('.item-column_inner').css({
                        opacity: 0
                    });
                    $skincolorContentSelect.find('.slick-arrow').css({
                        opacity: 0
                    });

                    $skincolorContentSelectItems.slideDown(500, function () {
                        $skincolorContentSelect.addClass('is-active');
                        $skincolorContentSelectItems.css({
                            display: ''
                        });
                    });

                    setTimeout(function () {
                        $skincolorContentSelect.find('.item-column_inner').animate({
                            opacity: 1
                        });
                        $skincolorContentSelect.find('.slick-arrow').animate({
                            opacity: 1
                        }, function () {
                            $skincolorContentSelect.find('.item-column_inner').css({
                                display: ''
                            });
                            $skincolorContentSelect.find('.slick-arrow').css({
                                display: ''
                            });
                        });
                    }, 450);
                }
            } else {
                if (isActive) return;

                $skincolor.find('.js-skincolor_skincolor-btn').removeClass('is-active');
                $skincolor.find('.js-skincolor_skincolor-btn').filter('[data-skincolor-num="' + skincolorNum + '"]').addClass('is-active');

                $skincolorContent.css({
                    opacity: 0
                });

                setTimeout(function () {
                    $skincolorContent.removeClass('is-active');
                    $skincolorContent.css({
                        opacity: ''
                    });
                    $skincolorContentSelect.addClass('is-active').css({
                        opacity: 0
                    });

                    setTimeout(function () {
                        $skincolorContentSelect.css({
                            opacity: ''
                        });
                        $skincolorContentSelect.find('.js-skincolor-slider').slick('setPosition');
                    }, 50);
                }, 250);
            }
        };

        var setViewTypeHandler = function setViewTypeHandler(e) {
            e.preventDefault();
            if ($(this).hasClass('is-active')) return;

            var viewType = $(this).attr('data-view-type');

            $skincolor.find('.pdp-skincolor_view-btn').removeClass('is-active');
            $skincolor.find('.pdp-skincolor_view-btn').filter('[data-view-type="' + viewType + '"]').addClass('is-active');

            $skincolor.find('.pdp-skincolor_content').css({
                opacity: 0
            });

            setTimeout(function () {
                $skincolor.find('.pdp-skincolor_content').removeClass('is-active');
                $skincolor.find('.pdp-skincolor_content').filter('[data-view-type="' + viewType + '"]').addClass('is-active').css({
                    opacity: 0
                });

                setTimeout(function () {
                    $skincolor.find('.pdp-skincolor_content').css({
                        opacity: ''
                    });

                    if (viewType === 'image') {
                        $skincolor.find('.pdp-skincolor_content').filter('[data-view-type="' + viewType + '"]').find('.js-skincolor-slider').slick('setPosition');
                    }
                }, 50);
            }, 250);
        };

        $(document).on('click', '.js-skincolor_skincolor-btn', setSkincolorHandler);
        $(document).on('click', '.js-skincolor_skincolor-btn-sp', setSkincolorHandler);
        $(document).on('click', '.js-skincolor_view-btn', setViewTypeHandler);
    };

    var initMatchMedia = function initMatchMedia() {
        window.matchMedia('(min-width:769px)').addListener(function () {
            if (window.matchMedia('(min-width:769px)').matches) {
                var $skinColor = $('#skincolor-app');
                var $selectedBtns = $skinColor.find('.pdp-skincolor_skincolor-tabs').find('.js-skincolor_skincolor-btn.is-active');
                var $selectBtnFirst = $selectedBtns.length === 0 ? $skinColor.find('.pdp-skincolor_skincolor-tabs').find('.js-skincolor_skincolor-btn').eq(0) : $selectedBtns.first();

                if ($selectedBtns.length === 1) return;

                // reset
                $skinColor.find('.js-skincolor_skincolor-btn').removeClass('is-active');
                $skinColor.find('.pdp-skincolor_content-skincolor').removeClass('is-active');

                // set
                var targetNum = $selectBtnFirst.attr('data-skincolor-num');
                $selectBtnFirst.addClass('is-active');

                var $selectedImageContent = $skinColor.find('.pdp-skincolor_content._image-view').find('.pdp-skincolor_content-skincolor').filter('[data-skincolor-num="' + targetNum + '"]');
                $selectedImageContent.addClass('is-active');
                $selectedImageContent.find('.js-skincolor_skincolor-btn').addClass('is-active');

                var $selectedGridContent = $skinColor.find('.pdp-skincolor_content._grid-view').find('.pdp-skincolor_content-skincolor').filter('[data-skincolor-num="' + targetNum + '"]');
                $selectedGridContent.addClass('is-active');
            }
        });
    };

    return {
        init: function init() {},
        ready: function ready() {
            if (typeof window.skinColorData === 'undefined') return;
            if (!$('#skincolor-app')[0]) return;
            skinColorMount();
            initMatchMedia();
        }
    };
}();

/**
 * Naire Modal
 */
var naireModal = function () {
    var naireTransition = function naireTransition(callback) {
        var target = $(this).attr('data-target');
        var $box = $(this).closest('.js-modal-r_content');
        var $currentBox = $(this).closest('.cpb-modalR_scroll_cover');
        var $targetBox = $box.find('.cpb-modalR_scroll_cover').filter('[data-name="' + target + '"]');

        $currentBox.animate({
            opacity: 0
        }, 300, function () {
            $currentBox.addClass('is-hide').css({
                opacity: ''
            });
            $targetBox.removeClass('is-hide').css({
                opacity: 0
            }).animate({
                opacity: 1
            }, 300, function () {
                $targetBox.css({
                    opacity: ''
                });
            });

            cpbUi.niceScroll.resize($box);

            if (typeof callback === 'function') callback();
        });
    };

    return {
        init: function init() {
            $(document).on('click', '.js-naire-product', function (e) {
                e.preventDefault();
                naireTransition.call(this, function () {});
            });
            $(document).on('click', '.js-naire-setting', function (e) {
                e.preventDefault();
                naireTransition.call(this, function () {});
            });
            $(document).on('click', '.js-naire-back', function (e) {
                e.preventDefault();
                naireTransition.call(this, function () {});
            });

            var textCheck = function textCheck() {
                var $box = $(this).closest('.js-modal-r_content');
                var text = $(this).val();

                text = text.replace(/[^a-zA-Z0-9 .&]/g, '');
                text = text.substr(0, 10);

                $(this).val(text);
                $box.find('.js-naire-preview').text(text);

                if (!text) {
                    $box.find('.js-naire-preview').text($(this).attr('placeholder'));
                }
            };

            var composition = false;

            $(document).on('keyup', '.js-naire-input', function (e) {
                if (!composition) {
                    textCheck.call(this);
                }
            });

            $(document).on('compositionstart', '.js-naire-input', function (e) {
                e.preventDefault();
                composition = true;
            });
            $(document).on('compositionend', '.js-naire-input', function (e) {
                composition = false;
                textCheck.call(this);
            });

            $(document).on('focusout', '.js-naire-input', function (e) {
                textCheck.call(this);
            });
        },
        ready: function ready() {}
    };
}();

/**
 * Movie Modal
 */
var movieModal = function () {
    var modalHtml = '\
 <div class="cpb-modalC_container cmd-modal-video js-modal-video_content">\
   <div class="cpb-modalC_wrap">\
     <div class="cpb-modalC_inner">\
       <div class="cmd-video_flex">\
         <iframe id="ytplayer" type="text/html" width="640" height="360" src="{{URL}}" frameborder="0" allowfullscreen allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"></iframe>\
       </div><!-- / cmd-video_flex-->\
     </div><!-- / cpb-modalC_inner -->\
   </div><!-- / cpb-modalC_wrap -->\
   <div class="cpb-modal_overlay js-modal-video_overlay"></div>\
 </div><!-- / cpb-modalC_container -->';

    return {
        init: function init() {
            $(document).on('click', '.js-modal-video', function (e) {
                e.preventDefault();
                var embedUrl = $(this).attr('href');
                var html = modalHtml.replace('{{URL}}', embedUrl);
                var $modal = $(html);
                var $wrapSlider = $(this).closest('.js-slider_container');

                $('html').addClass('is-modal-open');
                $('body').append($modal);

                if ($wrapSlider[0] && $wrapSlider.hasClass('slick-initialized')) {
                    var isAutoPlay = cpbUi.sectionSlider.getAutoPlay($wrapSlider);
                    if (isAutoPlay) {
                        var unique = 'id' + cpbUi.util.getUniqueStr();
                        $modal.attr('data-slider-autoplay', 'true');
                        $modal.attr('data-original', unique);
                        $wrapSlider.addClass(unique);
                        cpbUi.sectionSlider.pause($wrapSlider);
                    }
                }

                $modal.fadeIn();
            });

            var closeFunc = function closeFunc(e) {
                e.preventDefault();
                var $modal = $(this).closest('.js-modal-video_content');
                var unique = $modal.attr('data-original');
                var $original = $('.' + unique);
                $modal.animate({
                    opacity: 0
                }, 300, function () {
                    $modal.find('iframe').attr('src', '//about:blank');
                    $modal.remove();
                    cpbUi.sectionSlider.play($original);
                    $original.removeClass(unique);
                    $('html').removeClass('is-modal-open');
                });
            };

            $(document).on('click', '.js-modal-video_close', closeFunc);
            $(document).on('click', '.js-modal-video_overlay', closeFunc);
        },
        ready: function ready() {}
    };
}();

/**
 * section slider
 */
cpbUi.sectionSlider = function () {

    var ytPlayersMainSlider = {};
    var matchMediaPC = window.matchMedia('screen and (min-width: 993px)');
    var isPC = function isPC() {
        return matchMediaPC.matches;
    };

    var getBgMovieSize = function getBgMovieSize(aspectW, aspectH) {
        aspectW = aspectW || 16;
        aspectH = aspectH || 9;
        var videoRatio = (aspectW / aspectH).toFixed(2);
        var minWidth = window.innerWidth ? window.innerWidth : $(window).width();
        var minHeight = $(window).height() + 100;
        var widthRatio = minWidth / aspectW;
        var heightRatio = minHeight / aspectH;
        var size = {};
        if (widthRatio > heightRatio) {
            size.width = minWidth;
            size.height = Math.ceil(minWidth / videoRatio);
        } else {
            size.height = minHeight;
            size.width = Math.ceil(minHeight * videoRatio);
        }
        return size;
    };

    var mainSliderReady = function mainSliderReady() {
        var windowWidth = $(window).width();
        var windowDelay = 0;

        $('.js-slider_container[data-slider-type="main"]').each(function () {
            if ($(this).hasClass('slick-initialized')) return;

            var $slider = $(this);
            var $sliderWrap = $slider.parent('.cmd-section_slider');
            var uniqueId = 'id' + cpbUi.util.getUniqueStr();
            var carouselDuration = $(this).attr('data-slider-duration') || 15000;
            var videoList = [];
            var nextTimer;
            var seekbarTimer;
            var loadingTimer;
            var isSingleAndMovie = false;
            var hasVideoContent = $slider.find('.cmd-visual_video')[0];
            ytPlayersMainSlider[uniqueId] = [];

            $slider.addClass(uniqueId);
            if (hasVideoContent) $slider.addClass('has-video');

            if (!isPC()) {
                $slider.removeClass('is-loading');
            }

            // YouTubeの埋め込み
            function onPlayerReady(event) {
                event.target.mute();
                event.target.getPlaybackQuality('highres');
                sliderReady(event);
            }

            function onPlayerStateChange(event) {
                if (event.data === YT.PlayerState.ENDED) {
                    // $slider.slick('slickNext');
                }
            }

            function getVideoList() {
                var videoList = [];

                $slider.find('.cmd-visual_container').each(function (index) {
                    var $el = $(this).find('.cmd-visual_iframe-wrap');
                    if ($el[0]) {
                        $slider.removeClass('is-loading');
                        $el.attr('id', 'visual-slider_movieid_' + uniqueId + '_' + index);
                        videoList.push({
                            index: index,
                            videoId: $el.attr('data-yt-id')
                        });
                    }
                });

                return videoList;
            }

            function youtubeSetup() {
                for (var i = 0; i < videoList.length; i++) {
                    var playerVars = {
                        // 'autoplay': 1,
                        'controls': 0,
                        // 'loop': 1,
                        // 'playlist': videoList[i].videoId,
                        'disablekb': 1,
                        'rel': 0,
                        'playsinline': 1
                    };

                    // ytPlayersMainSlider[uniqueId].push('');

                    isSingleAndMovie = $slider.find('.cmd-slide').length === 1;

                    if (isSingleAndMovie) {
                        playerVars.playlist = videoList[i].videoId;
                        playerVars.loop = 1;
                    }

                    var ytPlayer = new YT.Player('visual-slider_movieid_' + uniqueId + '_' + videoList[i].index, {
                        width: 640,
                        height: 480,
                        videoId: videoList[i].videoId,
                        playerVars: playerVars,
                        events: {
                            'onReady': onPlayerReady,
                            'onStateChange': onPlayerStateChange
                        }
                    });
                    // ytPlayersMainSlider[uniqueId][videoList[i].index] = ytPlayer;
                    ytPlayersMainSlider[uniqueId].push(ytPlayer);
                }
            }

            function sliderInit() {
                slickInit();

                videoList = getVideoList();

                if (videoList.length) {
                    youtubeSetup();
                } else {
                    sliderReady();
                }
            }

            function sliderReady(event) {
                if (event && $(event.target.getIframe()).attr('id') === 'visual-slider_movieid_' + uniqueId + '_0') {
                    if (isPC() && ytPlayersMainSlider[uniqueId][0] && ytPlayersMainSlider[uniqueId][0].playVideo) {
                        ytPlayersMainSlider[uniqueId][0].playVideo();

                        setTimeout(function () {
                            $slider.removeClass('is-loading');
                            $slider.addClass('is-loaded');
                        }, 100);
                    }
                } else {
                    setTimeout(function () {
                        $slider.removeClass('is-loading');

                        setTimeout(function () {
                            $slider.addClass('is-loaded');
                        }, 2500);
                    }, 500);
                }
                slideStart(null, 0);
            }

            function slickInit() {
                $slider.on('init', function (event, slick) {
                    if (!$(slick.$slides[0]).find('.cmd-visual_video')[0]) {
                        $slider.removeClass('is-loading');
                    }
                    if ($(slick.$slides[0]).find('.cmd-visual_video')[0]) {
                        $(slick.$slides[0]).addClass('is-wait');
                    }

                    matchMediaPC.addListener(function (e) {
                        if (e.matches) {
                            var index = $slider.find('.slick-active').attr('data-slick-index');
                            if (ytPlayersMainSlider[uniqueId][index] && ytPlayersMainSlider[uniqueId][index].playVideo) {
                                ytPlayersMainSlider[uniqueId][index].playVideo();
                            }
                        } else {
                            for (var i = 0; i < ytPlayersMainSlider[uniqueId].length; i++) {
                                if (ytPlayersMainSlider[uniqueId][i].stopVideo) {
                                    ytPlayersMainSlider[uniqueId][i].stopVideo();
                                }
                            }
                        }
                    });
                });

                $slider.slick({
                    fade: true,
                    infinite: true,
                    dots: true,
                    appendDots: $slider.nextAll('.js-slider_dots'),
                    arrows: true,
                    appendArrows: $slider.nextAll('.js-slider_arrow')
                });

                $sliderWrap.find('.slick-dots').find('button').append('<span class="bar"></span>');

                $slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {});

                $slider.on('afterChange', function (event, slick, currentSlide) {
                    slideStart(slick, currentSlide);
                });

                centerSet_arrow_dots($slider);
            }

            function slideStart(slick, currentSlide) {
                clearTimeout(nextTimer);
                clearInterval(seekbarTimer);
                clearTimeout(loadingTimer);

                for (var i = 0; i < ytPlayersMainSlider[uniqueId].length; i++) {
                    if (ytPlayersMainSlider[uniqueId][i].stopVideo) {
                        ytPlayersMainSlider[uniqueId][i].stopVideo();
                    }
                }

                var $currentSlide = $slider.find('.slick-slide[data-slick-index="' + currentSlide + '"]');

                // 動画コンテンツはすべてwait
                $slider.find('.slick-slide').each(function () {
                    if ($(this).find('.cmd-visual_video')[0]) {
                        if (isPC()) {
                            $(this).addClass('is-wait');
                        }
                    }
                });

                // 動画が再生開始したらwait解除
                var loop = function loop() {
                    if (ytPlayersMainSlider[uniqueId][currentSlide] && ytPlayersMainSlider[uniqueId][currentSlide].getPlayerState() === YT.PlayerState.PLAYING) {
                        clearTimeout(loadingTimer);
                        $currentSlide.removeClass('is-wait');
                    }
                    loadingTimer = setTimeout(loop, 50);
                };
                if (isPC()) {
                    loop();
                } else {
                    $currentSlide.removeClass('is-wait');
                }

                $sliderWrap.find('.slick-dots').find('.bar').css('width', 0);

                if (ytPlayersMainSlider[uniqueId][currentSlide] && isPC()) {
                    ytPlayersMainSlider[uniqueId][currentSlide].playVideo();
                }
                seekbarPlay($currentSlide, currentSlide);
            }

            function videoStop() {
                clearTimeout(nextTimer);
                clearInterval(seekbarTimer);
                clearTimeout(loadingTimer);

                var currentSlideNum = $slider.slick('slickCurrentSlide');
                var $currentSlide = $slider.find('[data-slick-index="' + currentSlideNum + '"]');

                if ($currentSlide.find('.cmd-visual_video')[0]) {
                    if (isPC()) {
                        $currentSlide.addClass('is-wait');
                    }
                }

                setTimeout(function () {
                    ytPlayersMainSlider[uniqueId][currentSlideNum].stopVideo();
                }, 500);
            }

            function seekbarPlay($currentSlide, currentSlide) {
                var cnt = 0;
                var step = 10;
                var subtract = 500;
                var $dotsBar = $sliderWrap.find('.slick-dots').find('li').eq(currentSlide).find('.bar');

                seekbarTimer = setInterval(function () {
                    var duration = carouselDuration;

                    if (!$currentSlide.find('.cmd-visual_video')[0] || !isPC()) {
                        cnt += 10;
                    } else {
                        var movieDuration = ytPlayersMainSlider[uniqueId][currentSlide].getDuration() * 1000 - subtract;
                        duration = carouselDuration > movieDuration ? movieDuration : carouselDuration;
                        cnt = ytPlayersMainSlider[uniqueId][currentSlide].getCurrentTime() * 1000;
                    }

                    $dotsBar.css('width', cnt / duration * 100 + '%');

                    if (duration > 0 && duration < cnt) {
                        // 再生終了0.5秒前に次ぎスライドへ移動
                        // 関連動画表示対処
                        clearInterval(seekbarTimer);
                        if (isSingleAndMovie) {
                            if (typeof $slider.attr('data-slider-video-loop') !== 'undefined' && $slider.attr('data-slider-video-loop') === 'false') {
                                // $slider.find('.slick-slide.slick-active').find('.cmd-visual_video').css({opacity: 0});
                                videoStop();
                            } else {
                                slideStart(null, 0);
                            }
                        } else {
                            if (typeof $slider.attr('data-slider-autoplay') !== 'undefined' && $slider.attr('data-slider-autoplay') === 'false') {
                                videoStop();
                            } else {
                                $slider.slick('slickNext');
                            }
                        }
                    }
                }, 10);
            }

            sliderInit();
        });

        $(window).on('resize', function (e) {
            if ($(window).width() !== windowWidth) {
                clearTimeout(windowDelay);
                windowDelay = window.setTimeout(function () {
                    windowWidth = $(window).width();

                    $('.js-slider_container').filter('.has-video').each(function () {
                        var movieSize = getBgMovieSize();
                        $(this).find('.cmd-visual_video').each(function () {
                            $(this).css(movieSize);
                        });
                    });
                }, 50);
            }
        }).trigger('resize');
    };

    var mainSliderInit = function mainSliderInit() {
        // youtube api の読み込みと同時に YT YT.Player をチェック
        // APIの読み込みが完了したらsliderの実行
        // window.onYouTubeIframeAPIReadyは他のjsから実行されれている場合があるためYTをチェックする
        var youtubeApiLoad = function youtubeApiLoad() {
            var tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            var firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        };

        youtubeApiLoad();

        var YTcheck = setInterval(function () {
            if (typeof YT !== 'undefined' && typeof YT.Player !== 'undefined') {
                mainSliderReady();
                clearInterval(YTcheck);
            }
        }, 50);
    };

    var normalSliderInit = function normalSliderInit() {
        $('.js-slider_container').not('[data-slider-type="main"]').each(function () {
            var $slider = $(this);
            if (!$slider.hasClass('slick-initialized')) {
                var option = {
                    arrows: true,
                    appendArrows: $slider.nextAll('.js-slider_arrow'),
                    dots: true,
                    appendDots: $slider.nextAll('.js-slider_dots'),
                    autoplay: $slider.attr('data-slider-autoplay') === 'true',
                    autoplaySpeed: $slider.attr('data-slider-autoplay') === 'true' ? $slider.attr('data-slider-autoplayspeed') || 3000 : 0
                };

                $slider.slick(option);
                centerSet_arrow_dots($slider);
            }
        });
    };

    var centerSet_arrow_dots = function centerSet_arrow_dots($slider) {
        setTimeout(function () {
            if ($slider.hasClass('slick-initialized')) {
                var $arrow = $slider.nextAll('.js-slider_arrow');
                var $dots = $slider.nextAll('.js-slider_dots');
                var boxHeight = $slider.find('.slick-active').find('.cmd-visual_img').height();
                if ($slider.find('.slick-active').find('.cmd-visual_img')[0]) {
                    if (boxHeight) {
                        // $arrow.css({top: boxHeight/2});
                        $dots.css({
                            top: boxHeight
                        });
                    } else {
                        centerSet_arrow_dots($slider);
                    }
                }
            }
        }, 100);
    };

    var resizeCheckSliderParts = function resizeCheckSliderParts() {
        var windowDelay;
        var windowWidth = $(window).width();

        $(window).on('resize', function (e) {
            if ($(window).width() !== windowWidth) {
                clearTimeout(windowDelay);
                windowDelay = window.setTimeout(function () {
                    windowWidth = $(window).width();

                    $('.js-slider_container').each(function () {
                        var $slider = $(this);
                        centerSet_arrow_dots($slider);
                    });
                }, 50);
            }
        });
    };

    return {
        init: function init() {},
        ready: function ready() {
            normalSliderInit();
            mainSliderInit();
            resizeCheckSliderParts();
        },
        reInit: function reInit($target, option) {
            if ($target[0] && typeof $target.slick !== 'undefined') {
                $target.slick('slickSetOption', option);
            }
        },
        getAutoPlay: function getAutoPlay($target) {
            if ($target[0] && typeof $target.slick !== 'undefined') {
                return $target.slick('slickGetOption', 'autoplay');
            } else {
                return undefined;
            }
        },
        playPause: function playPause($target) {
            if ($target[0] && typeof $target.slick !== 'undefined') {
                var nowPlay = $target.slick('slickGetOption', 'autoplay');
                if (nowPlay) {
                    $target.slick('slickPause');
                } else {
                    $target.slick('slickPlay');
                }
            }
        },
        pause: function pause($target) {
            if ($target[0] && typeof $target.slick !== 'undefined') {
                $target.slick('slickPause');
            }
        },
        play: function play($target) {
            if ($target[0] && typeof $target.slick !== 'undefined') {
                $target.slick('slickPlay');
            }
        }
    };
}();

/**
 * inview animation
 */
var inViewAnimation = function () {
    return {
        init: function init() {},
        ready: function ready() {
            $('.js-anim-inout').on('inview', function (event, isInView) {
                if (isInView) {
                    $(this).addClass('is-anim-active');
                } else {
                    $(this).removeClass('is-anim-active');
                }
            });
            $('.js-anim-in').one('inview', function (event, isInView) {
                if (isInView) {
                    $(this).addClass('is-anim-active');
                }
            });
        }
    };
}();

var design = {
    init: function init() {
        setDirectionCheck();
        initHeader.init();
        initFooter.init();
        initGlobalNavigation.init();
        initRightModal.init();
        initRightModalLoginResetPassword.init();
        initCenterModal.init();
        initQuickView.init();
        standardTab.init();
        standardToggle.init();
        snsToggle.init();
        tabAccordion.init();
        selectChangeContent.init();
        numDropDown.init();
        inputToggle.init();
        cart.init();
        naireModal.init();
        movieModal.init();

        /**
         * page:DOMContent​Loaded
         */
        cpbUi.isDomReady = true;
        cpbUi.isPdp = $('#contents').hasClass('pdp-main');
        cpbUi.niceScroll.ready();
        cpbUi.recommendSlider.ready();
        selectChangeContent.ready();
        if (cpbUi.isPdp) {
            cpbUi.pdp.ready();
            cpbUi.pdpSkinColor.ready();
        }
        inputToggle.ready();
        cart.ready();
        cpbUi.sectionSlider.ready();
        inViewAnimation.ready();

        // scroll fix
        $(window).trigger('scroll');
        window.cpbUi = cpbUi;
    }
};

module.exports = design;

},{"./pages/product":43}],21:[function(require,module,exports){
'use strict';

var util = require('./util'),
    validator = require('./validator'),
    modal = require('./modal').global;

function showNewsletterModal() {
    modal.events.onClose(function () {
        var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
        util.setCookie(shouldDisplayNewsletter, false, 10);
    });

    modal.renderByUrl(Urls.showFullNewsletterForm).success(function (response) {
        modal.addCustomClass('newsletter-signup-modal');

        $('.modal-content button').prop('disabled', true);
        $('.modal-content button').css('color', '#FFFFFF');

        validator.initForm('.newsletter-signup-modal form');
    });
}

function isNewsletterEnabled() {
    $('.register-newsletter').removeClass('hide');
    $('.newsletter-success').addClass('hide');

    if (!enableNewsletter) {
        return;
    }

    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    var isViewedNewsletterValid = util.getCookieSelector(hasViewedNewsletter);

    if (isViewedNewsletterValid === 'true') {
        return;
    }

    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

    if (isDisplayedNewsletterValid === 'false') {
        return;
    }

    util.setCookie(hasViewedNewsletter, false, newsletterCookieDuration);
    util.setCookie(shouldDisplayNewsletter, true, newsletterCookieDuration);

    setNewsletterCounterCookie();
    signUpEventListener();
}

function setNewsletterCounterCookie() {
    var pageViewCount = [siteId, 'pageViewCount'].join('-');
    var isCookieValid = util.getCookieSelector(pageViewCount);
    var counterCookie = Number(isCookieValid);

    if (!isCookieValid) {
        counterCookie = 0;
    } else {
        counterCookie += 1;
    }

    util.setCookie(pageViewCount, counterCookie, newsletterCookieDuration);

    var shouldDisplayNewsletter = [siteId, 'shouldDisplayNewsletter'].join('-');
    var isDisplayedNewsletterValid = util.getCookieSelector(shouldDisplayNewsletter);

    if (counterCookie >= pageViewsToNewsletter && isDisplayedNewsletterValid === 'true') {
        showNewsletterModal();
    }
}

function signUpEventListener() {
    //S-Refresh niceScroll
    $('.news-letter-form button[type="submit"]').click(function (event) {
        event.preventDefault;
        $(this).closest('[data-modal-type="newsletter"]').find('.js-modal_scroll').removeClass('scroll-initialized');
        cpbUi.niceScroll.ready();
    });

    $('form.news-letter-form').keyup(function (event) {
        var code = event.keyCode || event.which;
        // tab key
        if (code == '9') {
            $(this).closest('[data-modal-type="newsletter"]').find('.js-modal_scroll').removeClass('scroll-initialized');
            cpbUi.niceScroll.ready();
        }
    });
    // event when click up or key up the input, refresh niceScroll
    $('div[data-modal-type="newsletter"]').on('keyup blur', '.cpb-modalR_contents input', function (e) {
        $(this).closest('[data-modal-type="newsletter"]').find('.js-modal_scroll').removeClass('scroll-initialized');
        cpbUi.niceScroll.ready();
    });
    //E-Refresh niceScroll

    $(document).on('submit', '.modal-content .news-letter-form', function (e) {
        e.preventDefault();

        var emailAddress = $('.modal-content input').val();
        validateNewsletterEmail(true, emailAddress);
    }).on('keyup blur', '.modal-content input', function (e) {
        var emailAddress = $(this).val();

        $('.modal-content button').prop('disabled', false);
        $('.modal-content button').css('color', '');

        if (!emailAddress.length) {
            $('.modal-content button').prop('disabled', true);
            $('.modal-content button').css('color', '#FFFFFF');
        }
    });
}

function newsletterHeader() {
    $(document).on('submit', 'form.news-letter-form', function (e) {
        e.preventDefault();

        // return the feature when firstname or lastname is invalid
        if (!$('.news-letter-form #newsletter-firstname').valid() || !$('.news-letter-form #newsletter-lastname').valid()) {
            return;
        }

        var emailAddress = $('.news-letter-form #newsletter-email').val();
        validateNewsletterEmail(false, emailAddress);
    });
}

function validateNewsletterEmail(isModal, emailAddress) {
    var firstName = $('.news-letter-form #newsletter-firstname').val();
    var lastName = $('.news-letter-form #newsletter-lastname').val();
    var validateClass = '.news-letter-form';

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
    $(validateClass + ' span').remove();

    if (!util.validateEmail(emailAddress)) {
        var errorMessage;

        if (isModal) {
            errorMessage = ['<span id="-error" class="error">', Resources.VALIDATE_EMAIL, '</span>'].join('');

            $(validateClass + ' .promotions-container').after(errorMessage);
            $(validateClass + ' button').prop('disabled', true);
        } else {
            errorMessage = ['<span id="-error" class="error">', Resources.VALIDATE_EMAIL, '</span>'].join('');

            $(validateClass + ' input').before(errorMessage);
        }
    }

    var postData = ['dwfrm_newsletter_email=', emailAddress].join('');
    var formAction = $('.newsletter-container form').attr('action');

    if ($('.newsletter-container form').length > 0) {
        $.ajax({
            type: 'POST',
            url: formAction,
            async: false,
            data: postData,
            success: function success(textStatus) {
                $('.register-newsletter').addClass('hide');
                $('.newsletter-success').removeClass('hide');
                $('.newsletter-success').addClass('show');
                $('.newsletter-success .registered-email').html(emailAddress);
                if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')) {
                    window.universal_variable.user.email = emailAddress;
                }
            }
        });
    }

    if (isModal) {
        setHasViewedNewsletterCookie(true);
    }

    if ($('.news-letter-form').length > 0) {
        $.ajax({
            type: 'POST',
            url: $('.news-letter-form').attr('action'),
            async: false,
            data: {
                email: emailAddress,
                fname: firstName,
                lname: lastName,
                source: isModal ? 'modal' : 'header',
                // add csrf token param
                csrf_token: $('.news-letter-form input[name="csrf_token"]').val()
            },
            success: function success(response) {
                if (isModal) {
                    modal.renderContent(response);
                    modal.addCustomClass('newsletter-signup-modal');
                    $(document).trigger("clicknewsletter", { "siteloc": "pop-up" });
                } else {
                    $('form.news-letter-form').html(response);
                    $(document).trigger("clicknewsletter", { "siteloc": "footer" });
                }
                if (window.universal_variable !== undefined && !window.universal_variable.user.hasOwnProperty('user_id')) {
                    window.universal_variable.user.email = emailAddress;
                }
            }
        });
    }
}

function setHasViewedNewsletterCookie(val) {
    var hasViewedNewsletter = [siteId, 'hasViewedNewsletter'].join('-');
    util.setCookie(hasViewedNewsletter, val, newsletterCookieDuration);
}

exports.isNewsletterEnabled = isNewsletterEnabled;
exports.newsletterHeader = newsletterHeader;

},{"./modal":19,"./util":69,"./validator":70}],22:[function(require,module,exports){
'use strict';

var modal = require('./modal').global,
    util = require('./util');

exports.init = function init() {

	//On Change Select in PDP
	$(".replenishmentCycle").change(function () {
		var footerURL = window.location.href;
		var selection = $(this).val();

		if (window.User.isCustomerAuthenticated == false && selection != 0) {
			$(".replenishmentCycle").val("0");

			// render content to modal by url
			modal.renderByUrl(Urls.replenishmentLogin);
			modal.setCallback(function () {
				$(".modal-btn-signin").click(function () {
					var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
					window.location = util.appendParamToURL(urlLink, 'replenishment', selection);
				});

				$(".modal-btn-register").click(function () {
					window.location = Urls.showCreateAccount;
				});
			});
		}

		$(".modal-btn-signin").click(function () {
			var urlLink = util.appendParamToURL(Urls.showLogin, 'original', footerURL);
			window.location = util.appendParamToURL(urlLink, 'replenishment', selection);
		});

		$(".modal-btn-register").click(function () {
			window.location = Urls.showCreateAccount;
		});
	});

	//Update the Order replenishment suggestion based on product variant sizeVariations	
	$("input[name=size]").click(function () {
		//Get the recommendation from the input data-isreplenishable
		var replennumber = this.getAttribute('data-isreplenishable');

		//Construct the replenishment message
		var replenmsg = "";
		if (replennumber !== null && replennumber > 0) {
			var message = Resources.RECOMMENDED_REPLENISHMENT;

			replenmsg += message;
			replenmsg += replennumber;
			replenmsg += " ";
			replenmsg += replennumber > 1 ? "${spanPlural}" : "${span}";
			replenmsg += ".";
		}

		//Assign it to replenreccomendation
		$("#replenrecommendation").text(replenmsg);
	});

	//My Account Replenishment Update Button
	$(".replenishmentupdate").click(function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var uuid = getQueryValue("rid", href);
		var rdays = $("." + uuid.substring(0, 26) + "_days").val();
		var replenishmentQuantity = $("." + uuid.substring(0, 26) + "_quantity").val();
		var updateReplenishment = href + "&rdays=" + rdays + "&qty=" + replenishmentQuantity;
		window.location = updateReplenishment;
	});

	//My Account Replenishment Cancel Button
	$(".replenishmentcancel").click(function (e) {
		e.preventDefault();
		var href = $(this).attr('href');
		var popup = new Foundation.Reveal($('#cancel-replenishment'));
		popup.open();

		$(".modal-btn-confirm").click(function () {
			window.location = href;
		});

		$(".modal-btn-keep").click(function () {
			popup.close();
		});
	});

	// Gets the query string value if it exists, returns null if it does not.
	// Example: getQueryValue("reset") will return the value true if the URL is http://www.domain.com?reset=true
	function getQueryValue(str, href) {
		/*var queryString = window.location.search.substring(1);*/
		var queryString = href;
		var queries = queryString.split("?");
		for (var i = 0; i < queries.length; i++) {
			var ft = queries[i].split("=");
			if (ft[0] == str) {
				return ft[1];
			}
		}
		return null;
	}
};

},{"./modal":19,"./util":69}],23:[function(require,module,exports){
'use strict';

var util = require('./util');

var page = {
    title: '',
    type: '',
    params: util.getQueryStringParams(window.location.search.substr(1)),
    redirect: function redirect(newURL) {
        setTimeout(function () {
            window.location.href = newURL;
        }, 0);
    },
    refresh: function refresh() {
        setTimeout(function () {
            window.location.assign(window.location.href);
        }, 500);
    }
};

module.exports = page;

},{"./util":69}],24:[function(require,module,exports){
'use strict';

var giftcert = require('../giftcert'),
    tooltip = require('../tooltip'),
    util = require('../util'),
    dialog = require('../dialog'),
    page = require('../page'),
    login = require('../login'),
    modal = require('../modal').global,
    cardValidation = require('./checkout/card-validation'),
    validator = require('../validator'),
    search = require('./search'),
    ajax = require('../ajax'),
    design = require('../design');

/**
 * @function
 * @description Initializes the events on the address form (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm() {
    var $form = $('#edit-address-form');

    $form.find('input[name="format"]').remove();
    tooltip.init();
    //$("<input/>").attr({type:"hidden", name:"format", value:"ajax"}).appendTo(form);

    $form.on('click', '.apply-button', function (e) {
        /****
        * e.preventDefault();
        * if (!$form.valid()) {
        *     return false;
        * }
        * var url = util.appendParamToURL($form.attr('action'), 'format', 'ajax');
        * var applyName = $form.find('.apply-button').attr('name');
        * var options = {
        *     url: url,
        *     data: $form.serialize() + '&' + applyName + '=x',
        *     type: 'POST'
        * };
        * $.ajax(options).done(function (data) {
        *     if (typeof(data) !== 'string') {
        *         if (data.success) {
        *             dialog.close();
        *             page.refresh();
        *         } else if (data.error) {
        *             page.redirect(Urls.csrffailed);
        *         } else {
        *             window.alert(data.message);
        *             return false;
        *         }
        *     } else {
        *         $('#dialog-container').html(data);
        *         account.init();
        *         tooltip.init();
        *     }
        * });
        ****/
    }).on('click', '.cancel-button, .close-button', function (e) {
        e.preventDefault();
        dialog.close();
    }).on('click', '.delete-button', function (e) {
        e.preventDefault();
        if (window.confirm(String.format(Resources.CONFIRM_DELETE, Resources.TITLE_ADDRESS))) {
            var url = util.appendParamsToUrl(Urls.deleteAddress, {
                AddressID: $form.find('#addressid').val(),
                format: 'ajax'
            });
            $.ajax({
                url: url,
                method: 'POST',
                dataType: 'json'
            }).done(function (data) {
                if (data.status.toLowerCase() === 'ok') {
                    dialog.close();
                    page.refresh();
                } else if (data.message.length > 0) {
                    window.alert(data.message);
                    return false;
                } else {
                    dialog.close();
                    page.refresh();
                }
            });
        }
    });
}
/**
 * @private
 * @function
 * @description Toggles the list of Orders
 */
function toggleFullOrder() {
    $('.order-items').find('li.hidden:first').prev('li').append('<a class="toggle">View All</a>').children('.toggle').click(function () {
        $(this).parent().siblings('li.hidden').show();
        $(this).remove();
    });
}
/**
 * @private
 * @function
 * @description Binds the events on the address form (edit, create, delete)
 */
function initAddressEvents() {
    var addresses = $('#addresses');
    if (addresses.length === 0) {
        return;
    }

    $(document).on("click", ".address-edit", function (evt) {
        evt.preventDefault();

        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var url = Urls.checkoutEditAccountAddress + addressID;
        ajax.load({
            url: url,
            callback: function callback(data) {
                $('#editaddressmodal').html(data);
                $.magnificPopup.open({
                    items: {
                        src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });
                validator.initForm('form[id="EditAddressForm"]');
                design.toggleSelectInit();
            }
        });
    });

    $(document).on('click', '.address-delete', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;
        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(href, 'format', 'ajax'),
            data: data,
            dataType: 'json'
        }).done(function (data) {
            page.refresh();
        });
    });

    $(document).on('click', '.address-make-default', function (e) {
        e.preventDefault();
        var href = $(this).attr('href');
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;
        $.ajax({
            type: 'POST',
            url: util.appendParamToURL(href, 'format', 'ajax'),
            data: data,
            dataType: 'json'
        }).done(function (data) {
            page.refresh();
        }).fail(function (jqXHR, textStatus, errorThrown) {
            console.log('error');
            console.log(jqXHR);
            console.log(textStatus);
            console.log(errorThrown);
        });
    });

    $(document).on("click", ".address-create", function (evt) {
        evt.preventDefault();

        ajax.load({
            url: Urls.checkoutAddAccountAddress,
            callback: function callback(data) {
                $('#editaddressmodal').html(data);
                $.magnificPopup.open({
                    items: {
                        src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });
                validator.initForm('form[id="EditAddressForm"]');
                design.toggleSelectInit();
            }
        });
    });
}

/**
 * @private
 * @function
 * @description Binds the events of the payment methods list (delete card)
 */
function initPaymentEvents() {
    $('.add-card').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                open: initializePaymentForm
            }
        });
    });

    if ($("#CreditCardForm").is(":visible")) {
        creditCardTypeDetector();
        validator.initForm('form[id$="CreditCardForm"]');
    }

    $('.credit-card-create').magnificPopup({
        type: 'ajax',
        ajax: {
            settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
            // For example:
            // settings: {cache:false, async:false}

            cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
            tError: Resources.ADDNEWCARD_OPEN_ERROR //  Error message, can contain %curr% and %total% tags if gallery is enabled
        },
        callbacks: {
            parseAjax: function parseAjax(mfpResponse) {
                // mfpResponse.data is a "data" object from ajax "success" callback
                // for simple HTML file, it will be just String

                // mfpResponse.data must be a String or a DOM (jQuery) element
                mfpResponse.data = $(mfpResponse.data).find('.c-block-modal01-gather').first();
            },
            ajaxContentAdded: function ajaxContentAdded() {
                $('#newcardmodal').html(this.content[0].outerHTML);
                $.magnificPopup.open({
                    items: {
                        src: '#newcardmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });

                design.toggleSelectInit(true);
                creditCardTypeDetector();
                cardValidation.init();
                validator.initForm('form[id$="CreditCardForm"]');
            }
        }
    });

    $('.remove-card').on('click', function () {
        $(this).closest('form').submit();
    });

    $('form.remove-card-form button.delete').on('click', function (e) {
        e.preventDefault();
        var $button = $(this);
        var $form = $button.closest('form.remove-card-form');
        var popup = new Foundation.Reveal($('#remove-card'));
        popup.open();

        //Yes button
        $(".cardDelete-modal-btn-ok").unbind();
        $(".cardDelete-modal-btn-ok").click(function () {
            popup.close();

            $('<input/>').attr({
                type: 'hidden',
                name: $button.attr('name'),
                value: $button.attr('value') || 'delete card'
            }).appendTo($form);
            var data = $form.serialize();

            $.ajax({
                type: 'POST',
                url: $form.attr('action'),
                data: data
            }).done(function () {
                page.redirect(Urls.paymentsList);
            });
        });

        //No button
        $(".cardDelete-modal-btn-cancel").unbind();
        $(".cardDelete-modal-btn-cancel").click(function () {
            popup.close();
        });
    });
}

function initializePaymentForm() {
    $('#CreditCardForm').on('click', '.cancel-button', function (e) {
        e.preventDefault();
        dialog.close();
    });
}

function mobileAccountMenu() {
    var pageContainer = $('#main');
    var primaryContent = $('#primary');
    var primaryContentHeight = $('#primary').outerHeight();
    var mobileNav = $('#secondary');
    var accountText = $('.account-text');
    var currentUrl = window.location.href;
    var cleanUrl = currentUrl.split('?')[0];

    $('.account-nav-asset a[href="' + cleanUrl + '"]').addClass('active-menu');

    $('.account-nav-asset a').on('click', function (e) {
        e.preventDefault();
        var url = $(this).attr('href');

        if (url != cleanUrl) {
            window.location = url;
        } else {
            mobileNav.css('min-height', primaryContentHeight);
            pageContainer.addClass('content-show');
        }
    });

    $('.back-to-account-btn a').on('click', function (e) {
        e.preventDefault();
        pageContainer.removeClass('content-show');
        mobileNav.css('min-height', 0);
    });
}

function initOrderHistoryEvents() {
    $(document).on('click', '.view-order-details', function (evt) {
        evt.preventDefault();

        $(this).prev().click();
    });
}

function registerAccountEvents() {
    // get the field elements
    var $gender = $('.registration-box #dwfrm_profile_customer_gender');
    var $newsletterCB = $('.registration-box #dwfrm_profile_customer_addtoemaillist');

    $gender.on('change', function (e) {
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });
    $newsletterCB.on('change', function (e) {
        $(this).closest('form').find('button[type="submit"]').prop('disabled', false);
    });

    // behavior of checkbox
    $('#RegistrationForm .agreement').on('change', function (e) {
        if (!this.checked) {
            $(this).closest('form').validate().element(this);
        }
    });
}

function addressEvents() {
    function toggleBillingAddressFields(visible) {
        if (visible == true) {
            $('.country-dependent').each(function () {
                $(this).show();
            });
        } else {
            $('.country-dependent').each(function () {
                $(this).hide();
            });
        }

        if (window.User.isCustomerAuthenticated == false) {
            $('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country', function () {
        var selectContry = $(this).val();
        var $form = $(this).closest('form');

        if (selectContry == '') {
            toggleBillingAddressFields();
        } else if (selectContry == 'us') {
            toggleBillingAddressFields(true);
            $(".us-fields").show();
            $(".cn-fields").hide();
            $form.find('.postcode').removeClass('required');
            $form.find('.province').removeClass('required');
        } else {
            toggleBillingAddressFields(true);
            $(".cn-fields").show().css({ "display": "flex" });
            $(".us-fields").hide();

            $form.find('.postcode').addClass('required').rules('add', {
                required: true,
                postal: true,
                messages: {
                    postal: Resources.INVALID_POSTAL
                }
            });
            $form.find('.province').addClass('required').rules('add', {
                required: true,
                simpletext: true,
                messages: {
                    simpletext: Resources.VALIDATE_PROVINCE
                }
            });
        }
    });
}

function enableCountryField(status) {
    var countryField = $('select[id$="billing_billingAddress_addressFields_country"]');
    if (status) {
        countryField.removeAttr('disabled');
    } else {
        countryField.prop('disabled', true);
    }
}

function initContactUs() {
    var registrationForm = $('form#RegistrationForm');
    var contactUsConfirmForm = $("form[name='ContactUsConfirmForm']");

    //B-validate zipcode field
    $('#dwfrm_contactus_postal').removeClass('postal');
    $('#dwfrm_contactus_postal').keyup(function () {
        if ($(this).val().length > 0) {
            $('#dwfrm_contactus_postal').addClass('postal');
        } else {
            $('#dwfrm_contactus_postal').removeClass('postal');
        }
    });
    //E-validate zipcode field

    //B - redirect to homepape
    $('#contactus-btn-ok').on('click', function (event) {
        event.preventDefault();
        window.location.href = Urls.homePage;
    });
    //E - redirect to homepage

    //B - show contactus complete modal
    contactUsConfirmForm.on('click', 'button[type="submit"]', function (e) {
        e.preventDefault();

        var url = util.appendParamsToUrl(Urls.customerServiceSubmit, {
            format: 'ajax',
            locale: 'en_GB'
        });

        $.ajax({
            url: url,
            data: contactUsConfirmForm.serialize(),
            method: 'POST'
        }).done(function (response) {
            if (response.status) {
                $('#contactmodal').magnificPopup({
                    type: 'inline',
                    midClick: true
                });

                $(document).trigger("gtmcontactus");
                //clearContactUsForm();
                contactUsConfirmForm[0].reset();
            }
        });
    });
    //E - show contactus complete modal
}

/**
 * Clear contact us form
 */
function clearContactUsForm() {
    $('input[name$="_contactus_firstname"]').val('');
    $('input[name$="_contactus_lastname"]').val('');
    $('input[name$="_contactus_email"]').val('');
    $('input[name$="_contactus_phone"]').val('');
    $('input[name$="_contactus_ordernumber"]').val('');
    $('textarea[name$="_contactus_comment"]').val('');
    $('input[name$="_contactus_gender"]').val('');
    $('input[name$="_contactus_country"]').val('');
    $('input[name$="_contactus_address"]').val('');
    $('input[name$="_contactus_city"]').val('');
    $('input[name$="_contactus_postal"]').val('');
    $('input[name$="_contactus_myquestion"]').val('');
    $('input[name$="_contactus_comment"]').val('');
    //	$('form#RegistrationForm button[type="submit"]').prop('disabled', true);
}

function enableDisableSubmitButton(el) {
    var $saveBtn = $(el).closest('form').find('button[type="submit"]');

    var hasError = $saveBtn.closest('form').find('span.error');
    if (hasError.length) {
        //        $saveBtn.prop('disabled', true);
    } else {
        $saveBtn.prop('disabled', false);
    }
}

function setGender() {
    var gender = $('.gender select').data('gender');

    $('.gender select').val(gender);
}

function getBirthday(birthmonth, dob, birthyear) {
    var birthday = [birthmonth, '/', dob, '/', birthyear].join('');

    if (birthday.indexOf('00/00/') != -1 || birthday.indexOf('0/0/') != -1) {
        birthday = '';

        $('#dwfrm_profile_customer_birthmonth').val('00');
        $('#dwfrm_profile_customer_dob').val('00');
    }

    $('#dwfrm_profile_customer_birthday').val(birthday);
}

function setBirthday() {
    var birthmonth = $('#dwfrm_profile_customer_birthmonth').val() || Number('00');
    var dob = $('#dwfrm_profile_customer_dob').val() || Number('00');
    var birthyear = $('#dwfrm_profile_customer_birthyear').val() || Number('0000');

    getBirthday(birthmonth, dob, birthyear);
}

function setNewBirthday(birthmonth, dob, birthyear) {
    var monthField = $('#dwfrm_profile_customer_birthmonth').prev('.c-select');
    var dayField = $('#dwfrm_profile_customer_dob').prev('.c-select');
    var yearField = $('#dwfrm_profile_customer_birthyear').prev('.c-select');
    var $birthdayFieldParent = monthField.parent().parent();

    var month = ~~birthmonth ? birthmonth : '';
    var day = ~~dob ? dob : '';
    var year = ~~birthyear ? birthyear : '';

    $birthdayFieldParent.siblings('.c-text-error').remove();
    $birthdayFieldParent.parent().find('.c-input-label').removeClass('is-error');
    $birthdayFieldParent.parent().find('.c-input-label .c-input-label-small').css('color', 'initial');

    monthField.removeClass('is-error');
    dayField.removeClass('is-error');
    yearField.removeClass('is-error');

    if (month || day || year) {
        var now = new Date();
        var birthday = new Date(birthyear, birthmonth - 1, dob, 0, 0, 0, 0);
        var dateRegex = /^(?=\d)(?:(?:31(?!.(?:0?[2469]|11))|(?:30|29)(?!.0?2)|29(?=.0?2.(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00)))(?:\x20|$))|(?:2[0-8]|1\d|0?[1-9]))([-.\/])(?:1[012]|0?[1-9])\1(?:1[6-9]|[2-9]\d)?\d\d(?:(?=\x20\d)\x20|$))?(((0?[1-9]|1[012])(:[0-5]\d){0,2}(\x20[AP]M))|([01]\d|2[0-3])(:[0-5]\d){1,2})?$/;
        var formattedDate = [day, '-', month, '-', year].join('');
        var validDate = dateRegex.test(formattedDate);

        if (!month.match(/^[\d]{1,2}$/) || !day.match(/^[\d]{1,2}$/) || !year.match(/^[\d]{4}$/) || !birthday.getTime() || now.getTime() <= birthday.getTime() || !validDate) {

            $('<ul class="c-text-error c-text-error--simple birthday-error"><li class="is-error">' + Resources.INVALID_BIRTHDAY + '</li></ul>').insertAfter($birthdayFieldParent);
            $birthdayFieldParent.parent().find('.c-input-label').addClass('is-error');
            $birthdayFieldParent.parent().find('.c-input-label .c-input-label-small').css('color', 'inherit');

            if (!month.match(/^[\d]{1,2}$/) || !day.match(/^[\d]{1,2}$/) || !year.match(/^[\d]{4}$/)) {
                if (!month.match(/^[\d]{1,2}$/)) monthField.addClass('is-error');
                if (!day.match(/^[\d]{1,2}$/)) dayField.addClass('is-error');
                if (!year.match(/^[\d]{4}$/)) yearField.addClass('is-error');
            } else {
                monthField.addClass('is-error');
                dayField.addClass('is-error');
                yearField.addClass('is-error');
            }
        }
    }

    getBirthday(birthmonth, dob, birthyear);
}

function updateBirthday() {
    var birthyear = $('#dwfrm_profile_customer_birthyear').val(),
        birthmonth = $('#dwfrm_profile_customer_birthmonth').val(),
        dob = $('#dwfrm_profile_customer_dob').val();
    $('#dwfrm_profile_customer_birthyear').change(function () {
        birthyear = $(this).val();

        setNewBirthday(birthmonth, dob, birthyear);
    });

    $('#dwfrm_profile_customer_birthmonth').change(function () {
        birthmonth = $(this).val();

        if (birthyear || birthmonth === '00' && !birthyear) {
            setNewBirthday(birthmonth, dob, birthyear);
        }
    });

    $('#dwfrm_profile_customer_dob').change(function () {
        dob = $(this).val();

        if (birthyear || dob === '00' && !birthyear) {
            setNewBirthday(birthmonth, dob, birthyear);
        }
    });
}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),


    // MasterCard
    mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),


    // American Express
    amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),


    // Diners 300-305,3095,36,38-39
    diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),


    // UnionPay
    unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<img class="visa" src="' + Urls.staticPath + 'images/common/icn_visa.gif" alt="">');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<img class="mastercard" src="' + Urls.staticPath + 'images/common/icn_mastercard.gif" alt="">');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<img class="amex" src="' + Urls.staticPath + 'images/common/icn_amex.gif" alt="">');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(diners_regex)) {
            $ccNumberContain.addClass('is_diners');
            $creditCard.find('input[name$="_type"]').val("Diners").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<img class="diners" src="' + Urls.staticPath + 'images/common/icn_diners.gif" alt="">');
        } else {
            $ccNumberContain.removeClass('is_diners');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<img class="unionpay" src="' + Urls.staticPath + 'images/common/icn_unionpay.gif" alt="">');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (cur_val != '' && !cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) && !cur_val.match(amex_regex) && !cur_val.match(diners_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
            clearCardIcon($creditCard);
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });
};

/**
 * Clear card icon 
 * @returns
 */
function clearCardIcon($creditCard) {
    $creditCard.find('input[name*="_number"]').parent().find('.mastercard').remove();
    $creditCard.find('input[name*="_number"]').parent().find('.visa').remove();
    $creditCard.find('input[name*="_number"]').parent().find('.diners').remove();
    $creditCard.find('input[name*="_number"]').parent().find('.amex').remove();
    $creditCard.find('input[name*="_number"]').parent().find('.unionpay').remove();
}

/**
 * @private
 * @function
 * @description Binds the events of the order, address and payment pages
 */
function initializeEvents() {
    cardValidation.init();
    toggleFullOrder();
    initAddressEvents();
    initPaymentEvents();
    login.init();
    registerAccountEvents();
    addressEvents();
    initContactUs();
    mobileAccountMenu();
    setGender();
    setBirthday();
    updateBirthday();
    search.viewMore();
    initOrderHistoryEvents();
}

var account = {
    init: function init() {
        initializeEvents();
        giftcert.init();
    },
    initCartLogin: function initCartLogin() {
        login.init();
    },
    initMobileMenu: function initMobileMenu() {
        mobileAccountMenu();
    }
};

module.exports = account;

},{"../ajax":1,"../design":8,"../dialog":9,"../giftcert":13,"../login":17,"../modal":19,"../page":23,"../tooltip":68,"../util":69,"../validator":70,"./checkout/card-validation":29,"./search":50}],25:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var account = require('./account'),
    bonusProductsView = require('../bonus-products-view'),
    quickview = require('../quickview'),
    images = require('./product/image'),
    variant = require('./product/variant'),
    giftShipping = require('./checkout/shipping'),
    recommendations = require('./product/recommendations'),
    cartStoreInventory = require('../storeinventory/cart'),
    modal = require('../modal').global,
    samples = require('../samples'),
    giftCert = require('../giftcert-modal'),
    login = require('./checkout/login'),
    util = require('../util'),
    design = require('../design'),
    addToCart = require('./product/addToCart');

/**
 * @private
 * @function
 * @description Binds events to the cart page (edit item's details, bonus item's actions, coupon code entry)
 */
function initializeEvents() {
    $('#cart-items-form .c-list-products-full-edit a').magnificPopup({
        type: 'ajax',
        ajax: {
            settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
            // For example:
            // settings: {cache:false, async:false}

            cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
            tError: '<a href="%url%">The content</a> could not be loaded.' //  Error message, can contain %curr% and %total% tags if gallery is enabled
        },
        callbacks: {
            parseAjax: function parseAjax(mfpResponse) {
                // mfpResponse.data is a "data" object from ajax "success" callback
                // for simple HTML file, it will be just String

                // mfpResponse.data must be a String or a DOM (jQuery) element
                mfpResponse.data = $(mfpResponse.data).find('.c-block-shopingmodal').first();
            },
            ajaxContentAdded: function ajaxContentAdded() {
                $('#shopingmodal').html(this.content[0].outerHTML);
                $.magnificPopup.open({
                    items: {
                        src: '#shopingmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });

                images();
                variant();
                addToCart();
                renderThumbnails();

                $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function () {
                    window.location.href = url + '#reviews'; // redirect when rating star is clicked
                });

                $(document).on('click', '.bv-popup-in .bv-read-review', function () {
                    window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
                });

                design.modalInit();
                design.pdpInit();
                design.selectQuantityInit();
                design.toggleSelectInit();
                giftCert.initModal();
            }
        }
    });

    $('#cart-table').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();

        quickview.show({
            url: e.target.href,
            source: 'cart',
            callback: function callback() {
                variant();
                renderThumbnails();
            }
        });
    }).on('click', '.bonus-item-actions a, .item-details .bonusproducts a', function (e) {
        e.preventDefault();
        bonusProductsView.show(this.href);
    });

    // override enter key for coupon code entry
    $('input[name$="_couponCode"]').on('keydown', function (e) {
        if (e.which === 13 && $(this).val().length === 0) {
            return false;
        }
    });

    //to prevent multiple submissions of the form when removing a product from the cart
    var removeItemEvent = false;
    $('.cpb-cart-bag_box .item-remove a').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
            var deleteHtml = $(this).closest('.cpb-cart-bag_box').find('input[name$=_deleteProduct]')[0].outerHTML;
            $('input[name$=_deleteGiftCertificate]').remove();
            $('input[name$=_deleteProduct]').remove();
            $('input[name$=_deleteCoupon]').remove();
            $(this).parent().append(deleteHtml);
            $(this).closest('form').submit();
        }
    });

    $('.c-list-giftcard-full-remove a').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
            var deleteHtml = $(this).closest('.c-list-products-full-item-text-parts--short').find('input[name$=_deleteGiftCertificate]')[0].outerHTML;
            $('input[name$=_deleteGiftCertificate]').remove();
            $('input[name$=_deleteProduct]').remove();
            $('input[name$=_deleteCoupon]').remove();
            $(this).parent().append(deleteHtml);
            $(this).closest('form').submit();
        }
    });

    $('.c-list-sample-remove a').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
            var deleteHtml = $(this).closest('.c-block-productsItem--smbreak').find('input[name$=_deleteProduct]')[0].outerHTML;
            $('input[name$=_deleteGiftCertificate]').remove();
            $('input[name$=_deleteProduct]').remove();
            $('input[name$=_deleteCoupon]').remove();
            $(this).parent().append(deleteHtml);
            $(this).closest('form').submit();
        }
    });

    $('.c-list-coupon-remove a').on('click', function (e) {
        if (removeItemEvent) {
            e.preventDefault();
        } else {
            removeItemEvent = true;
            var deleteHtml = $(this).closest('.c-list-products-full-item-text-parts--short').find('input[name$=_deleteCoupon]')[0].outerHTML;
            $('input[name$=_deleteGiftCertificate]').remove();
            $('input[name$=_deleteProduct]').remove();
            $('input[name$=_deleteCoupon]').remove();
            $(this).parent().append(deleteHtml);
            $(this).closest('form').submit();
        }
    });

    // product level bonus modal
    $('div.bonus-item-promo').on('click', 'a.select-bonus', function (e) {
        e.preventDefault();

        var urlToRender = $(this).attr('href');
        if (urlToRender) {
            modal.addCustomClass('bonus-item-modal');
            modal.renderByUrl(urlToRender);
        }
    });

    $(document).on('click', '#item-sample .cpb-cart_add_btn a.button[data-modal-target="sample"]', function (e) {
        samples.showSelectionInCart();
    }).on('click', '.paypal-container a', function (e) {
        e.preventDefault();

        var cartCheckoutForm = $('.cart-action-checkout');
        if (cartCheckoutForm.length > 0) {
            cartCheckoutForm.attr('action', Urls.cartPaypalCheckout);
            cartCheckoutForm.submit();
        }
    });

    reloadWishlistButtonEvent();

    dropDownEvents();

    $('.ico-favorite.unlogin').on('click', function (e) {
        e.preventDefault();

        window.location = $(this).attr('href');
    });
}

/**
 * init dropdown events
 * @returns
 */
function dropDownEvents() {
    // Click '+' in cart
    $('.cpb-cart-bag_box .js-num-drop_down').on('dropDownCart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Click '-' in cart
    $('.cpb-cart-bag_box .js-num-drop_up').on('dropUpCart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Select quantity in cart
    $('.cpb-cart-bag_box .js-num-drop_select').on('dropSelectCart', function () {
        var $form = $(this).closest('form');
        $form.find('input[name$=_deleteGiftCertificate]').remove();
        $form.find('input[name$=_deleteProduct]').remove();
        $form.find('input[name$=_deleteCoupon]').remove();
        $form.submit();
    });
    // Click drop quantity in cart
    $('.cpb-cart-bag_box .js-num-drop_drop').on('dropDropCart', function () {
        // write something here
    });
}

function reloadWishlistButtonEvent() {
    $('.cpb-cart-bag_box .add-to-wishlist').on('click', function (e) {
        if (!window.User.isCustomerAuthenticated) {
            return;
        }

        e.preventDefault();
        var $target = $(this).parent();
        var url = util.appendParamsToUrl($(this).attr('href'), {
            format: 'ajax'
        });
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;

        $.ajax({
            type: 'POST',
            url: url,
            data: data
        }).done(function (response) {
            if (typeof response === 'string' && response !== "") {
                $target.empty().html(response);
                reloadWishlistButtonEvent();
            } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
                window.alert(response.error);
            }
        });
    });

    $('.cpb-cart-bag_box .remove-from-wishlist').on('click', function (e) {
        e.preventDefault();

        var $target = $(this).parent();
        var url = util.appendParamsToUrl($(this).attr('href'), {
            format: 'ajax'
        });
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;

        $.ajax({
            type: 'POST',
            url: url,
            data: data
        }).done(function (response) {
            if (typeof response === 'string' && response !== "") {
                $target.empty().html(response);
                reloadWishlistButtonEvent();
            } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
                window.alert(response.error);
            }
        }).fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });
}

function renderThumbnails() {
    if ($('#thumbnails').length > 0) {
        $('#thumbnails').empty(); // clear the list
        images(); // populate the thumbnails
    }
};

function isGift() {
    var isGift = sessionStorage.getItem('isGift') === 'true';
    var isGiftName = [$('#cart-items-form').attr('name'), 'isGift'].join('_');

    $('#checkout-form .is-gift').val(isGift);
    $('#checkout-form .is-gift').attr('name', isGiftName);
    $('.gift-container .input-checkbox').attr('checked', isGift);
    $('.gift-container .input-checkbox').change(function () {
        isGift = $(this).is(':checked');

        if (!isGift) {
            $('.c-block-cartmessage .input-textarea').val('');
            $('#checkout-form .gift-message').val('');
            $('#checkout-form button').prop('disabled', false); // Added by ADe to enable Checkout button
            $('.third-party-container').css('opacity', 1);
            $('.third-party-container').css('pointer-events', 'all');
            //Ade
            if ($('.gift-message-textarea span.error:visible').length > 0) {
                $('.gift-message-textarea span.error').remove();
            }
            sessionStorage.removeItem('isGift');
            sessionStorage.removeItem('giftMessage');
        } else {
            $('.gift-container .input-textarea').keyup();
            sessionStorage.setItem('isGift', isGift);
        }

        $('#checkout-form .is-gift').val(isGift);
    });
}

function giftMessage() {
    var giftMessage = sessionStorage.getItem('giftMessage') ? sessionStorage.getItem('giftMessage') : '';
    var giftMessageName = [$('#cart-items-form').attr('name'), 'giftMessage'].join('_');

    $('#checkout-form .gift-message').val(giftMessage);
    $('#checkout-form .gift-message').attr('name', giftMessageName);
    $('.c-block-cartmessage .input-textarea').val(giftMessage);
    $('.c-block-cartmessage .input-textarea').on('keyup', function () {
        giftMessage = $(this).val().trim();

        if (giftMessage === '' || util.validateMessage(giftMessage)) {
            $('#checkout-form .gift-message').val(giftMessage);
            $('.gift-message-textarea .form-caption').removeClass('error-message');
            $('.gift-message-textarea .form-caption').empty();
            $('#checkout-form button').prop('disabled', false);
            $('.third-party-container').css('opacity', 1);
            $('.third-party-container').css('pointer-events', 'all');
            sessionStorage.setItem('giftMessage', giftMessage);
        } else {
            $('.gift-message-textarea .form-caption').addClass('error-message');
            $('.gift-message-textarea .form-caption').text('Invalid message');
            $('#checkout-form button').prop('disabled', true);
            $('.third-party-container').css('opacity', 0.5);
            $('.third-party-container').css('pointer-events', 'none');
        }
    });
}

function couponCodeEvent() {
    $('.cpb-cart-side_code input').on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();

            $('#add-coupon').click();
        }
    });
}

function updateCart() {
    $('.item-quantity select').change(function () {
        $('#cart-items-form').submit();
    });
}

function cartCount() {
    if ($('.cart-empty').length) {
        sessionStorage.removeItem('isGift');
        sessionStorage.removeItem('giftMessage');
    }
}

exports.init = function () {
    login.init();
    initializeEvents();
    recommendations();
    isGift();
    giftMessage();
    updateCart();
    couponCodeEvent();
    cartCount();
    giftShipping.init();
    giftCert.init();

    if (SitePreferences.STORE_PICKUP) {
        cartStoreInventory.init();
    }

    account.initCartLogin();
};

},{"../bonus-products-view":4,"../design":8,"../giftcert-modal":12,"../modal":19,"../quickview":58,"../samples":60,"../storeinventory/cart":64,"../util":69,"./account":24,"./checkout/login":32,"./checkout/shipping":34,"./product/addToCart":39,"./product/image":42,"./product/recommendations":45,"./product/variant":47}],26:[function(require,module,exports){
'use strict';

var formPrepare = require('./checkout/formPrepare'),
    validator = require('../validator');

/**
 * @private
 * @function
 * @description Validates if check order form is filled out before enabling button
 */
function initializeEvents() {
  validator.initForm('form[id$="ordertrack"]');
}

exports.init = function () {
  initializeEvents();
};

},{"../validator":70,"./checkout/formPrepare":30}],27:[function(require,module,exports){
'use strict';

var util = require('../../util');
var shipping = require('./shipping');

/**
 * @function
 * @description Selects the first address from the list of addresses
 */
exports.init = function () {
    var $form = $('.address');
    // select address from list
    $('select[name$="_addressList"]', $form).on('change', function () {
        var selected = $(this).children(':selected').first();
        var selectedAddress = $(selected).data('address');
        if (!selectedAddress) {
            return;
        }
        util.fillAddressFields(selectedAddress, $form);
        shipping.updateShippingMethodList();
        // re-validate the form
        $form.validate().form();
    });
};

},{"../../util":69,"./shipping":34}],28:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    formPrepare = require('./formPrepare'),
    giftcard = require('../../giftcard'),
    util = require('../../util'),
    modal = require('../../modal').global,
    cardValidation = require('./card-validation'),
    validator = require('../../validator'),
    design = require('../../design');

var $cache;

/**
 * @function
 * @description Changes the payment method form depending on the passed paymentMethodID
 * @param {String} paymentMethodID the ID of the payment method, to which the payment method form should be changed to
 */
function updatePaymentMethod(paymentMethodID) {
    var $paymentMethods = $('.payment-method');
    $paymentMethods.removeClass('payment-method-expanded');

    var dataMethod = paymentMethodID;
    if (paymentMethodID == 'SA_SILENTPOST') {
        dataMethod = 'CREDIT_CARD';
    }

    var $selectedPaymentMethod = $paymentMethods.filter('[data-method="' + dataMethod + '"]');
    if ($selectedPaymentMethod.length === 0) {
        $selectedPaymentMethod = $('[data-method="Custom"]');
    }

    if (paymentMethodID == "CREDIT_CARD" || paymentMethodID == "SA_SILENTPOST") {
        $(".spsavecard").show();
    } else if ((paymentMethodID == "SA_REDIRECT" || paymentMethodID == "SA_IFRAME") && SitePreferences.TOKENIZATION_ENABLED) {
        $(".spsavecard").show();
    } else {
        $(".spsavecard").hide();
    }

    $selectedPaymentMethod.addClass('payment-method-expanded');

    // ensure checkbox of payment method is checked
    $('input[name$="_selectedPaymentMethodID"]').removeAttr('checked');
    $('input[value=' + paymentMethodID + ']').prop('checked', 'checked');
}

function creditCardTypeDetector(options) {

    // the regular expressions check for possible matches as you type, hence the OR operators based on the number of chars
    // Visa
    var visa_regex = new RegExp('^4[0-9]{0,15}$'),


    // MasterCard
    mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),


    // American Express
    amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),


    // Diners 300-305,3095,36,38-39
    diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),


    // UnionPay
    unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

    $('.cc-number input').focusout(function (e) {
        var cur_val = $(this).val();

        //Commenting this out since the event is handled on focusout
        // if ( cur_val.length == 16 ) {
        //     e.preventDefault();
        //     return;
        // }

        var $ccNumberContain = $(this).parents('.cc-number');

        // get rid of spaces and dashes before using the regular expression
        cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

        var $creditCard = $('[data-method="CREDIT_CARD"]');

        // checks per each, as their could be multiple hits
        if (cur_val.match(visa_regex)) {
            $ccNumberContain.addClass('is_visa');
            $creditCard.find('input[name$="_type"]').val("Visa").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<i class="ico-card"><img class="visa" src="' + Urls.staticPath + 'images/common/icn_visa.gif" alt="VISA"></i>');
        } else {
            $ccNumberContain.removeClass('is_visa');
        }

        if (cur_val.match(mastercard_regex)) {
            $ccNumberContain.addClass('is_mastercard');
            $creditCard.find('input[name$="_type"]').val("MasterCard").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<i class="ico-card"><img class="mastercard" src="' + Urls.staticPath + 'images/common/icn_mastercard.gif" alt="MASTERCARD"></i>');
        } else {
            $ccNumberContain.removeClass('is_mastercard');
        }

        if (cur_val.match(amex_regex)) {
            $ccNumberContain.addClass('is_amex');
            $creditCard.find('input[name$="_type"]').val("Amex").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<i class="ico-card"><img class="amex" src="' + Urls.staticPath + 'images/common/icn_amex.gif" alt="AMEX"></i>');
        } else {
            $ccNumberContain.removeClass('is_amex');
        }

        if (cur_val.match(diners_regex)) {
            $ccNumberContain.addClass('is_diners');
            $creditCard.find('input[name$="_type"]').val("Diners").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<i class="ico-card"><img class="diners" src="' + Urls.staticPath + 'images/common/icn_diners.gif" alt="DINERS"></i>');
        } else {
            $ccNumberContain.removeClass('is_diners');
        }

        if (cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_unionpay');
            $creditCard.find('input[name$="_type"]').val("Union").trigger('change');
            clearCardIcon($creditCard);
            $creditCard.find('input[name*="_number"]').parent().append('<i class="ico-card"><img class="unionpay" src="' + Urls.staticPath + 'images/common/icn_unionpay.gif" alt="UNIONPAY">');
        } else {
            $ccNumberContain.removeClass('is_unionpay');
        }

        // if nothing is a hit we add a class to fade them all out
        if (!cur_val.match(visa_regex) && !cur_val.match(mastercard_regex) && !cur_val.match(amex_regex) && !cur_val.match(diners_regex) && !cur_val.match(unionpay_regex)) {
            $ccNumberContain.addClass('is_nothing');
            clearCardIcon($creditCard);
        } else {
            $ccNumberContain.removeClass('is_nothing');
        }
    });
};

/**
 * Clear card icon 
 * @returns
 */
function clearCardIcon($creditCard) {
    $creditCard.find('input[name*="_number"]').parent().find('.ico-card').remove();
}

function checkGiftCert() {
    var $balance = $('.c-block-giftcardbalance-block-send .balance');
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

    $error.html('');
    if ($error.hasClass('cmd-form_err')) {
        $error.removeClass('cmd-form_err');
    }

    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
    } else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
    }
    if ($error.html() !== "") {
        $error.addClass('cmd-form_err');
        return;
    }

    giftcard.checkBalance($giftCode.val(), $giftPin.val(), function (data) {
        if (data && data.error) {
            $error.addClass('cmd-form_err');
            return $error.html(data.error);
        }

        if (!data || !data.giftCertificate) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            $error.addClass('cmd-form_err');
            return;
        }

        $balance.find('.item-price').html('<strong><span>' + data.giftCertificate.balance + '</span></strong>');

        //$('a#check-giftcert-modal').closest('.cmd-button_container').addClass('is-hide');
        //$('a#add-giftcert-modal').closest('.cmd-button_container').removeClass('is-hide');
        $('button#new-giftcert-modal').removeClass('mfp-hide');
    });
};

function applyGiftCert() {
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

    $error.html('');
    if ($error.hasClass('cmd-form_err')) {
        $error.removeClass('cmd-form_err');
    }
    if ($giftCode.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_INVALID);
        $error.addClass('cmd-form_err');
        return;
    }
    /*else if ($giftCode.val().length !== 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_PIN_INVALID);
        return;
    } else if ($giftCode.val().length === 0 && $giftPin.val().length === 0) {
        $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
        return;
    }*/

    var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
        giftCertCode: $giftCode.val(),
        giftCertPIN: $giftPin.val(),
        format: 'ajax'
    });
    $.getJSON(url, function (data) {
        var fail = false;
        var msg = '';
        if (!data) {
            msg = Resources.BAD_RESPONSE;
            fail = true;
        } else if (!data.success) {
            msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
            fail = true;
        }
        if (fail) {
            $error.html(msg);
            $error.addClass('cmd-form_err');
            return;
        } else {
            window.location.assign(Urls.billing);
        }
    });
};

function resetGiftcard() {
    var $balance = $('.c-block-giftcardbalance-block-send .balance');
    var $error = $('div#gift-card-balance-form .balance-error');
    var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
    var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');
    var $checkGiftBtn = $('.cpb-modal_giftcard a#check-giftcert-modal');
    var $applyGiftBtn = $('.cpb-modal_giftcard a#add-giftcert-modal');

    $balance.find("p.item-price").html('');

    $error.html('');
    $error.removeClass('cmd-form_err');

    //$checkGiftBtn.closest('.cmd-button_container').removeClass('is-hide');
    //$applyGiftBtn.closest('.cmd-button_container').addClass('is-hide');

    $giftCode.siblings('.cmd-form_err._simple').remove();
    $giftPin.siblings('.cmd-form_err._simple').remove();

    $giftCode.closest('.cmd-form_box').removeClass('is-error');
    $giftPin.closest('.cmd-form_box').removeClass('is-error');

    $giftCode.val('');
    $giftPin.val('');
}

function initCache() {
    $cache = {};

    $cache.checkoutForm = $(".checkout-billing");
    $cache.selectedCardIdInput = $cache.checkoutForm.find('input[name$="_selectedCardID"]');
}

function initCreditCardForm() {
    $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    $cache.checkoutForm.find('input[name*="_number"]').val('');

    var $ccContainer = $cache.checkoutForm.find(".payment-method").filter(function () {
        return $(this).data("method") == "CREDIT_CARD";
    });

    $ccContainer.find('input[name*="_number"]').on('change', function (e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });
    $ccContainer.find('input[name$="_owner"]').on('change', function (e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');
    });

    $ccContainer.find('select[name*="expiration"]').on('change', function (e) {
        $cache.checkoutForm.find('input[name$="_selectedCardID"]').val('');

        var selectedPaymentMethodID = $('input[name$="_selectedPaymentMethodID"]:checked').val();
        var cardNumber = $cache.checkoutForm.find('input[name*="_number"]').val();
        if (cardNumber.indexOf('****') != -1 && selectedPaymentMethodID == 'SA_SILENTPOST') {
            $cache.checkoutForm.find('input[name*="_number"]').val('');
        }
    });
}

function setSelectedCardID(uuid) {
    $cache.selectedCardIdInput.val(uuid);
}

function enableCountryField(status) {
    var countryField = $('input[id$="billing_billingAddress_addressFields_country"]');
    if (status) {
        countryField.removeAttr('disabled');
    } else {
        countryField.prop('disabled', true);
    }
}

function addCVNEvent() {
    $('input[name$="creditCard_cvn"]').on('keydown', function (e) {
        if (e.key.toString().match(/[\d]/) || $.inArray(e.keyCode, [8, 9, 13, 46, 33, 34, 35, 36, 37, 38, 39, 40]) >= 0) {
            // do nothing
        } else {
            e.preventDefault();
            e.stopPropagation();
            return;
        }
    });
}

function initGiftCardBalance() {
    var $checkoutForm = $('.checkout-billing');
    var $addGiftCert = $('#add-giftcert');
    var $giftCertCode = $('input[name$="_giftCertCode"]');
    var $giftCertPin = $('input[name$="_giftCertPIN"]');
    var $addCoupon = $('#add-coupon');
    var $couponCode = $('input[name$="_couponCode"]');

    // Check Balance button is clicked in Check Balance Modal
    $(document).off('click', 'a#check-giftcert-modal');
    $(document).on('click', 'a#check-giftcert-modal', function (e) {
        e.preventDefault();
        checkGiftCert();
    });

    // Check Another Card button is clicked in Check Balance Modal
    $(document).off('click', 'button#new-giftcert-modal');
    $(document).on('click', 'button#new-giftcert-modal', function (e) {
        var $balance = $('div#gift-card-balance-form .balance');
        var $error = $('div#gift-card-balance-form .balance-error');
        var $giftCode = $('div#gift-card-balance-form input[name$="_giftCertCode"]');
        var $giftPin = $('div#gift-card-balance-form input[name$="_giftCertPIN"]');

        $balance.html('');
        $error.html('');
        $giftCode.val(null).removeAttr('disabled');
        $giftPin.val(null).removeAttr('disabled');

        $('a#add-giftcert-modal').closest('.cmd-button_container').addClass('is-hide');
        $('button#new-giftcert-modal').addClass('mfp-hide');
        $('a#check-giftcert-modal').closest('.cmd-button_container').removeClass('is-hide');
    });

    // Apply button is clicked in Check Balance Modal
    $(document).off('click', 'a#add-giftcert-modal');
    $(document).on('click', 'a#add-giftcert-modal', function (e) {
        e.preventDefault();
        applyGiftCert();
    });

    $addGiftCert.off();
    $addGiftCert.on('click', function (e) {
        e.preventDefault();
        var code = $giftCertCode.val();
        var pin = $giftCertPin.val();
        //var $error = $checkoutForm.find('.giftcert-error');
        var $error = $checkoutForm.find('.apply-error');

        // clear all errors
        $(this).closest('form').find('span.error').remove();

        $error.html('');
        if (code.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_INVALID);
            return;
        } else if (code.length !== 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_PIN_INVALID);
            return;
        } else if (code.length === 0 && pin.length === 0) {
            $error.html(Resources.GIFT_CARD_CODE_PIN_INVALID);
            return;
        }

        var url = util.appendParamsToUrl(Urls.redeemGiftCert, {
            giftCertCode: code,
            giftCertPIN: pin,
            format: 'ajax'
        });
        $.getJSON(url, function (data) {
            var fail = false;
            var msg = '';
            if (!data) {
                msg = Resources.BAD_RESPONSE;
                fail = true;
            } else if (!data.success) {
                msg = data.message.split('<').join('&lt;').split('>').join('&gt;');
                fail = true;
            }
            if (fail) {
                $error.html(msg);
                return;
            } else {
                window.location.assign(Urls.billing);
            }
        });
    });

    $giftCertCode.off();
    $giftCertCode.on('keydown', function (e) {
        if (e.which === 13) {
            e.preventDefault();
            $addGiftCert.click();
        }
    });
}

/**
 * @function
 * @description loads billing address, Gift Certificates, Coupon and Payment methods
 */
exports.init = function () {
    cardValidation.init();
    initCache();
    initCreditCardForm();
    initGiftCardBalance();

    var $selectPaymentMethod = $('.payment-method-options');
    var selectedPaymentMethod = $selectPaymentMethod.find(':checked').val();

    validator.initForm('form[id$="billing"]');

    function toggleBillingAddressFields(visible) {
        if (visible == true) {
            $('.country-dependent').each(function () {
                $(this).show();
            });
        } else {
            $('.country-dependent').each(function () {
                $(this).hide();
            });
        }

        if (window.User.isCustomerAuthenticated == false) {
            $('.checkout-billing').find('.set-default-cb').hide();
        }
    }

    $(document).on('change', '#dwfrm_billing_billingAddress_addressFields_country, #dwfrm_billingaddress_country', function () {
        var selectContry = $(this).val();
        if (selectContry == '') {
            toggleBillingAddressFields();
        } else if (selectContry == 'us') {
            toggleBillingAddressFields(true);
            $('.us-fields').show();
            $('.us-fields input').each(function () {
                $(this).addClass('required');
            });

            $('.cn-fields').hide();
            $('.cn-fields input').each(function () {
                $(this).removeClass('required');
            });
        } else {
            toggleBillingAddressFields(true);
            $(".cn-fields").show().css({ "display": "flex" });
            $('.cn-fields input').each(function () {
                $(this).addClass('required');
            });

            $('.us-fields').hide();
            $('.us-fields input').each(function () {
                $(this).removeClass('required');
            });
        }
    });

    $('.billing-address-section :input').on('change', function (e) {
        if (e.target.id == 'dwfrm_billing_billingAddress_useAsBillingAddress') {
            return false;
        }

        $('#dwfrm_billing_billingAddress_useAsBillingAddress').prop('checked', false);
    });

    if ($('input#same-as-shipping').is(":checked")) {
        $('.saved-addresses.select-billing-address').addClass('mfp-hide');
        $('.saved-addresses.default-billing-address').removeClass('mfp-hide');
    }

    $('input#same-as-shipping').on('change', function () {
        var sameascheckbox = $(this);

        if (sameascheckbox.is(":checked")) {
            $('.saved-addresses.select-billing-address').addClass('mfp-hide');
            $('.saved-addresses.default-billing-address').removeClass('mfp-hide');

            $('#dwfrm_billing_billingAddress_addressFields_firstName').val($('#dwfrm_billing_billingAddress_addressFields_firstName').attr('data-firstname'));
            $('#dwfrm_billing_billingAddress_addressFields_lastName').val($('#dwfrm_billing_billingAddress_addressFields_lastName').attr('data-lastname'));
            $('#dwfrm_billing_billingAddress_addressFields_address1').val($('#dwfrm_billing_billingAddress_addressFields_address1').attr('data-address1'));
            $('#dwfrm_billing_billingAddress_addressFields_address2').val($('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2') != 'null' ? $('#dwfrm_billing_billingAddress_addressFields_address2').attr('data-address2') : '');
            $('#dwfrm_billing_billingAddress_addressFields_city').val($('#dwfrm_billing_billingAddress_addressFields_city').attr('data-city'));
            $('#dwfrm_billing_billingAddress_addressFields_postal').val($('#dwfrm_billing_billingAddress_addressFields_postal').attr('data-postal'));
            $('#dwfrm_billing_billingAddress_addressFields_country').val($('#dwfrm_billing_billingAddress_addressFields_country').val());
            $('#dwfrm_billing_billingAddress_addressFields_states_state').val($('#dwfrm_billing_billingAddress_addressFields_states_state').parent().find('.c-select-current').attr('data-state'));
            $('#dwfrm_billing_billingAddress_addressFields_phone').val($('#dwfrm_billing_billingAddress_addressFields_phone').attr('data-phone'));

            $(".flag-show-hide").fadeIn();
            toggleBillingAddressFields(true);

            // for logged-in users with address, reselect default shipping address
            // if customer chooses to use the shipping address as their billing address
            var selectedShipping = $('div.address-tile.address-default');
            if (selectedShipping) {
                selectedShipping.removeClass('is-current');
                selectedShipping.removeClass('default');
                selectedShipping.click();
            }
        } else {
            $('.saved-addresses.default-billing-address').addClass('mfp-hide');
            $('.saved-addresses.select-billing-address').removeClass('mfp-hide');

            $('#dwfrm_billing_billingAddress_addressFields_address1').val('');
            $('#dwfrm_billing_billingAddress_addressFields_address2').val('');
            $('#dwfrm_billing_billingAddress_addressFields_city').val('');
            $('#dwfrm_billing_billingAddress_addressFields_postal').val('');
            $('#dwfrm_billing_billingAddress_addressFields_phone').val('');
            $('#dwfrm_billing_billingAddress_addressFields_postcode').val('');
            $('#dwfrm_billing_billingAddress_addressFields_province').val('');
            $('#dwfrm_billing_billingAddress_addressFields_states_state').val('');
            $('#dwfrm_billing_billingAddress_addressFields_states_state').parent().find('.c-select-current').attr('data-v', '').html($('#dwfrm_billing_billingAddress_addressFields_states_state').prev().find('li:first .c-select-list-item-text').html());
            $('#dwfrm_billing_billingAddress_addressFields_states_state').prev().find('a.is-selected').removeClass('is-selected');
            $('#dwfrm_billing_billingAddress_addressFields_country').parent().find('.c-select-current').attr('data-v', '').html($('#dwfrm_billing_billingAddress_addressFields_country').prev().find('li:first .c-select-list-item-text').html());
            $('#dwfrm_billing_billingAddress_addressFields_country').prev().find('a.is-selected').removeClass('is-selected');
            $(".flag-show-hide").fadeOut();
            $(".us-fields").show();
            $(".cn-fields").hide();

            $('#dwfrm_billing_billingAddress_addressFields_country').val('sg');

            toggleBillingAddressFields();
        }
    });

    // default payment method to 'CREDIT_CARD'
    updatePaymentMethod(selectedPaymentMethod ? selectedPaymentMethod : 'CREDIT_CARD');
    $selectPaymentMethod.on('click', 'input[type="radio"]', function () {
        updatePaymentMethod($(this).val());
    });

    $('.gift-card-form-toggle').on('click', function (e) {
        e.preventDefault();

        var $giftCardForm = $('.gift-card-form');
        var $giftCardCheckLink = $('.check-gift-card');

        $giftCardForm.slideDown().removeClass('rolledup');
        $giftCardCheckLink.removeClass('mfp-hide');
        $(this).addClass('mfp-hide');
        initGiftCardBalance();
    });

    var $inithtml = $('#giftcardbalancemodal').html();

    $('.check-gift-card').on('click', function (e) {
        resetGiftcard();
        $('.gift-card-balance-modal input[name$="_giftCertCode"], .gift-card-balance-modal input[name$="_giftCertPIN"]').on('blur', function (e) {
            var $this = $(this);

            $this.siblings('.cmd-form_err._simple').remove();
            $this.closest('.cmd-form_box').removeClass('is-error');

            $('.gift-card-balance-modal a#check-giftcert-modal').prop('disabled', false);
            $('.gift-card-balance-modal .balance-error').html('');
            $('.gift-card-balance-modal .balance-error').removeClass('cmd-form_err');

            $('.c-block-giftcardbalance-block-send .balance').find("p.item-price").html('');

            //$('a#check-giftcert-modal').closest('.cmd-button_container').removeClass('is-hide');
            //$('a#add-giftcert-modal').closest('.cmd-button_container').addClass('is-hide');

            if ($this.val() && !$this.val().trim().match(/^[a-z0-9]+$/i)) {
                $('<p class="cmd-form_err _simple">' + $this.attr('data-required-text') + '</p>').insertAfter($this);
                $this.closest('.cmd-form_box').addClass('is-error');
            }

            if ($('.gift-card-balance-modal span.error').length > 0) {
                //    			$('.gift-card-balance-modal button#check-giftcert-modal').prop('disabled',true);
            }
        });
    });

    creditCardTypeDetector();

    // Add new credit card
    $(document).on('click', '.credit-card-create[data-modal-target="creditcard"]', function (evt) {
        evt.preventDefault();
        var $this = $(this);
        $.get($this.attr('href')).done(function (data) {
            $('.js-modal-r_content[data-modal-type="creditcard"] .cpb-modalR_contents').html(data);
            cpbUi.util.rightModalOpen.call($this, undefined, function (target) {
                cpbUi.niceScroll.ready();
                creditCardTypeDetector();
                cardValidation.init();
                validator.initForm('form[id$="CreditCardForm"]');
            });
        });
    });

    // Editing Credit card
    $(document).on('click', '.credit-card-edit[data-modal-target="creditcard"]', function (e) {
        e.preventDefault();
        var element = document.getElementById($(this).parents('.creditcard-tile-inner').attr('id'));
        var cartPosition = element.dataset.creditcardPosition;
        var cardUUID = element.dataset.uuid;
        if (!cardUUID || !cartPosition) {
            return;
        }

        var url = util.appendParamsToUrl(Urls.checkoutEditCreditCard + cartPosition, {
            creditcardUUID: cardUUID,
            checkout: true,
            format: 'ajax'
        });

        var $this = $(this);
        $.get(url).done(function (data) {
            $('.js-modal-r_content[data-modal-type="creditcard"] .cpb-modalR_contents').html(data);
            cpbUi.util.rightModalOpen.call($this, undefined, function (target) {
                cpbUi.niceScroll.ready();
                creditCardTypeDetector();
                cardValidation.init();
                validator.initForm('form[id$="CreditCardForm"]');
            });
        });
    });

    $(document).on("submit", "#CreditCardForm", function (evt) {
        evt.preventDefault();
        var $form = $(this);
        $.ajax({
            url: util.appendParamToURL($form.attr('action'), 'format', 'ajax'),
            data: $form.serialize() + '&' + $form.find('#applyBtn').attr('name') + '=x',
            type: 'POST'
        }).done(function (data) {
            if (data.length) {
                modal.setContent(data);
                validator.initForm('form[id$="CreditCardForm"]');
                return;
            }

            if (!location.assign(Urls.billing)) {
                window.location.href = Urls.billing;
            }
        });
    });

    //select credit card tile
    $(document).on('click', '.cpb-cart-card_select', function (evt) {
        var $this = $(this);
        var $thisInner = $this.children('.creditcard-tile-inner');

        if ($(this).find('.creditcard:checked').length > 0) {
            return false;
        } else {
            var fauxCVNInput = '<input class="cvn-input" type="text" maxlength="4" />';
            var cvnInput = '<input type="text" id="dwfrm_billing_paymentMethods_creditCard_cvn" name="dwfrm_billing_paymentMethods_creditCard_cvn" value="" maxlength="4" aria-invalid="false">';
            var element = document.getElementById(evt.currentTarget.getElementsByClassName('creditcard-tile-inner')[0].id);

            $('.creditcard-tile-inner').each(function () {
                $(this).find('.saved-cvn input').replaceWith(fauxCVNInput);
            });

            $this.find('.cvn-input').replaceWith(cvnInput);
            $this.find('input[name$="creditCard_cvn"]').focus();

            var creditcardPosition = element.dataset.creditcardPosition;

            var url = util.appendParamsToUrl(Urls.checkoutCreditCardSelection, {
                position: creditcardPosition
            });
            $.ajax({
                url: url,
                type: 'GET',
                success: function success(result) {}
            });

            setSelectedCardID($this.find('.creditcard-tile-inner').data("uuid"));
            addCVNEvent();
        }
    });

    $(document).on("click", ".address-create", function (evt) {
        evt.preventDefault();

        ajax.load({
            url: Urls.checkoutAddBillingAddress,
            callback: function callback(data) {
                $('#editaddressmodal').html(data);
                $.magnificPopup.open({
                    items: {
                        src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });
                validator.initForm('form[id="EditAddressForm"]');
                design.toggleSelectInit();
            }
        });
    });

    $(document).on("click", ".address-edit", function (evt) {
        evt.preventDefault();
        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var addressCode = element.dataset.addressCode;
        var url = Urls.checkoutEditBillingAddress + addressID;

        var $this = $(this);
        var addressID = $this.data('addressId');

        ajax.load({
            url: url,
            callback: function callback(data) {
                $('#editaddressmodal').html(data);
                $.magnificPopup.open({
                    items: {
                        src: '#editaddressmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });

                validator.initForm('form[id="EditAddressForm"]');
                design.toggleSelectInit();
            }
        });
    });

    $(document).on('click', '.address-list .address-tile', function (evt) {

        if ($(this).is('.selected, .default') || evt.target.nodeName == 'A') {
            return false;
        } else {
            $('.address-list .address-tile').each(function () {
                $(this).removeClass('is-current');
                $(this).removeClass('default');
            });

            $(this).addClass('is-current');

            var element = document.getElementById(evt.currentTarget.id);
            var addressID = element.dataset.addressId;

            var url = util.appendParamsToUrl(Urls.updateBillingAddressDetails, {
                addressID: addressID
                //format: 'ajax'
            });
            $.ajax({
                url: url,
                type: 'GET',
                success: function success(result) {
                    //alert(result);
                }
            });
        }
    });

    $('.order-summary-footer form').submit(function () {
        $('#summary-place-order').prop('disabled', true).addClass('loading');
        return true;
    });

    // if same as shipping is checked, re-select default address
    // or if nothing is selected, re-select default address
    if ($('input#same-as-shipping').length > 0 && $('input#same-as-shipping').is(":checked") || $('ul.address-list div.address-tile.is-current').length <= 0) {
        $(document).find('ul.address-list div.address-tile').each(function (ind, evt) {
            if ($(this).hasClass('default') || $(this).hasClass('is-current') || $(this).hasClass('address-default')) {
                $(this).removeClass('is-current');
                $(this).removeClass('default');

                $(this).click();
            }
        });
    } else if ($('input#same-as-shipping').length == 0 && $('ul.address-list div.address-tile.is-current').length > 0) {
        // if no physical product to ship, re-select tile to properly assign billing address
        var reSelectTile = $('ul.address-list div.address-tile.is-current');
        reSelectTile.removeClass('is-current');
        reSelectTile.removeClass('default');
        reSelectTile.click();
    }

    // trigger click event for selected by default cc (to manually trigger cc code)
    var selectedCC = $('div.payment-method div.creditcard-tile.selected');
    if (selectedCC) {
        selectedCC.removeClass('selected').click();
    }

    // maximize order checkout summary dropdown
    util.maximizeCheckoutSummary();

    // trigger only for non-registered users
    if (window.User.isCustomerAuthenticated == false) {
        $('input[name$="_creditCard_cvn"], input[name$="_creditCard_owner"]').on('change', function () {
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
            $('select[name$="_creditCard_expiration_month"]').trigger('change');
        });
    }

    $('.cpb-cart-checkout_fixed .cpb-cart_submit button').on('click', function () {
        $('.cpb-cart-side_submit button').trigger('click');
    });
};

},{"../../ajax":1,"../../design":8,"../../giftcard":11,"../../modal":19,"../../util":69,"../../validator":70,"./card-validation":29,"./formPrepare":30}],29:[function(require,module,exports){
'use strict';

// https://gist.github.com/ShirtlessKirk/2134376

var validator = require('../../validator');
var errors = {};
var inputCVN = 'input[id="card_code"]';
var inputMonth = 'select[name$=_expiration_month]';
var inputYear = 'select[name$=_expiration_year]';

var luhnCheck = function (arr) {
	return function (ccNum) {
		var len = ccNum.length;
		var bit = 1;
		var sum = 0;
		var val;

		while (len) {
			val = parseInt(ccNum.charAt(--len), 10);
			sum += (bit ^= 1) ? arr[val] : val;
		}

		return sum && sum % 10 === 0;
	};
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

var cvvCheck = function cvvCheck(cvv) {
	return (/^[0-9]{3,4}$/.test(cvv)
	);
};

var initCardExpiry = function initCardExpiry() {
	var ccSave = $('#CreditCardForm #applyBtn');
	ccSave.on('click', function (e) {
		validateCardExpiry(this, true);

		$('#CreditCardForm').find('button[type="submit"]').trigger('click');
	});

	$('.card-expiry .c-select-current').on('change blur', function () {
		validateCardExpiry(this);
	});

	$('form[id$=_billing] button[name$=_billing_save]').on('click touchstart', function (event) {
		validateCardExpiryDropdown($(this), true, event);
	});

	$('form[id$=_billing] select[name$=_creditCard_expiration_month], form[id$=_billing] select[name$=_creditCard_expiration_year], form[id="CreditCardForm"] select[name$=_newcreditcard_expiration_month], form[id="CreditCardForm"] select[name$=_newcreditcard_expiration_year]').on('change blur focusout', function () {
		validateCardExpiryDropdown($(this));
	});
};

var validateCardExpiry = function validateCardExpiry(el, checkEmpty) {
	console.log("validateCardExpiry");
	// need to declare specifically in order not to confuse with other forms with similar inputs
	var $this = $(el);
	var $month = $this.closest('form').find(inputMonth);
	var $year = $this.closest('form').find(inputYear);
	var $submit = $this.closest('form').find('a[type="submit"]');
	var hasError = false;

	var now = new Date();
	var nowMonth = now.getMonth() + 1;
	var nowYear = now.getFullYear();

	removeErrorInObj(inputMonth);
	removeErrorInObj(inputYear);
	$submit.prop('disabled', false);

	// validate only on form submit
	if (checkEmpty) {
		if (!$month.val()) {
			pushError(inputMonth, Resources.INVALID_CARDEXPIRY);
			hasError = true;
		}
		if (!$year.val()) {
			pushError(inputYear, Resources.INVALID_CARDEXPIRY);
			hasError = true;
		}
		// validate only if month and year has value, otherwise, ignore
	} else if ($month.val() && $year.val()) {
		if ($year.val() < nowYear) {
			pushError(inputYear, Resources.VALIDATE_CARDEXPIRY);
			hasError = true;
		} else if ($month.val() < nowMonth && $year.val() == nowYear) {
			$month(inputMonth, Resources.VALIDATE_CARDEXPIRY);
			hasError = true;
		}
	}

	// highlight inputs if expiry has error 
	if (hasError) {
		showError($month);
	}

	// disable button if there are errors -- // change by ticket shi-5388
	if ($this.closest('form').find('.cmd-form_err').length > 0) {
		$submit.prop('disabled', true);
	}
};

function validateCardExpiryDropdown($el, checkEmpty, e) {
	var $month = $el.closest('form').find(inputMonth);
	var $year = $el.closest('form').find(inputYear);
	var $cvn = $el.closest('form').find(inputCVN);

	if ($month.length && $year.length) {
		var $monthWrapper = $month.parent();
		var monthValue = $month.val() ? $month.val() != 'null' ? $month.val() : 0 : 0;
		var $yearWrapper = $year.parent();
		var yearValue = $year.val() ? $year.val() != 'null' ? $year.val() : 0 : 0;

		var now = new Date();
		var nowMonth = now.getMonth() + 1;
		var nowYear = now.getFullYear();

		if (checkEmpty) {
			if (!monthValue) {
				e.preventDefault();
				addError($monthWrapper, Resources.INVALID_CARDEXPIRY_MONTH);
			}
			if (!yearValue) {
				e.preventDefault();
				addError($yearWrapper, Resources.INVALID_CARDEXPIRY_YEAR);
			}
		} else {
			if (!monthValue || !yearValue) {
				//Add error when choose invalid value
				if ($el.attr('name').match(".*_expiration_month$")) {
					if ($el.closest($('form.checkout-billing')).length || $el.closest($('form#CreditCardForm')).length) {
						removeErrorInObj(inputMonth);
						if (!monthValue) {
							pushError(inputMonth, Resources.INVALID_CARDEXPIRY_MONTH);
						}
						showError($month);
					} else {
						removeError($monthWrapper);
						if (!monthValue) {
							addError($monthWrapper, Resources.INVALID_CARDEXPIRY_MONTH);
						}
					}
				} else {
					if ($el.closest($('form.checkout-billing')).length || $el.closest($('form#CreditCardForm')).length) {
						removeErrorInObj(inputYear);
						if (!yearValue) {
							pushError(inputYear, Resources.INVALID_CARDEXPIRY_YEAR);
						}
						showError($year);
					} else {
						removeError($yearWrapper);
						if (!yearValue) {
							addError($yearWrapper, Resources.INVALID_CARDEXPIRY_YEAR);
						}
					}
				}
			} else if (monthValue && yearValue) {
				//Check invalid month year
				if ($el.closest($('form.checkout-billing')).length || $el.closest($('form#CreditCardForm')).length) {
					removeErrorInObj(inputMonth);
					removeErrorInObj(inputYear);

					if (yearValue < nowYear) {
						pushError(inputYear, Resources.INVALID_CARDEXPIRY_YEAR);
					} else if (monthValue < nowMonth && yearValue == nowYear) {
						pushError(inputMonth, Resources.INVALID_CARDEXPIRY_MONTH);
					}
					showError($year);
				} else {
					removeError($monthWrapper);
					removeError($yearWrapper);

					if (yearValue < nowYear) {
						addError($yearWrapper, Resources.INVALID_CARDEXPIRY_YEAR);
					} else if (monthValue < nowMonth && yearValue == nowYear) {
						addError($monthWrapper, Resources.INVALID_CARDEXPIRY_MONTH);
					}
				}
			}
		}
	}
}

function addError($el, message) {
	$el.find('.c-input-label').addClass('is-error');
	$el.find('.c-select').addClass('is-error');
	if (!$el.find('ul.c-text-error').length) {
		$('<ul class="c-text-error c-text-error--simple"><li class="is-error">' + message + '</li></ul>').insertAfter($el.find('.c-input-label'));
	}
}

function removeError($el) {
	$el.find('ul.c-text-error').remove();
	$el.find('.c-input-label').removeClass('is-error');
	$el.find('.c-select').removeClass('is-error');
}

function initCVN() {
	$(inputCVN).on('blur', function () {
		removeErrorInObj(inputCVN);
		if (!validator.cvn($(this).val())) {
			pushError(inputCVN, Resources.VALIDATE_CVN);
		}
		showError($(this));
	});
}

function removeCurrentValidationCVN() {
	//	const rules = $(inputCVN).rules();
	//
	//	for (var key in rules) {
	//		if (rules.hasOwnProperty(key)) {
	//			rules[key] = false;
	//		}
	//	}
	//
	//	$(inputCVN).rules('add', rules);
}

function pushError(key, val) {
	errors[key] = val;
}

function removeErrorInObj(key) {
	delete errors[key];
	var $el = $(key).closest('.cmd-form_box');
	if ($el.hasClass('is-error')) {
		$el.removeClass('is-error');
	}
}

function showError($el) {
	$el.parent().parent().parent().closest('.cmd-form_box').find('.cmd-form_err._simple').remove();
	if (Object.keys(errors).length > 0) {
		var errStr = "";
		for (var i in errors) {
			errStr += errors[i] + '<br>';
			// add class error 
			var $elCmd = $(i).closest('.cmd-form_box');
			if (!$elCmd.hasClass('is-error')) {
				$elCmd.addClass('is-error');
			}
		}
		$('<p class="cmd-form_err _simple">' + errStr + '</p>').insertAfter($el.closest('.cmd-box_container'));
	}
}

exports.init = function () {
	errors = {};
	initCardExpiry();
	removeCurrentValidationCVN();
	initCVN();
};

},{"../../validator":70}],30:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = require('lodash');

var hasEmptyRequired = function hasEmptyRequired() {
    // filter out only the visible fields
    var requiredValues = this.$requiredInputs.filter(':visible').map(function () {
        return $(this).val();
    });
    return _(requiredValues).contains('');
};

var validateForm = function validateForm() {
    var _self = this;
    // only validate form when all required fields are filled to avoid
    // throwing errors on empty form
    if (!this.validator) {
        return;
    }

    // wait for the form to show before validating.. this applies to modals
    this.timer = setInterval(function () {
        if (_self.$form.is(':visible')) {
            if (_self.$form.find('span.error:visible, .error-form:visible').length == 0) {
                //!_self.hasEmptyRequired() &&
                _self.$continue.removeAttr('disabled');
            } else {
                _self.$continue.prop('disabled', true);
            }
            clearInterval(_self.timer);
        }
    }, 100);
};

var validateEl = function validateEl(e) {
    if ($(e.target).val() === '') {
        this.$continue.prop('disabled', true);
    } else {
        // enable continue button on last required field that is valid
        // only validate single field
        if (!this.hasEmptyRequired()) {
            this.$continue.removeAttr('disabled');
        } else {
            this.$continue.prop('disabled', true);
        }
    }
};

var checkValue = function checkValue(repopulateRequiredFields, e) {
    var $el = $(e.target);
    var attr = $el.attr('clear-on-error');

    // check for new required fields (e.g. changing US -> CH in address)
    if (repopulateRequiredFields) {
        this.$requiredInputs = this.$form.find('input.required');
    }

    // remove any error message residue from previous validation
    $el.siblings('span.is-error').remove();

    if (this.validator.element($el) && this.$form.find('span.is-error:visible').length == 0) {
        this.$continue.prop('disabled', false);
    } else {
        //        this.$continue.prop('disabled', true);

        // clear the value if input has error
        if ((typeof attr === 'undefined' ? 'undefined' : _typeof(attr)) !== (typeof undefined === 'undefined' ? 'undefined' : _typeof(undefined)) && attr !== false) $el.val('');
    }
};

var submitForm = function submitForm(e) {
    this.$form.find('input').blur();
    this.$form.find('select').blur();

    if (this.validator.numberOfInvalids() > 0 || this.$form.data('submitting') == true) {
        //    	this.$continue.prop('disabled', true);
        e.preventDefault();
        e.stopPropagation();
        return;
    }

    // adding this to prevent multiple submission of forms
    if (this.$form.attr('multiple-submission') === 'false') {
        this.$form.data('submitting', true);
    }
};

var init = function init(opts, settings) {
    if (!opts.formSelector || !opts.continueSelector) {
        throw new Error('Missing form and continue action selectors.');
    }
    this.$form = $(opts.formSelector);
    this.$continue = $(opts.continueSelector);
    this.validator = settings ? this.$form.validate(settings) : this.$form.validate();
    this.$allInputs = $('input, textarea', this.$form);
    this.$allSelect = $('select', this.$form);
    this.$requiredInputs = this.$form.find('input.required');
    //    this.validateForm();

    // start listening
    //    this.$requiredInputs.on('change', $.proxy(this.validateEl, this));
    //this.$allInputs.on('keyup', $.proxy(this.checkValue, this, false));
    this.$allSelect.on('blur', $.proxy(this.checkValue, this, true));
    this.$continue.on('click', $.proxy(this.submitForm, this));
    // [life-hack:5079] needed to trigger onclick since blur prevents the form from submitting
    if (this.$continue.attr('mousesubmit') === 'true') {
        this.$continue.on('mousedown', $.proxy(function (e) {
            this.$continue.click();
        }, this));
    }
};

var formPrepare = function formPrepare() {
    return {
        $form: null,
        $continue: null,
        $allInputs: null,
        $allSelect: null,
        $requiredInputs: null,
        validator: null,
        init: init,
        timer: null,
        hasEmptyRequired: hasEmptyRequired,
        checkValue: checkValue,
        validateForm: validateForm,
        submitForm: submitForm,
        validateEl: validateEl
    };
};

module.exports = formPrepare;

},{"lodash":76}],31:[function(require,module,exports){
'use strict';

var address = require('./address'),
    billing = require('./billing'),
    multiship = require('./multiship'),
    shipping = require('./shipping');

/**
 * @function Initializes the page events depending on the checkout stage (shipping/billing)
 */
exports.init = function () {
    address.init();
    if ($('.checkout-shipping').length > 0) {
        shipping.init();
    } else if ($('.checkout-multi-shipping').length > 0) {
        multiship.init();
    } else {
        billing.init();
    }

    //if on the order review page and there are products that are not available diable the submit order button
    if ($('.order-summary-footer').length > 0) {
        if ($('.notavailable').length > 0) {
            $('.order-summary-footer .submit-order .button-fancy-large').attr('disabled', 'disabled');
        }
    }

    $('.cpb-cart-checkout_fixed.js-place-order').on('click', function () {
        $('#summary-place-order').trigger('click');
    });
};

},{"./address":27,"./billing":28,"./multiship":33,"./shipping":34}],32:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Enable/disable button depending if input has value
 */

exports.init = function () {
    var $emailInput = $('.checkoutlogin input[type="email"]');
    var $emailButton = $('.checkoutlogin button');
    $emailInput.on('keyup', function (e) {
        if ($emailInput.val().length) {
            $emailButton.prop('disabled', false);
        } else {
            //    	    	$emailButton.prop('disabled', true);
        }
    });
};

},{}],33:[function(require,module,exports){
'use strict';

var address = require('./address'),
    formPrepare = require('./formPrepare'),
    dialog = require('../../dialog'),
    util = require('../../util'),
    validator = require('../../validator');

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox() {
    $.each($('.item-list'), function () {
        var $this = $(this);
        var $giftMessage = $this.find('.gift-message-text');

        //handle initial load
        $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');

        //set event listeners
        $this.on('change', function () {
            $giftMessage.toggleClass('hidden', $('input[name$="_isGift"]:checked', this).val() !== 'true');
        });
    });
}

/**
 * @function
 * @description capture add edit adddress form events
 */
function addEditAddress(target) {
    var $addressForm = $('form[name$="multishipping_editAddress"]'),
        $addressDropdown = $addressForm.find('select[name$=_addressList]'),
        $addressList = $addressForm.find('.address-list'),
        add = true,
        originalUUID,
        resetOptionValue = false,
        selectedAddressUUID = $(target).parent().siblings('.select-address').val();

    $addressDropdown.on('change', function (e) {
        e.preventDefault();

        var selectedAddress = $addressList.find('select').val();
        if (selectedAddress !== 'newAddress') {
            selectedAddress = $.grep($addressList.data('addresses'), function (add) {
                return add.UUID === selectedAddress;
            })[0];
            add = false;
            resetOptionValue = false;
            // proceed to fill the form with the selected address
            util.fillAddressFields(selectedAddress, $addressForm);
        } else if (selectedAddress === 'newAddress') {
            add = true;
            resetOptionValue = true;
            $addressForm.find('.input-text, .input-select').val('');
        } else {
            //reset the form if the value of the option is not a UUID
            $addressForm.find('.input-text, .input-select').val('');
        }
    });

    $addressForm.on('click', '.cancel', function (e) {
        e.preventDefault();
        dialog.close();
    });

    $addressForm.on('submit', function (e) {
        e.preventDefault();
        if (!$addressForm.valid()) {
            return false;
        }

        $.getJSON(Urls.addEditAddress, $addressForm.serialize(), function (response) {
            if (!response.success) {
                $('#multiaddresserror').html(Resources.COULD_NOT_SAVE_ADDRESS);
                return;
            }
            $('#multiaddresserror').toggleClass('hidden', response.success);

            var address = response.address,
                $shippingAddress = $(target).closest('.shippingaddress'),
                $select = $shippingAddress.find('.select-address'),
                $selected = $select.find('option:selected'),
                newOption = '<option value="' + address.UUID + '">' + (address.ID ? '(' + address.ID + ')' : address.firstName + ' ' + address.lastName) + ', ' + address.address1 + ', ' + address.city + ', ' + address.stateCode + ', ' + address.postalCode + '</option>';
            dialog.close();

            if (address.UUID !== originalUUID) {
                resetOptionValue = true;
            }

            if (add) {
                $('.shippingaddress select').removeClass('no-option').append(newOption);
                $('.no-address').hide();
            } else {
                $('.shippingaddress select').find('option[value="' + address.UUID + '"]').html(newOption);
            }
            // if there's no previously selected option, select it
            if ($selected.length === 0 || $selected.val() === '' || resetOptionValue) {
                $select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
            }
        });
    });

    //preserve the uuid of the option for the hop up form
    if (selectedAddressUUID) {
        //update the form with selected address
        $addressList.find('option').each(function () {
            //check the values of the options
            if ($(this).attr('value') === selectedAddressUUID) {
                $(this).prop('selected', 'selected');
                $addressDropdown.trigger('change');
            }
        });
        originalUUID = selectedAddressUUID;
    }

    validator.init();
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
    initMultiGiftMessageBox();
    if ($('.cart-row .shippingaddress .select-address').length > 0) {
        validator.initForm('form[id$="multishipping_addressSelection"]');
    }
    $('.edit-address').on('click', 'span', function (e) {
        dialog.open({ url: this.attributes.href.value, options: { open: function open() {
                    address.init();
                    addEditAddress(e.target);
                } } });
    });
};

},{"../../dialog":9,"../../util":69,"../../validator":70,"./address":27,"./formPrepare":30}],34:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    progress = require('../../progress'),
    tooltip = require('../../tooltip'),
    util = require('../../util'),
    validator = require('../../validator'),
    modal = require('../../modal').global,
    design = require('../../design'),
    addressVerificationSvc = require('../../qas');

var $cache, shippingMethods;

function initCache() {
    var $formEle = $('form[id$="_shippingAddress"]');
    $cache = {
        addrForm: {
            address1: $formEle.find('input[name$="_address1"]'),
            address2: $formEle.find('input[name$="_address2"]'),
            countryCode: $formEle.find('input[id$="_country"]'),
            stateCode: $formEle.find('input[id$="_state"]'),
            postalCode: $formEle.find('input[name$="_postal"]'),
            city: $formEle.find('input[name$="_city"]')
        }
    };
}

function initEvents() {
    $(document)
    // create address link
    .on("click", ".address-create", function (evt) {
        evt.preventDefault();
        var $createShippingAddBtn = $(this);
        var dataSend = {
            format: 'ajax',
            showtype: 'rightmodal'
        };
        ajax.load({
            url: Urls.checkoutAddAddress,
            data: dataSend,
            callback: function callback(data) {
                $('.js-modal-r_content[data-modal-type="address"] .cpb-modalR_contents').html(data);
                // show modal
                cpbUi.util.rightModalOpen.call($createShippingAddBtn, undefined, function (target) {
                    validator.initForm('form[id="EditAddressForm"]');
                    cpbUi.niceScroll.ready();
                    initAddressEvent();
                });
            }
        });
    });

    // authenticated user address change
    $('.address-list').on('change', '.address-tile input[name="shipping"]', function () {
        var $addressTile = $(this).closest('.address-tile');
        var addressID = $addressTile.data('addressId');

        // update address; on success update shipping method list
        $.get(Urls.updateAddressDetails, { addressID: addressID }, function (response) {
            updateShippingMethodList();
        });

        //checkSelectedAddress();
    });

    $('.btn-edit-shippingaddress').on("click", function (evt) {
        evt.preventDefault();
        var $editShippingAddBtn = $(this);
        var element = document.getElementById(evt.currentTarget.id);
        var addressID = element.dataset.addressId;
        var url = Urls.checkoutEditAccountAddress + addressID;
        var dataSend = {
            showtype: 'rightmodal'
        };

        $.ajax({
            type: 'get',
            url: url,
            data: dataSend
        }).done(function (data) {
            $('.js-modal-r_content[data-modal-type="address"] .cpb-modalR_contents').html(data);
            // show modal
            cpbUi.util.rightModalOpen.call($editShippingAddBtn, undefined, function (target) {
                validator.initForm('form[id="EditAddressForm"]');
                cpbUi.niceScroll.ready();
            });
        });
    });

    // guest user address change
    var timer = null;
    $('form[id$="_shippingAddress"]').on('change', 'input[name$="_addressFields_address1"], input[name$="_addressFields_address2"], input[name$="_addressFields_states_state"], input[name$="_addressFields_city"], input[name$="_addressFields_postal"]', function () {
        if (!validateAddrForm()) {
            return;
        }

        if (timer) {
            window.clearTimeout(timer);
        }

        timer = window.setTimeout(function () {
            $.post(Urls.setShippingAddressDetails, $('form[id$="_singleshipping_shippingAddress"]').serialize(), function (result) {
                updateShippingMethodList();
            });
        }, 200);
    });

    $('input[name$="_shippingAddress_isGift"]').on('click', giftMessageBox);
    $('input[name$="_cart_isGift"]').on('click', giftMessageBox);

    $('.cpb-cart-checkout_fixed .cpb-cart_submit button').on('click', function () {
        $('.cpb-cart-side_submit button').trigger('click');
    });
}

/**
 * @function
 * @description Initializes gift message box, if shipment is gift
 */
function giftMessageBox() {
    // show gift message box, if shipment is gift
    $('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val() !== 'true');
    $('.c-block-cartmessage').toggleClass('mfp-hide', $('input[name$="_cart_isGift"]:checked').val() !== 'true');
}

/**
 * @function
 * @description updates the order summary based on a possibly recalculated basket after a shipping promotion has been applied
 */
function updateSummary() {
    var $summary = $('#secondary.summary');
    var couponError;

    if ($('.cart-coupon-code .error').length) {
        couponError = $('.cart-coupon-code .error').clone();
    }

    // indicate progress
    progress.show($summary);

    // load the updated summary area
    $summary.load(Urls.summaryRefreshURL, function () {
        // hide edit shipping method link
        $summary.fadeIn('fast');

        // checkout checkout minicart on right side event handling
        addSummaryScrollbar();

        $summary.find('.checkout-mini-cart .minishipment .header a').hide();
        $summary.find('.order-totals-table .order-shipping .label a').hide();
        $('.cart-coupon-code').append(couponError);
        util.maximizeCheckoutSummary();

        $(".checkout-mini-cart .accordion").foundation();
    });
}

function getAddressFromTile() {
    var $selectedAddress = $(".address-tile.is-current address");

    return {
        address1: $selectedAddress.data("address-one"),
        address2: $selectedAddress.data("address-two") || "",
        countryCode: $selectedAddress.data("country-code"),
        stateCode: $selectedAddress.data("state-code"),
        postalCode: $selectedAddress.data("postal-code"),
        city: $selectedAddress.data("city")
    };
}

/**
 * Init submit button on address add/edit modal, on change content in form
 * @returns
 */
function initAddressEvent() {
    // Refresh niceScroll
    $('#EditAddressForm button[name$="_address_create"]').on('click', function (e) {
        $(this).closest('[data-modal-type="address"]').find('.js-modal_scroll').removeClass('scroll-initialized');

        cpbUi.niceScroll.ready();
    });
    // Refresh niceScroll
    $('#EditAddressForm').on("click", function () {
        $(this).closest('[data-modal-type="address"]').find('.js-modal_scroll').removeClass('scroll-initialized');

        cpbUi.niceScroll.ready();
    });
    // Refresh niceScroll
    $('#EditAddressForm').keyup(function (e) {
        var code = e.keyCode || e.which;
        // tab key
        if (code == '9') {
            $(this).closest('[data-modal-type="address"]').find('.js-modal_scroll').removeClass('scroll-initialized');

            cpbUi.niceScroll.ready();
        }
    });
}

function getAddressFromForm() {
    return {
        address1: $cache.addrForm.address1.val(),
        address2: $cache.addrForm.address2.val(),
        countryCode: $cache.addrForm.countryCode.val(),
        stateCode: $cache.addrForm.stateCode.val(),
        postalCode: $cache.addrForm.postalCode.val(),
        city: $cache.addrForm.city.val()
    };
}
/**
 * @function
 * @description Helper method which constructs a URL for an AJAX request using the
 * entered address information as URL request parameters.
 */
function getShippingMethodURL(url, extraParams) {
    var params = User.isCustomerAuthenticated ? getAddressFromTile() : getAddressFromForm();
    return util.appendParamsToUrl(url, $.extend(params, extraParams));
}

/**
 * @function
 * @description selects a shipping method for the default shipment and updates the summary section on the right hand side
 * @param
 */
function selectShippingMethod(shippingMethodID) {
    // nothing entered
    if (!shippingMethodID) {
        return;
    }
    // attempt to set shipping method
    var url = getShippingMethodURL(Urls.selectShippingMethodsList, { shippingMethodID: shippingMethodID });
    ajax.getJson({
        url: url,
        callback: function callback(data) {
            updateSummary();
            if (!data || !data.shippingMethodID) {
                window.alert('Couldn\'t select shipping method.');
                return false;
            }
            // display promotion in UI and update the summary section,
            // if some promotions were applied
            $('.shippingpromotions').empty();

            // if (data.shippingPriceAdjustments && data.shippingPriceAdjustments.length > 0) {
            //     var len = data.shippingPriceAdjustments.length;
            //     for (var i=0; i < len; i++) {
            //         var spa = data.shippingPriceAdjustments[i];
            //     }
            // }
        }
    });
}

/**
 * @function
 * @description Make an AJAX request to the server to retrieve the list of applicable shipping methods
 * based on the merchandise in the cart and the currently entered shipping address
 * (the address may be only partially entered).  If the list of applicable shipping methods
 * has changed because new address information has been entered, then issue another AJAX
 * request which updates the currently selected shipping method (if needed) and also updates
 * the UI.
 */
function updateShippingMethodList() {
    var $shippingMethodList = $('#shipping-method-list');
    if (!$shippingMethodList || $shippingMethodList.length === 0) {
        return;
    }
    var url = getShippingMethodURL(Urls.shippingMethodsJSON);
    ajax.getJson({
        url: url,
        callback: function callback(data) {
            if (!data) {
                window.alert('Couldn\'t get list of applicable shipping methods.');
                return false;
            }

            // shipping methods remain unchanged; update summary as selected method may/may not change
            if (shippingMethods && shippingMethods.toString() === data.toString()) {
                updateSummary();
                return true;
            }

            // We need to update the UI.  The list has changed.
            // Cache the array of returned shipping methods.
            shippingMethods = data;
            // indicate progress
            progress.show($shippingMethodList);

            // load the shipping method form
            var smlUrl = getShippingMethodURL(Urls.shippingMethodsList);
            $shippingMethodList.load(smlUrl, function () {
                $shippingMethodList.fadeIn('fast');
                // rebind the radio buttons onclick function to a handler.
                $shippingMethodList.find('[name$="_shippingMethodID"]').click(function () {
                    selectShippingMethod($(this).val());
                });

                // update the summary
                updateSummary();
                progress.hide();
                tooltip.init();
                //if nothing is selected in the shipping methods select the first one
                if ($shippingMethodList.find('.input-radio:checked').length === 0) {
                    $shippingMethodList.find('.input-radio:first').prop('checked', 'checked');
                }
            });
        }
    });
}

/**
 * Check there is an address selected, if not, disable the continue button
 * */
function checkSelectedAddress() {
    var $form = $('form[id$="_shippingAddress"]');
    var $submit = $form.find('button[type="submit"]');
    var $footerSubmit = $('.cpb-cart-checkout_fixed .cpb-cart_submit button');

    // enable the submit button if there are no shipping card
    // if there are, user must have at least 1 selected shipping card for the button to be enabled
    if ($form.find('.address-tile').length == 0 || $form.find('.address-tile input[name="shipping"]:checked').length) {
        $submit.prop('disabled', false);
        $footerSubmit.prop('disabled', false);
    } else {
        $submit.prop('disabled', true);
        $footerSubmit.prop('disabled', true);
    }
}

function validateAddrForm() {
    var addr = getAddressFromForm();
    return addr.address1 && addr.city && addr.postalCode && addr.stateCode && addr.countryCode;
}

function initCouponCodeField() {

    $('.cpb-cart-side_code input').on('keydown', function (e) {
        var couponCode = $('.cpb-cart-side_code input').val();
        if (couponCode == '') {
            $('#add-coupon').prop('disabled', true);
        } else {
            $('#add-coupon').prop('disabled', false);
        }

        if (e.which === 13) {
            e.preventDefault();
            $('#add-coupon').click();
        }
    });
}

exports.init = function () {
    initCache();
    initEvents();
    addressVerificationSvc.init();

    if (window.User.isCustomerAuthenticated == false) {
        $('.checkout-shipping').find('.set-default-cb').hide();
    }

    validator.initForm('form[name$="shippingAddress_save"]');

    giftMessageBox();
    updateShippingMethodList();
    //initCouponCodeField();

    $(document).find('ul.address-list div.address-tile').each(function () {
        if ($(this).hasClass('default') || $(this).hasClass('is-current') || $(this).hasClass('address-default')) {
            $(this).removeClass('is-current');
            $(this).removeClass('default');

            $(this).click();
        }
    });

    //checkSelectedAddress();
};

exports.updateShippingMethodList = updateShippingMethodList;

},{"../../ajax":1,"../../design":8,"../../modal":19,"../../progress":56,"../../qas":57,"../../tooltip":68,"../../util":69,"../../validator":70}],35:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    page = require('../page'),
    productTile = require('../product-tile'),
    quickview = require('../quickview');

/**
 * @private
 * @function
 * @description Binds the click events to the remove-link and quick-view button
 */
function initializeEvents() {
    $('#compare-table').on('click', '.remove-link', function (e) {
        e.preventDefault();
        ajax.getJson({
            url: this.href,
            callback: function callback() {
                page.refresh();
            }
        });
    }).on('click', '.open-quick-view', function (e) {
        e.preventDefault();
        var url = $(this).closest('.product').find('.thumb-link').attr('href');
        quickview.show({
            url: url,
            source: 'quickview'
        });
    });

    $('#compare-category-list').on('change', function () {
        $(this).closest('form').submit();
    });
}

exports.init = function () {
    productTile.init();
    initializeEvents();
    addProductToCart();
};

},{"../ajax":1,"../page":23,"../product-tile":55,"../quickview":58,"./product/addToCart":39}],36:[function(require,module,exports){
'use strict';

var util = require('../util');

function initializeEvents() {
    $(document)

    // mobile navigation
    .on('change', '.promotion-nav-select select', function (e) {
        var newUrl = $(this).find("option:selected").val();

        if (newUrl) {
            window.location.href = newUrl;
        }
    });

    // concierge form events
    var conciergeForm = $('form[id$="_beautyconsultant"]');
    if (conciergeForm.length > 0) {
        // secure concierge access
        /*if (location && location.protocol === 'http:') {
            window.location.href = Urls.secureConciergeForm;
        }*/

        var successShown = false;
        conciergeForm.on('click', 'button#sendBtn', function (e) {
            e.preventDefault();

            $.ajax({
                url: util.appendParamToURL(Urls.customerServiceSubmit, 'source', 'concierge'),
                data: conciergeForm.serialize(),
                method: 'POST'
            }).done(function (response) {
                var conciergeModal = $('#concierge-modal');
                if (response && response.success && conciergeModal.length > 0) {
                    // show success modal
                    successShown = true;
                    var popup = new Foundation.Reveal(conciergeModal);
                    //Window height minus 80px, which sets the modal to fit inside the device's screen
                    var windowHeight = window.innerHeight - 130;

                    popup.$element.children('.modal-body').css('max-height', windowHeight);
                    popup.open();

                    // trigger ga
                    window.history.pushState("", "", Urls.conciergeForm);
                    $(document).trigger("askanexpert");
                }
            });
        });

        $(document).on('click', '.reveal-overlay', function () {
            // trigger redirect when concierge overlay is closed
            if (successShown && $(this).css('display') == 'none') {
                successShown = false;
                window.location.href = Urls.secureConciergeForm;
            }
        });
    }
}

module.exports.init = function () {
    initializeEvents();
};

},{"../util":69}],37:[function(require,module,exports){
'use strict';

var addToCart = require('./product/addToCart'),
    product = require('./product/index'),
    util = require('../util');

var getProductStatus = function getProductStatus(pid, callback) {
	$.ajax({
		type: 'GET',
		url: Urls.checkStatus + '?pid=' + pid + '&format=ajax'
	}).done(function (data) {
		callback(pid, data);
	});
};

var wishlistAction = function wishlistAction(ele, unauthenticateAction, doneAction) {
	ele.off('click').click(function (e) {
		if (!window.User.isCustomerAuthenticated) {
			unauthenticateAction();

			return;
		}

		e.preventDefault();

		var form = $(this).parent();
		var url = util.appendParamsToUrl(form.attr('action'), {
			format: 'ajax'
		});

		$.ajax({
			type: 'POST',
			url: url,
			data: form.serialize()
		}).done(doneAction);
	});
};

exports.init = function () {
	$('#product-action-form #add-to-cart-content').off('click').click(addToCart.addToCart);
};

exports.init_window = function () {
	window.getProductStatusFn = getProductStatus;
	window.wishlistActionFn = wishlistAction;

	window.addToCartPDP = addToCart.addToCart;
	window.addToWishlistPDP = product.addToWishlist;
	window.removeFromWishlistPDP = product.removeFromWishlist;
};

},{"../util":69,"./product/addToCart":39,"./product/index":43}],38:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {
	if ($('.pt_order-confirmation').length) {
		recommendations();
	} else {
		return;
	}
};

},{"./product/recommendations":45}],39:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog'),
    minicart = require('../../minicart'),
    page = require('../../page'),
    util = require('../../util'),
    Promise = require('promise'),
    _ = require('lodash'),
    design = require('../../design');

/**
 * @description set addToCart error message
 * @param {String} msg
 */
var timer;
var setAddToCartError = function setAddToCartError(msg) {
    var $errEle = $("#a2c-error");
    $errEle.html(msg);
};

/**
 * @description Make the AJAX request to add an item to cart
 * @param {Element} form The form element that contains the item quantity and ID data
 * @returns {Promise}
 */
var addItemToCart = function addItemToCart(form) {
    var $form = $(form);
    return Promise.resolve($.ajax({
        type: 'POST',
        url: util.ajaxUrl(Urls.addProduct),
        data: $form.serialize()
    })).then(function (response) {
        // handle error in the response
        if (response.error) {
            setAddToCartError(response.error);
            throw new Error(response.error);
            return false;
        }
        return response;
    });
};

/**
 * set addToCartType
 */
var setAddToCartType = function setAddToCartType(type, pid) {
    $.ajax({
        type: 'POST',
        url: util.appendParamsToUrl(util.ajaxUrl(Urls.addToCartType), {
            type: type,
            pid: pid
        })
    });
};

/**
 * @description Handler to handle the add to cart event
 */
var addToCart = function addToCart(e) {
    e.preventDefault();
    var $form = $(this).closest('form');
    $form.find('input[name="Quantity"]').val(1);
    var pid = $form.find('input[name="pid"]').val();
    var isQuickView = $(this).parents('#cpb-modal-quickview').length > 0;
    var addToCartType = isQuickView ? 'Quick Shop' : 'Product page';
    addItemToCart($form).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            // do not close quickview if adding individual item that is part of product set
            // @TODO should notify the user some other way that the add action has completed successfully
            $(document).trigger("gtadd-to-cart");
            if (isQuickView) {
                cpbUi.util.rightModalClose.call($('#cpb-modal-quickview .js-quickview_close'), 'quickview', function () {
                    $("#cpb-modal-quickview").find('.js-modal_scroll').getNiceScroll().remove();
                    $('#cpb-modal-quickview').remove();
                    // show minicart
                    minicart.show(response);
                    // reset isQuickView value
                    cpbUi.isQuickView = false;
                });
            } else {
                minicart.show(response);
            }
        }
        setAddToCartType(addToCartType, pid);
    }.bind(this));
};

/**
 * @description Handler to handle the add all items to cart event
 */
var addAllTo = function addAllTo(e) {
    e.preventDefault();

    var pidData = formatPidDataFromEles($('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea'));
    minicart.addAllProducts(pidData, e.data.to);
};

/**
 * @description Handler to handle the add an item to cart event on PDP footer
 */
var addToCartOnFooter = function addToCartOnFooter(e) {
    e.preventDefault();
    var $form = $('.pdpForm');
    if (!$form.length || $(this).find('button').prop('disabled')) {
        return;
    }

    var quantity = 1;

    $form.find('input[name="Quantity"]').val(quantity);
    var pid = $form.find('input[name="pid"]').val();

    addItemToCart($form).then(function (response) {
        var $uuid = $form.find('input[name="uuid"]');
        if ($uuid.length > 0 && $uuid.val().length > 0) {
            page.refresh();
        } else {
            // do not close quickview if adding individual item that is part of product set
            // @TODO should notify the user some other way that the add action has completed successfully
            $(document).trigger("gtadd-to-cart");
            minicart.show(response);
        }
        setAddToCartType('Product page', pid);
    }.bind(this));
};

// Accepts jQuery selector of n elements containing data attr storing pid
// Returns formatted pid data required for addAllProducts request (ex. 'pidA:1,pidB:1,pidN:1')
// To fetch qty, searches for qty dropdown or defaults to 1
function formatPidDataFromEles($selector) {
    return $selector.toArray().map(function (ele) {
        var $ele = $(ele),
            pid = $ele.data('pid'),
            qty = $ele.find('input[name="Quantity"]').length ? $ele.find('input[name="Quantity"]').val() : 1;

        return pid + ":" + qty;
    }).join(',');
}

/**
 * @function
 * @description Binds the click event to a given target for the add-to-cart handling
 */
module.exports = function () {
    $('.add-to-cart[disabled]').attr('title', $('.availability-msg').text());
    $('#add-all-to-cart').off('click').on('click', { to: 'Cart' }, addAllTo);
    $('#cpb-products_submit .add-to-cart').off('click').on('click', addToCart);
    $('.cpb-products-cart_fixed .cpb-products-cart_submit button').off('click').on('click', addToCartOnFooter);
};

/**
 * duplicated add-to-cart from export above - endorse for re-factoring
 * reason for duplication : sometimes add to bag/cart script won't trigger/execute
 */
$(document).on('click', '#samples-add-to-cart', addSamplesToCart);
$(document).on('click', '.cpb-cart-sample_list .cpb-cart-sample_item', sampleTileSelect);
$(document).on('change', '.reveal.sample-selection .close-button', function (e) {
    scrollToTop(e);
});
$("form.multi-select-form").on('submit', function (e) {
    e.preventDefault();

    var pidData = formatPidDataFromEles($(this).find('button.multiselect[value="selected"]'));
    minicart.addAllProducts(pidData, 'Cart');
});

function sampleTileSelect(e) {
    e.preventDefault();

    var $this = $(this);
    var $tile = $this.find('[name="sampleselect"]');
    var $multiSelectForm = $this.parents('form');
    var $thresholdInput = $multiSelectForm.find('input#pids');

    var selectedCount = $multiSelectForm.find($('input[name="sampleselect"]:checked')).length;
    var limitCount = $thresholdInput.data('limit');

    if (!$('#sampleserror').hasClass('invisible')) {
        $('#sampleserror').addClass('invisible');
        $('#sampleserror').find('li.is-error').html(null);
    }

    // do checking to compare if limit is met
    if (selectedCount > limitCount) {
        // toggle val/text
        $tile.prop('checked', false);

        // display sample error
        $('#sampleserror').removeClass('invisible');
        $('#sampleserror').html($("input#pids").data('error'));

        // refresh niceScroll
        $(this).closest('[data-modal-type="sample"]').find('.js-modal_scroll').removeClass('scroll-initialized');
        cpbUi.niceScroll.ready();
    }

    var selectedProductList = [];
    var enableAddToBag = true;

    // fetch all items that are selected
    $multiSelectForm.find('[name="sampleselect"]:checked').each(function (index, item) {
        selectedProductList.push($(item).val());
        enableAddToBag = true;
    });

    // store all selected products to hidden input
    $thresholdInput.val(selectedProductList);

    // update selected counter
    var selectedCount = parseInt(selectedProductList.length);
    var selectedLimit = parseInt($thresholdInput.data('count'));
    $("span#sample-count").html(selectedCount <= selectedLimit ? selectedCount : selectedLimit);

    // enable "Add to Bag" button
    var cartButton = $thresholdInput.data('button');
    if (enableAddToBag) {
        $('#' + cartButton).removeClass('disabled');
    } else {
        $('#' + cartButton).addClass('disabled');
    }
}

function addSamplesToCart(e) {
    e.preventDefault();

    var url = util.toAbsoluteUrl($(this).data('action'));
    var data = {};
    data['pid'] = $(this).parents('form').find("input#pids").val();
    data[$(this).parents('form').find("input#csrf")[0].name] = $(this).parents('form').find("input#csrf").val();

    $.ajax({
        url: util.appendParamToURL(url, 'format', 'ajax'),
        data: data,
        method: 'POST'
    }).done(function (response) {
        if ($(location).attr('pathname').match(".*Cart-Show$|.*Cart-SubmitForm$")) {
            window.location.assign(Urls.cartShow);
        } else {
            minicart.show(response);
            design.dropdownToggleInit();
        }
    });

    // close sample modal
    cpbUi.util.rightModalClose.call($('.js-modal-r_content[data-modal-type="sample"] .js-modal-r_close'), undefined, function (target) {});
}

},{"../../design":8,"../../dialog":9,"../../minicart":18,"../../page":23,"../../util":69,"lodash":76,"promise":77}],40:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    util = require('../../util');

var updateContainer = function updateContainer(data) {
    var $availabilityMsg = $('.pdp-main .cpb-products-stock');
    var message; // this should be lexically scoped, when `let` is supported (ES6)
    if (!data) {
        $availabilityMsg.html('<div class="item-txt">' + Resources.ITEM_STATUS_NOTAVAILABLE + '</div>');
        return;
    }
    $availabilityMsg.empty();
    // Look through levels ... if msg is not empty, then create span el
    if (data.levels.IN_STOCK > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            // Just in stock
            message = Resources.IN_STOCK;
        } else {
            // In stock with conditions ...
            message = Resources.IN_STOCK + '<br>' + data.inStockMsg;
        }
        $availabilityMsg.append('<div class="item-txt">' + message);
    }
    if (data.levels.PREORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.BACKORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.PREORDER;
        } else {
            message = Resources.PREORDER + '<br>' + data.preOrderMsg;
        }
        $availabilityMsg.append('<div class="item-txt">' + message);
    }
    if (data.levels.BACKORDER > 0) {
        if (data.levels.IN_STOCK === 0 && data.levels.PREORDER === 0 && data.levels.NOT_AVAILABLE === 0) {
            message = Resources.BACKORDER;
        } else {
            message = Resources.BACKORDER + '<br>' + data.backOrderMsg;
        }
        $availabilityMsg.append('<div class="item-txt">' + message);
    }
    if (data.inStockDate !== '') {
        $availabilityMsg.append(String.format(Resources.IN_STOCK_DATE, data.inStockDate));
    }
    if (data.levels.NOT_AVAILABLE > 0) {
        if (data.levels.PREORDER === 0 && data.levels.BACKORDER === 0 && data.levels.IN_STOCK === 0) {
            message = Resources.NOT_AVAILABLE;
        } else {
            message = Resources.NOT_AVAILABLE + '<br>' + Resources.REMAIN_NOT_AVAILABLE;
        }
        $availabilityMsg.append('<div class="item-txt">' + message);
    }

    $availabilityMsg.append('</div>');
};

var getAvailability = function getAvailability() {
    ajax.getJson({
        url: util.appendParamsToUrl(Urls.getAvailability, {
            pid: $('#pid').val(),
            Quantity: $(this).val()
        }),
        callback: updateContainer
    });
};

module.exports = function () {
    $('#pdpMain').on('change', '.pdpForm input[name="Quantity"]', getAvailability);
};

},{"../../ajax":1,"../../util":69}],41:[function(require,module,exports){
'use strict';

function initializeEvents() {
	$('.video-carousel').slick({
		dots: true,
		infinite: false,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [{
			breakpoint: 480,
			settings: 'unslick'
		}]
	});
}

module.exports = {
	init: function init() {
		initializeEvents();
	}
};

},{}],42:[function(require,module,exports){
'use strict';

var dialog = require('../../dialog');
var modal = require('../../modal').global;
var util = require('../../util');
var qs = require('qs');
var url = require('url');
var _ = require('lodash');

function getProductImageURL(viewType) {
    var pid = $("span[itemprop='productID']").data("pid");
    return util.appendParamsToUrl(Urls.getProductImages, { "pid": pid, "sz": viewType });
}

function lazyLoadThumbnails() {
    var viewType = util.isMobile() ? "large" : "icon";
    var thumbnailProductImageURL = getProductImageURL(viewType);

    $.get(thumbnailProductImageURL).done(function (res) {
        $("#thumbnails").html(res);

        var thumbnailImageCount = $("#thumbnails li").length;
        if (thumbnailImageCount == 0) {
            return false;
        } else if (thumbnailImageCount > 1 && window.innerWidth > 767) {
            initThumbnailCarousel();
        } else if (thumbnailImageCount > 1 && window.innerWidth < 768) {
            initMainImageCarousel();
        }
    });
}

function initThumbnailCarousel() {
    $('#thumbnails ul').slick({
        dots: false,
        infinite: true,
        arrows: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        focusOnSelect: true
    });
}

function initMainImageCarousel() {
    $('#thumbnails ul').slick({
        dots: true,
        vertical: false,
        infinite: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 1,
        focusOnSelect: true
    });
}

/**
 * @description Sets the main image attributes and the href for the surrounding <a> tag
 * @param {Object} atts Object with url, alt, title and hires properties
 */
function setMainImage(atts) {
    $('#pdpMain .primary-image').attr({
        src: atts.url,
        alt: atts.alt,
        title: atts.title
    });
    updatePinButton(atts.url);
    updateFacebookButton(atts.url);
    if (!dialog.isActive() && !util.isMobile()) {
        $('#pdpMain .main-image').find('img').attr('src', atts.hires);
    }
}

function updatePinButton(imageUrl) {
    var pinButton = document.querySelector('.share-icon[data-share=pinterest]');

    if (!pinButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(pinButton.href);
    var query = qs.parse(href.query);
    query.media = url.resolve(window.location.href, newUrl);
    query.url = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    pinButton.href = newHref;
}

function updateFacebookButton(imageUrl) {
    var facebookButton = document.querySelector('.share-icon[data-share=facebook]');

    if (!facebookButton) {
        return;
    }
    var newUrl = imageUrl;
    if (!imageUrl) {
        newUrl = document.querySelector('#pdpMain .primary-image').getAttribute('src');
    }
    var href = url.parse(facebookButton.href);
    var query = qs.parse(href.query);
    query.picture = url.resolve(window.location.href, newUrl);
    query.u = window.location.href;
    var newHref = url.format(_.extend({}, href, {
        query: query, // query is only used if search is absent
        search: qs.stringify(query)
    }));
    facebookButton.href = newHref;
}

/* @module image
 * @description this module handles the primary image viewer on PDP
 **/

/**
 * @description by default, this function sets up zoom and event handler for thumbnail click
 **/
module.exports = function () {
    if (dialog.isActive() || util.isMobile()) {
        $('#pdpMain .main-image').removeAttr('href');
    }
    updatePinButton();
    updateFacebookButton();
    lazyLoadThumbnails();

    // bind zoom event handler
    $(document).on('click', '.image-zoom', function (evt) {
        evt.preventDefault();
        var viewType = "zoom";
        // var thumbnailProductImageURL = getSingleProductImageURL(viewType);
        // modal.renderByUrl(thumbnailProductImageURL);

        var zoomImageUrl = null;
        if ($('.productthumbnail').length > 1) {
            zoomImageUrl = $('.productthumbnail.slick-current').data('zoomimg');
        } else {
            // for only one thumbnail, select that one image
            zoomImageUrl = $($('.productthumbnail')[0]).data('zoomimg');
        }

        modal.renderContent('<img src="' + zoomImageUrl + '">');

        modal.addCustomClass('productImageZoom');
    });

    // handle product thumbnail click event
    $("#thumbnails").on('click', '.productthumbnail', function () {
        var $that = $(this);
        if (!$that.hasClass("selected")) {
            $(document).trigger("clickproductthumbnail");
        }

        $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
        $that.addClass('selected');
        setMainImage($that.data('lgimg'));
    });
};

module.exports.setMainImage = setMainImage;
module.exports.lazyLoadThumbnails = lazyLoadThumbnails;

},{"../../dialog":9,"../../modal":19,"../../util":69,"lodash":76,"qs":87,"url":94}],43:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var dialog = require('../../dialog'),
    modal = require('../../modal').global,
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util'),
    addToCart = require('./addToCart'),
    availability = require('./availability'),
    image = require('./image'),

//productNav = require('./productNav'),
howToSection = require('./howToSection'),
    productSet = require('./productSet'),
    recommendations = require('./recommendations'),
    socialShareIcons = require('./socialShareIcons'),
    variant = require('./variant'),
    design = require('../../design'),
    ajax = require('../../ajax');

/**
 * @description Initialize product detail page with reviews, recommendation and product navigation.
 */

function initializeDom() {
    //productNav();
    recommendations();
}

/**
 * @description Initialize event handlers on product detail page
 */
function initializeEvents() {
    var $pdpMain = $('#pdpMain');

    addToCart();
    availability();
    variant();
    image();
    howToSection.init();
    //productSet();
    socialShareIcons();
    //    design.pdpInit();
    if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
    }

    // Add to Wishlist and Add to Gift Registry links behaviors
    $pdpMain.on('click', '[data-action="wishlist"], [data-action="gift-registry"]', function () {
        var data = util.getQueryStringParams($('.pdpForm').serialize());
        if (data.cartAction) {
            delete data.cartAction;
        }
        var url = util.appendParamsToUrl(this.href, data);
        this.setAttribute('href', url);
    });

    // product options
    $pdpMain.on('change', '.product-options select', function () {
        var salesPrice = $pdpMain.find('.product-add-to-cart .price-sales');
        var selectedItem = $(this).children().filter(':selected').first();
        salesPrice.text(selectedItem.data('combined'));
    });

    // prevent default behavior of thumbnail link and add this Button
    $pdpMain.on('click', '.thumbnail-link, .unselectable a', function (e) {
        e.preventDefault();
    });

    $('.full-ingredients').on('click', function (e) {
        e.preventDefault();
        var $this = $(this);
        var $fullIngredientList = $('.c-block-ingredientslist');
        var contentUrl = $this.attr('href');

        if ($fullIngredientList.length) {
            $this.toggleClass('show-list');
        } else {
            $.get(util.appendParamToURL(contentUrl, 'format', 'ajax')).done(function (content) {
                $('<div class="full-ingredients-list"><a class="close"><i class="icon-close"></i></a>' + content + '</div>').insertAfter($this);
            });
            $this.toggleClass('show-list');
        }
    });

    $pdpMain.on('click', '.close', function (e) {
        e.preventDefault();
        $('.full-ingredients.show-list').removeClass('show-list');
    });

    $('.cpb-products-details #save-for-later').on('click', function (e) {
        if (!window.User.isCustomerAuthenticated) {
            return;
        }

        e.preventDefault();
        var $target = $(this).parent();
        var url = util.appendParamsToUrl($(this).attr('href'), {
            format: 'ajax'
        });
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;

        $.ajax({
            type: 'POST',
            url: url,
            data: data
        }).done(function (response) {
            if (typeof response === 'string' && response !== "") {
                $target.empty().html(response);
                product.initializeEvents();
            } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
                window.alert(response.error);
            }
        });
    });

    $('.cpb-products-details .remove-from-wishlist').on('click', function (e) {
        e.preventDefault();

        var $target = $(this).parent();
        var url = util.appendParamsToUrl($(this).attr('href'), {
            format: 'ajax'
        });
        var data = {};
        data[this.dataset.csrfname] = this.dataset.csrfvalue;

        $.ajax({
            type: 'POST',
            url: url,
            data: data
        }).done(function (response) {
            if (typeof response === 'string' && response !== "") {
                $target.empty().html(response);
                product.initializeEvents();
            } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
                window.alert(response.error);
            }
        }).fail(function (xhr, textStatus) {
            if (textStatus === 'parsererror') {
                window.alert(Resources.BAD_RESPONSE);
            } else {
                window.alert(Resources.SERVER_CONNECTION_ERROR);
            }
        });
    });

    if ($('.item-link_box').length > 0) {
        var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
        var pids = $productForms.map(function (formEle) {
            return $(formEle).data('pid');
        }).join(',');

        $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
            pid: pids
        }), function (data) {
            if (data === 'false') {
                $('.product-form-actions .product-set-wishlist').removeClass('invisible');
                $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
            } else {
                $('.product-form-actions .product-set-wishlist').addClass('invisible');
                $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
            }
        });

        $('.product-set-wishlist').on('click', function (e) {
            if (!window.User.isCustomerAuthenticated) {
                return;
            }

            e.preventDefault();

            var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
            var pids = $productForms.map(function (formEle) {
                return $(formEle).data('pid');
            }).join(',');

            $.post(util.appendParamsToUrl($(this).attr('href'), {
                pid: pids,
                format: 'ajax'
            }), function (data) {
                if (data === 'false') {
                    $('.product-form-actions .product-set-wishlist').removeClass('invisible');
                    $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
                } else {
                    $('.product-form-actions .product-set-wishlist').addClass('invisible');
                    $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
                }
            });
        });

        $('.remove-product-set-from-wishlist').on('click', function (e) {
            e.preventDefault();

            var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
            var pids = $productForms.map(function (formEle) {
                return $(formEle).data('pid');
            }).join(',');

            $.post(util.appendParamsToUrl(Urls.wishlistRemoveAll, {
                pid: pids,
                format: 'ajax'
            }), function (data) {
                if (data === 'false') {
                    $('.product-form-actions .product-set-wishlist').removeClass('invisible');
                    $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
                } else {
                    $('.product-form-actions .product-set-wishlist').addClass('invisible');
                    $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
                }
            });
        });
    }

    $('.ico-favorite.unlogin').on('click', function (e) {
        e.preventDefault();
        var original = $(this).data('original');
        var pids = '';
        if ($('.cpb-products-variety_area').length > 0) {
            var _$productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
            pids = _$productForms.map(function (formEle) {
                return $(formEle).data('pid');
            }).join(',');
        } else {
            pids = $('#pid').val();
        }

        var originalUrl = original + pids;

        window.location = Urls.showLogin + '?original=' + originalUrl;
    });

    $('.size-chart-link a').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });

    $('.accordion-toggle').on('click', function (e) {
        e.preventDefault();
        var $toggleFor = $(this).attr('href');
        var $toggleHeight = $('.accordion-toggle').outerHeight();
        var $stickyHeader = $('.sticky-header').outerHeight();

        var totalOffset = $toggleHeight + $stickyHeader;

        if ($(this).hasClass('is-open')) {
            $(this).removeClass('is-open');
            $($toggleFor).removeClass('is-open').slideUp();
            return false;
        } else {
            var accordionToggle = $('.accordion-toggle.is-open');
            var accordionContent = $('.pdp-content-section.is-open');

            // $(document).find(accordionToggle).removeClass('is-open');
            // $(document).find(accordionContent).removeClass('is-open').slideUp(100);

            $(this).toggleClass('is-open');
            $($toggleFor).toggleClass('is-open').slideDown(function () {
                $('html, body').animate({
                    scrollTop: $(this).offset().top - totalOffset
                }, 400);
            });
        }

        if ($(this).attr('id') == 'rec-toggle') {
            $('.carousel-recommendations.slick-slider').slick('refresh');
        }
    });
}

var product = {
    initializeEvents: initializeEvents,
    init: function init() {
        initializeDom();
        initializeEvents();
    }
};

module.exports = product;

},{"../../ajax":1,"../../design":8,"../../dialog":9,"../../modal":19,"../../storeinventory/product":66,"../../util":69,"./addToCart":39,"./availability":40,"./howToSection":41,"./image":42,"./productSet":44,"./recommendations":45,"./socialShareIcons":46,"./variant":47}],44:[function(require,module,exports){
'use strict';

var ajax = require('../../ajax'),
    tooltip = require('../../tooltip'),
    util = require('../../util');

module.exports = function () {
    var $addToCart = $('#add-to-cart'),
        $addAllToCart = $('#add-all-to-cart'),
        $productSetList = $('#product-set-list');

    var updateAddToCartButtons = function updateAddToCartButtons() {
        if ($productSetList.find('.add-to-cart[disabled]').length > 0) {
            $addAllToCart.attr('disabled', 'disabled');
            // product set does not have an add-to-cart button, but product bundle does
            $addToCart.attr('disabled', 'disabled');
        } else {
            $addAllToCart.removeAttr('disabled');
            $addToCart.removeAttr('disabled');
        }
    };

    if ($productSetList.length > 0) {
        updateAddToCartButtons();
    }
    // click on swatch for product set
    $productSetList.on('click', '.product-set-item .swatchanchor', function (e) {
        e.preventDefault();
        var url = Urls.getSetItem + this.search;
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('form input[name="Quantity"]').first().val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function callback() {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });

    $productSetList.on('change', '.product-set-item .variation-select', function (e) {
        e.preventDefault();

        var $selectedVariantOption = $(this).find("option:selected");
        if ($selectedVariantOption.length === 0 || !$selectedVariantOption.val()) {
            return;
        }

        var url = Urls.getSetItem + "?" + util.getQueryString($selectedVariantOption.val());
        var $container = $(this).closest('.product-set-item');
        var qty = $container.find('select[name="Quantity"] option:selected').val();

        ajax.load({
            url: util.appendParamToURL(url, 'Quantity', isNaN(qty) ? '1' : qty),
            target: $container,
            callback: function callback() {
                updateAddToCartButtons();
                tooltip.init();
            }
        });
    });
    if (screen.width > 640) {
        $(window).load(function () {
            $('#pdpMain').find('#BVRRSummaryContainer .bv-rating-stars-container').off().on('click', function (e) {
                e.preventDefault();
                e.stopPropagation();
                $(".tabs-title:nth-child(1)").removeClass("is-active");
                $(".tabs-title:nth-child(2)").addClass("is-active");
                $("#questions").removeClass("is-active");
                $("#reviews").addClass("is-active").stop(true, true);
                $('html, body').stop(true, true).animate({
                    scrollTop: $("#bazaarvoice-tabs").offset().top - 150
                }, 1000);
            });
        });
    }
};

$(document).on('click', '.bv-popup-in .bv-read-review', function () {
    $(".tabs-title:nth-child(1)").removeClass("is-active");
    $(".tabs-title:nth-child(2)").addClass("is-active");
    $("#questions").removeClass("is-active");
    $("#reviews").addClass("is-active");
    e.preventDefault();
    e.stopPropagation();
    $('html, body').stop(true, true).animate({
        scrollTop: $("#bazaarvoice-tabs").offset().top - 150
    }, 1000);
});

},{"../../ajax":1,"../../tooltip":68,"../../util":69}],45:[function(require,module,exports){
'use strict';

/**
 * @description Creates product recommendation carousel using Slick carousel
 **/

module.exports = function () {
    var $carousel = $('.carousel-recommendations').not('.slick-initialized');
    if (!$carousel || $carousel.length === 0 || $carousel.children().length === 0) {
        return;
    }
    $carousel.slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 3,
        slide: 'li',
        dots: true,
        responsive: [{
            breakpoint: 600,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true,
                dots: true
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true
            }
        }]
    });
};

},{}],46:[function(require,module,exports){
'use strict';

module.exports = function socialShareIcons() {
    $('.social-share-trigger').on('click', function () {
        $(this).parent().toggleClass('animate');

        if (!Foundation.MediaQuery.atLeast('medium')) {
            $('#wrapper').toggleClass('overlay');
        };
    });

    $('.social-modal-close').on('click', function () {
        $(this).parent().removeClass('animate');
        $('#wrapper').removeClass('overlay');
    });
};

},{}],47:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ajax = require('../../ajax'),
    progress = require('../../progress'),
    productStoreInventory = require('../../storeinventory/product'),
    util = require('../../util'),
    design = require('../../design'),
    addToCart = require('./addToCart');

function colorSelectInit(isSet) {
  var index = 0;

  if (!isSet) {
    $('.cpb-products_details_area .cpb-products-color_list a').off('click').on('click', function (e) {
      e.preventDefault();

      $('.cpb-products-cart_fixed .cpb-products-color_list li').removeClass('selected');
      $('.cpb-products-cart_fixed .cpb-products-color_list .c-list-color-panel').removeClass('is-current');
      var index = $('.cpb-products_details_area .cpb-products-color_list a').index(this);
      $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
        var $btn = $(this).find('li').eq(index);
        $btn.addClass('selected');
        $btn.find('.c-list-color-panel').addClass('is-current');
      });

      var href = $(this).attr('href');
      updateContent($(this), href, '.cpb-products_details_area');
      updateProductSummaryArea($(this).data('params'), $('.cpb-products_details_area+.cpb-products-summary_area'));
      return;
    });
    $('.cpb-modal_quickview-inner .cpb-products-color_list a').off('click').on('click', function (e) {
      e.preventDefault();

      $('.cpb-products-cart_fixed .cpb-products-color_list li').removeClass('selected');
      $('.cpb-products-cart_fixed .cpb-products-color_list .c-list-color-panel').removeClass('is-current');
      var index = $('.cpb-modal_quickview-inner .cpb-products-color_list a').index(this);
      $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
        var $btn = $(this).find('li').eq(index);
        $btn.addClass('selected');
        $btn.find('.c-list-color-panel').addClass('is-current');
      });

      var href = $(this).attr('href');
      updateQuickviewContent($(this), href);
      return;
    });
    $('.cpb-products-cart_fixed .cpb-products-color_list a').off('click').on('click', function (e) {
      e.preventDefault();

      $(this).closest('.cpb-products-color_list').find('li').removeClass('selected');
      $(this).closest('.cpb-products-color_list').find('.c-list-color-panel').removeClass('is-current');
      var index = $('.cpb-products-cart_fixed .cpb-products-color_list a').index(this);
      $('.cpb-products-cart_fixed .cpb-products-color_list').each(function () {
        var $btn = $(this).find('li').eq(index);
        $btn.addClass('selected');
        $btn.find('.c-list-color-panel').addClass('is-current');
      });

      if ($('.cpb-products_details_area').length > 0) {
        $('.cpb-products_details_area .cpb-products-color_list a').eq(index).trigger('click');
      }
      if ($('.cpb-modal_quickview-inner').length > 0) {
        $('.cpb-modal_quickview-inner .cpb-products-color_list a').eq(index).trigger('click');
      }
    });

    $('.cpb-products_details_area .cpb-products-size_list li, .cpb-products-variation .cpb-products-size_list li').off('click').on('click', function (e) {
      e.preventDefault();

      var href = $(this).data('href');
      updateContent($(this), href, '.cpb-products_details_area, .cpb-modal_quickview ');
      updateProductSummaryArea($(this).data('params'), $('.cpb-products_details_area+.cpb-products-summary_area'));
      return;
    });

    $('.cmd-select select.js-select-change_tab').off('change.ingredientContent').on('change.ingredientContent', function (e) {
      updateProductSummaryArea($(this).children('option:selected').data('params'), $('#ingredient-tab-content'), true);
    });
  } else {
    $('.cpb-products-variety_box .cpb-products-color_list a').off('click').on('click', function (e) {
      e.preventDefault();
      var href = $(this).attr('href');
      updateSetContent($(this), href);
      return;
    });
  }
}

/**
 * Update selected color
 * @param $ele
 * @param isSet
 * @returns
 */
function updateVariationContent($ele, isSet) {
  var des = $ele.find('span').first().data('description');
  var colorSelected = void 0;
  if ($ele.find('span').first().hasClass('is-disabled')) {
    colorSelected = '<p class="item-color"><del>' + des + '</del></p><p class="item-state">' + Resources.OUT_OF_STOCK + '</p>';
  } else {
    colorSelected = '<p class="item-color">' + des + '</p>';
  }

  // update product bottom fixed position
  if ($('.cpb-products-cart_fixed .cpb-products-data_box').length > 0) {
    if ($('.cpb-products-cart_fixed .cpb-products-data_box').find('.item-color').length > 0) {
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-color').remove();
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-state').remove();
    }

    $('.cpb-products-cart_fixed .cpb-products-data_box').prepend(colorSelected);

    // update price bottom fixed position
    if ($('.cpb-products-cart_fixed .cpb-products-data_box').find('.item-price').html() != '') {
      $('.cpb-products-cart_fixed .cpb-products-data_box .item-price').html('');
    }

    $('.cpb-products-cart_fixed .cpb-products-data_box .item-price').html($('#cpb-products_price').html().replace('class="num"', ''));
  }
}

function updateContent($ele, href, target) {
  var $pdpForm = $('.pdpForm');

  var params = {
    Quantity: '1',
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    target: $(target),
    callback: function callback() {
      updateVariationContent($ele, false);
      changeBottomButton();

      if (typeof VIRTUAL_MAKE !== 'undefined') {
        VIRTUAL_MAKE.MODULE.setVM();
      }

      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }

      // re-init pdp events
      cpbUi.pdp.ready();

      addToCart();
      colorSelectInit();

      // reload wishlist button event
      reloadWishlistButtonEvent();
      changeBottomButton();

      $('.cpb-modal_quickview').append('<button class="cpb-modalR_close js-quickview_close"><span class="invisible">CLOSE</span></button>');

      var learnMore_href = $('.item-link_container .item-link_details a').attr('href');
      $('.item-link_container .item-link_details').remove();
      $('.cpb-modalR_bottom .item-link_details a').attr("href", learnMore_href);
      if (SitePreferences.YOTPO_ENABLE) {
        yotpo.refreshWidgets();
      }
    }
  });
}

function updateQuickviewContent($ele, href) {
  var $pdpForm = $('.pdpForm');

  var params = {
    Quantity: '1',
    format: 'ajax',
    productlistid: $pdpForm.find('input[name="productlistid"]').first().val()
  };

  ajax.load({
    url: util.appendParamsToUrl(href, params),
    callback: function callback(data) {
      var $pdpHtml = $(data);
      var $modal = $('#cpb-modal-quickview');
      updateVariationContent($ele, false);

      $modal.find('.cpb-modalR_bottom .quantity_box').html($pdpHtml.find('#cpb-products_price').prop('outerHTML'));
      $modal.find('.cpb-modalR_bottom .cmd-button_container').html($pdpHtml.find('#cpb-products_submit').prop('outerHTML'));
      $modal.find('.cpb-modal_quickview-inner').html($pdpHtml.find('.cpb-products-details'));
      $modal.find('.cpb-modal_quickview-inner').find('.item-link_details').remove();

      changeBottomButton();

      if (SitePreferences.STORE_PICKUP) {
        productStoreInventory.init();
      }

      // re-init pdp events
      cpbUi.pdp.ready();

      addToCart();
      colorSelectInit();

      // reload wishlist button event
      reloadWishlistButtonEvent();
      changeBottomButton();
    }
  });
}

function updateProductSummaryArea(params, $target) {
  var isPartialUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if ($target === undefined || $target.length === 0) {
    return;
  }
  var targetBeforeUpdate = isPartialUpdate ? '' : $target.find('.js-tab-acc_list a.js-tab-acc_btn.is-active').data('tab-target');
  var url = params ? Urls.productSummaryArea + '?' + params : Urls.productSummaryArea;
  $.ajax({
    dataType: 'html',
    url: util.appendParamToURL(url, 'format', 'ajax'),
    xhrFields: {
      withCredentials: true
    }
  }).done(function (response) {
    if (isPartialUpdate) {
      var updateInformation = $(response).find($target.selector).html();
      $target.empty().html(updateInformation);
      colorSelectInit();
      return;
    }
    $target.empty().html(response);
    $target.find('.js-tab-acc_list a[data-tab-target="' + targetBeforeUpdate + '"]').click();
    colorSelectInit();
  });
}

function updateSetContent($ele, href) {
  var $productSetItemCtnr = $ele.closest('.cpb-products-variety_box');
  var qty = $productSetItemCtnr.find('input[name="Quantity"]').val();

  //    progress.show($productSetItemCtnr);

  ajax.load({
    url: util.appendParamsToUrl(href, {
      Quantity: isNaN(qty) ? '1' : qty,
      format: 'ajax',
      setproduct: true
    }),
    target: $productSetItemCtnr,
    callback: function callback() {
      updateVariationContent($ele, true);

      if (typeof VIRTUAL_MAKE !== 'undefined') {
        VIRTUAL_MAKE.MODULE.setVM();
      }

      addToCart();
      colorSelectInit(true);

      // Update wishlist button
      updateWishlistButton();
    }
  });
}

/**
 * Reload wishlist button event
 * @returns
 */
function reloadWishlistButtonEvent() {
  $('.cpb-products-details #save-for-later').on('click', function (e) {
    if (!window.User.isCustomerAuthenticated) {
      return;
    }

    e.preventDefault();
    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    });
  });

  $('.cpb-products-details .remove-from-wishlist').on('click', function (e) {
    e.preventDefault();

    var $target = $(this).parent();
    var url = util.appendParamsToUrl($(this).attr('href'), {
      format: 'ajax'
    });
    var data = {};
    data[this.dataset.csrfname] = this.dataset.csrfvalue;

    $.ajax({
      type: 'POST',
      url: url,
      data: data
    }).done(function (response) {
      if (typeof response === 'string' && response !== '') {
        $target.empty().html(response);
        reloadWishlistButtonEvent();
      } else if ((typeof response === 'undefined' ? 'undefined' : _typeof(response)) === 'object' && !response.success) {
        window.alert(response.error);
      }
    }).fail(function (xhr, textStatus) {
      if (textStatus === 'parsererror') {
        window.alert(Resources.BAD_RESPONSE);
      } else {
        window.alert(Resources.SERVER_CONNECTION_ERROR);
      }
    });
  });
}

/**
 * Update wishlist button
 * @returns
 */
function updateWishlistButton() {
  if ($('.item-link_box').length > 0) {
    var $productForms = $('.cpb-products-variety_area').find('.cpb-products-variety_box .txtarea').toArray();
    var pids = $productForms.map(function (formEle) {
      return $(formEle).data('pid');
    }).join(',');

    $.post(util.appendParamsToUrl(Urls.wishlistIsSavedForLater, {
      pid: pids
    }), function (data) {
      if (data === 'false') {
        $('.product-form-actions .product-set-wishlist').removeClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').addClass('invisible');
      } else {
        $('.product-form-actions .product-set-wishlist').addClass('invisible');
        $('.product-form-actions .remove-product-set-from-wishlist').removeClass('invisible');
      }
    });
  }
}

/**
 * Update product bottom fixed position cart button when select variation
 * @returns
 */
function changeBottomButton() {
  var $dockButton = $('.cpb-products-cart_fixed .cpb-products-cart_submit button');
  var $cartButton = $('#add-to-cart');
  if ($cartButton.length === 0 || $dockButton.length === 0) {
    return;
  }

  var buttonText = $cartButton.text();
  $dockButton.text(buttonText);
  if ($cartButton.prop('disabled') == true) {
    $dockButton.attr('disabled', 'disabled');
  } else {
    $dockButton.removeAttr('disabled');
  }
}

module.exports = function () {
  var isSet = $('.cpb-products-variety_area').length > 0;
  // color select event
  if ($('.cpb-products-details .cpb-products-color_list a span.is-current').length > 0) {
    var $ele = $('.cpb-products-details .cpb-products-color_list a span.is-current').closest('a');
    updateVariationContent($ele, isSet);
  }
  changeBottomButton();
  colorSelectInit(isSet);
};

},{"../../ajax":1,"../../design":8,"../../progress":56,"../../storeinventory/product":66,"../../util":69,"./addToCart":39}],48:[function(require,module,exports){
'use strict';

var util = require('../util');

var $cache;

function initializeCache() {
	$cache = {};
	$cache['errorMsg'] = $('#promotion-landing-container .landing-error');
}

function initializeEvents() {
	$(document).on('submit', '#PromoLandingForm', function (e) {
		var httpParams = util.getQueryStringParams(util.getQueryString(window.location.href));
		$('<input type="hidden" name="promoid" value="' + httpParams["promoid"] + '" />').appendTo(e.target);
	}).on('focus', '#PromoLandingForm input', function () {
		$cache.errorMsg.hide();
	});
}

module.exports.init = function () {
	initializeCache();
	initializeEvents();

	if (window.location.href.indexOf('error') > -1) {
		$cache.errorMsg.show();
	}
	if (window.couponCode) {
		$("#promo-code").text(window.couponCode);
	}
};

},{"../util":69}],49:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    ajax = require('../ajax'),
    login = require('../login'),
    quickview = require('../quickview'),
    util = require('../util');

/**
 * @function
 * @description Loads address details to a given address and fills the address form
 * @param {String} addressID The ID of the address to which data will be loaded
 */
function populateForm(addressID, $form) {
    // load address details
    var url = Urls.giftRegAdd + addressID;
    ajax.getJson({
        url: url,
        callback: function callback(data) {
            if (!data || !data.address) {
                window.alert(Resources.REG_ADDR_ERROR);
                return false;
            }
            // fill the form
            $form.find('[name$="_addressid"]').val(data.address.ID);
            $form.find('[name$="_firstname"]').val(data.address.firstName);
            $form.find('[name$="_lastname"]').val(data.address.lastName);
            $form.find('[name$="_address1"]').val(data.address.address1);
            $form.find('[name$="_address2"]').val(data.address.address2);
            $form.find('[name$="_city"]').val(data.address.city);
            $form.find('[name$="_country"]').val(data.address.countryCode).trigger('change');
            $form.find('[name$="_postal"]').val(data.address.postalCode);
            $form.find('[name$="_state"]').val(data.address.stateCode);
            $form.find('[name$="_phone"]').val(data.address.phone);
            // $form.parent('form').validate().form();
        }
    });
}

/**
 * @private
 * @function
 * @description Initializes events for the gift registration
 */
function initializeEvents() {
    var $eventAddressForm = $('form[name$="_giftregistry"]'),
        $beforeAddress = $eventAddressForm.find('fieldset[name="address-before"]'),
        $afterAddress = $eventAddressForm.find('fieldset[name="address-after"]');

    $('.usepreevent').on('click', function () {
        // filter out storefront toolkit
        $(':input', $beforeAddress).not('[id^="ext"]').not('select[name$="_addressBeforeList"]').each(function () {
            var fieldName = $(this).attr('name'),
                $afterField = $afterAddress.find('[name="' + fieldName.replace('Before', 'After') + '"]');
            $afterField.val($(this).val()).trigger('change');
        });
    });
    $eventAddressForm.on('change', 'select[name$="_addressBeforeList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) {
            return;
        }
        populateForm(addressID, $beforeAddress);
    }).on('change', 'select[name$="_addressAfterList"]', function () {
        var addressID = $(this).val();
        if (addressID.length === 0) {
            return;
        }
        populateForm(addressID, $afterAddress);
    });

    $('.item-list').on('click', '.item-edit-details a', function (e) {
        e.preventDefault();
        var productListID = $('input[name=productListID]').val();
        quickview.show({
            url: e.target.href,
            source: 'giftregistry',
            productlistid: productListID
        });
    });
}

exports.init = function () {
    initializeEvents();
    addProductToCart();
    login.init();
    util.setDeleteConfirmation('.item-list', String.format(Resources.CONFIRM_DELETE, Resources.TITLE_GIFTREGISTRY));
};

},{"../ajax":1,"../login":17,"../quickview":58,"../util":69,"./product/addToCart":39}],50:[function(require,module,exports){
'use strict';

var compareWidget = require('../compare-widget'),
    productTile = require('../product-tile'),
    progress = require('../progress'),
    video = require("../video"),
    util = require('../util'),
    design = require('../design');

function copyBottomResultHitsToTop() {
    $("#results-hits-top").html($("#results-hits-bottom .results-hits").html());
}

function viewMoreClick() {
    // getting the hidden div, which is the placeholder for the next page
    var loadingPlaceHolder = $('.infinite-scroll-placeholder[data-loading-state="unloaded"]');
    // get url hidden in DOM
    var gridUrl = loadingPlaceHolder.attr('data-grid-url');

    if (loadingPlaceHolder.length === 1) {
        // switch state to 'loading'
        // - switches state, so the above selector is only matching once
        // - shows loading indicator
        loadingPlaceHolder.attr('data-loading-state', 'loading');
        loadingPlaceHolder.addClass('infinite-scroll-loading');

        // named wrapper function, which can either be called, if cache is hit, or ajax repsonse is received
        var fillEndlessScrollChunk = function fillEndlessScrollChunk(html) {
            loadingPlaceHolder.removeClass('infinite-scroll-loading');
            loadingPlaceHolder.attr('data-loading-state', 'loaded');
            $('.js-page-list').append(html);

            var currentNum = $('.number-item-of-page').last().text().trim();
            $('.c-list-pagination .js-list-num-current').html(currentNum);

            var winT = $(window).scrollTop();
            matchHeightProducts();
            $(window).scrollTop(winT);

            // rebind the View More event
            $("#view-more").off();
            $("#view-more").on("click", viewMoreClick);

            // hide view-more button and view-all button when items in OrderHistory all loaded 
            if ($('.ajaxAllOrderHistory').length === 1 || $('.ajax-all').length > 0) {
                $("#view-more").parents('li').remove();
                $("#view-all").parents('li').remove();
            }
        };

        // old condition for caching was `'sessionStorage' in window && sessionStorage["scroll-cache_" + gridUrl]`
        // it was removed to temporarily address RAP-2649

        $.ajax({
            type: 'GET',
            dataType: 'html',
            url: gridUrl,
            success: function success(response) {
                // put response into cache
                try {
                    sessionStorage['scroll-cache_' + gridUrl] = response;
                } catch (e) {}
                // nothing to catch in case of out of memory of session storage
                // it will fall back to load via ajax

                // update UI
                $(".results-hits").remove();
                fillEndlessScrollChunk(response);
                copyBottomResultHitsToTop();
                productTile.init();
                $(document).trigger("plpviewmore");
            }
        });
    }
}

/**
 * @private
 * @function
 * @description replaces breadcrumbs, lefthand nav and product listing with ajax and puts a loading indicator over the product listing
 */
function updateProductListing(url, tabType) {
    if (!url || url === window.location.href) {
        return;
    }
    progress.show($('.js-page-list'));
    if (typeof tabType === "undefined" || tabType === null) {
        tabType = "undefined";
    }

    $.ajax({
        type: 'GET',
        dataType: 'html',
        url: util.appendParamToURL(url, 'format', 'ajax')
    }).done(function (data, textStatus, jqXHR) {
        var dataRes = $($.parseHTML(data));
        if (dataRes.find('main').length > 0) {
            $('main').html(dataRes.find('main')[0].innerHTML);
        } else {
            $('main').html(data);
        }

        compareWidget.init();
        productTile.init();
        design.searchInit();
        design.plpInit();
        design.selectQuantityInit();
        design.productSearchInit();
        if (tabType === "sort") {
            $('.c-block-products-search-tabs .c-block-products-search-tabs--sort .tab').trigger('click');
        }
        if (tabType === "filter") {
            $('.c-block-products-search-tabs .c-block-products-search-tabs--filter .tab').trigger('click');
        }
        design.toggleSelectInit(true);
        matchHeightProducts();
        progress.hide();
        history.pushState(undefined, '', url);
    });
}

function excludeCompoundAttributeRefinements(refineUrl) {
    var newUrl = refineUrl;

    var params = util.getQueryStringParams(refineUrl);
    Object.keys(params).forEach(function (paramName) {
        if (paramName.indexOf('prefv') === -1) {
            return;
        }

        var splitParam = params[paramName].split("|");
        newUrl = util.updateQueryStringParam(newUrl, paramName, splitParam[splitParam.length - 1]);
    });

    return newUrl;
}

/**
 * @private
 * @function
 * @description Initializes events for the following elements:<br/>
 * <p>refinement blocks</p>
 * <p>updating grid: refinements, pagination, breadcrumb</p>
 * <p>item click</p>
 * <p>sorting changes</p>
 */
function initializeEvents() {
    var $main = $('main');
    // compare checked
    $main.on('click', 'input[type="checkbox"].compare-check', function () {
        var cb = $(this);
        var tile = cb.closest('.product-tile');

        var func = this.checked ? compareWidget.addProduct : compareWidget.removeProduct;
        var itemImg = tile.find('.product-image a img').first();
        func({
            itemid: tile.data('itemid'),
            uuid: tile[0].id,
            img: itemImg,
            cb: cb
        });
    });

    // handle events for updating grid
    $main.on('click', '.refinements a, .pagination a, .breadcrumb-refinement-value a', function (e) {
        // don't intercept for category and folder refinements, as well as unselectable
        if ($(this).parents('.category-refinement').length > 0 || $(this).parents('.folder-refinement').length > 0 || $(this).parent().hasClass('unselectable')) {
            return;
        }
        e.preventDefault();
        updateProductListing(this.href);
    });

    // handle sorting change
    $main.on('click', '.c-block-products-search-panel--sort .c-select-list-item', function (e) {
        e.preventDefault();
        updateProductListing($(this).find('a').attr('data'), "sort");
    }).on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        if (refineUrl === 'INFINITE_SCROLL') {
            $('html').addClass('infinite-scroll').removeClass('disable-infinite-scroll');
        } else {
            $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
            updateProductListing(refineUrl);
        }
    });

    //handle refinement change
    $main.on('click', '.c-block-products-search-panel--filter .c-select-list-item', function (e) {
        e.preventDefault();

        if ($(this).hasClass('is-skip')) {
            return;
        }

        var refineUrl = $(this).data('url');
        if (refineUrl.indexOf('prefv') > -1) {
            refineUrl = excludeCompoundAttributeRefinements(refineUrl);
        }

        updateProductListing(refineUrl, "filter");
    }).on('change', '.items-per-page select', function () {
        var refineUrl = $(this).find('option:selected').val();
        $('html').addClass('disable-infinite-scroll').removeClass('infinite-scroll');
        updateProductListing(refineUrl);
    });

    $('.category-tab-links select').off('change').on('change', function (e) {
        var $selected = $(this).find(":selected");
        var link = $selected.attr('href');

        if (link) {
            window.location.href = link;
        }
    });
}

function matchHeightProducts() {
    if ($('.c-product-cards-step-header').length) {
        $('.c-product-cards-list .c-product-cards-step-header').matchHeight();
    }
    $('.c-product-cards-list .c-product-cards-list-item').matchHeight();
}

exports.init = function () {

    video.init(function () {
        initializeEvents();
    });

    compareWidget.init();
    //$("#view-more").on("click", viewMoreClick);

    $(document).on("click", "#view-more", viewMoreClick);
    //$('#filter1-submit').click(function() {
    //	$('#filter1').val('0');
    //});
    productTile.init();
    //initializeEvents();
    design.toggleSelectInit(true);

    // content navigation title link
    $('.nav.content-navigation .accordion-title span').on('click', function () {
        window.location = $(this).data('url');
    });

    // content navigation dropdown redirect
    $('.nav.content-navigation select').on('change', function () {
        window.location = $(this).val();
    });

    var $accordionToggle = $('.refinements .accordion-arrow');

    $accordionToggle.on('click', function (evt) {
        console.log($(this));
        evt.preventDefault();

        $(this).next($('#category-level-2')).slideToggle();

        $(this).parent($('li')).toggleClass('expanded');
    });
};
exports.viewMore = function () {
    $(document).on("click", "#view-more", viewMoreClick);
};

},{"../compare-widget":5,"../design":8,"../product-tile":55,"../progress":56,"../util":69,"../video":71}],51:[function(require,module,exports){
'use strict';

var recommendations = require('./product/recommendations');

exports.init = function () {

    recommendations();
    $('#homepage-hero').slick({
        arrows: true,
        autoplay: true,
        autoplaySpeed: 4000,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 480,
            settings: {
                arrows: false
            }
        }]
    });
    $('.sub-feature-article').slick({
        arrows: false,
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3,
        responsive: [{
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true
            }
        }]
    });
};

},{"./product/recommendations":45}],52:[function(require,module,exports){
'use strict';

var dialog = require('../dialog');

exports.init = function () {
    $('.store-details-link').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href')
        });
    });
};

},{"../dialog":9}],53:[function(require,module,exports){
'use strict';

function initTutorialCarousel() {
    $('.related-carousel-wrapper .tutorial-wrapper').slick({
        infinite: true,
        slidesToShow: 4,
        slidesToScroll: 4,
        dots: true,
        arrows: false,
        responsive: [{
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true
            }
        }, {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                arrows: false,
                dots: true
            }
        }]
    });

    if ($("#thumbnails li").length == 0) {
        return false;
    } else if ($("#thumbnails li").length > 1 && window.innerWidth > 767) {
        tutorialThumbnailCarousel();
    } else if ($("#thumbnails li").length > 1 && window.innerWidth < 768) {
        tutorialMainImageCarousel();
    }
    tutorialImages();
}

function tutorialThumbnailCarousel() {
    $('#thumbnails ul').slick({
        dots: false,
        infinite: true,
        arrows: true,
        vertical: true,
        slidesToShow: 4,
        slidesToScroll: 1
    });
}

function tutorialMainImageCarousel() {
    $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
    $('#thumbnails ul').slick({
        dots: true,
        vertical: false,
        infinite: true,
        arrows: false,
        centerMode: false,
        slidesToShow: 1
    });
}

// tutorial image carousel
function tutorialImages() {
    $("#thumbnails").on('click', '.productthumbnail', function () {
        var $that = $(this);

        $("#thumbnails").find('.productthumbnail.selected').removeClass('selected');
        $that.addClass('selected');
        setTutorialMainImage($that.find('img').attr('src'));
    });
}

function setTutorialMainImage(src) {
    $('#tutorial-image-template .primary-image').attr('src', src);
}

exports.init = function () {
    initTutorialCarousel();
};

},{}],54:[function(require,module,exports){
'use strict';

var addProductToCart = require('./product/addToCart'),
    page = require('../page'),
    login = require('../login'),
    util = require('../util'),
    account = require('./account'),
    minicart = require('../minicart'),
    design = require('../design');

function changeQuantity() {
    $('.quantity-container select').change(function () {
        var quantity = $(this).find('option:selected').val();

        $('.option-quantity-desired input').val(quantity);
        $(this).closest('form').find('.update-item').click();
    });
}

function addItemToBag() {
    $(document).off('click', 'button.add-all-to-cart').on('click', 'button.add-all-to-cart', function (e) {
        e.preventDefault();
        var count;

        //Clear list of product added to cart
        $('.add-all-form .cart-added-list').data('plist', '');
        $('#minicart-notification .notify').html('');
        $(document).find('button[name$="_addToCart"]').each(function (index, e) {
            count = index + 1;
            $(this).trigger("click", { isAddAllToBagClicked: true, count: count }); //since we want to know if the click is from add all to bag or not.
        });
    });

    $(document).off('click', 'button[name$="_addToCart"]').on('click', 'button[name$="_addToCart"]', function (e, wishListData) {
        e.preventDefault();
        var displayPopup = false;
        var wishListItemLen = $(".c-list-products-full-item").length;
        var displayProdSpecificMsg = wishListItemLen == 1 ? true : false;
        if (typeof wishListData == "undefined") {
            var wishListData = {};
            wishListData.isAddAllToBagClicked = false;
            wishListData.count = 1;
            displayProdSpecificMsg = true;
        }

        if (window.innerWidth <= 768) {
            displayPopup = true;
        }
        if (wishListData.isAddAllToBagClicked == false) {
            $('#minicart-notification .notify').html('');
            displayPopup = true;
        } else {
            if (wishListItemLen == wishListData.count) {
                displayPopup = true;
            }
        }

        var $form = $(this).closest('form');
        $form.find('input[name="Quantity"]').val($form.find('.c-quantitySelection .c-select-current').text());

        var $serialize = $form.serialize();
        var extraParams = "&displayPopup=" + displayPopup + "&displayProdSpecificMsg=" + displayProdSpecificMsg + "&isAddAllToBagClicked=" + wishListData.isAddAllToBagClicked;
        $serialize = $serialize + extraParams;
        var divError = $form.find('div.product-error');
        var $cartAddedList = $('.add-all-form .cart-added-list');

        $.ajax({
            type: 'POST',
            url: util.ajaxUrl(Urls.wishlistAddToCart),
            data: $serialize,
            success: function success(response) {
                if (response.error) {
                    divError.html('<ul class="c-text-error c-text-error--simple"><li>' + response.error + '</li></ul>');
                } else {
                    divError.html(null);
                    minicart.show(response);
                    design.dropdownToggleInit();

                    if (wishListData.isAddAllToBagClicked == true && window.innerWidth <= 768) {
                        //Create a list of product added to cart successful
                        if ($cartAddedList.data('plist') !== '') {
                            $cartAddedList.data('plist', $cartAddedList.data('plist') + ', ' + $form.find('input[name=pname]').val());
                        } else {
                            $cartAddedList.data('plist', $form.find('input[name=pname]').val());
                        }

                        //Copy list of product added to cart successful to display
                        $('#minicart-notification .notify').html($cartAddedList.data('plist'));
                    } else if (wishListData.isAddAllToBagClicked == false && window.innerWidth <= 768) {
                        $('#minicart-notification .notify').html($form.find('input[name=pname]').val());
                    }

                    if (displayPopup) {
                        minicart.showAddToCartPopup('#minicart-notification');
                    }
                }
            }
        });
    });
}

exports.init = function () {
    addProductToCart();
    changeQuantity();
    addItemToBag();

    $('#editAddress').on('change', function () {
        page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
    });

    //add js logic to remove the , from the qty feild to pass regex expression on client side
    $('.option-quantity-desired input').on('focusout', function () {
        $(this).val($(this).val().replace(',', ''));
    });

    login.init();
    account.initMobileMenu();
};

},{"../design":8,"../login":17,"../minicart":18,"../page":23,"../util":69,"./account":24,"./product/addToCart":39}],55:[function(require,module,exports){
'use strict';

var imagesLoaded = require('imagesloaded'),
    images = require('./pages/product/image'),
    quickview = require('./quickview'),
    addToCart = require('./pages/product/addToCart'),
    variant = require('./pages/product/variant'),
    design = require('./design');

function initQuickViewButtons() {
    if (!quickViewEnabled) {
        return;
    }

    $('.c-product-cards-quickshop-toggle').magnificPopup({
        type: 'ajax',
        ajax: {
            settings: null, // Ajax settings object that will extend default one - http://api.jquery.com/jQuery.ajax/#jQuery-ajax-settings
            // For example:
            // settings: {cache:false, async:false}

            cursor: 'mfp-ajax-cur', // CSS class that will be added to body during the loading (adds "progress" cursor)
            tError: Resources.QUICKVIEW_ERROR //  Error message, can contain %curr% and %total% tags if gallery is enabled
        },
        callbacks: {
            parseAjax: function parseAjax(mfpResponse) {
                // mfpResponse.data is a "data" object from ajax "success" callback
                // for simple HTML file, it will be just String

                // mfpResponse.data must be a String or a DOM (jQuery) element
                mfpResponse.data = $(mfpResponse.data).find('.c-block-shopingmodal').first();
            },
            ajaxContentAdded: function ajaxContentAdded() {
                $('#shopingmodal').html(this.content[0].outerHTML);
                $.magnificPopup.open({
                    items: {
                        src: '#shopingmodal', // can be a HTML string, jQuery object, or CSS selector
                        type: 'inline'
                    }
                });

                images();
                addToCart();
                variant();
                renderThumbnails();
                quickview.initWishlistButton();

                $('#BVRRSummaryContainer').on('click', '.bv-rating-stars-container', function () {
                    window.location.href = url + '#reviews'; // redirect when rating star is clicked
                });

                $(document).on('click', '.bv-popup-in .bv-read-review', function () {
                    window.location.href = url + '#reviews'; // redirect when read reviews button is clicked
                });

                design.toggleSelectInit(true);
                design.modalInit();
                design.pdpInit();
                design.selectQuantityInit();
            }
        }
    });
}

function gridViewToggle() {
    $('.toggle-grid').on('click', function () {
        $('.search-result-content').toggleClass('wide-tiles');
        $(this).toggleClass('wide');
    });
}

function renderThumbnails() {
    if ($('#thumbnails').length > 0) {
        $('#thumbnails').empty(); // clear the list
        images(); // populate the thumbnails
    }
};

function initCarouselSwatches() {
    $('.swatch-list').not(".slick-slider").slick({
        dots: false,
        focusOnSelect: true,
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 3,
        speed: 300
    });
}

/**
 * @private
 * @function
 * @description Initializes events on the product-tile for the following elements:
 * - swatches
 * - thumbnails
 */
function initializeEvents() {
    initQuickViewButtons();
    initColorChange();
    gridViewToggle();
    $('.swatch-list').on('mouseleave', function () {
        // Restore current thumb image
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $thumb.data('current');

        if (!data) {
            return;
        }

        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
    $('.swatch-list .swatch').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('selected')) {
            return;
        }

        var $tile = $(this).closest('.product-tile');
        $(this).closest('.swatch-list').find('.swatch.selected').removeClass('selected');
        $(this).addClass('selected');
        $tile.find('.thumb-link').attr('href', $(this).attr('href'));
        $tile.find('name-link').attr('href', $(this).attr('href'));

        var data = $(this).children('img').filter(':first').data('thumb');
        var $thumb = $tile.find('.product-image .thumb-link img').eq(0);
        var currentAttrs = {
            src: data.src,
            alt: data.alt,
            title: data.title
        };
        $thumb.attr(currentAttrs);
        $thumb.data('current', currentAttrs);
    }).on('mouseenter', function () {
        // get current thumb details
        var $tile = $(this).closest('.product-tile'),
            $thumb = $tile.find('.product-image .thumb-link img').eq(0),
            data = $(this).children('img').filter(':first').data('thumb'),
            current = $thumb.data('current');

        if (!data) {
            return;
        }

        // If this is the first time, then record the current img
        if (!current) {
            $thumb.data('current', {
                src: $thumb[0].src,
                alt: $thumb[0].alt,
                title: $thumb[0].title
            });
        }

        // Set the tile image to the values provided on the swatch data attributes
        $thumb.attr({
            src: data.src,
            alt: data.alt,
            title: data.title
        });
    });
}

function initColorChange() {
    $('div.c-product-cards .c-list-color li > a').on('click mousehover', function () {
        $(this).closest('.c-product-cards').find('.c-product-cards-photo-img').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val());
        $(this).closest('.c-product-cards').find('.c-product-cards-text > a').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val());
        $(this).closest('.c-product-cards').find('.c-product-cards-quickshop-toggle').attr('href', $(this).attr('href') + '&cgid=' + $('#categoryId').val() + '&source=quickview');
    });
}

exports.init = function () {
    var $tiles = $('.c-product-cards-list .c-product-cards-list-item');
    if ($tiles.length === 0) {
        return;
    }

    initCarouselSwatches();
    initializeEvents();
};

exports.initCarouselSwatches = initCarouselSwatches;
exports.initQuickViewButtons = initQuickViewButtons;
exports.initColorChange = initColorChange;

},{"./design":8,"./pages/product/addToCart":39,"./pages/product/image":42,"./pages/product/variant":47,"./quickview":58,"imagesloaded":75}],56:[function(require,module,exports){
'use strict';

var $loader;

/**
 * @function
 * @description Shows an AJAX-loader on top of a given container
 * @param {Element} container The Element on top of which the AJAX-Loader will be shown
 */
var show = function show(container) {
    var target = !container || $(container).length === 0 ? $('body') : $(container);
    $loader = $loader || $('.loader');

    if ($loader.length === 0) {
        $loader = $('<div/>').addClass('loader').append($('<div/>').addClass('loader-indicator'), $('<div/>').addClass('loader-bg'));
    }
    return $loader.appendTo(target).show();
};
/**
 * @function
 * @description Hides an AJAX-loader
 */
var hide = function hide() {
    if ($loader) {
        $loader.hide();
    }
};

exports.show = show;
exports.hide = hide;

},{}],57:[function(require,module,exports){
'use strict';

var util = require('./util');
var page = require('./page');
var modal = require('./modal');
var cache = {};

function initCache() {
    if ($('#EditAddressForm').length > 0) {
        cache["$formId"] = '#EditAddressForm';
        cache["$form"] = $('#EditAddressForm');
        cache["$source"] = 'dwfrm_shippingaddress';
        cache["$save"] = $('#EditAddressForm').find('.apply-button').attr('name');
    } else if ($('#dwfrm_singleshipping_shippingAddress').length > 0) {
        cache["$formId"] = '#dwfrm_singleshipping_shippingAddress';
        cache["$form"] = $('#dwfrm_singleshipping_shippingAddress');
        cache["$source"] = 'dwfrm_singleshipping_shippingAddress_addressFields';
        cache["$save"] = 'dwfrm_singleshipping_shippingAddress_save';
    }

    cache["$modal"] = modal.create("#qas-modal", "#qas-modal .modal-body", { closeOnClick: false, closeOnEsc: false });
}

function initEvents() {
    if (cache.$form && cache.$form.length > 0) {
        cache.$form.off('click').on('click', ' button[name="' + cache.$save + '"]', validate);
    }
}

function submitForm() {
    cache.$form.append('<input type="hidden" name="' + cache.$save + '"/>');
    cache.$form.submit();
}

function updateAddressForm(addr) {
    cache.$form.find('input[name$="_address1"]').val(addr.add1);
    cache.$form.find('input[name$="_address2"]').val(addr.add2);
    cache.$form.find('select[id$="_state"]').val(addr.state ? addr.state.toUpperCase() : "");
    cache.$form.find('input[name$="_city"]').val(addr.city);
    cache.$form.find('input[name$="_postal"]').val(addr.zip);
}

function updateAddress(data) {
    $.ajax({
        type: 'POST',
        url: Urls.qasUpdateAddress,
        data: data,
        dataType: 'html'
    }).done(function (response, textStatus, request) {
        var response = JSON.parse(response);
        if (response.action === 'reValidate') {
            cache.$modal.close();
            validate('reValidate');
        } else {
            if (response.action !== 'useOrig') {
                updateAddressForm(response.address);
            }

            submitForm();
        }
    });
}

function validate(action) {
    if ($('#dwfrm_singleshipping_shippingAddress').length > 0 && !$('#EditAddressForm').is(':visible')) {
        //Ade -- if (cache.$formId === '#EditAddressForm' && 
        cache["$formId"] = '#dwfrm_singleshipping_shippingAddress';
        cache["$form"] = $('#dwfrm_singleshipping_shippingAddress');
        cache["$source"] = 'dwfrm_singleshipping_shippingAddress_addressFields';
        cache["$save"] = 'dwfrm_singleshipping_shippingAddress_save';
    }

    if (!cache.$form.validate().form()) {
        return;
    }

    var data = cache.$form.serialize() + '&source=' + cache.$source;
    if (typeof action === 'string') {
        data = data + '&dwfrm_addForm_action=' + action;
    }

    $.ajax({
        type: 'POST',
        url: Urls.qasVerifyAddress,
        data: data,
        dataType: 'html'
    }).done(function (content, textStatus, request) {
        if (/json/.test(request.getResponseHeader('Content-Type'))) {
            var response = JSON.parse(content);
            if (response.action === 'addrVerified') {
                updateAddressForm(response.address);
                submitForm();
            } else if (response.action === 'verified') {
                submitForm();
            }
        } else {
            cache.$modal.renderContent(content);

            $('.addForm').on('click', 'button', function () {
                var form = $(this).parents('form');
                form.append('<input type="hidden" name="' + $(this).attr('name') + '"/>');

                updateAddress(form.serialize());
                cache.$modal.close();

                return false;
            });
        }
    });

    return false;
}

var qas = {
    init: function init() {
        if (SitePreferences.IS_QAS_ENABLED) {
            initCache();
            initEvents();
        }
    }
};

module.exports = qas;

},{"./modal":19,"./page":23,"./util":69}],58:[function(require,module,exports){
'use strict';

var product = require('./pages/product');

var quickview = {
    init: function init() {
        $(document).on('click', '.js-quickview-btn', function (e) {
            e.preventDefault();
            if (!cpbUi.isQuickView) {
                cpbUi.isQuickView = true;
                cpbUi.directQuickView($(this).attr('href'), function () {
                    cpbUi.pdp.ready();

                    cpbUi.util.rightModalOpen.call(this, 'quickview', function () {
                        // init product's events
                        product.initializeEvents();

                        cpbUi.niceScroll.ready();
                        cpbUi.sliderControl.resize();
                    });
                });
            }
        });
        $(document).on('click', '.js-quickview_close', function (e) {
            e.preventDefault();
            cpbUi.util.rightModalClose.call(this, 'quickview', function () {
                $("#cpb-modal-quickview").find('.js-modal_scroll').getNiceScroll().remove();
                $('#cpb-modal-quickview').remove();
                cpbUi.isQuickView = false;
            });
        });
        $(document).on('click', '.js-quickview_overlay', function (e) {
            e.preventDefault();
            cpbUi.util.rightModalClose.call(this, 'quickview', function () {
                $("#cpb-modal-quickview").find('.js-modal_scroll').getNiceScroll().remove();
                $('#cpb-modal-quickview').remove();
                cpbUi.isQuickView = false;
            });
        });
    }
};

module.exports = quickview;

},{"./pages/product":43}],59:[function(require,module,exports){
'use strict';

/**
 * copied from https://github.com/darkskyapp/string-hash
 */

function hashFn(str) {
    var hash = 5381,
        i = str.length;

    while (i) {
        hash = hash * 33 ^ str.charCodeAt(--i);
    }
    /* JavaScript does bitwise operations (like XOR, above) on 32-bit signed
    * integers. Since we want the results to be always positive, convert the
    * signed int to an unsigned by doing an unsigned bitshift. */
    return hash >>> 0;
}

/**
 * Create rating based on hash ranging from 2-5
 * @param pid
 */
function getRating(pid) {
    return hashFn(pid.toString()) % 30 / 10 + 2;
}

module.exports = {
    init: function init() {
        $('.product-review').each(function (index, review) {
            var pid = $(review).data('pid');
            if (!pid) {
                return;
            }
            // rating range from 2 - 5
            var rating = getRating(pid);
            var baseRating = Math.floor(rating);
            var starsCount = 0;
            for (var i = 0; i < baseRating; i++) {
                $('.rating', review).append('<i class="fa fa-star"></i>');
                starsCount++;
            }
            // give half star for anything in between
            if (rating > baseRating) {
                $('.rating', review).append('<i class="fa fa-star-half-o"></i>');
                starsCount++;
            }
            if (starsCount < 5) {
                for (var j = 0; j < 5 - starsCount; j++) {
                    $('.rating', review).append('<i class="fa fa-star-o"></i>');
                }
            }
        });
    }
};

},{}],60:[function(require,module,exports){
'use strict';

var util = require('./util'),
    modal = require('./modal').global,
    ajax = require('./ajax'),
    sampleCookieName = "sample.selection.shown";

/**
 * Creates sample selection cookie
 */
var createSelectionShownCookie = function createSelectionShownCookie() {
	util.setCookie(sampleCookieName, "1");
};

/**
 * Checks if sample selection cookie exists
 * @return {boolean}
 */
var canShowSelection = function canShowSelection() {
	return !SitePreferences.SAMPLES_ENABLED ? false : true;
};

/**
 * Render Samples
 * @return {boolean}
 */
var showSelection = function showSelection() {
	// set selection cookie
	//createSelectionShownCookie();

	// render content to modal by url

	modal.addCustomClass('sample-selection');
	modal.renderByUrl(Urls.showSampleSelection);

	// close quickview
	if ($('.mfp-ready').length > 0) {
		$.magnificPopup.close();
	}

	$.magnificPopup.open({
		items: {
			src: '#sampleselectionmodal',
			type: 'inline',
			removalDelay: 500
		}
	});
};

var showSelectionInCart = function showSelectionInCart() {
	$.get(util.appendParamToURL(Urls.showSampleSelectionInCart, 'format', 'ajax')).done(function (data) {
		$('.js-modal-r_content[data-modal-type="sample"] .cpb-modalR_contents').html(data);
		cpbUi.util.rightModalOpen.call($('#item-sample .cpb-cart_add_btn a.button[data-modal-target="sample"]'), undefined, function (target) {
			cpbUi.niceScroll.ready();
		});
	});
};

exports.createSelectionShownCookie = createSelectionShownCookie;
exports.canShowSelection = canShowSelection;
exports.showSelection = showSelection;
exports.showSelectionInCart = showSelectionInCart;

},{"./ajax":1,"./modal":19,"./util":69}],61:[function(require,module,exports){
'use strict';

/**
 * @private
 * @function
 * @description Binds event to the place holder (.blur)
 */

function initializeEvents() {
    $('#q').focus(function () {
        var input = $(this);
        if (input.val() === input.attr('placeholder')) {
            input.val('');
        }
    }).blur(function () {
        var input = $(this);
        if (input.val() === '' || input.val() === input.attr('placeholder')) {
            input.val(input.attr('placeholder'));
        }
    }).blur();
}

exports.init = initializeEvents;

},{}],62:[function(require,module,exports){
'use strict';

var util = require('./util');

var currentQuery = null,
    lastQuery = null,
    runningQuery = null,
    listTotal = -1,
    listCurrent = -1,
    delay = 30,
    $resultsContainer;
/**
 * @function
 * @description Handles keyboard's arrow keys
 * @param keyCode Code of an arrow key to be handled
 */
function handleArrowKeys(keyCode) {
    switch (keyCode) {
        case 38:
            // keyUp
            listCurrent = listCurrent <= 0 ? listTotal - 1 : listCurrent - 1;
            break;
        case 40:
            // keyDown
            listCurrent = listCurrent >= listTotal - 1 ? 0 : listCurrent + 1;
            break;
        default:
            // reset
            listCurrent = -1;
            return false;
    }

    $resultsContainer.children().removeClass('selected').eq(listCurrent).addClass('selected');
    $('input[name="q"]').val($resultsContainer.find('.selected .suggestionterm').first().text());
    return true;
}

var searchsuggest = {
    /**
     * @function
     * @description Configures parameters and required object instances
     */
    init: function init(container, defaultValue) {
        var $searchContainer = $(container);
        var $searchForm = $searchContainer.find('form[name="simpleSearch"]');
        var $searchField = $searchForm.find('input[name="q"]');
        var $submitButton = $searchForm.find('button[type="submit"]');

        // disable go button on page load
        //        $submitButton.prop('disabled', true);

        // disable browser auto complete
        $searchField.attr('autocomplete', 'off');

        // on focus listener (clear default value)
        $searchField.focus(function () {
            if (!$resultsContainer) {
                // create results container if needed
                $resultsContainer = $('<div/>').attr('id', 'search-suggestions').appendTo($searchContainer);
            }
            if ($searchField.val() === defaultValue) {
                $searchField.val('');
            }
        });

        $(document).on('click', function (e) {
            //get id of object clicked
            var id = e.target.id;
            //get class of object clicked
            var cl = e.target.className;
            //check if user click(press) on an element that is child of ul.slick-dots then return TRUE. Otherwise return FALSE
            var condition = cl != '' && $('.' + cl).parent().is('ul.slick-dots') || id != '' && $('#' + id).parent().parent().is('ul.slick-dots');
            if (!condition && !$searchContainer.is(e.target)) {
                setTimeout(this.clearResults, 200);
            }
        }.bind(this));

        // on blur listener
        $searchField.on('blur', function (e) {
            this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));

        // on key up listener
        $searchField.keyup(function (e) {

            // get keyCode (window.event is for IE)
            var keyCode = e.keyCode || window.event.keyCode;

            // check and treat up and down arrows
            if (handleArrowKeys(keyCode)) {
                return;
            }
            // check for an ENTER or ESC
            if (keyCode === 13 || keyCode === 27) {
                this.clearResults();
                this.checkInput(e, $searchField, $submitButton, defaultValue);
                return;
            }

            currentQuery = $searchField.val().trim();

            // no query currently running, init an update
            if (!runningQuery) {
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
        }.bind(this));

        $submitButton.on('click', function (e) {
            this.checkInput(e, $searchField, $submitButton, defaultValue);
        }.bind(this));
    },

    /**
     * @function
     * @description trigger suggest action
     */
    suggest: function suggest() {
        // check whether query to execute (runningQuery) is still up to date and had not changed in the meanwhile
        // (we had a little delay)
        if (runningQuery !== currentQuery) {
            // update running query to the most recent search phrase
            runningQuery = currentQuery;
        }

        // if it's empty clear the results box and return
        if (runningQuery.length === 0) {
            this.clearResults();
            runningQuery = null;
            return;
        }

        // if the current search phrase is the same as for the last suggestion call, just return
        if (lastQuery === runningQuery) {
            runningQuery = null;
            return;
        }

        // build the request url
        var reqUrl = util.appendParamToURL(Urls.searchsuggest, 'q', runningQuery);

        // execute server call
        $.get(reqUrl, function (data) {
            var suggestionHTML = data,
                ansLength = suggestionHTML.trim().length;

            // if there are results populate the results div
            if (ansLength === 0) {
                this.clearResults();
            } else {
                // update the results div
                $resultsContainer.html(suggestionHTML).fadeIn(200);
            }

            // record the query that has been executed
            lastQuery = runningQuery;
            // reset currently running query
            runningQuery = null;

            // check for another required update (if current search phrase is different from just executed call)
            if (currentQuery !== lastQuery) {
                // ... and execute immediately if search has changed while this server call was in transit
                runningQuery = currentQuery;
                setTimeout(this.suggest.bind(this), delay);
            }
            this.hideLeftPanel();
        }.bind(this));
    },
    /**
     * @function
     * @description
     */
    clearResults: function clearResults() {
        if (!$resultsContainer) {
            return;
        }
        $resultsContainer.fadeOut(200, function () {
            $resultsContainer.empty();
        });
    },
    /**
     * @function
     * @description
     */
    hideLeftPanel: function hideLeftPanel() {
        //hide left panel if there is only a matching suggested custom phrase
        if ($('.search-suggestion-left-panel-hit').length === 1 && $('.search-phrase-suggestion a').text().replace(/(^[\s]+|[\s]+$)/g, '').toUpperCase() === $('.search-suggestion-left-panel-hit a').text().toUpperCase()) {
            $('.search-suggestion-left-panel').css('display', 'none');
            $('.search-suggestion-wrapper-full').addClass('search-suggestion-wrapper');
            $('.search-suggestion-wrapper').removeClass('search-suggestion-wrapper-full');
        }
    },

    checkInput: function checkInput(e, $searchField, $submitButton, defaultValue) {
        if ($searchField.val().trim().toLowerCase() == defaultValue.toLowerCase()) {
            e.preventDefault();
            e.stopImmediatePropagation();
            $searchField.val(defaultValue);
            //    		$submitButton.prop('disabled', true);
            return false;
        }
    }
};

module.exports = searchsuggest;

},{"./util":69}],63:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes Slick carousels
 */

exports.init = function () {
  $('.slick').slick();
};

},{}],64:[function(require,module,exports){
'use strict';

var inventory = require('./');

var cartInventory = {
    setSelectedStore: function setSelectedStore(storeId) {
        var $selectedStore = $('.store-tile.' + storeId),
            $lineItem = $('.cart-row[data-uuid="' + this.uuid + '"]'),
            storeAddress = $selectedStore.find('.store-address').html(),
            storeStatus = $selectedStore.find('.store-status').data('status'),
            storeStatusText = $selectedStore.find('.store-status').text();
        this.selectedStore = storeId;

        $lineItem.find('.instore-delivery .selected-store-address').data('storeId', storeId).attr('data-store-id', storeId).html(storeAddress);
        $lineItem.find('.instore-delivery .selected-store-availability').data('status', storeStatus).attr('data-status', storeStatus).text(storeStatusText);
        $lineItem.find('.instore-delivery .delivery-option').removeAttr('disabled').trigger('click');
    },
    cartSelectStore: function cartSelectStore(selectedStore) {
        var self = this;
        inventory.getStoresInventory(this.uuid).then(function (stores) {
            inventory.selectStoreDialog({
                stores: stores,
                selectedStoreId: selectedStore,
                selectedStoreText: Resources.SELECTED_STORE,
                continueCallback: function continueCallback() {},
                selectStoreCallback: self.setSelectedStore.bind(self)
            });
        }).done();
    },
    setDeliveryOption: function setDeliveryOption(value, storeId) {
        // set loading state
        $('.item-delivery-options').addClass('loading').children().hide();

        var data = {
            plid: this.uuid,
            storepickup: value === 'store' ? true : false
        };
        if (value === 'store') {
            data.storepickup = true;
            data.storeid = storeId;
        } else {
            data.storepickup = false;
        }
        $.ajax({
            url: Urls.setStorePickup,
            data: data,
            success: function success() {
                // remove loading state
                $('.item-delivery-options').removeClass('loading').children().show();
            }
        });
    },
    init: function init() {
        var self = this;
        $('.item-delivery-options .set-preferred-store').on('click', function (e) {
            e.preventDefault();
            self.uuid = $(this).data('uuid');
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            if (!User.zip) {
                inventory.zipPrompt(function () {
                    self.cartSelectStore(selectedStore);
                });
            } else {
                self.cartSelectStore(selectedStore);
            }
        });
        $('.item-delivery-options .delivery-option').on('click', function () {
            // reset the uuid
            var selectedStore = $(this).closest('.instore-delivery').find('.selected-store-address').data('storeId');
            self.uuid = $(this).closest('.cart-row').data('uuid');
            self.setDeliveryOption($(this).val(), selectedStore);
        });
    }
};

module.exports = cartInventory;

},{"./":65}],65:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    dialog = require('../dialog'),
    TPromise = require('promise'),
    util = require('../util');

var newLine = '\n';
var storeTemplate = function storeTemplate(store, selectedStoreId, selectedStoreText) {
    return ['<li class="store-tile ' + store.storeId + (store.storeId === selectedStoreId ? ' selected' : '') + '">', '    <p class="store-address">', '        ' + store.address1 + '<br/>', '        ' + store.city + ', ' + store.stateCode + ' ' + store.postalCode, '    </p>', '    <p class="store-status" data-status="' + store.statusclass + '">' + store.status + '</p>', '    <button class="select-store-button" data-store-id="' + store.storeId + '"' + (store.statusclass !== 'store-in-stock' ? 'disabled="disabled"' : '') + '>', '        ' + (store.storeId === selectedStoreId ? selectedStoreText : Resources.SELECT_STORE), '    </button>', '</li>'].join(newLine);
};

var storeListTemplate = function storeListTemplate(stores, selectedStoreId, selectedStoreText) {
    if (stores && stores.length) {
        return ['<div class="store-list-container">', '<ul class="store-list">', _.map(stores, function (store) {
            return storeTemplate(store, selectedStoreId, selectedStoreText);
        }).join(newLine), '</ul>', '</div>', '<div class="store-list-pagination">', '</div>'].join(newLine);
    } else {
        return '<div class="no-results">' + Resources.INVALID_ZIP + '</div>';
    }
};

var zipPromptTemplate = function zipPromptTemplate() {
    return ['<div id="preferred-store-panel">', '    <input type="text" id="user-zip" placeholder="' + Resources.ENTER_ZIP + '" name="zipCode"/>', '</div>'].join(newLine);
};

/**
 * @description test whether zipcode is valid for either US or Canada
 * @return {Boolean} true if the zipcode is valid for either country, false if it's invalid for both
 **/
var validateZipCode = function validateZipCode(zipCode) {
    var regexes = {
        canada: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ]( )?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i,
        usa: /^\d{5}(-\d{4})?$/
    },
        valid = false;
    if (!zipCode) {
        return;
    }
    _.each(regexes, function (re) {
        var regexp = new RegExp(re);
        valid = regexp.test(zipCode);
    });
    return valid;
};

var storeinventory = {
    zipPrompt: function zipPrompt(callback) {
        var self = this;
        dialog.open({
            html: zipPromptTemplate(),
            options: {
                title: Resources.STORE_NEAR_YOU,
                width: 500,
                buttons: [{
                    text: Resources.SEARCH,
                    click: function click() {
                        var zipCode = $('#user-zip').val();
                        if (validateZipCode(zipCode)) {
                            self.setUserZip(zipCode);
                            if (callback) {
                                callback(zipCode);
                            }
                        }
                    }
                }],
                open: function open() {
                    $('#user-zip').on('keypress', function (e) {
                        if (e.which === 13) {
                            // trigger the search button
                            $('.ui-dialog-buttonset .ui-button').trigger('click');
                        }
                    });
                }
            }
        });
    },
    getStoresInventory: function getStoresInventory(pid) {
        return TPromise.resolve($.ajax({
            url: util.appendParamsToUrl(Urls.storesInventory, {
                pid: pid,
                zipCode: User.zip
            }),
            dataType: 'json'
        }));
    },
    /**
     * @description open the dialog to select store
     * @param {Array} options.stores
     * @param {String} options.selectedStoreId
     * @param {String} options.selectedStoreText
     * @param {Function} options.continueCallback
     * @param {Function} options.selectStoreCallback
     **/
    selectStoreDialog: function selectStoreDialog(options) {
        var self = this,
            stores = options.stores,
            selectedStoreId = options.selectedStoreId,
            selectedStoreText = options.selectedStoreText,
            storeList = storeListTemplate(stores, selectedStoreId, selectedStoreText);
        dialog.open({
            html: storeList,
            options: {
                title: Resources.SELECT_STORE + ' - ' + User.zip,
                buttons: [{
                    text: Resources.CHANGE_LOCATION,
                    click: function () {
                        self.setUserZip(null);
                        // trigger the event to start the process all over again
                        $('.set-preferred-store').trigger('click');
                    }.bind(this)
                }, {
                    text: Resources.CONTINUE,
                    click: function click() {
                        if (options.continueCallback) {
                            options.continueCallback(stores);
                        }
                        dialog.close();
                    }
                }],
                open: function open() {
                    $('.select-store-button').on('click', function (e) {
                        e.preventDefault();
                        var storeId = $(this).data('storeId');
                        // if the store is already selected, don't select again
                        if (storeId === selectedStoreId) {
                            return;
                        }
                        $('.store-list .store-tile.selected').removeClass('selected').find('.select-store-button').text(Resources.SELECT_STORE);
                        $(this).text(selectedStoreText).closest('.store-tile').addClass('selected');
                        if (options.selectStoreCallback) {
                            options.selectStoreCallback(storeId);
                        }
                    });
                }
            }
        });
    },
    setUserZip: function setUserZip(zip) {
        User.zip = zip;
        $.ajax({
            type: 'POST',
            url: Urls.setZipCode,
            data: {
                zipCode: zip
            }
        });
    },
    shippingLoad: function shippingLoad() {
        var $checkoutForm = $('.address');
        $checkoutForm.off('click');
        $checkoutForm.on('click', 'input[name$="_shippingAddress_isGift"]', function () {
            $(this).parent().siblings('.gift-message-text').toggleClass('hidden', $('input[name$="_shippingAddress_isGift"]:checked').val());
        });
    }
};

module.exports = storeinventory;

},{"../dialog":9,"../util":69,"lodash":76,"promise":77}],66:[function(require,module,exports){
'use strict';

var _ = require('lodash'),
    inventory = require('./'),
    util = require('../util');

var newLine = '\n';
var pdpStoreTemplate = function pdpStoreTemplate(store) {
  return ['<li class="store-list-item ' + (store.storeId === User.storeId ? ' selected' : '') + '">', '    <div class="store-address">' + store.address1 + ', ' + store.city + ' ' + store.stateCode + ' ' + store.postalCode + '</div>', '    <div class="store-status" data-status="' + store.statusclass + '">' + store.status + '</div>', '</li>'].join(newLine);
};
var pdpStoresListingTemplate = function pdpStoresListingTemplate(stores) {
  if (stores && stores.length) {
    return ['<div class="store-list-pdp-container">', stores.length > 1 ? '    <a class="stores-toggle collapsed" href="#">' + Resources.SEE_MORE + '</a>' : '', '    <ul class="store-list-pdp">', _.map(stores, pdpStoreTemplate).join(newLine), '    </ul>', '</div>'].join(newLine);
  }
};

var storesListing = function storesListing(stores) {
  // list all stores on PDP page
  if ($('.store-list-pdp-container').length) {
    $('.store-list-pdp-container').remove();
  }
  $('.availability-results').append(pdpStoresListingTemplate(stores));
};

var productInventory = {
  setPreferredStore: function setPreferredStore(storeId) {
    User.storeId = storeId;
    $.ajax({
      url: Urls.setPreferredStore,
      type: 'POST',
      data: { storeId: storeId }
    });
  },
  productSelectStore: function productSelectStore() {
    var self = this;
    inventory.getStoresInventory(this.pid).then(function (stores) {
      inventory.selectStoreDialog({
        stores: stores,
        selectedStoreId: User.storeId,
        selectedStoreText: Resources.PREFERRED_STORE,
        continueCallback: storesListing,
        selectStoreCallback: self.setPreferredStore
      });
    }).done();
  },
  init: function init() {
    var $availabilityContainer = $('.availability-results'),
        self = this;
    this.pid = $('input[name="pid"]').val();

    $('#product-content .set-preferred-store').on('click', function (e) {
      e.preventDefault();
      if (!User.zip) {
        inventory.zipPrompt(function () {
          self.productSelectStore();
        });
      } else {
        self.productSelectStore();
      }
    });

    if ($availabilityContainer.length) {
      if (User.storeId) {
        inventory.getStoresInventory(this.pid).then(storesListing);
      }

      // See more or less stores in the listing
      $availabilityContainer.on('click', '.stores-toggle', function (e) {
        e.preventDefault();
        $('.store-list-pdp .store-list-item').toggleClass('visible');
        if ($(this).hasClass('collapsed')) {
          $(this).text(Resources.SEE_LESS);
        } else {
          $(this).text(Resources.SEE_MORE);
        }
        $(this).toggleClass('collapsed');
      });
    }

    if ($('.js-select-change_tab option').length == 0) {
      $('.cmd-select._auto').hide();
    }
  }
};

module.exports = productInventory;

$('#product-image-carousel').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  }]
});

$('#product-video-carousel').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 3,
  slidesToScroll: 3,
  responsive: [{
    breakpoint: 1024,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3,
      infinite: true,
      dots: true
    }
  }, {
    breakpoint: 600,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  }]
});

},{"../util":69,"./":65,"lodash":76}],67:[function(require,module,exports){
'use strict';

var util = require('./util');

/**
 * Checks the TLS and displays a warning if appropriate
 * @function getUserAgent Checks the TLS and displays a warning if appropriate
 **/
function getUserAgent() {
    // Use an external service to check the TLS of the browser
    // NOTE: this implementation uses https://www.howsmyssl.com
    //     you may also wish to consider the API available at https://www.ssllabs.com/projects/ssllabs-apis/index.html
    var url = 'https://www.howsmyssl.com/a/check';
    var cookieName = 'dw_TLSWarning';
    var cookieValue = getCookie(cookieName);

    // Test to see if this browser has already been flagged by looking at its cookies
    if (!cookieValue) {
        getTLS(url, function (message) {
            if (message.length > 0) {
                showWarning(message[0]);

                // the browser is bad - set the cookie to true (for 15 minutes)
                util.setCookie(cookieName, 'true', 15);
            } else {
                // else the browser is good, set the cookie to false (for 30 days) so we don't check again
                util.setCookie(cookieName, 'false', 60 * 24 * 30);
            }
        });
    } else if (cookieValue === 'true') {
        // if we already know that this is an invalid browser, show the warning
        showWarning(Resources.TLS_WARNING);
    }
}

/**
 * Calls out to the TLS service and calls the callback with a message (if necessary)
 * @function getTLS
 *
 * @param {string} url - URL of external TLS-checking API
 * @param {function} callback - function to call with response
 **/
function getTLS(url, callback) {
    var message = [];

    // First, see if the browser is among the suspect browsers to see if a TLS check is necessary
    var userAgent = navigator.userAgent;

    /** This list derived from https://www.ssllabs.com/ssltest/clients.html **/
    var badBrowsers = ['MSIE 6.0', 'MSIE 7.0', 'MSIE 8.0', 'MSIE 9.0', 'MSIE 10.0', 'Android 2.3.7', 'Android 4.0.4', 'Android 4.1.1', 'Android 4.2.2', 'Android 4.3', 'Safari 5.1.9 / OS X 10.6.8', 'Safari 6.0.4 / OS X 10.8.4 '];
    function checkTLSLevel(data) {
        // If we can determine the TLS level, check to see if it's less than 1.2
        if (parseFloat(data.tls_version.split(' ')[1]) < 1.1) {
            message.push(Resources.TLS_WARNING);
            callback(message);

            //If you want to track statistics on bad TLS hits, include this call
            $.ajax({ url: Urls.TLSBadTLS });
        }
    }

    function reportBadBrowser() {
        // If the TLS level cannot be determined just report that this browser is suspect
        message.push(Resources.TLS_WARNING);
        callback(message);

        //If you want to track statistics on deprecated browsers, include this call
        $.ajax({ url: Urls.TLSBadBrowser });
    }

    for (var i = 0; i < badBrowsers.length; i++) {
        if (userAgent.match(badBrowsers[i])) {
            // It's a suspect browser, let's see what it's TLS level is
            $.ajax({
                url: url
            }).done(checkTLSLevel).fail(reportBadBrowser);
            break;
        }
    }

    /** For testing purposes, uncomment this block
        message.push(Resources.TLS_WARNING);
    **/
    callback(message);
}

/**
 * @function showWarning turns on the browser-compatibility-alert and sets the message
 *
 * @param {string} message - the message that will be shown upon detection of a bad browser
 **/
function showWarning(message) {
    $('<div/>').addClass('browser-compatibility-alert').append($('<p/>').addClass('browser-error').html(message)).appendTo('#browser-check');
}

/**
 * @function getCookie
 *
 * @param {string} key - The cookie name
 * @returns {string} value - the value of the cookie if found, null otherwise
 **/
function getCookie(key) {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var tokens = cookies[i].split('=');
        var cookieKey = tokens[0].trim();
        if (cookieKey === key) {
            return tokens[1];
        }
    }
    return '';
}

/**
 * Export the getUserAgent function
 */

exports.getUserAgent = getUserAgent;

},{"./util":69}],68:[function(require,module,exports){
'use strict';

/**
 * @function
 * @description Initializes the tooltip-content and layout
 */

exports.init = function () {
    $(document).tooltip({
        items: '.tooltip',
        track: true,
        content: function content() {
            return $(this).find('.tooltip-content').html();
        }
    });

    $('.share-link').on('click', function (e) {
        e.preventDefault();
        var target = $(this).data('target');
        if (!target) {
            return;
        }
        $(target).toggleClass('active');
    });
};

},{}],69:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ = require('lodash');
var validator = require('./validator');
var util = {
    filterArr: function filterArr(arr) {
        var finishedArr = new Array();

        arr.forEach(function (o) {
            if ((typeof o === 'undefined' ? 'undefined' : _typeof(o)) === "object") {
                var finishedObj = new Object();

                Object.keys(o).forEach(function (k) {
                    if (!o[k]) {
                        return;
                    }
                    finishedObj[k] = o[k];
                });

                if (Object.keys(finishedObj).length > 0) {
                    finishedArr.push(finishedObj);
                }
            } else if (!!o) {
                finishedArr.push(o);
            }
        });

        return finishedArr;
    },

    filterObj: function filterObj(o) {
        var finishedObj = {};

        Object.keys(o).forEach(function (k) {
            if (!o[k]) {
                return;
            } else if (o[k] instanceof Array) {
                finishedObj[k] = this.filterArr(o[k]);
            } else {
                finishedObj[k] = o[k];
            }
        }, this);

        return finishedObj;
    },

    /**
     * @function
     * @description appends the parameter with the given name and value to the given url and returns the changed url
     * @param {String} url the url to which the parameter will be added
     * @param {String} name the name of the parameter
     * @param {String} value the value of the parameter
     */
    appendParamToURL: function appendParamToURL(url, name, value) {
        // quit if the param already exists
        if (url.indexOf(name + '=') !== -1) {
            return url;
        }
        var separator = url.indexOf('?') !== -1 ? '&' : '?';

        return url + separator + name + '=' + encodeURIComponent(value);
    },

    /**
     * @function
     * @description remove the parameter and its value from the given url and returns the changed url
     * @param {String} url the url from which the parameter will be removed
     * @param {String} name the name of parameter that will be removed from url
     */
    removeParamFromURL: function removeParamFromURL(url, name) {
        if (url.indexOf('?') === -1 || url.indexOf(name + '=') === -1) {
            return url;
        }
        var hash;
        var params;
        var domain = url.split('?')[0];
        var paramUrl = url.split('?')[1];
        var newParams = [];
        // if there is a hash at the end, store the hash
        if (paramUrl.indexOf('#') > -1) {
            hash = paramUrl.split('#')[1] || '';
            paramUrl = paramUrl.split('#')[0];
        }
        params = paramUrl.split('&');
        for (var i = 0; i < params.length; i++) {
            // put back param to newParams array if it is not the one to be removed
            if (params[i].split('=')[0] !== name) {
                newParams.push(params[i]);
            }
        }
        return domain + '?' + newParams.join('&') + (hash ? '#' + hash : '');
    },

    /**
     * @function
     * @description appends the parameters to the given url and returns the changed url
     * @param {String} url the url to which the parameters will be added
     * @param {Object} params
     */
    appendParamsToUrl: function appendParamsToUrl(url, params) {
        var _url = url;
        _.each(params, function (value, name) {
            _url = this.appendParamToURL(_url, name, value);
        }.bind(this));

        return _url;
    },
    /**
     * @function
     * @description extract the query string from URL
     * @param {String} url the url to extra query string from
     **/
    getQueryString: function getQueryString(url) {
        var qs;
        if (!_.isString(url)) {
            return;
        }
        var a = document.createElement('a');
        a.href = url;
        if (a.search) {
            qs = a.search.substr(1); // remove the leading ?
        }
        return qs;
    },

    updateQueryStringParam: function updateQueryStringParam(url, paramName, newVal) {
        var _url = url;

        if (_url.indexOf(paramName) === -1) {
            return _url;
        }

        var newParamObj = new Object();
        newParamObj[paramName] = newVal;

        _url = this.removeParamFromURL(_url, paramName);
        _url = this.appendParamsToUrl(_url, newParamObj);

        return _url;
    },

    getHashParam: function getHashParam(paramName) {
        var output = "";

        var hashParams = window.location.hash.replace("#", "").split("&");
        for (var i = 0; i < hashParams.length; i++) {
            if (hashParams[i].indexOf(paramName) > -1) {
                output = hashParams[i].split("=")[1];
            }
        }

        return output;
    },

    /**
     * @function
     * @description
     * @param {String}
     * @param {String}
     */
    elementInViewport: function elementInViewport(el, offsetToTop) {
        var top = el.offsetTop,
            left = el.offsetLeft,
            width = el.offsetWidth,
            height = el.offsetHeight;

        while (el.offsetParent) {
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }

        if (typeof offsetToTop !== 'undefined') {
            top -= offsetToTop;
        }

        if (window.pageXOffset !== null) {
            return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
        }

        if (document.compatMode === 'CSS1Compat') {
            return top < window.document.documentElement.scrollTop + window.document.documentElement.clientHeight && left < window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth && top + height > window.document.documentElement.scrollTop && left + width > window.document.documentElement.scrollLeft;
        }
    },

    /**
     * @function
     * @description Appends the parameter 'format=ajax' to a given path
     * @param {String} path the relative path
     */
    ajaxUrl: function ajaxUrl(path) {
        return this.appendParamToURL(path, 'format', 'ajax');
    },

    /**
     * @function
     * @description
     * @param {String} url
     */
    toAbsoluteUrl: function toAbsoluteUrl(url) {
        if (url.indexOf('http') !== 0 && url.charAt(0) !== '/') {
            url = '/' + url;
        }
        return url;
    },
    /**
     * @function
     * @description Loads css dynamically from given urls
     * @param {Array} urls Array of urls from which css will be dynamically loaded.
     */
    loadDynamicCss: function loadDynamicCss(urls) {
        var i,
            len = urls.length;
        for (i = 0; i < len; i++) {
            this.loadedCssFiles.push(this.loadCssFile(urls[i]));
        }
    },

    /**
     * @function
     * @description Loads css file dynamically from given url
     * @param {String} url The url from which css file will be dynamically loaded.
     */
    loadCssFile: function loadCssFile(url) {
        return $('<link/>').appendTo($('head')).attr({
            type: 'text/css',
            rel: 'stylesheet'
        }).attr('href', url); // for i.e. <9, href must be added after link has been appended to head
    },
    // array to keep track of the dynamically loaded CSS files
    loadedCssFiles: [],

    /**
     * @function
     * @description Removes all css files which were dynamically loaded
     */
    clearDynamicCss: function clearDynamicCss() {
        var i = this.loadedCssFiles.length;
        while (0 > i--) {
            $(this.loadedCssFiles[i]).remove();
        }
        this.loadedCssFiles = [];
    },

    /**
     * @function
     * @description Extracts all parameters from a given query string into an object
     * @param {String} qs The query string from which the parameters will be extracted
     */
    getQueryStringParams: function getQueryStringParams(qs) {
        if (!qs || qs.length === 0) {
            return {};
        }
        var params = {},
            unescapedQS = decodeURIComponent(qs);
        // Use the String::replace method to iterate over each
        // name-value pair in the string.
        unescapedQS.replace(new RegExp('([^?=&]+)(=([^&]*))?', 'g'), function ($0, $1, $2, $3) {
            params[$1] = $3;
        });
        return params;
    },

    fillAddressFields: function fillAddressFields(address, $form) {
        for (var field in address) {
            if (field === 'ID' || field === 'UUID' || field === 'key') {
                continue;
            }
            // if the key in address object ends with 'Code', remove that suffix
            // keys that ends with 'Code' are postalCode, stateCode and countryCode
            $form.find('[name$="' + field.replace('Code', '') + '"]').val(address[field]);
            // update the state fields
            if (field === 'countryCode') {
                $form.find('[name$="country"]').trigger('change');
                // retrigger state selection after country has changed
                // this results in duplication of the state code, but is a necessary evil
                // for now because sometimes countryCode comes after stateCode
                $form.find('[name$="state"]').val(address.stateCode);
            }
        }
    },
    /**
     * @function
     * @description Updates the number of the remaining character
     * based on the character limit in a text area
     */
    limitCharacters: function limitCharacters() {
        $('form').find('textarea[data-character-limit]').each(function () {
            var characterLimit = $(this).data('character-limit');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG, '<span class="countnow">0</span>', '<span class="countlimit">' + characterLimit + '</span>');

            //if window size is small then char-count should be after
            var containerPlacement = $(this).prev('p.c-textarea-count');
            var containerInsert = $('<p class="c-textarea-count"/>').insertBefore($(this));

            if ($(window).width() < 640) {
                containerPlacement = $(this).next('p.c-textarea-count');;
                containerInsert = $('<p class="c-textarea-count"/>').insertAfter($(this));
            }

            var charCountContainer = containerPlacement;
            if (charCountContainer.length === 0) {
                charCountContainer = containerInsert;
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });

        $('form').find('textarea[maxlength]').each(function () {
            if ($(this).data('character-limit') !== undefined || $(this).parent().find('.c-textarea-count').length) {
                return;
            }
            var characterLimit = $(this).attr('maxlength');
            var charCountHtml = String.format(Resources.CHAR_LIMIT_MSG_BOT, '<span class="countlimit">' + characterLimit + '</span>');

            var containerPlacement = $(this).next('p.c-textarea-count');
            var containerInsert = $('<p class="c-textarea-count js-countDown is-bottom"/>').insertAfter($(this));
            var charCountContainer = containerPlacement;
            if (charCountContainer.length === 0) {
                charCountContainer = containerInsert;
            }
            charCountContainer.html(charCountHtml);
            // trigger the keydown event so that any existing character data is calculated
            $(this).change();
        });
    },
    /**
     * @function
     * @description Binds the onclick-event to a delete button on a given container,
     * which opens a confirmation box with a given message
     * @param {String} container The name of element to which the function will be bind
     * @param {String} message The message the will be shown upon a click
     */
    setDeleteConfirmation: function setDeleteConfirmation(container, message) {
        $(container).on('click', '.delete', function () {
            return window.confirm(message);
        });
    },
    /**
     * @function
     * @description Scrolls a browser window to a given x point
     * @param {String} The x coordinate
     */
    scrollBrowser: function scrollBrowser(xLocation) {
        $('html, body').animate({ scrollTop: xLocation }, 500);
    },

    isMobile: function isMobile() {
        var mobileAgentHash = ['mobile', 'tablet', 'phone', 'ipad', 'ipod', 'android', 'blackberry', 'windows ce', 'opera mini', 'palm'];
        var idx = 0;
        var isMobile = false;
        var userAgent = navigator.userAgent.toLowerCase();

        while (mobileAgentHash[idx] && !isMobile) {
            isMobile = userAgent.indexOf(mobileAgentHash[idx]) >= 0;
            idx++;
        }
        return isMobile;
    },

    /**
     * @function getCookieSelector
     * @description Returns the cookie value
     **/
    getCookieSelector: function getCookieSelector(cookieName) {
        var regularExpression = '(?:(?:^|.*;\\s*)' + cookieName + '\\s*\\=\\s*([^;]*).*$)|^.*$';
        var regExp = new RegExp(regularExpression, '');

        return document.cookie.replace(regExp, '$1');
    },

    /**
     * @function setCookie
     *
     * @param {string} key - The cookie name
     * @param {string} value - The cookie value
     * @param {integer} minutes - The number of minutes to expire the cookie
     **/
    setCookie: function setCookie(key, value, minutes) {
        var duration = '';

        if (minutes) {
            var date = new Date();

            date.setTime(date.getTime() + minutes * 60 * 1000);

            duration = ' expires=' + date.toGMTString() + ';';
        }

        document.cookie = key + '=' + value + ';' + duration + ' path=/';
    },

    /**
     * @function validateEmail
     *
     * @description Returns boolean
     * @param {string} emailAddress - The email address
     **/
    validateEmail: function validateEmail(emailAddress) {
        var emailRegExp = new RegExp('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,3}$');

        return emailRegExp.test(emailAddress);
    },

    /**
     * @function validateMessage
     *
     * @description Returns boolean
     * @param {string} message - The message
     **/
    validateMessage: function validateMessage(message) {
        var country = 'other';

        if (window.User.locale) {
            switch (window.User.locale) {
                case 'default':
                case 'en_SG':
                case 'en_ID':
                case 'en_MY':
                    break;
                case 'en':
                    country = 'int';
                    break;
                default:
                    country = window.User.locale.slice(-2).toLowerCase();
                    break;
            }
        }
        var messageRegExp = validator.regex.message[country];

        return messageRegExp.test(message);
    },

    /**
     * @function maximizeCheckoutSummary
     *
     * @description Maximizes/Expands the Order Checkout Summary
     **/
    maximizeCheckoutSummary: function maximizeCheckoutSummary() {
        if (SitePreferences.IS_CHECKOUT_MAXIMIZED) {
            $('.accordion-navigation').addClass('is-active');
            $('.accordion-title').attr('aria-expanded', true);
            $('.accordion-title').attr('aria-selected', true);
            $('#panel11a').css('display', 'block');
        }
    }
};

module.exports = util;

},{"./validator":70,"lodash":76}],70:[function(require,module,exports){
'use strict';

var formPrepare = require('./pages/checkout/formPrepare');

var naPhone = /^\(?([2-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/;
var regex = {
  phone: {
    ca: /^\d{10}$/,
    de: /^0((\d{6})|(\d{8})|(\d{9})|(\d{10}))$/,
    hk: /^\d{8}$/,
    id: /^\d{10,11}$/,
    int: /^\d{1,30}$/,
    jp: /^\d{10,11}$/,
    kr: /^\d{10,11}$/,
    my: /^\d{10,11}$/,
    ph: /^0((\d{6})|(\d{8})|(\d{9})|(\d{10}))$/,
    ru: /^\d{10}$/,
    sg: /^\d{8}$/,
    th: /^\d{9,10}$/,
    tw: /^\d{10}$/,
    vn: /^\d{10,11}$/,
    us: naPhone,
    fr: /^0[1-6]{1}(([0-9]{2}){4})|((\s[0-9]{2}){4})|((-[0-9]{2}){4})$/,
    it: /^(([0-9]{2,4})([-\s\/]{0,1})([0-9]{4,8}))?$/,
    cn: /.*/,
    gb: /^0((\d{6})|(\d{8})|(\d{9})|(\d{10}))$/,
    other: /^\(?([0-9][0-8][0-9])\)?[\-\. ]?([2-9][0-9]{2})[\-\. ]?([0-9]{4})(\s*x[0-9]+)?$/
  },
  postal: {
    ca: /^([0-9]){6}$/,
    de: /^([0-9]){5}$/,
    id: /^([0-9]){5}$/,
    jp: /^([0-9]){7}$/,
    kr: /^([0-9]){6}$/,
    my: /^([0-9]){5}$/,
    ph: /^([0-9]){4}$/,
    ru: /^([0-9]){6}$/,
    sg: /^([0-9]){6}$/,
    th: /^([0-9]){5}$/,
    tw: /^([0-9]){5}$/,
    vn: /^([0-9]){6}$/,
    us: /^\d{5}(-\d{4})?$/,
    int: /^([0-9]){6}$/,
    fr: /^(F-)?((2[A|B])|[0-9]{2})[0-9]{3}$/,
    it: /^([0-9]){5}$/,
    cn: /^([0-9]){6}$/,
    gb: /^([A-PR-UWYZ0-9][A-HK-Y0-9][AEHMNPRTVXY0-9]?[ABEHMNPRVWXY0-9]? {1,2}[0-9][ABD-HJLN-UW-Z]{2}|GIR 0AA)$/,
    other: /^\d{5}(-\d{4})?$/
  },
  name: {
    ca: /^[a-zA-ZÀ-ÿ ]+$/,
    hk: /^[豈-舘㐀-䶵一-鿏 ]+$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 ]+$/,
    int: /.+/,
    jp: /^[一-龥ぁ-ゔァ-ヴー々〆〤]+$/,
    ph: /.+/,
    ru: /^[Ѐ-ӷ ]+$/,
    th: /^[ก-๛ ]+$/,
    tw: /^[豈-舘㐀-䶵一-鿏 ]+$/,
    vn: /^[ A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]+$/,
    de: /^[A-Za-zÀ-ž\u0370-\u03FF\u0400-\u04FF\u002D ]+$/,
    gb: /.+/,
    other: /^[a-zA-Z\s.-]*$/
  },
  simpletext: {
    ca: /^[a-zA-ZÀ-ÿ 0-9-.,']+$/,
    hk: /^[豈-舘㐀-䶵一-鿏 0-9-.,']+$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 0-9-.,']+$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤　０-９－0-9-。、’]+$/,
    ru: /^[Ѐ-ӷ 0-9-.,']+$/,
    th: /^[ก-๛ 0-9-.,']+$/,
    tw: /^[豈-舘㐀-䶵一-鿏 0-9-.,']+$/,
    vn: /^[ ',-9A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]+$/,
    other: /^[0-9a-zA-Z .,'-]*$/
  },
  addr2regex: {
    ca: /^[a-zA-ZÀ-ÿａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    hk: /^[豈-舘㐀-䶵一-鿏a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    kr: /^[a-zA-Zᄀ-ᇿㄱ-ㆎ가-힣a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-。、’＃]*$/,
    ru: /^[Ѐ-ӷa-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    th: /^[ก-๛a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    tw: /^[豈-舘㐀-䶵一-鿏a-zA-Zａ-ｚＡ-Ｚ　 ０-９－0-9-.,'#]*$/,
    vn: /^[ #',-9A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9\u3000\uFF0D\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A]*$/,
    other: /^[0-9a-zA-Z .,'#]*$/
  },
  message: {
    ca: /^[a-zA-ZÀ-ÿ 0-9-.,'!?;:()"\n]*$/,
    hk: /^[豈-舘㐀-䶵一-鿏 0-9-.,'!?;:()"\n]*$/,
    kr: /^[ᄀ-ᇿㄱ-ㆎ가-힣 0-9-.,'!?;:()"\n]*$/,
    int: /^[\s\S]*$/,
    jp: /^[一-鿏ぁ-ゔァ-ヴー々〆〤　０-９－0-9-。、’！？；：（）”\n]*$/,
    ru: /^[Ѐ-ӷ 0-9-.,'!?;:()"\n]*$/,
    th: /^[ก-๛ 0-9-.,'!?;:()"\n]*$/,
    tw: /^[豈-舘㐀-䶵一-鿏 0-9-.,'!?;:()"\n]*$/,
    vn: /^[\n -"'-\),-\.0-;\?A-Za-z\xC0-\xC3\xC8-\xCA\xCC\xCD\xD2-\xD5\xD9\xDA\xDD\xE0-\xE3\xE8-\xEA\xEC\xED\xF2-\xF5\xF9\xFA\xFD\u0102\u0103\u0110\u0111\u0128\u0129\u0168\u0169\u01A0\u01A1\u01AF\u01B0\u1EA0-\u1EF9]*$/,
    other: /^[\w\.\,\!\?\;\:\(\)\'\" \n]*$/
  },
  notCC: /^(?!(([0-9 -]){13,19}))([a-zA-Z0-9 .-]*)$/,
  password: /^(?=.{8,})(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[\W])/,
  email: /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/i,
  hasPOBox: /[p]+(ost)*\.*\s*[o|0]+(ffice)*\.*\s*b[o|0]x/ig,
  ordernumber: /^[0-9a-z\s-\(\)#]*$/i,
  cvn: /^\d{3,4}$/,
  cvn_amex: /^\d{4}$/,
  cvn_visa: /^\d{3}$/,
  cvn_master: /^\d{3}$/,
  cvn_diners: /^\d{3}$/,
  cvn_union: /^\d{3}$/,
  alphanumeric: /^[a-z0-9]*$/i
};
// global form validator settings
var settings = {
  errorClass: 'is-error',
  errorElement: 'p',
  onkeyup: false,
  highlight: function highlight(element) {
    var $parent = $(element).parent();
    if ($parent.hasClass('cmd-form_box') || $parent.hasClass('cpb-security-code')) {
      $parent.addClass('is-error');
    } else if ($parent.parent().hasClass('cmd-form_box')) {
      $parent.parent().addClass('is-error');
    } else {
      $(element).addClass('is-error');
    }
  },
  unhighlight: function unhighlight(element) {
    if ($('form#CreditCardForm').length) {
      var $month = $(element).closest('form').find('input#card_month');
      var $year = $(element).closest('form').find('input#card_year');

      if ($month.val() && $year.val()) {
        var now = new Date();
        var nowMonth = now.getMonth() + 1;
        var nowYear = now.getFullYear();

        if ($(element).attr('id') === 'card_year' && $year.val() < nowYear || $(element).attr('id') === 'card_month' && $month.val() < nowMonth && $year.val() == nowYear) {
          return;
        }
      }
    }

    var $parent = $(element).parent();
    if ($parent.hasClass('cmd-form_box') || $parent.hasClass('cpb-security-code')) {
      $parent.removeClass('is-error');
    } else if ($parent.parent().hasClass('cmd-form_box')) {
      $parent.parent().removeClass('is-error');
    } else {
      $(element).removeClass('is-error');
    }
  },
  onfocusout: function onfocusout(element) {
    if (!this.checkable(element)) {
      this.element(element);
    }

    if ($(element).closest($('form.checkout-billing')).length > 0 || $(element).closest($('form#CreditCardForm')).length > 0) {
      return;
    }

    // remove label error class
    if (!$(element).hasClass('is-error') && $(element).closest('.cmd-form_box').length === 0) {
      $(element).parent().find('.c-input-label').first().removeClass('is-error');
      // remove error message when no error
      if ($(element).parent().find('.cmd-form_err').length > 0) {
        $(element).parent().find('.cmd-form_err').remove();
      }
      if ($(element).parent('.c-input-group').length == 1) {
        $(element).parent().parent().children('.cmd-form_err').remove();
        $(element).parent().parent().children('.c-input-label').first().removeClass('is-error');
      }
    }
  },
  errorPlacement: function errorPlacement(error, element) {
    if (['card_month', 'card_year'].indexOf(element.attr('id')) < 0) {
      // insert error message
      if ($(element).parent('.c-input-group').length == 1) {
        if ($(element).parent().parent().find('.cmd-form_err').length == 0) {
          error.insertAfter($(element).parent());
        } else {
          $(element).parent().parent().find('.cmd-form_err').remove();
          error.insertAfter($(element).parent());
        }
      } else {
        if ($(element).parent().find('.cmd-form_err').length == 0) {
          if ($(element).parents('form.news-letter-form .ge-footer-connectWithUs-check').length > 0 || $(element).hasClass('agreement')) {
            error.insertAfter($(element).next());
          } else if ($(element).parent('.cmd-select').length > 0) {
            error.insertAfter($(element).parent('.cmd-select'));
          } else {
            error.insertAfter($(element));
          }
        } else {
          $(element).parent().find('.cmd-form_err').remove();
          error.insertAfter($(element));
        }
      }

      // add class error for ul tag
      if ($(element).closest($('form.news-letter-form')).length == 1) {
        error.addClass('cmd-form_err');
      } else {
        error.addClass('cmd-form_err _simple');
      }
    }

    // add class error for label
    error.parent().find('.c-input-label').first().addClass('is-error');

    // clear error message when has `no-display-error` attribute in the field
    if (error.parent().find('input[no-display-error]').length > 0) {
      error.remove();
    }
  },
  ignore: ":hidden, .ignore"
};

/**
 * @function
 * @description Validates a given credit card if it has the correct format
 * @param {String} value of credit card which will be validated
 */
var luhnCheck = function (arr) {
  return function (ccNum) {
    var len = ccNum.length;
    var bit = 1;
    var sum = 0;
    var val;

    while (len) {
      val = parseInt(ccNum.charAt(--len), 10);
      sum += (bit ^= 1) ? arr[val] : val;
    }

    return sum && sum % 10 === 0;
  };
}([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

/**
 * @function
 * @description Validates a given phone number against the countries phone regex
 * @param {String} value The phone number which will be validated
 * @param {String} el The input field
 */
var validatePhone = function validatePhone(value, el) {
  var selectedCountry = findSelectedCountry(el, regex.phone);

  var rgx = regex.phone[selectedCountry];
  var isOptional = this.optional(el);
  var isValid = rgx.test($.trim(value));

  return isOptional || isValid;
};

/**
 * @function
 * @description Determine the current country
 * @param {String} el The input field
 * @param {Object} regex The type of regex
 */
function findSelectedCountry(el, regex) {
  var selectedCountry = 'other';
  var country = 'sg';

  if (window.User.locale) {
    switch (window.User.locale) {
      case 'default':
        break;
      case 'en':
        country = 'int';
        break;
      default:
        country = window.User.locale.slice(-2).toLowerCase();
        break;
    }
  }

  if (regex[country]) {
    selectedCountry = country;
  }
  return selectedCountry;
}

/**
 * @function
 * @description Validates that a Address2 is not a Address2
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateAddress2 = function validateAddress2(value, el) {
  var selectedCountry = findSelectedCountry(el, regex.addr2regex);
  var isValid = regex.addr2regex[selectedCountry].test($.trim(value));
  return isValid;
};

/**
 * @function
 * @description Validates that a credit card owner is not a Credit card number
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateOwner = function validateOwner(value) {
  var isValid = regex.notCC.test($.trim(value));
  return isValid;
};

/**
 * @function
 * @description Validates that a name contains no special characters, except for "-"
 * @param {String} value The owner field which will be validated
 * @param {String} el The input field
 */
var validateName = function validateName(value, el) {
  var selectedCountry = findSelectedCountry(el, regex.name);
  var isValid = regex.name[selectedCountry].test($.trim(value));
  return isValid;
};

/**
 * Add phone validation method to jQuery validation plugin.
 * Text fields must have 'phone' css class to be validated as phone
 */
$.validator.addMethod('phone', validatePhone, Resources.INVALID_PHONE);

/**
 * Add CCOwner validation method to jQuery validation plugin.
 * Text fields must have 'owner' css class to be validated as not a credit card
 */
$.validator.addMethod('owner', validateOwner, Resources.INVALID_OWNER);

/**
* Add Address2 validation method to jQuery validation plugin.
* Text fields must have 'address2' css class to be validated as address2
*/
$.validator.addMethod('address2', validateAddress2, Resources.INVALID_ADDRESS2);

/**
 * Add First and Last Name validation method to jQuery validation plugin.
 * Text fields must have 'firstname' or 'lastname' css class to be validated.
 */
$.validator.addMethod('firstname', validateName, Resources.INVALID_FIRSTNAME);
$.validator.addMethod('lastname', validateName, Resources.INVALID_LASTNAME);
$.validator.addMethod('fullname', validateName, simpleTextMessage);

$.validator.addMethod('simpletext', function (value, el) {
  var selectedCountry = findSelectedCountry(el, regex.simpletext);
  var isValid = regex.simpletext[selectedCountry].test($.trim(value));
  return isValid;
}, simpleTextMessage);

$.validator.addClassRules({
  city: {
    simpletext: true
  },
  address1: {
    simpletext: true,
    address: true
  },

  province: {
    simpletext: true
  }
});

/**
 * Add Alphanumeric method to jQuery validation plugin.
 * Text fields must have 'alphanumeric' css class to be validated.
 */
$.validator.addMethod('alphanumeric', function (value) {
  var isValid = regex.alphanumeric.test($.trim(value));
  return isValid;
}, simpleTextMessage);

/**
 * Modify password validation method of jQuery validation plugin.
 * Text fields must have 'password' css class to be validated.
 */
$.validator.addMethod('create-password', function (value) {
  var isValid = regex.password.test($.trim(value));
  return isValid;
}, Resources.VALIDATE_PASSWORD);

/**
 * Modify email validation method of jQuery validation plugin.
 * Text fields must have 'email' css class to be validated.
 */
$.validator.addMethod('email', function (value) {
  var isValid = regex.email.test($.trim(value));
  return isValid;
}, Resources.VALIDATE_EMAIL);

/**
 * Add gift cert amount validation method to jQuery validation plugin.
 * Text fields must have 'gift-cert-amont' css class to be validated
 */
$.validator.addMethod('gift-cert-amount', function (value, el) {
  var isOptional = this.optional(el);
  var isValid = !isNaN(value) && parseFloat(value) >= 5 && parseFloat(value) <= 5000;
  return isOptional || isValid;
}, Resources.GIFT_CERT_AMOUNT_INVALID);

/**
 * Add positive number validation method to jQuery validation plugin.
 * Text fields must have 'positivenumber' css class to be validated as positivenumber
 */
$.validator.addMethod('positivenumber', function (value) {
  if ($.trim(value).length === 0) {
    return true;
  }
  return !isNaN(value) && Number(value) >= 0;
}, ''); // '' should be replaced with error message if needed

/**
 * Add CC number validation method to jQuery validation plugin.
 * Text fields must have 'number' css class to be validated
 */
$.validator.addMethod('number', function (value) {
  // number == Credit card number
  var isValid = luhnCheck($.trim(value));
  return isValid;
}, Resources.VALIDATE_NUMBER);

/**
 * Add CVN number validation method to jQuery validation plugin.
 * Text fields must have 'cvn' css class to be validated
 */
$.validator.addMethod('cvn', function (value) {
  return cvn(value);
}, Resources.VALIDATE_CVN);

/**
 * Add Order number validation method to jQuery validation plugin.
 * Text fields must have 'ordernumber' css class to be validated
 */
$.validator.addMethod('ordernumber', function (value) {
  var isValid = regex.ordernumber.test($.trim(value));
  return isValid;
}, Resources.INVALID_ORDER_NUMBER);

/**
 * Add equal value validation method to jQuery validation plugin.
 * Text fields must have 'equal-to' css class to be validated
 */
$.validator.addMethod('equal-to', function (value, el) {
  var equalTo = $(el).attr('equal-to');
  var $equalToEl = $(el).closest('form').find(equalTo);

  return value === $equalToEl.val();
}, function (value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_EQUALTO;
});

/**
 * Add address validation method to jQuery validation plugin.
 * Text fields must have 'address1' css class to be validated
 */
$.validator.addMethod('address', function (value, el) {
  // check 'PO BOX' value in string and complement result
  var isValid = !$.trim(value).match(regex.hasPOBox);

  return isValid;
}, Resources.ADDRESS_PO_BOX_ERROR);

/**
 * Add zipcode validation method to jQuery validation plugin.
 * Text fields must have 'zipcode' css class to be validated
 */
$.validator.addMethod('postal', function (value, el) {
  var selectedCountry = findSelectedCountry(el, regex.postal);

  var rgx = null;
  var isValid = false;
  if ($(el).hasClass('global-zip')) {
    // if universal, it accepts both US and CN values
    isValid = regex.postal['us'].test($.trim(value)) || regex.postal['cn'].test($.trim(value));
  } else {
    rgx = regex.postal[selectedCountry];
    isValid = rgx.test($.trim(value));
  }

  return isValid;
}, Resources.INVALID_ZIP);

/**
 * Add postcode validation method to jQuery validation plugin.
 * Text fields must have 'postcode' css class to be validated
 * Adding this for China addresses
 */
$.validator.addMethod('postcode', function (value, el) {
  var $form = $(el).closest('form');
  var $country = $form.find('select[name$="_country"]');
  var selectedCountry = $country.length > 0 ? $country.val() : 'sg';

  var rgx = regex.postal[selectedCountry];
  var isValid = rgx.test($.trim(value));

  return isValid;
}, Resources.INVALID_POSTAL);

/**
 * Add message validation method to jQuery validation plugin.
 * Text fields must have 'message' css class to be validated
 */
$.validator.addMethod('message', function (value, el) {
  var selectedCountry = findSelectedCountry(el, regex.message);
  var isValid = regex.message[selectedCountry].test($.trim(value));
  return isValid;
}, Resources.INVALID_MESSAGE);

var requiredMessage = function requiredMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var simpleTextMessage = function simpleTextMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_REQUIRED;
};

var passwordMessage = function passwordMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || Resources.VALIDATE_PASSWORD;
};

var maxLengthMessage = function maxLengthMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || $.validator.format(Resources.VALIDATE_MAXLENGTH);
};

var minLengthMessage = function minLengthMessage(value, el) {
  var message = $(el).attr('data-required-text');
  return message || $.validator.format(Resources.VALIDATE_MINLENGTH);
};

var cvn = function cvn(value) {
  // Visa
  var visa_regex = new RegExp('^4[0-9]{0,15}$'),


  // MasterCard
  mastercard_regex = new RegExp('^5$|^5[1-5][0-9]{0,14}$'),


  // American Express
  amex_regex = new RegExp('^3$|^3[47][0-9]{0,13}$'),


  // Diners 300-305,3095,36,38-39
  diners_regex = new RegExp('^(30[0-5]\\d{11}|3095\\d{10}|36\\d{12}|3[8-9]\\d{12})$'),


  // UnionPay
  unionpay_regex = new RegExp('^62[0-9]{0,14}$|^645[0-9]{0,13}$|^65[0-9]{0,14}$');

  var isValid = false;
  var cur_val = $('.cc-number input').val();

  // get rid of spaces and dashes before using the regular expression
  cur_val = cur_val.replace(/ /g, '').replace(/-/g, '');

  if (cur_val.match(visa_regex)) {
    isValid = regex.cvn_visa.test($.trim(value));
  } else if (cur_val.match(mastercard_regex)) {
    isValid = regex.cvn_master.test($.trim(value));
  } else if (cur_val.match(amex_regex)) {
    isValid = regex.cvn_amex.test($.trim(value));
  } else if (cur_val.match(diners_regex)) {
    isValid = regex.cvn_diners.test($.trim(value));
  } else if (cur_val.match(unionpay_regex)) {
    isValid = regex.cvn_union.test($.trim(value));
  } else {
    isValid = regex.cvn.test($.trim(value));
  }

  return isValid;
};

$.extend($.validator.messages, {
  required: requiredMessage,
  remote: Resources.VALIDATE_REMOTE,
  email: Resources.VALIDATE_EMAIL,
  address1: Resources.ADDRESS_PO_BOX_ERROR,
  password: passwordMessage,
  url: Resources.VALIDATE_URL,
  date: Resources.VALIDATE_DATE,
  dateISO: Resources.VALIDATE_DATEISO,
  number: Resources.VALIDATE_NUMBER,
  digits: Resources.VALIDATE_DIGITS,
  creditcard: Resources.VALIDATE_CREDITCARD,
  equalTo: Resources.VALIDATE_EQUALTO,
  maxlength: maxLengthMessage,
  minlength: minLengthMessage,
  rangelength: $.validator.format(Resources.VALIDATE_RANGELENGTH),
  range: $.validator.format(Resources.VALIDATE_RANGE),
  max: $.validator.format(Resources.VALIDATE_MAX),
  min: $.validator.format(Resources.VALIDATE_MIN),
  postal: Resources.INVALID_ZIP,
  message: Resources.INVALID_MESSAGE,
  fullname: simpleTextMessage,
  simpletext: simpleTextMessage,
  alphanumeric: simpleTextMessage
});
// Updated code to populate green tick check if the password meets the requirements.
var validator = {
  regex: regex,
  settings: settings,
  init: function init() {
    var _self = this;
    $('form:not(.suppress)').each(function () {
      _self.initForm(this);
    }).on('blur', '.create-password', function () {
      var isValid = regex.password.test($.trim($(this).val())),
          currentItem = $(this),
          parentOfCurrent = currentItem.parent('.field-wrapper');
      if (isValid == true) {
        parentOfCurrent.find('span.error').remove();
        parentOfCurrent.addClass('ticmark').find('.create-password').removeClass('error');
      } else {
        parentOfCurrent.removeClass('ticmark');
      }
    }).on('blur', '.passwordconfirm, .newpasswordconfirm', function () {
      var currentItem = $(this),
          currentPassword = $('.create-password').val(),
          confirmPassword = $('.passwordconfirm,.newpasswordconfirm').val(),
          parentOfCurrent = currentItem.parent('.field-wrapper'),
          existError = $('.create-password').parent('.field-wrapper').find('span.error').length;
      if (currentPassword === confirmPassword && existError == 0) {
        parentOfCurrent.find('span.error').remove();
        parentOfCurrent.addClass('ticmark').find('.passwordconfirm').removeClass('error');
      } else {
        parentOfCurrent.removeClass('ticmark');
      }
    });
  },
  initForm: function initForm(f) {
    var _self = this;
    var $form = $(f);
    var $submitForm = $form.find('button[type="submit"]:not(.ignore)');
    if ($form.attr('id') === 'CreditCardForm') {
      $submitForm = $form.find('a[type="submit"]:not(.ignore)');
    }
    var fp = formPrepare();
    fp.init({
      formSelector: $form,
      continueSelector: $submitForm
    }, _self.settings);
  },
  cvn: cvn
};

module.exports = validator;

},{"./pages/checkout/formPrepare":30}],71:[function(require,module,exports){
"use strict";

var modal = require('./modal').global;

module.exports = {
	init: function init(cb) {
		if (typeof window.YT !== "undefined") {
			if (cb !== undefined) {
				return cb();
			} else {
				return;
			}
		}

		window.onYouTubeIframeAPIReady = cb;

		// load youtube iframe api
		var tag = document.createElement("script");

		tag.async = true;
		tag.src = "https://www.youtube.com/iframe_api";

		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	},

	playInline: function playInline($ele, videoId) {
		var eleId = $ele.attr("id");
		if (!eleId || !videoId) {
			return;
		}

		new YT.Player(eleId, {
			videoId: videoId,
			width: $ele.width(),
			height: $ele.height(),
			playerVars: { rel: 0 },
			events: {
				onReady: function onReady(evt) {
					var player = evt.target;
					player.playVideo();
				}
			}
		});
	},

	playInModal: function playInModal(videoId) {
		if (!videoId) {
			return;
		}

		modal.setContent('<div class="responsive-embed"><div id="video-player"></div></div>');

		new YT.Player("video-player", {
			videoId: videoId,
			events: {
				onReady: function onReady(evt) {
					var player = evt.target;
					modal.events.onOpen(function () {
						var modalBodyWidth = $(".modal-body").width();
						//$("#video-player").width(modalBodyWidth);
						player.playVideo();
					});
					modal.events.onClose(function () {
						player.destroy();
					});
					modal.open();
				}
			}
		});
	}
};

},{"./modal":19}],72:[function(require,module,exports){
"use strict";

// rawAsap provides everything we need except exception management.
var rawAsap = require("./raw");
// RawTasks are recycled to reduce GC churn.
var freeTasks = [];
// We queue errors to ensure they are thrown in right order (FIFO).
// Array-as-queue is good enough here, since we are just dealing with exceptions.
var pendingErrors = [];
var requestErrorThrow = rawAsap.makeRequestCallFromTimer(throwFirstError);

function throwFirstError() {
    if (pendingErrors.length) {
        throw pendingErrors.shift();
    }
}

/**
 * Calls a task as soon as possible after returning, in its own event, with priority
 * over other events like animation, reflow, and repaint. An error thrown from an
 * event will not interrupt, nor even substantially slow down the processing of
 * other events, but will be rather postponed to a lower priority event.
 * @param {{call}} task A callable object, typically a function that takes no
 * arguments.
 */
module.exports = asap;
function asap(task) {
    var rawTask;
    if (freeTasks.length) {
        rawTask = freeTasks.pop();
    } else {
        rawTask = new RawTask();
    }
    rawTask.task = task;
    rawAsap(rawTask);
}

// We wrap tasks with recyclable task objects.  A task object implements
// `call`, just like a function.
function RawTask() {
    this.task = null;
}

// The sole purpose of wrapping the task is to catch the exception and recycle
// the task object after its single use.
RawTask.prototype.call = function () {
    try {
        this.task.call();
    } catch (error) {
        if (asap.onerror) {
            // This hook exists purely for testing purposes.
            // Its name will be periodically randomized to break any code that
            // depends on its existence.
            asap.onerror(error);
        } else {
            // In a web browser, exceptions are not fatal. However, to avoid
            // slowing down the queue of pending tasks, we rethrow the error in a
            // lower priority turn.
            pendingErrors.push(error);
            requestErrorThrow();
        }
    } finally {
        this.task = null;
        freeTasks[freeTasks.length] = this;
    }
};

},{"./raw":73}],73:[function(require,module,exports){
(function (global){
"use strict";

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],74:[function(require,module,exports){
/*!
 * eventie v1.0.6
 * event binding helper
 *   eventie.bind( elem, 'click', myFn )
 *   eventie.unbind( elem, 'click', myFn )
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true */
/*global define: false, module: false */

( function( window ) {

'use strict';

var docElem = document.documentElement;

var bind = function() {};

function getIEEvent( obj ) {
  var event = window.event;
  // add event.target
  event.target = event.target || event.srcElement || obj;
  return event;
}

if ( docElem.addEventListener ) {
  bind = function( obj, type, fn ) {
    obj.addEventListener( type, fn, false );
  };
} else if ( docElem.attachEvent ) {
  bind = function( obj, type, fn ) {
    obj[ type + fn ] = fn.handleEvent ?
      function() {
        var event = getIEEvent( obj );
        fn.handleEvent.call( fn, event );
      } :
      function() {
        var event = getIEEvent( obj );
        fn.call( obj, event );
      };
    obj.attachEvent( "on" + type, obj[ type + fn ] );
  };
}

var unbind = function() {};

if ( docElem.removeEventListener ) {
  unbind = function( obj, type, fn ) {
    obj.removeEventListener( type, fn, false );
  };
} else if ( docElem.detachEvent ) {
  unbind = function( obj, type, fn ) {
    obj.detachEvent( "on" + type, obj[ type + fn ] );
    try {
      delete obj[ type + fn ];
    } catch ( err ) {
      // can't delete window object properties
      obj[ type + fn ] = undefined;
    }
  };
}

var eventie = {
  bind: bind,
  unbind: unbind
};

// ----- module definition ----- //

if ( typeof define === 'function' && define.amd ) {
  // AMD
  define( eventie );
} else if ( typeof exports === 'object' ) {
  // CommonJS
  module.exports = eventie;
} else {
  // browser global
  window.eventie = eventie;
}

})( window );

},{}],75:[function(require,module,exports){
/*!
 * imagesLoaded v3.2.0
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */

( function( window, factory ) { 'use strict';
  // universal module definition

  /*global define: false, module: false, require: false */

  if ( typeof define == 'function' && define.amd ) {
    // AMD
    define( [
      'eventEmitter/EventEmitter',
      'eventie/eventie'
    ], function( EventEmitter, eventie ) {
      return factory( window, EventEmitter, eventie );
    });
  } else if ( typeof module == 'object' && module.exports ) {
    // CommonJS
    module.exports = factory(
      window,
      require('wolfy87-eventemitter'),
      require('eventie')
    );
  } else {
    // browser global
    window.imagesLoaded = factory(
      window,
      window.EventEmitter,
      window.eventie
    );
  }

})( window,

// --------------------------  factory -------------------------- //

function factory( window, EventEmitter, eventie ) {

'use strict';

var $ = window.jQuery;
var console = window.console;

// -------------------------- helpers -------------------------- //

// extend objects
function extend( a, b ) {
  for ( var prop in b ) {
    a[ prop ] = b[ prop ];
  }
  return a;
}

var objToString = Object.prototype.toString;
function isArray( obj ) {
  return objToString.call( obj ) == '[object Array]';
}

// turn element or nodeList into an array
function makeArray( obj ) {
  var ary = [];
  if ( isArray( obj ) ) {
    // use object if already an array
    ary = obj;
  } else if ( typeof obj.length == 'number' ) {
    // convert nodeList to array
    for ( var i=0; i < obj.length; i++ ) {
      ary.push( obj[i] );
    }
  } else {
    // array of single index
    ary.push( obj );
  }
  return ary;
}

  // -------------------------- imagesLoaded -------------------------- //

  /**
   * @param {Array, Element, NodeList, String} elem
   * @param {Object or Function} options - if function, use as callback
   * @param {Function} onAlways - callback function
   */
  function ImagesLoaded( elem, options, onAlways ) {
    // coerce ImagesLoaded() without new, to be new ImagesLoaded()
    if ( !( this instanceof ImagesLoaded ) ) {
      return new ImagesLoaded( elem, options, onAlways );
    }
    // use elem as selector string
    if ( typeof elem == 'string' ) {
      elem = document.querySelectorAll( elem );
    }

    this.elements = makeArray( elem );
    this.options = extend( {}, this.options );

    if ( typeof options == 'function' ) {
      onAlways = options;
    } else {
      extend( this.options, options );
    }

    if ( onAlways ) {
      this.on( 'always', onAlways );
    }

    this.getImages();

    if ( $ ) {
      // add jQuery Deferred object
      this.jqDeferred = new $.Deferred();
    }

    // HACK check async to allow time to bind listeners
    var _this = this;
    setTimeout( function() {
      _this.check();
    });
  }

  ImagesLoaded.prototype = new EventEmitter();

  ImagesLoaded.prototype.options = {};

  ImagesLoaded.prototype.getImages = function() {
    this.images = [];

    // filter & find items if we have an item selector
    for ( var i=0; i < this.elements.length; i++ ) {
      var elem = this.elements[i];
      this.addElementImages( elem );
    }
  };

  /**
   * @param {Node} element
   */
  ImagesLoaded.prototype.addElementImages = function( elem ) {
    // filter siblings
    if ( elem.nodeName == 'IMG' ) {
      this.addImage( elem );
    }
    // get background image on element
    if ( this.options.background === true ) {
      this.addElementBackgroundImages( elem );
    }

    // find children
    // no non-element nodes, #143
    var nodeType = elem.nodeType;
    if ( !nodeType || !elementNodeTypes[ nodeType ] ) {
      return;
    }
    var childImgs = elem.querySelectorAll('img');
    // concat childElems to filterFound array
    for ( var i=0; i < childImgs.length; i++ ) {
      var img = childImgs[i];
      this.addImage( img );
    }

    // get child background images
    if ( typeof this.options.background == 'string' ) {
      var children = elem.querySelectorAll( this.options.background );
      for ( i=0; i < children.length; i++ ) {
        var child = children[i];
        this.addElementBackgroundImages( child );
      }
    }
  };

  var elementNodeTypes = {
    1: true,
    9: true,
    11: true
  };

  ImagesLoaded.prototype.addElementBackgroundImages = function( elem ) {
    var style = getStyle( elem );
    // get url inside url("...")
    var reURL = /url\(['"]*([^'"\)]+)['"]*\)/gi;
    var matches = reURL.exec( style.backgroundImage );
    while ( matches !== null ) {
      var url = matches && matches[1];
      if ( url ) {
        this.addBackground( url, elem );
      }
      matches = reURL.exec( style.backgroundImage );
    }
  };

  // IE8
  var getStyle = window.getComputedStyle || function( elem ) {
    return elem.currentStyle;
  };

  /**
   * @param {Image} img
   */
  ImagesLoaded.prototype.addImage = function( img ) {
    var loadingImage = new LoadingImage( img );
    this.images.push( loadingImage );
  };

  ImagesLoaded.prototype.addBackground = function( url, elem ) {
    var background = new Background( url, elem );
    this.images.push( background );
  };

  ImagesLoaded.prototype.check = function() {
    var _this = this;
    this.progressedCount = 0;
    this.hasAnyBroken = false;
    // complete if no images
    if ( !this.images.length ) {
      this.complete();
      return;
    }

    function onProgress( image, elem, message ) {
      // HACK - Chrome triggers event before object properties have changed. #83
      setTimeout( function() {
        _this.progress( image, elem, message );
      });
    }

    for ( var i=0; i < this.images.length; i++ ) {
      var loadingImage = this.images[i];
      loadingImage.once( 'progress', onProgress );
      loadingImage.check();
    }
  };

  ImagesLoaded.prototype.progress = function( image, elem, message ) {
    this.progressedCount++;
    this.hasAnyBroken = this.hasAnyBroken || !image.isLoaded;
    // progress event
    this.emit( 'progress', this, image, elem );
    if ( this.jqDeferred && this.jqDeferred.notify ) {
      this.jqDeferred.notify( this, image );
    }
    // check if completed
    if ( this.progressedCount == this.images.length ) {
      this.complete();
    }

    if ( this.options.debug && console ) {
      console.log( 'progress: ' + message, image, elem );
    }
  };

  ImagesLoaded.prototype.complete = function() {
    var eventName = this.hasAnyBroken ? 'fail' : 'done';
    this.isComplete = true;
    this.emit( eventName, this );
    this.emit( 'always', this );
    if ( this.jqDeferred ) {
      var jqMethod = this.hasAnyBroken ? 'reject' : 'resolve';
      this.jqDeferred[ jqMethod ]( this );
    }
  };

  // --------------------------  -------------------------- //

  function LoadingImage( img ) {
    this.img = img;
  }

  LoadingImage.prototype = new EventEmitter();

  LoadingImage.prototype.check = function() {
    // If complete is true and browser supports natural sizes,
    // try to check for image status manually.
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      // report based on naturalWidth
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      return;
    }

    // If none of the checks above matched, simulate loading on detached element.
    this.proxyImage = new Image();
    eventie.bind( this.proxyImage, 'load', this );
    eventie.bind( this.proxyImage, 'error', this );
    // bind to image as well for Firefox. #191
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.proxyImage.src = this.img.src;
  };

  LoadingImage.prototype.getIsImageComplete = function() {
    return this.img.complete && this.img.naturalWidth !== undefined;
  };

  LoadingImage.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.img, message );
  };

  // ----- events ----- //

  // trigger specified handler for event type
  LoadingImage.prototype.handleEvent = function( event ) {
    var method = 'on' + event.type;
    if ( this[ method ] ) {
      this[ method ]( event );
    }
  };

  LoadingImage.prototype.onload = function() {
    this.confirm( true, 'onload' );
    this.unbindEvents();
  };

  LoadingImage.prototype.onerror = function() {
    this.confirm( false, 'onerror' );
    this.unbindEvents();
  };

  LoadingImage.prototype.unbindEvents = function() {
    eventie.unbind( this.proxyImage, 'load', this );
    eventie.unbind( this.proxyImage, 'error', this );
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  // -------------------------- Background -------------------------- //

  function Background( url, element ) {
    this.url = url;
    this.element = element;
    this.img = new Image();
  }

  // inherit LoadingImage prototype
  Background.prototype = new LoadingImage();

  Background.prototype.check = function() {
    eventie.bind( this.img, 'load', this );
    eventie.bind( this.img, 'error', this );
    this.img.src = this.url;
    // check if image is already complete
    var isComplete = this.getIsImageComplete();
    if ( isComplete ) {
      this.confirm( this.img.naturalWidth !== 0, 'naturalWidth' );
      this.unbindEvents();
    }
  };

  Background.prototype.unbindEvents = function() {
    eventie.unbind( this.img, 'load', this );
    eventie.unbind( this.img, 'error', this );
  };

  Background.prototype.confirm = function( isLoaded, message ) {
    this.isLoaded = isLoaded;
    this.emit( 'progress', this, this.element, message );
  };

  // -------------------------- jQuery -------------------------- //

  ImagesLoaded.makeJQueryPlugin = function( jQuery ) {
    jQuery = jQuery || window.jQuery;
    if ( !jQuery ) {
      return;
    }
    // set local variable
    $ = jQuery;
    // $().imagesLoaded()
    $.fn.imagesLoaded = function( options, callback ) {
      var instance = new ImagesLoaded( this, options, callback );
      return instance.jqDeferred.promise( $(this) );
    };
  };
  // try making plugin
  ImagesLoaded.makeJQueryPlugin();

  // --------------------------  -------------------------- //

  return ImagesLoaded;

});

},{"eventie":74,"wolfy87-eventemitter":96}],76:[function(require,module,exports){
(function (global){
/**
 * @license
 * lodash 3.10.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modern -d -o ./index.js`
 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '3.10.1';

  /** Used to compose bitmasks for wrapper metadata. */
  var BIND_FLAG = 1,
      BIND_KEY_FLAG = 2,
      CURRY_BOUND_FLAG = 4,
      CURRY_FLAG = 8,
      CURRY_RIGHT_FLAG = 16,
      PARTIAL_FLAG = 32,
      PARTIAL_RIGHT_FLAG = 64,
      ARY_FLAG = 128,
      REARG_FLAG = 256;

  /** Used as default options for `_.trunc`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect when a function becomes hot. */
  var HOT_COUNT = 150,
      HOT_SPAN = 16;

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2;

  /** Used as the `TypeError` message for "Functions" methods. */
  var FUNC_ERROR_TEXT = 'Expected a function';

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      objectTag = '[object Object]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      weakMapTag = '[object WeakMap]';

  var arrayBufferTag = '[object ArrayBuffer]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39|#96);/g,
      reUnescapedHtml = /[&<>"'`]/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\n\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\n\\]|\\.)*?)\2)\]/g;

  /**
   * Used to match `RegExp` [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns)
   * and those outlined by [`EscapeRegExpPattern`](http://ecma-international.org/ecma-262/6.0/#sec-escaperegexppattern).
   */
  var reRegExpChars = /^[:!,]|[\\^$.*+?()[\]{}|\/]|(^[0-9a-fA-Fnrtuvx])|([\n\r\u2028\u2029])/g,
      reHasRegExpChars = RegExp(reRegExpChars.source);

  /** Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks). */
  var reComboMark = /[\u0300-\u036f\ufe20-\ufe23]/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /** Used to match [ES template delimiters](http://ecma-international.org/ecma-262/6.0/#sec-template-literal-lexical-components). */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect hexadecimal string values. */
  var reHasHexPrefix = /^0[xX]/;

  /** Used to detect host constructors (Safari > 5). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^\d+$/;

  /** Used to match latin-1 supplementary letters (excluding mathematical operators). */
  var reLatin1 = /[\xc0-\xd6\xd8-\xde\xdf-\xf6\xf8-\xff]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to match words to create compound words. */
  var reWords = (function() {
    var upper = '[A-Z\\xc0-\\xd6\\xd8-\\xde]',
        lower = '[a-z\\xdf-\\xf6\\xf8-\\xff]+';

    return RegExp(upper + '+(?=' + upper + lower + ')|' + upper + '?' + lower + '|' + upper + '+|[0-9]+', 'g');
  }());

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'ArrayBuffer', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Math', 'Number',
    'Object', 'RegExp', 'Set', 'String', '_', 'clearTimeout', 'isFinite',
    'parseFloat', 'parseInt', 'setTimeout', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dateTag] = typedArrayTags[errorTag] =
  typedArrayTags[funcTag] = typedArrayTags[mapTag] =
  typedArrayTags[numberTag] = typedArrayTags[objectTag] =
  typedArrayTags[regexpTag] = typedArrayTags[setTag] =
  typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[boolTag] =
  cloneableTags[dateTag] = cloneableTags[float32Tag] =
  cloneableTags[float64Tag] = cloneableTags[int8Tag] =
  cloneableTags[int16Tag] = cloneableTags[int32Tag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[stringTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[mapTag] = cloneableTags[setTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map latin-1 supplementary letters to basic latin letters. */
  var deburredLetters = {
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcC': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xeC': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '`': '&#96;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'",
    '&#96;': '`'
  };

  /** Used to determine if values are of the language type `Object`. */
  var objectTypes = {
    'function': true,
    'object': true
  };

  /** Used to escape characters for inclusion in compiled regexes. */
  var regexpEscapes = {
    '0': 'x30', '1': 'x31', '2': 'x32', '3': 'x33', '4': 'x34',
    '5': 'x35', '6': 'x36', '7': 'x37', '8': 'x38', '9': 'x39',
    'A': 'x41', 'B': 'x42', 'C': 'x43', 'D': 'x44', 'E': 'x45', 'F': 'x46',
    'a': 'x61', 'b': 'x62', 'c': 'x63', 'd': 'x64', 'e': 'x65', 'f': 'x66',
    'n': 'x6e', 'r': 'x72', 't': 'x74', 'u': 'x75', 'v': 'x76', 'x': 'x78'
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Detect free variable `exports`. */
  var freeExports = objectTypes[typeof exports] && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = objectTypes[typeof module] && module && !module.nodeType && module;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = freeExports && freeModule && typeof global == 'object' && global && global.Object && global;

  /** Detect free variable `self`. */
  var freeSelf = objectTypes[typeof self] && self && self.Object && self;

  /** Detect free variable `window`. */
  var freeWindow = objectTypes[typeof window] && window && window.Object && window;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports && freeExports;

  /**
   * Used as a reference to the global object.
   *
   * The `this` value is used if it's the global object to avoid Greasemonkey's
   * restricted `window` object, otherwise the `window` object is used.
   */
  var root = freeGlobal || ((freeWindow !== (this && this.window)) && freeWindow) || freeSelf || this;

  /*--------------------------------------------------------------------------*/

  /**
   * The base implementation of `compareAscending` which compares values and
   * sorts them in ascending order without guaranteeing a stable sort.
   *
   * @private
   * @param {*} value The value to compare.
   * @param {*} other The other value to compare.
   * @returns {number} Returns the sort order indicator for `value`.
   */
  function baseCompareAscending(value, other) {
    if (value !== other) {
      var valIsNull = value === null,
          valIsUndef = value === undefined,
          valIsReflexive = value === value;

      var othIsNull = other === null,
          othIsUndef = other === undefined,
          othIsReflexive = other === other;

      if ((value > other && !othIsNull) || !valIsReflexive ||
          (valIsNull && !othIsUndef && othIsReflexive) ||
          (valIsUndef && othIsReflexive)) {
        return 1;
      }
      if ((value < other && !valIsNull) || !othIsReflexive ||
          (othIsNull && !valIsUndef && valIsReflexive) ||
          (othIsUndef && valIsReflexive)) {
        return -1;
      }
    }
    return 0;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {Function} predicate The function invoked per iteration.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromRight) {
    var length = array.length,
        index = fromRight ? length : -1;

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without support for binary searches.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    if (value !== value) {
      return indexOfNaN(array, fromIndex);
    }
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isFunction` without support for environments
   * with incorrect `typeof` results.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
   */
  function baseIsFunction(value) {
    // Avoid a Chakra JIT bug in compatibility modes of IE 11.
    // See https://github.com/jashkenas/underscore/issues/1621 for more details.
    return typeof value == 'function' || false;
  }

  /**
   * Converts `value` to a string if it's not one. An empty string is returned
   * for `null` or `undefined` values.
   *
   * @private
   * @param {*} value The value to process.
   * @returns {string} Returns the string.
   */
  function baseToString(value) {
    return value == null ? '' : (value + '');
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the first character not found in `chars`.
   */
  function charsLeftIndex(string, chars) {
    var index = -1,
        length = string.length;

    while (++index < length && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last character
   * of `string` that is not found in `chars`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @param {string} chars The characters to find.
   * @returns {number} Returns the index of the last character not found in `chars`.
   */
  function charsRightIndex(string, chars) {
    var index = string.length;

    while (index-- && chars.indexOf(string.charAt(index)) > -1) {}
    return index;
  }

  /**
   * Used by `_.sortBy` to compare transformed elements of a collection and stable
   * sort them in ascending order.
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareAscending(object, other) {
    return baseCompareAscending(object.criteria, other.criteria) || (object.index - other.index);
  }

  /**
   * Used by `_.sortByOrder` to compare multiple properties of a value to another
   * and stable sort them.
   *
   * If `orders` is unspecified, all valuess are sorted in ascending order. Otherwise,
   * a value is sorted in ascending order if its corresponding order is "asc", and
   * descending if "desc".
   *
   * @private
   * @param {Object} object The object to compare.
   * @param {Object} other The other object to compare.
   * @param {boolean[]} orders The order to sort by for each property.
   * @returns {number} Returns the sort order indicator for `object`.
   */
  function compareMultiple(object, other, orders) {
    var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;

    while (++index < length) {
      var result = baseCompareAscending(objCriteria[index], othCriteria[index]);
      if (result) {
        if (index >= ordersLength) {
          return result;
        }
        var order = orders[index];
        return result * ((order === 'asc' || order === true) ? 1 : -1);
      }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://code.google.com/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
  }

  /**
   * Used by `_.deburr` to convert latin-1 supplementary letters to basic latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  function deburrLetter(letter) {
    return deburredLetters[letter];
  }

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeHtmlChar(chr) {
    return htmlEscapes[chr];
  }

  /**
   * Used by `_.escapeRegExp` to escape characters for inclusion in compiled regexes.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @param {string} leadingChar The capture group for a leading character.
   * @param {string} whitespaceChar The capture group for a whitespace character.
   * @returns {string} Returns the escaped character.
   */
  function escapeRegExpChar(chr, leadingChar, whitespaceChar) {
    if (leadingChar) {
      chr = regexpEscapes[chr];
    } else if (whitespaceChar) {
      chr = stringEscapes[chr];
    }
    return '\\' + chr;
  }

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the index at which the first occurrence of `NaN` is found in `array`.
   *
   * @private
   * @param {Array} array The array to search.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched `NaN`, else `-1`.
   */
  function indexOfNaN(array, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 0 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      var other = array[index];
      if (other !== other) {
        return index;
      }
    }
    return -1;
  }

  /**
   * Checks if `value` is object-like.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
   */
  function isObjectLike(value) {
    return !!value && typeof value == 'object';
  }

  /**
   * Used by `trimmedLeftIndex` and `trimmedRightIndex` to determine if a
   * character code is whitespace.
   *
   * @private
   * @param {number} charCode The character code to inspect.
   * @returns {boolean} Returns `true` if `charCode` is whitespace, else `false`.
   */
  function isSpace(charCode) {
    return ((charCode <= 160 && (charCode >= 9 && charCode <= 13) || charCode == 32 || charCode == 160) || charCode == 5760 || charCode == 6158 ||
      (charCode >= 8192 && (charCode <= 8202 || charCode == 8232 || charCode == 8233 || charCode == 8239 || charCode == 8287 || charCode == 12288 || charCode == 65279)));
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      if (array[index] === placeholder) {
        array[index] = PLACEHOLDER;
        result[++resIndex] = index;
      }
    }
    return result;
  }

  /**
   * An implementation of `_.uniq` optimized for sorted arrays without support
   * for callback shorthands and `this` binding.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} [iteratee] The function invoked per iteration.
   * @returns {Array} Returns the new duplicate-value-free array.
   */
  function sortedUniq(array, iteratee) {
    var seen,
        index = -1,
        length = array.length,
        resIndex = -1,
        result = [];

    while (++index < length) {
      var value = array[index],
          computed = iteratee ? iteratee(value, index, array) : value;

      if (!index || seen !== computed) {
        seen = computed;
        result[++resIndex] = value;
      }
    }
    return result;
  }

  /**
   * Used by `_.trim` and `_.trimLeft` to get the index of the first non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the first non-whitespace character.
   */
  function trimmedLeftIndex(string) {
    var index = -1,
        length = string.length;

    while (++index < length && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimRight` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedRightIndex(string) {
    var index = string.length;

    while (index-- && isSpace(string.charCodeAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  function unescapeHtmlChar(chr) {
    return htmlUnescapes[chr];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the given `context` object.
   *
   * @static
   * @memberOf _
   * @category Utility
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // using `context` to mock `Date#getTime` use in `_.now`
   * var mock = _.runInContext({
   *   'Date': function() {
   *     return { 'getTime': getTimeMock };
   *   }
   * });
   *
   * // or creating a suped-up `defer` in Node.js
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  function runInContext(context) {
    // Avoid issues with some ES3 environments that attempt to use values, named
    // after built-in constructors like `Object`, for the creation of literals.
    // ES5 clears this up by stating that literals must use built-in constructors.
    // See https://es5.github.io/#x11.1.5 for more details.
    context = context ? _.defaults(root.Object(), context, _.pick(root, contextProps)) : root;

    /** Native constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Number = context.Number,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for native method references. */
    var arrayProto = Array.prototype,
        objectProto = Object.prototype,
        stringProto = String.prototype;

    /** Used to resolve the decompiled source of functions. */
    var fnToString = Function.prototype.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /**
     * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
     * of values.
     */
    var objToString = objectProto.toString;

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Native method references. */
    var ArrayBuffer = context.ArrayBuffer,
        clearTimeout = context.clearTimeout,
        parseFloat = context.parseFloat,
        pow = Math.pow,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        Set = getNative(context, 'Set'),
        setTimeout = context.setTimeout,
        splice = arrayProto.splice,
        Uint8Array = context.Uint8Array,
        WeakMap = getNative(context, 'WeakMap');

    /* Native method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeCreate = getNative(Object, 'create'),
        nativeFloor = Math.floor,
        nativeIsArray = getNative(Array, 'isArray'),
        nativeIsFinite = context.isFinite,
        nativeKeys = getNative(Object, 'keys'),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = getNative(Date, 'now'),
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random;

    /** Used as references for `-Infinity` and `Infinity`. */
    var NEGATIVE_INFINITY = Number.NEGATIVE_INFINITY,
        POSITIVE_INFINITY = Number.POSITIVE_INFINITY;

    /** Used as references for the maximum length and index of an array. */
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

    /**
     * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
     * of an array-like value.
     */
    var MAX_SAFE_INTEGER = 9007199254740991;

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit chaining.
     * Methods that operate on and return arrays, collections, and functions can
     * be chained together. Methods that retrieve a single value or may return a
     * primitive value will automatically end the chain returning the unwrapped
     * value. Explicit chaining may be enabled using `_.chain`. The execution of
     * chained methods is lazy, that is, execution is deferred until `_#value`
     * is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion. Shortcut
     * fusion is an optimization strategy which merge iteratee calls; this can help
     * to avoid the creation of intermediate data structures and greatly reduce the
     * number of iteratee executions.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `reverse`, `shift`, `slice`, `sort`,
     * `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `compact`, `drop`, `dropRight`, `dropRightWhile`, `dropWhile`, `filter`,
     * `first`, `initial`, `last`, `map`, `pluck`, `reject`, `rest`, `reverse`,
     * `slice`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, `toArray`,
     * and `where`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `at`, `before`, `bind`, `bindAll`, `bindKey`,
     * `callback`, `chain`, `chunk`, `commit`, `compact`, `concat`, `constant`,
     * `countBy`, `create`, `curry`, `debounce`, `defaults`, `defaultsDeep`,
     * `defer`, `delay`, `difference`, `drop`, `dropRight`, `dropRightWhile`,
     * `dropWhile`, `fill`, `filter`, `flatten`, `flattenDeep`, `flow`, `flowRight`,
     * `forEach`, `forEachRight`, `forIn`, `forInRight`, `forOwn`, `forOwnRight`,
     * `functions`, `groupBy`, `indexBy`, `initial`, `intersection`, `invert`,
     * `invoke`, `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`,
     * `matchesProperty`, `memoize`, `merge`, `method`, `methodOf`, `mixin`,
     * `modArgs`, `negate`, `omit`, `once`, `pairs`, `partial`, `partialRight`,
     * `partition`, `pick`, `plant`, `pluck`, `property`, `propertyOf`, `pull`,
     * `pullAt`, `push`, `range`, `rearg`, `reject`, `remove`, `rest`, `restParam`,
     * `reverse`, `set`, `shuffle`, `slice`, `sort`, `sortBy`, `sortByAll`,
     * `sortByOrder`, `splice`, `spread`, `take`, `takeRight`, `takeRightWhile`,
     * `takeWhile`, `tap`, `throttle`, `thru`, `times`, `toArray`, `toPlainObject`,
     * `transform`, `union`, `uniq`, `unshift`, `unzip`, `unzipWith`, `values`,
     * `valuesIn`, `where`, `without`, `wrap`, `xor`, `zip`, `zipObject`, `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clone`, `cloneDeep`,
     * `deburr`, `endsWith`, `escape`, `escapeRegExp`, `every`, `find`, `findIndex`,
     * `findKey`, `findLast`, `findLastIndex`, `findLastKey`, `findWhere`, `first`,
     * `floor`, `get`, `gt`, `gte`, `has`, `identity`, `includes`, `indexOf`,
     * `inRange`, `isArguments`, `isArray`, `isBoolean`, `isDate`, `isElement`,
     * `isEmpty`, `isEqual`, `isError`, `isFinite` `isFunction`, `isMatch`,
     * `isNative`, `isNaN`, `isNull`, `isNumber`, `isObject`, `isPlainObject`,
     * `isRegExp`, `isString`, `isUndefined`, `isTypedArray`, `join`, `kebabCase`,
     * `last`, `lastIndexOf`, `lt`, `lte`, `max`, `min`, `noConflict`, `noop`,
     * `now`, `pad`, `padLeft`, `padRight`, `parseInt`, `pop`, `random`, `reduce`,
     * `reduceRight`, `repeat`, `result`, `round`, `runInContext`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedLastIndex`, `startCase`,
     * `startsWith`, `sum`, `template`, `trim`, `trimLeft`, `trimRight`, `trunc`,
     * `unescape`, `uniqueId`, `value`, and `words`
     *
     * The wrapper method `sample` will return a wrapped value when `n` is provided,
     * otherwise an unwrapped value is returned.
     *
     * @name _
     * @constructor
     * @category Chain
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // returns an unwrapped value
     * wrapped.reduce(function(total, n) {
     *   return total + n;
     * });
     * // => 6
     *
     * // returns a wrapped value
     * var squares = wrapped.map(function(n) {
     *   return n * n;
     * });
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__chain__') && hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The function whose prototype all chaining wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable chaining for all wrapper methods.
     * @param {Array} [actions=[]] Actions to peform to resolve the unwrapped value.
     */
    function LodashWrapper(value, chainAll, actions) {
      this.__wrapped__ = value;
      this.__actions__ = actions || [];
      this.__chain__ = !!chainAll;
    }

    /**
     * An object environment feature flags.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    var support = lodash.support = {};

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB). Change the following template settings to use
     * alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type Object
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type RegExp
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type string
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type Object
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type Function
         */
        '_': lodash
      }
    };

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = POSITIVE_INFINITY;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = arrayCopy(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = arrayCopy(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = arrayCopy(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || arrLength < LARGE_ARRAY_SIZE || (arrLength == length && takeCount == length)) {
        return baseWrapperValue((isRight && isArr) ? array.reverse() : array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a cache object to store key/value pairs.
     *
     * @private
     * @static
     * @name Cache
     * @memberOf _.memoize
     */
    function MapCache() {
      this.__data__ = {};
    }

    /**
     * Removes `key` and its value from the cache.
     *
     * @private
     * @name delete
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed successfully, else `false`.
     */
    function mapDelete(key) {
      return this.has(key) && delete this.__data__[key];
    }

    /**
     * Gets the cached value for `key`.
     *
     * @private
     * @name get
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the cached value.
     */
    function mapGet(key) {
      return key == '__proto__' ? undefined : this.__data__[key];
    }

    /**
     * Checks if a cached value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapHas(key) {
      return key != '__proto__' && hasOwnProperty.call(this.__data__, key);
    }

    /**
     * Sets `value` to `key` of the cache.
     *
     * @private
     * @name set
     * @memberOf _.memoize.Cache
     * @param {string} key The key of the value to cache.
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache object.
     */
    function mapSet(key, value) {
      if (key != '__proto__') {
        this.__data__[key] = value;
      }
      return this;
    }

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates a cache object to store unique values.
     *
     * @private
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var length = values ? values.length : 0;

      this.data = { 'hash': nativeCreate(null), 'set': new Set };
      while (length--) {
        this.push(values[length]);
      }
    }

    /**
     * Checks if `value` is in `cache` mimicking the return signature of
     * `_.indexOf` by returning `0` if the value is found, else `-1`.
     *
     * @private
     * @param {Object} cache The cache to search.
     * @param {*} value The value to search for.
     * @returns {number} Returns `0` if `value` is found, else `-1`.
     */
    function cacheIndexOf(cache, value) {
      var data = cache.data,
          result = (typeof value == 'string' || isObject(value)) ? data.set.has(value) : data.hash[value];

      return result ? 0 : -1;
    }

    /**
     * Adds `value` to the cache.
     *
     * @private
     * @name push
     * @memberOf SetCache
     * @param {*} value The value to cache.
     */
    function cachePush(value) {
      var data = this.data;
      if (typeof value == 'string' || isObject(value)) {
        data.set.add(value);
      } else {
        data.hash[value] = true;
      }
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a new array joining `array` with `other`.
     *
     * @private
     * @param {Array} array The array to join.
     * @param {Array} other The other array to join.
     * @returns {Array} Returns the new concatenated array.
     */
    function arrayConcat(array, other) {
      var index = -1,
          length = array.length,
          othIndex = -1,
          othLength = other.length,
          result = Array(length + othLength);

      while (++index < length) {
        result[index] = array[index];
      }
      while (++othIndex < othLength) {
        result[index++] = other[othIndex];
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function arrayCopy(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.forEach` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEach(array, iteratee) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.forEachRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns `array`.
     */
    function arrayEachRight(array, iteratee) {
      var length = array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }
      return array;
    }

    /**
     * A specialized version of `_.every` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     */
    function arrayEvery(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseExtremum` for arrays which invokes `iteratee`
     * with one argument: (value).
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function arrayExtremum(array, iteratee, comparator, exValue) {
      var index = -1,
          length = array.length,
          computed = exValue,
          result = computed;

      while (++index < length) {
        var value = array[index],
            current = +iteratee(value);

        if (comparator(current, computed)) {
          computed = current;
          result = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.filter` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function arrayFilter(array, predicate) {
      var index = -1,
          length = array.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.map` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function arrayMap(array, iteratee) {
      var index = -1,
          length = array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }
      return result;
    }

    /**
     * Appends the elements of `values` to `array`.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to append.
     * @returns {Array} Returns `array`.
     */
    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }
      return array;
    }

    /**
     * A specialized version of `_.reduce` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the first element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduce(array, iteratee, accumulator, initFromArray) {
      var index = -1,
          length = array.length;

      if (initFromArray && length) {
        accumulator = array[++index];
      }
      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.reduceRight` for arrays without support for
     * callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {boolean} [initFromArray] Specify using the last element of `array`
     *  as the initial value.
     * @returns {*} Returns the accumulated value.
     */
    function arrayReduceRight(array, iteratee, accumulator, initFromArray) {
      var length = array.length;
      if (initFromArray && length) {
        accumulator = array[--length];
      }
      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }
      return accumulator;
    }

    /**
     * A specialized version of `_.some` for arrays without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function arraySome(array, predicate) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }
      return false;
    }

    /**
     * A specialized version of `_.sum` for arrays without support for callback
     * shorthands and `this` binding..
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function arraySum(array, iteratee) {
      var length = array.length,
          result = 0;

      while (length--) {
        result += +iteratee(array[length]) || 0;
      }
      return result;
    }

    /**
     * Used by `_.defaults` to customize its `_.assign` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : objectValue;
    }

    /**
     * Used by `_.template` to customize its `_.assign` use.
     *
     * **Note:** This function is like `assignDefaults` except that it ignores
     * inherited property values when checking if a property is `undefined`.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @param {string} key The key associated with the object and source values.
     * @param {Object} object The destination object.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function assignOwnDefaults(objectValue, sourceValue, key, object) {
      return (objectValue === undefined || !hasOwnProperty.call(object, key))
        ? sourceValue
        : objectValue;
    }

    /**
     * A specialized version of `_.assign` for customizing assigned values without
     * support for argument juggling, multiple sources, and `this` binding `customizer`
     * functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     */
    function assignWith(object, source, customizer) {
      var index = -1,
          props = keys(source),
          length = props.length;

      while (++index < length) {
        var key = props[index],
            value = object[key],
            result = customizer(value, source[key], key, object, source);

        if ((result === result ? (result !== value) : (value === value)) ||
            (value === undefined && !(key in object))) {
          object[key] = result;
        }
      }
      return object;
    }

    /**
     * The base implementation of `_.assign` without support for argument juggling,
     * multiple sources, and `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return source == null
        ? object
        : baseCopy(source, keys(source), object);
    }

    /**
     * The base implementation of `_.at` without support for string collections
     * and individual key arguments.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {number[]|string[]} props The property names or indexes of elements to pick.
     * @returns {Array} Returns the new array of picked elements.
     */
    function baseAt(collection, props) {
      var index = -1,
          isNil = collection == null,
          isArr = !isNil && isArrayLike(collection),
          length = isArr ? collection.length : 0,
          propsLength = props.length,
          result = Array(propsLength);

      while(++index < propsLength) {
        var key = props[index];
        if (isArr) {
          result[index] = isIndex(key, length) ? collection[key] : undefined;
        } else {
          result[index] = isNil ? undefined : collection[key];
        }
      }
      return result;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property names to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @returns {Object} Returns `object`.
     */
    function baseCopy(source, props, object) {
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];
        object[key] = source[key];
      }
      return object;
    }

    /**
     * The base implementation of `_.callback` which supports specifying the
     * number of arguments to provide to `func`.
     *
     * @private
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function baseCallback(func, thisArg, argCount) {
      var type = typeof func;
      if (type == 'function') {
        return thisArg === undefined
          ? func
          : bindCallback(func, thisArg, argCount);
      }
      if (func == null) {
        return identity;
      }
      if (type == 'object') {
        return baseMatches(func);
      }
      return thisArg === undefined
        ? property(func)
        : baseMatchesProperty(func, thisArg);
    }

    /**
     * The base implementation of `_.clone` without support for argument juggling
     * and `this` binding `customizer` functions.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The object `value` belongs to.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates clones with source counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, isDeep, customizer, key, object, stackA, stackB) {
      var result;
      if (customizer) {
        result = object ? customizer(value, key, object) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return arrayCopy(value, result);
        }
      } else {
        var tag = objToString.call(value),
            isFunc = tag == funcTag;

        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = initCloneObject(isFunc ? {} : value);
          if (!isDeep) {
            return baseAssign(result, value);
          }
        } else {
          return cloneableTags[tag]
            ? initCloneByTag(value, tag, isDeep)
            : (object ? value : {});
        }
      }
      // Check for circular references and return its corresponding clone.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == value) {
          return stackB[length];
        }
      }
      // Add the source value to the stack of traversed objects and associate it with its clone.
      stackA.push(value);
      stackB.push(result);

      // Recursively populate clone (susceptible to call stack limits).
      (isArr ? arrayEach : baseForOwn)(value, function(subValue, key) {
        result[key] = baseClone(subValue, isDeep, customizer, key, value, stackA, stackB);
      });
      return result;
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} prototype The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(prototype) {
        if (isObject(prototype)) {
          object.prototype = prototype;
          var result = new object;
          object.prototype = undefined;
        }
        return result || {};
      };
    }());

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts an index
     * of where to slice the arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Object} args The arguments provide to `func`.
     * @returns {number} Returns the timer id.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of `_.difference` which accepts a single array
     * of values to exclude.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values) {
      var length = array ? array.length : 0,
          result = [];

      if (!length) {
        return result;
      }
      var index = -1,
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          cache = (isCommon && values.length >= LARGE_ARRAY_SIZE) ? createCache(values) : null,
          valuesLength = values.length;

      if (cache) {
        indexOf = cacheIndexOf;
        isCommon = false;
        values = cache;
      }
      outer:
      while (++index < length) {
        var value = array[index];

        if (isCommon && value === value) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === value) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (indexOf(values, value, 0) < 0) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object|string} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * Gets the extremum value of `collection` invoking `iteratee` for each value
     * in `collection` to generate the criterion by which the value is ranked.
     * The `iteratee` is invoked with three arguments: (value, index|key, collection).
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(collection, iteratee, comparator, exValue) {
      var computed = exValue,
          result = computed;

      baseEach(collection, function(value, index, collection) {
        var current = +iteratee(value, index, collection);
        if (comparator(current, computed) || (current === exValue && current === result)) {
          computed = current;
          result = value;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : (end >>> 0);
      start >>>= 0;

      while (start < length) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.find`, `_.findLast`, `_.findKey`, and `_.findLastKey`,
     * without support for callback shorthands and `this` binding, which iterates
     * over `collection` using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function} predicate The function invoked per iteration.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @param {boolean} [retKey] Specify returning the key of the found element
     *  instead of the element itself.
     * @returns {*} Returns the found element or its key, else `undefined`.
     */
    function baseFind(collection, predicate, eachFunc, retKey) {
      var result;
      eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
          result = retKey ? key : value;
          return false;
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with added support for restricting
     * flattening and specifying the start index.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param {boolean} [isStrict] Restrict flattening to arrays-like objects.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, isDeep, isStrict, result) {
      result || (result = []);

      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index];
        if (isObjectLike(value) && isArrayLike(value) &&
            (isStrict || isArray(value) || isArguments(value))) {
          if (isDeep) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, isDeep, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForIn` and `baseForOwn` which iterates
     * over `object` properties returned by `keysFunc` invoking `iteratee` for
     * each property. Iteratee functions may exit iteration early by explicitly
     * returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forIn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForIn(object, iteratee) {
      return baseFor(object, iteratee, keysIn);
    }

    /**
     * The base implementation of `_.forOwn` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from those provided.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the new array of filtered property names.
     */
    function baseFunctions(object, props) {
      var index = -1,
          length = props.length,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var key = props[index];
        if (isFunction(object[key])) {
          result[++resIndex] = key;
        }
      }
      return result;
    }

    /**
     * The base implementation of `get` without support for string paths
     * and default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path of the property to get.
     * @param {string} [pathKey] The key representation of path.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path, pathKey) {
      if (object == null) {
        return;
      }
      if (pathKey !== undefined && pathKey in toObject(object)) {
        path = [pathKey];
      }
      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[path[index++]];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `_.isEqual` without support for `this` binding
     * `customizer` functions.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, customizer, isLoose, stackA, stackB) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, baseIsEqual, customizer, isLoose, stackA, stackB);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA=[]] Tracks traversed `value` objects.
     * @param {Array} [stackB=[]] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = arrayTag,
          othTag = arrayTag;

      if (!objIsArr) {
        objTag = objToString.call(object);
        if (objTag == argsTag) {
          objTag = objectTag;
        } else if (objTag != objectTag) {
          objIsArr = isTypedArray(object);
        }
      }
      if (!othIsArr) {
        othTag = objToString.call(other);
        if (othTag == argsTag) {
          othTag = objectTag;
        } else if (othTag != objectTag) {
          othIsArr = isTypedArray(other);
        }
      }
      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && !(objIsArr || objIsObj)) {
        return equalByTag(object, other, objTag);
      }
      if (!isLoose) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          return equalFunc(objIsWrapped ? object.value() : object, othIsWrapped ? other.value() : other, customizer, isLoose, stackA, stackB);
        }
      }
      if (!isSameTag) {
        return false;
      }
      // Assume cyclic values are equal.
      // For more information on detecting circular references see https://es5.github.io/#JO.
      stackA || (stackA = []);
      stackB || (stackB = []);

      var length = stackA.length;
      while (length--) {
        if (stackA[length] == object) {
          return stackB[length] == other;
        }
      }
      // Add `object` and `other` to the stack of traversed objects.
      stackA.push(object);
      stackB.push(other);

      var result = (objIsArr ? equalArrays : equalObjects)(object, other, equalFunc, customizer, isLoose, stackA, stackB);

      stackA.pop();
      stackB.pop();

      return result;
    }

    /**
     * The base implementation of `_.isMatch` without support for callback
     * shorthands and `this` binding.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} matchData The propery names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparing objects.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = toObject(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var result = customizer ? customizer(objValue, srcValue, key) : undefined;
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, true) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.map` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which does not clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        var key = matchData[0][0],
            value = matchData[0][1];

        return function(object) {
          if (object == null) {
            return false;
          }
          return object[key] === value && (value !== undefined || (key in toObject(object)));
        };
      }
      return function(object) {
        return baseIsMatch(object, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which does not clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to compare.
     * @returns {Function} Returns the new function.
     */
    function baseMatchesProperty(path, srcValue) {
      var isArr = isArray(path),
          isCommon = isKey(path) && isStrictComparable(srcValue),
          pathKey = (path + '');

      path = toPath(path);
      return function(object) {
        if (object == null) {
          return false;
        }
        var key = pathKey;
        object = toObject(object);
        if ((isArr || !isCommon) && !(key in object)) {
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          if (object == null) {
            return false;
          }
          key = last(path);
          object = toObject(object);
        }
        return object[key] === srcValue
          ? (srcValue !== undefined || (key in object))
          : baseIsEqual(srcValue, object[key], undefined, true);
      };
    }

    /**
     * The base implementation of `_.merge` without support for argument juggling,
     * multiple sources, and `this` binding `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {Object} Returns `object`.
     */
    function baseMerge(object, source, customizer, stackA, stackB) {
      if (!isObject(object)) {
        return object;
      }
      var isSrcArr = isArrayLike(source) && (isArray(source) || isTypedArray(source)),
          props = isSrcArr ? undefined : keys(source);

      arrayEach(props || source, function(srcValue, key) {
        if (props) {
          key = srcValue;
          srcValue = source[key];
        }
        if (isObjectLike(srcValue)) {
          stackA || (stackA = []);
          stackB || (stackB = []);
          baseMergeDeep(object, source, key, baseMerge, customizer, stackA, stackB);
        }
        else {
          var value = object[key],
              result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
              isCommon = result === undefined;

          if (isCommon) {
            result = srcValue;
          }
          if ((result !== undefined || (isSrcArr && !(key in object))) &&
              (isCommon || (result === result ? (result !== value) : (value === value)))) {
            object[key] = result;
          }
        }
      });
      return object;
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Array} [stackA=[]] Tracks traversed source objects.
     * @param {Array} [stackB=[]] Associates values with source counterparts.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseMergeDeep(object, source, key, mergeFunc, customizer, stackA, stackB) {
      var length = stackA.length,
          srcValue = source[key];

      while (length--) {
        if (stackA[length] == srcValue) {
          object[key] = stackB[length];
          return;
        }
      }
      var value = object[key],
          result = customizer ? customizer(value, srcValue, key, object, source) : undefined,
          isCommon = result === undefined;

      if (isCommon) {
        result = srcValue;
        if (isArrayLike(srcValue) && (isArray(srcValue) || isTypedArray(srcValue))) {
          result = isArray(value)
            ? value
            : (isArrayLike(value) ? arrayCopy(value) : []);
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          result = isArguments(value)
            ? toPlainObject(value)
            : (isPlainObject(value) ? value : {});
        }
        else {
          isCommon = false;
        }
      }
      // Add the source value to the stack of traversed objects and associate
      // it with its merged value.
      stackA.push(srcValue);
      stackB.push(result);

      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        object[key] = mergeFunc(result, srcValue, customizer, stackA, stackB);
      } else if (result === result ? (result !== value) : (value === value)) {
        object[key] = result;
      }
    }

    /**
     * The base implementation of `_.property` without support for deep paths.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @returns {Function} Returns the new function.
     */
    function baseProperty(key) {
      return function(object) {
        return object == null ? undefined : object[key];
      };
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     */
    function basePropertyDeep(path) {
      var pathKey = (path + '');
      path = toPath(path);
      return function(object) {
        return baseGet(object, path, pathKey);
      };
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * index arguments and capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0;
      while (length--) {
        var index = indexes[length];
        if (index != previous && isIndex(index)) {
          var previous = index;
          splice.call(array, index, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for argument juggling
     * and returning floating-point numbers.
     *
     * @private
     * @param {number} min The minimum possible value.
     * @param {number} max The maximum possible value.
     * @returns {number} Returns the random number.
     */
    function baseRandom(min, max) {
      return min + nativeFloor(nativeRandom() * (max - min + 1));
    }

    /**
     * The base implementation of `_.reduce` and `_.reduceRight` without support
     * for callback shorthands and `this` binding, which iterates over `collection`
     * using the provided `eachFunc`.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {*} accumulator The initial value.
     * @param {boolean} initFromCollection Specify using the first or last element
     *  of `collection` as the initial value.
     * @param {Function} eachFunc The function to iterate over `collection`.
     * @returns {*} Returns the accumulated value.
     */
    function baseReduce(collection, iteratee, accumulator, initFromCollection, eachFunc) {
      eachFunc(collection, function(value, index, collection) {
        accumulator = initFromCollection
          ? (initFromCollection = false, value)
          : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `setData` without support for hot loop detection.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      start = start == null ? 0 : (+start || 0);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : (+end || 0);
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortBy` which uses `comparer` to define
     * the sort order of `array` and replaces criteria objects with their
     * corresponding values.
     *
     * @private
     * @param {Array} array The array to sort.
     * @param {Function} comparer The function to define sort order.
     * @returns {Array} Returns `array`.
     */
    function baseSortBy(array, comparer) {
      var length = array.length;

      array.sort(comparer);
      while (length--) {
        array[length] = array[length].value;
      }
      return array;
    }

    /**
     * The base implementation of `_.sortByOrder` without param guards.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseSortByOrder(collection, iteratees, orders) {
      var callback = getCallback(),
          index = -1;

      iteratees = arrayMap(iteratees, function(iteratee) { return callback(iteratee); });

      var result = baseMap(collection, function(value) {
        var criteria = arrayMap(iteratees, function(iteratee) { return iteratee(value); });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.sum` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {number} Returns the sum.
     */
    function baseSum(collection, iteratee) {
      var result = 0;
      baseEach(collection, function(value, index, collection) {
        result += +iteratee(value, index, collection) || 0;
      });
      return result;
    }

    /**
     * The base implementation of `_.uniq` without support for callback shorthands
     * and `this` binding.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The function invoked per iteration.
     * @returns {Array} Returns the new duplicate-value-free array.
     */
    function baseUniq(array, iteratee) {
      var index = -1,
          indexOf = getIndexOf(),
          length = array.length,
          isCommon = indexOf == baseIndexOf,
          isLarge = isCommon && length >= LARGE_ARRAY_SIZE,
          seen = isLarge ? createCache() : null,
          result = [];

      if (seen) {
        indexOf = cacheIndexOf;
        isCommon = false;
      } else {
        isLarge = false;
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value, index, array) : value;

        if (isCommon && value === value) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (indexOf(seen, computed, 0) < 0) {
          if (iteratee || isLarge) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.values` and `_.valuesIn` which creates an
     * array of `object` property values corresponding to the property names
     * of `props`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} props The property names to get values for.
     * @returns {Object} Returns the array of property values.
     */
    function baseValues(object, props) {
      var index = -1,
          length = props.length,
          result = Array(length);

      while (++index < length) {
        result[index] = object[props[index]];
      }
      return result;
    }

    /**
     * The base implementation of `_.dropRightWhile`, `_.dropWhile`, `_.takeRightWhile`,
     * and `_.takeWhile` without support for callback shorthands and `this` binding.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to peform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      var index = -1,
          length = actions.length;

      while (++index < length) {
        var action = actions[index];
        result = action.func.apply(action.thisArg, arrayPush([result], action.args));
      }
      return result;
    }

    /**
     * Performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndex(array, value, retHighest) {
      var low = 0,
          high = array ? array.length : low;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if ((retHighest ? (computed <= value) : (computed < value)) && computed !== null) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return binaryIndexBy(array, value, identity, retHighest);
    }

    /**
     * This function is like `binaryIndex` except that it invokes `iteratee` for
     * `value` and each element of `array` to compute their sort ranking. The
     * iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function binaryIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array ? array.length : 0,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsUndef = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            isDef = computed !== undefined,
            isReflexive = computed === computed;

        if (valIsNaN) {
          var setLow = isReflexive || retHighest;
        } else if (valIsNull) {
          setLow = isReflexive && isDef && (retHighest || computed != null);
        } else if (valIsUndef) {
          setLow = isReflexive && (retHighest || isDef);
        } else if (computed == null) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * A specialized version of `baseCallback` which only supports `this` binding
     * and specifying the number of arguments to provide to `func`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {number} [argCount] The number of arguments to provide to `func`.
     * @returns {Function} Returns the callback.
     */
    function bindCallback(func, thisArg, argCount) {
      if (typeof func != 'function') {
        return identity;
      }
      if (thisArg === undefined) {
        return func;
      }
      switch (argCount) {
        case 1: return function(value) {
          return func.call(thisArg, value);
        };
        case 3: return function(value, index, collection) {
          return func.call(thisArg, value, index, collection);
        };
        case 4: return function(accumulator, value, index, collection) {
          return func.call(thisArg, accumulator, value, index, collection);
        };
        case 5: return function(value, other, key, object, source) {
          return func.call(thisArg, value, other, key, object, source);
        };
      }
      return function() {
        return func.apply(thisArg, arguments);
      };
    }

    /**
     * Creates a clone of the given array buffer.
     *
     * @private
     * @param {ArrayBuffer} buffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function bufferClone(buffer) {
      var result = new ArrayBuffer(buffer.byteLength),
          view = new Uint8Array(result);

      view.set(new Uint8Array(buffer));
      return result;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders) {
      var holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          leftIndex = -1,
          leftLength = partials.length,
          result = Array(leftLength + argsLength);

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        result[holders[argsIndex]] = args[argsIndex];
      }
      while (argsLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array|Object} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders) {
      var holdersIndex = -1,
          holdersLength = holders.length,
          argsIndex = -1,
          argsLength = nativeMax(args.length - holdersLength, 0),
          rightIndex = -1,
          rightLength = partials.length,
          result = Array(argsLength + rightLength);

      while (++argsIndex < argsLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        result[offset + holders[holdersIndex]] = args[argsIndex++];
      }
      return result;
    }

    /**
     * Creates a `_.countBy`, `_.groupBy`, `_.indexBy`, or `_.partition` function.
     *
     * @private
     * @param {Function} setter The function to set keys and values of the accumulator object.
     * @param {Function} [initializer] The function to initialize the accumulator object.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee, thisArg) {
        var result = initializer ? initializer() : {};
        iteratee = getCallback(iteratee, thisArg, 3);

        if (isArray(collection)) {
          var index = -1,
              length = collection.length;

          while (++index < length) {
            var value = collection[index];
            setter(result, value, iteratee(value, index, collection), collection);
          }
        } else {
          baseEach(collection, function(value, key, collection) {
            setter(result, value, iteratee(value, key, collection), collection);
          });
        }
        return result;
      };
    }

    /**
     * Creates a `_.assign`, `_.defaults`, or `_.merge` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return restParam(function(object, sources) {
        var index = -1,
            length = object == null ? 0 : sources.length,
            customizer = length > 2 ? sources[length - 2] : undefined,
            guard = length > 2 ? sources[2] : undefined,
            thisArg = length > 1 ? sources[length - 1] : undefined;

        if (typeof customizer == 'function') {
          customizer = bindCallback(customizer, thisArg, 5);
          length -= 2;
        } else {
          customizer = typeof thisArg == 'function' ? thisArg : undefined;
          length -= (customizer ? 1 : 0);
        }
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        var length = collection ? getLength(collection) : 0;
        if (!isLength(length)) {
          return eachFunc(collection, iteratee);
        }
        var index = fromRight ? length : -1,
            iterable = toObject(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var iterable = toObject(object),
            props = keysFunc(object),
            length = props.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length)) {
          var key = props[index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with the `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to bind.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new bound function.
     */
    function createBindWrapper(func, thisArg) {
      var Ctor = createCtorWrapper(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(thisArg, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a `Set` cache object to optimize linear searches of large arrays.
     *
     * @private
     * @param {Array} [values] The values to cache.
     * @returns {null|Object} Returns the new cache object if `Set` is supported, else `null`.
     */
    function createCache(values) {
      return (nativeCreate && Set) ? new SetCache(values) : null;
    }

    /**
     * Creates a function that produces compound words out of the words in a
     * given string.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        var index = -1,
            array = words(deburr(string)),
            length = array.length,
            result = '';

        while (++index < length) {
          result = callback(result, array[index], index);
        }
        return result;
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtorWrapper(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors.
        // See http://ecma-international.org/ecma-262/6.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a `_.curry` or `_.curryRight` function.
     *
     * @private
     * @param {boolean} flag The curry bit flag.
     * @returns {Function} Returns the new curry function.
     */
    function createCurry(flag) {
      function curryFunc(func, arity, guard) {
        if (guard && isIterateeCall(func, arity, guard)) {
          arity = undefined;
        }
        var result = createWrapper(func, flag, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = curryFunc.placeholder;
        return result;
      }
      return curryFunc;
    }

    /**
     * Creates a `_.defaults` or `_.defaultsDeep` function.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Function} Returns the new defaults function.
     */
    function createDefaults(assigner, customizer) {
      return restParam(function(args) {
        var object = args[0];
        if (object == null) {
          return object;
        }
        args.push(customizer);
        return assigner.apply(undefined, args);
      });
    }

    /**
     * Creates a `_.max` or `_.min` function.
     *
     * @private
     * @param {Function} comparator The function used to compare values.
     * @param {*} exValue The initial extremum value.
     * @returns {Function} Returns the new extremum function.
     */
    function createExtremum(comparator, exValue) {
      return function(collection, iteratee, thisArg) {
        if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
          iteratee = undefined;
        }
        iteratee = getCallback(iteratee, thisArg, 3);
        if (iteratee.length == 1) {
          collection = isArray(collection) ? collection : toIterable(collection);
          var result = arrayExtremum(collection, iteratee, comparator, exValue);
          if (!(collection.length && result === exValue)) {
            return result;
          }
        }
        return baseExtremum(collection, iteratee, comparator, exValue);
      };
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFind(eachFunc, fromRight) {
      return function(collection, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        if (isArray(collection)) {
          var index = baseFindIndex(collection, predicate, fromRight);
          return index > -1 ? collection[index] : undefined;
        }
        return baseFind(collection, predicate, eachFunc);
      };
    }

    /**
     * Creates a `_.findIndex` or `_.findLastIndex` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new find function.
     */
    function createFindIndex(fromRight) {
      return function(array, predicate, thisArg) {
        if (!(array && array.length)) {
          return -1;
        }
        predicate = getCallback(predicate, thisArg, 3);
        return baseFindIndex(array, predicate, fromRight);
      };
    }

    /**
     * Creates a `_.findKey` or `_.findLastKey` function.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new find function.
     */
    function createFindKey(objectFunc) {
      return function(object, predicate, thisArg) {
        predicate = getCallback(predicate, thisArg, 3);
        return baseFind(object, predicate, objectFunc, true);
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return function() {
        var wrapper,
            length = arguments.length,
            index = fromRight ? length : -1,
            leftIndex = 0,
            funcs = Array(length);

        while ((fromRight ? index-- : ++index < length)) {
          var func = funcs[leftIndex++] = arguments[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (!wrapper && LodashWrapper.prototype.thru && getFuncName(func) == 'wrapper') {
            wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? -1 : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) && data[1] == (ARY_FLAG | CURRY_FLAG | PARTIAL_FLAG | REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func)) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value) && value.length >= LARGE_ARRAY_SIZE) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      };
    }

    /**
     * Creates a function for `_.forEach` or `_.forEachRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createForEach(arrayFunc, eachFunc) {
      return function(collection, iteratee, thisArg) {
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee)
          : eachFunc(collection, bindCallback(iteratee, thisArg, 3));
      };
    }

    /**
     * Creates a function for `_.forIn` or `_.forInRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForIn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee, keysIn);
      };
    }

    /**
     * Creates a function for `_.forOwn` or `_.forOwnRight`.
     *
     * @private
     * @param {Function} objectFunc The function to iterate over an object.
     * @returns {Function} Returns the new each function.
     */
    function createForOwn(objectFunc) {
      return function(object, iteratee, thisArg) {
        if (typeof iteratee != 'function' || thisArg !== undefined) {
          iteratee = bindCallback(iteratee, thisArg, 3);
        }
        return objectFunc(object, iteratee);
      };
    }

    /**
     * Creates a function for `_.mapKeys` or `_.mapValues`.
     *
     * @private
     * @param {boolean} [isMapKeys] Specify mapping keys instead of values.
     * @returns {Function} Returns the new map function.
     */
    function createObjectMapper(isMapKeys) {
      return function(object, iteratee, thisArg) {
        var result = {};
        iteratee = getCallback(iteratee, thisArg, 3);

        baseForOwn(object, function(value, key, object) {
          var mapped = iteratee(value, key, object);
          key = isMapKeys ? mapped : key;
          value = isMapKeys ? value : mapped;
          result[key] = value;
        });
        return result;
      };
    }

    /**
     * Creates a function for `_.padLeft` or `_.padRight`.
     *
     * @private
     * @param {boolean} [fromRight] Specify padding from the right.
     * @returns {Function} Returns the new pad function.
     */
    function createPadDir(fromRight) {
      return function(string, length, chars) {
        string = baseToString(string);
        return (fromRight ? string : '') + createPadding(string, length, chars) + (fromRight ? '' : string);
      };
    }

    /**
     * Creates a `_.partial` or `_.partialRight` function.
     *
     * @private
     * @param {boolean} flag The partial bit flag.
     * @returns {Function} Returns the new partial function.
     */
    function createPartial(flag) {
      var partialFunc = restParam(function(func, partials) {
        var holders = replaceHolders(partials, partialFunc.placeholder);
        return createWrapper(func, flag, undefined, partials, holders);
      });
      return partialFunc;
    }

    /**
     * Creates a function for `_.reduce` or `_.reduceRight`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over an array.
     * @param {Function} eachFunc The function to iterate over a collection.
     * @returns {Function} Returns the new each function.
     */
    function createReduce(arrayFunc, eachFunc) {
      return function(collection, iteratee, accumulator, thisArg) {
        var initFromArray = arguments.length < 3;
        return (typeof iteratee == 'function' && thisArg === undefined && isArray(collection))
          ? arrayFunc(collection, iteratee, accumulator, initFromArray)
          : baseReduce(collection, getCallback(iteratee, thisArg, 4), accumulator, initFromArray, eachFunc);
      };
    }

    /**
     * Creates a function that wraps `func` and invokes it with optional `this`
     * binding of, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybridWrapper(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & ARY_FLAG,
          isBind = bitmask & BIND_FLAG,
          isBindKey = bitmask & BIND_KEY_FLAG,
          isCurry = bitmask & CURRY_FLAG,
          isCurryBound = bitmask & CURRY_BOUND_FLAG,
          isCurryRight = bitmask & CURRY_RIGHT_FLAG,
          Ctor = isBindKey ? undefined : createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it to other functions.
        var length = arguments.length,
            index = length,
            args = Array(length);

        while (index--) {
          args[index] = arguments[index];
        }
        if (partials) {
          args = composeArgs(args, partials, holders);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight);
        }
        if (isCurry || isCurryRight) {
          var placeholder = wrapper.placeholder,
              argsHolders = replaceHolders(args, placeholder);

          length -= argsHolders.length;
          if (length < arity) {
            var newArgPos = argPos ? arrayCopy(argPos) : undefined,
                newArity = nativeMax(arity - length, 0),
                newsHolders = isCurry ? argsHolders : undefined,
                newHoldersRight = isCurry ? undefined : argsHolders,
                newPartials = isCurry ? args : undefined,
                newPartialsRight = isCurry ? undefined : args;

            bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
            bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);

            if (!isCurryBound) {
              bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
            }
            var newData = [func, bitmask, thisArg, newPartials, newsHolders, newPartialsRight, newHoldersRight, newArgPos, ary, newArity],
                result = createHybridWrapper.apply(undefined, newData);

            if (isLaziable(func)) {
              setData(result, newData);
            }
            result.placeholder = placeholder;
            return result;
          }
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        if (argPos) {
          args = reorder(args, argPos);
        }
        if (isAry && ary < args.length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtorWrapper(func);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates the padding required for `string` based on the given `length`.
     * The `chars` string is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {string} string The string to create padding for.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the pad for `string`.
     */
    function createPadding(string, length, chars) {
      var strLength = string.length;
      length = +length;

      if (strLength >= length || !nativeIsFinite(length)) {
        return '';
      }
      var padLength = length - strLength;
      chars = chars == null ? ' ' : (chars + '');
      return repeat(chars, nativeCeil(padLength / chars.length)).slice(0, padLength);
    }

    /**
     * Creates a function that wraps `func` and invokes it with the optional `this`
     * binding of `thisArg` and the `partials` prepended to those provided to
     * the wrapper.
     *
     * @private
     * @param {Function} func The function to partially apply arguments to.
     * @param {number} bitmask The bitmask of flags. See `createWrapper` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to the new function.
     * @returns {Function} Returns the new bound function.
     */
    function createPartialWrapper(func, bitmask, thisArg, partials) {
      var isBind = bitmask & BIND_FLAG,
          Ctor = createCtorWrapper(func);

      function wrapper() {
        // Avoid `arguments` object use disqualifying optimizations by
        // converting it to an array before providing it `func`.
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength);

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.ceil`, `_.floor`, or `_.round` function.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        precision = precision === undefined ? 0 : (+precision || 0);
        if (precision) {
          precision = pow(10, precision);
          return func(number * precision) / precision;
        }
        return func(number);
      };
    }

    /**
     * Creates a `_.sortedIndex` or `_.sortedLastIndex` function.
     *
     * @private
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {Function} Returns the new index function.
     */
    function createSortedIndex(retHighest) {
      return function(array, value, iteratee, thisArg) {
        var callback = getCallback(iteratee);
        return (iteratee == null && callback === baseCallback)
          ? binaryIndex(array, value, retHighest)
          : binaryIndexBy(array, value, callback(iteratee, thisArg, 1), retHighest);
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to reference.
     * @param {number} bitmask The bitmask of flags.
     *  The bitmask may be composed of the following flags:
     *     1 - `_.bind`
     *     2 - `_.bindKey`
     *     4 - `_.curry` or `_.curryRight` of a bound function
     *     8 - `_.curry`
     *    16 - `_.curryRight`
     *    32 - `_.partial`
     *    64 - `_.partialRight`
     *   128 - `_.rearg`
     *   256 - `_.ary`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrapper(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      length -= (holders ? holders.length : 0);
      if (bitmask & PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func),
          newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

      if (data) {
        mergeData(newData, data);
        bitmask = newData[1];
        arity = newData[9];
      }
      newData[9] = arity == null
        ? (isBindKey ? 0 : func.length)
        : (nativeMax(arity - length, 0) || 0);

      if (bitmask == BIND_FLAG) {
        var result = createBindWrapper(newData[0], newData[2]);
      } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !newData[4].length) {
        result = createPartialWrapper.apply(undefined, newData);
      } else {
        result = createHybridWrapper.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setter(result, newData);
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing arrays.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var index = -1,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isLoose && othLength > arrLength)) {
        return false;
      }
      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index],
            result = customizer ? customizer(isLoose ? othValue : arrValue, isLoose ? arrValue : othValue, index) : undefined;

        if (result !== undefined) {
          if (result) {
            continue;
          }
          return false;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (isLoose) {
          if (!arraySome(other, function(othValue) {
                return arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB);
              })) {
            return false;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, isLoose, stackA, stackB))) {
          return false;
        }
      }
      return true;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag) {
      switch (tag) {
        case boolTag:
        case dateTag:
          // Coerce dates and booleans to numbers, dates to milliseconds and booleans
          // to `1` or `0` treating invalid dates coerced to `NaN` as not equal.
          return +object == +other;

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case numberTag:
          // Treat `NaN` vs. `NaN` as equal.
          return (object != +object)
            ? other != +other
            : object == +other;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings primitives and string
          // objects as equal. See https://es5.github.io/#x15.10.6.4 for more details.
          return object == (other + '');
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Function} [customizer] The function to customize comparing values.
     * @param {boolean} [isLoose] Specify performing partial comparisons.
     * @param {Array} [stackA] Tracks traversed `value` objects.
     * @param {Array} [stackB] Tracks traversed `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, equalFunc, customizer, isLoose, stackA, stackB) {
      var objProps = keys(object),
          objLength = objProps.length,
          othProps = keys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isLoose) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isLoose ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      var skipCtor = isLoose;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key],
            result = customizer ? customizer(isLoose ? othValue : objValue, isLoose? objValue : othValue, key) : undefined;

        // Recursively compare objects (susceptible to call stack limits).
        if (!(result === undefined ? equalFunc(objValue, othValue, customizer, isLoose, stackA, stackB) : result)) {
          return false;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (!skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Gets the appropriate "callback" function. If the `_.callback` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseCallback` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function} Returns the chosen function or its result.
     */
    function getCallback(func, thisArg, argCount) {
      var result = lodash.callback || callback;
      result = result === callback ? baseCallback : result;
      return argCount ? result(func, thisArg, argCount) : result;
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name,
          array = realNames[result],
          length = array ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the appropriate "indexOf" function. If the `_.indexOf` method is
     * customized this function returns the custom method, otherwise it returns
     * the `baseIndexOf` function. If arguments are provided the chosen function
     * is invoked with them and its result is returned.
     *
     * @private
     * @returns {Function|number} Returns the chosen function or its result.
     */
    function getIndexOf(collection, target, fromIndex) {
      var result = lodash.indexOf || indexOf;
      result = result === indexOf ? baseIndexOf : result;
      return collection ? result(collection, target, fromIndex) : result;
    }

    /**
     * Gets the "length" property value of `object`.
     *
     * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
     * that affects Safari on at least iOS 8.1-8.3 ARM64.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {*} Returns the "length" value.
     */
    var getLength = baseProperty('length');

    /**
     * Gets the propery names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = pairs(object),
          length = result.length;

      while (length--) {
        result[length][2] = isStrictComparable(result[length][1]);
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = object == null ? undefined : object[key];
      return isNative(value) ? value : undefined;
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add array properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      var Ctor = object.constructor;
      if (!(typeof Ctor == 'function' && Ctor instanceof Ctor)) {
        Ctor = Object;
      }
      return new Ctor;
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return bufferClone(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          var buffer = object.buffer;
          return new Ctor(isDeep ? bufferClone(buffer) : buffer, object.byteOffset, object.length);

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          var result = new Ctor(object.source, reFlags.exec(object));
          result.lastIndex = object.lastIndex;
      }
      return result;
    }

    /**
     * Invokes the method at `path` on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function invokePath(object, path, args) {
      if (object != null && !isKey(path, object)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        path = last(path);
      }
      var func = object == null ? object : object[path];
      return func == null ? undefined : func.apply(object, args);
    }

    /**
     * Checks if `value` is array-like.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     */
    function isArrayLike(value) {
      return value != null && isLength(getLength(value));
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
      length = length == null ? MAX_SAFE_INTEGER : length;
      return value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the provided arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
          ? (isArrayLike(object) && isIndex(index, object.length))
          : (type == 'string' && index in object)) {
        var other = object[index];
        return value === value ? (value === other) : (other !== other);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      var type = typeof value;
      if ((type == 'string' && reIsPlainProp.test(value)) || type == 'number') {
        return true;
      }
      if (isArray(value)) {
        return false;
      }
      var result = !reIsDeepProp.test(value);
      return result || (object != null && value in toObject(object));
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart, else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func);
      if (!(funcName in LazyWrapper.prototype)) {
        return false;
      }
      var other = lodash[funcName];
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers required to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and `_.rearg`
     * augment function arguments, making the order in which they are executed important,
     * preventing the merging of metadata. However, we make an exception for a safe
     * common case where curried functions have `_.ary` and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < ARY_FLAG;

      var isCombo =
        (srcBitmask == ARY_FLAG && bitmask == CURRY_FLAG) ||
        (srcBitmask == ARY_FLAG && bitmask == REARG_FLAG && data[7].length <= source[8]) ||
        (srcBitmask == (ARY_FLAG | REARG_FLAG) && bitmask == CURRY_FLAG);

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= (bitmask & BIND_FLAG) ? 0 : CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : arrayCopy(value);
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : arrayCopy(source[4]);
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : arrayCopy(value);
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : arrayCopy(source[6]);
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = arrayCopy(value);
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use.
     *
     * @private
     * @param {*} objectValue The destination object property value.
     * @param {*} sourceValue The source object property value.
     * @returns {*} Returns the value to assign to the destination object.
     */
    function mergeDefaults(objectValue, sourceValue) {
      return objectValue === undefined ? sourceValue : merge(objectValue, sourceValue, mergeDefaults);
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties specified
     * by `props`.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} props The property names to pick.
     * @returns {Object} Returns the new object.
     */
    function pickByArray(object, props) {
      object = toObject(object);

      var index = -1,
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index];
        if (key in object) {
          result[key] = object[key];
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.pick` which picks `object` properties `predicate`
     * returns truthy for.
     *
     * @private
     * @param {Object} object The source object.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Object} Returns the new object.
     */
    function pickByCallback(object, predicate) {
      var result = {};
      baseForIn(object, function(value, key, object) {
        if (predicate(value, key, object)) {
          result[key] = value;
        }
      });
      return result;
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = arrayCopy(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity function
     * to avoid garbage collection pauses in V8. See [V8 issue 2070](https://code.google.com/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = (function() {
      var count = 0,
          lastCalled = 0;

      return function(key, value) {
        var stamp = now(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return key;
          }
        } else {
          count = 0;
        }
        return baseSetData(key, value);
      };
    }());

    /**
     * A fallback implementation of `Object.keys` which creates an array of the
     * own enumerable property names of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function shimKeys(object) {
      var props = keysIn(object),
          propsLength = props.length,
          length = propsLength && object.length;

      var allowIndexes = !!length && isLength(length) &&
        (isArray(object) || isArguments(object));

      var index = -1,
          result = [];

      while (++index < propsLength) {
        var key = props[index];
        if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to an array-like object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array|Object} Returns the array-like object.
     */
    function toIterable(value) {
      if (value == null) {
        return [];
      }
      if (!isArrayLike(value)) {
        return values(value);
      }
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to an object if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Object} Returns the object.
     */
    function toObject(value) {
      return isObject(value) ? value : Object(value);
    }

    /**
     * Converts `value` to property path array if it's not one.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {Array} Returns the property path array.
     */
    function toPath(value) {
      if (isArray(value)) {
        return value;
      }
      var result = [];
      baseToString(value).replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      return wrapper instanceof LazyWrapper
        ? wrapper.clone()
        : new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__, arrayCopy(wrapper.__actions__));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `collection` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new array containing chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size == null) {
        size = 1;
      } else {
        size = nativeMax(nativeFloor(size) || 1, 1);
      }
      var index = 0,
          length = array ? array.length : 0,
          resIndex = -1,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[++resIndex] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array ? array.length : 0,
          resIndex = -1,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[++resIndex] = value;
        }
      }
      return result;
    }

    /**
     * Creates an array of unique `array` values not included in the other
     * provided arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The arrays of values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.difference([1, 2, 3], [4, 2]);
     * // => [1, 3]
     */
    var difference = restParam(function(array, values) {
      return (isObjectLike(array) && isArrayLike(array))
        ? baseDifference(array, baseFlatten(values, false, true))
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that match the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [1]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active', false), 'user');
     * // => ['barney']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropRightWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.dropWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.dropWhile(users, 'active', false), 'user');
     * // => ['pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.dropWhile(users, 'active'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8], '*', 1, 2);
     * // => [4, '*', 8]
     */
    function fill(array, value, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(chr) {
     *   return chr.user == 'barney';
     * });
     * // => 0
     *
     * // using the `_.matches` callback shorthand
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findIndex(users, 'active', false);
     * // => 0
     *
     * // using the `_.property` callback shorthand
     * _.findIndex(users, 'active');
     * // => 2
     */
    var findIndex = createFindIndex();

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(chr) {
     *   return chr.user == 'pebbles';
     * });
     * // => 2
     *
     * // using the `_.matches` callback shorthand
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastIndex(users, 'active', false);
     * // => 2
     *
     * // using the `_.property` callback shorthand
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    var findLastIndex = createFindIndex(true);

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias head
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.first([1, 2, 3]);
     * // => 1
     *
     * _.first([]);
     * // => undefined
     */
    function first(array) {
      return array ? array[0] : undefined;
    }

    /**
     * Flattens a nested array. If `isDeep` is `true` the array is recursively
     * flattened, otherwise it is only flattened a single level.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {boolean} [isDeep] Specify a deep flatten.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, 3, [4]]]);
     * // => [1, 2, 3, [4]]
     *
     * // using `isDeep`
     * _.flatten([1, [2, 3, [4]]], true);
     * // => [1, 2, 3, 4]
     */
    function flatten(array, isDeep, guard) {
      var length = array ? array.length : 0;
      if (guard && isIterateeCall(array, isDeep, guard)) {
        isDeep = false;
      }
      return length ? baseFlatten(array, isDeep) : [];
    }

    /**
     * Recursively flattens a nested array.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to recursively flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, 3, [4]]]);
     * // => [1, 2, 3, 4]
     */
    function flattenDeep(array) {
      var length = array ? array.length : 0;
      return length ? baseFlatten(array, true) : [];
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `array`. If `array` is sorted providing `true` for `fromIndex`
     * performs a faster binary search.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=0] The index to search from or `true`
     *  to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // using `fromIndex`
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     *
     * // performing a binary search
     * _.indexOf([1, 1, 2, 2], 2, true);
     * // => 2
     */
    function indexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      if (typeof fromIndex == 'number') {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : fromIndex;
      } else if (fromIndex) {
        var index = binaryIndex(array, value);
        if (index < length &&
            (value === value ? (value === array[index]) : (array[index] !== array[index]))) {
          return index;
        }
        return -1;
      }
      return baseIndexOf(array, value, fromIndex || 0);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      return dropRight(array, 1);
    }

    /**
     * Creates an array of unique values that are included in all of the provided
     * arrays using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of shared values.
     * @example
     * _.intersection([1, 2], [4, 2], [2, 1]);
     * // => [2]
     */
    var intersection = restParam(function(arrays) {
      var othLength = arrays.length,
          othIndex = othLength,
          caches = Array(length),
          indexOf = getIndexOf(),
          isCommon = indexOf == baseIndexOf,
          result = [];

      while (othIndex--) {
        var value = arrays[othIndex] = isArrayLike(value = arrays[othIndex]) ? value : [];
        caches[othIndex] = (isCommon && value.length >= 120) ? createCache(othIndex && value) : null;
      }
      var array = arrays[0],
          index = -1,
          length = array ? array.length : 0,
          seen = caches[0];

      outer:
      while (++index < length) {
        value = array[index];
        if ((seen ? cacheIndexOf(seen, value) : indexOf(result, value, 0)) < 0) {
          var othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if ((cache ? cacheIndexOf(cache, value) : indexOf(arrays[othIndex], value, 0)) < 0) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(value);
          }
          result.push(value);
        }
      }
      return result;
    });

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array ? array.length : 0;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to search.
     * @param {*} value The value to search for.
     * @param {boolean|number} [fromIndex=array.length-1] The index to search from
     *  or `true` to perform a binary search on a sorted array.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // using `fromIndex`
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     *
     * // performing a binary search
     * _.lastIndexOf([1, 1, 2, 2], 2, true);
     * // => 3
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array ? array.length : 0;
      if (!length) {
        return -1;
      }
      var index = length;
      if (typeof fromIndex == 'number') {
        index = (fromIndex < 0 ? nativeMax(length + fromIndex, 0) : nativeMin(fromIndex || 0, length - 1)) + 1;
      } else if (fromIndex) {
        index = binaryIndex(array, value, true) - 1;
        var other = array[index];
        if (value === value ? (value === other) : (other !== other)) {
          return index;
        }
        return -1;
      }
      if (value !== value) {
        return indexOfNaN(array, index, true);
      }
      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }
      return -1;
    }

    /**
     * Removes all provided values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3, 1, 2, 3];
     *
     * _.pull(array, 2, 3);
     * console.log(array);
     * // => [1, 1]
     */
    function pull() {
      var args = arguments,
          array = args[0];

      if (!(array && array.length)) {
        return array;
      }
      var index = 0,
          indexOf = getIndexOf(),
          length = args.length;

      while (++index < length) {
        var fromIndex = 0,
            value = args[index];

        while ((fromIndex = indexOf(array, value, fromIndex)) > -1) {
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * Removes elements from `array` corresponding to the given indexes and returns
     * an array of the removed elements. Indexes may be specified as an array of
     * indexes or as individual arguments.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [5, 10, 15, 20];
     * var evens = _.pullAt(array, 1, 3);
     *
     * console.log(array);
     * // => [5, 15]
     *
     * console.log(evens);
     * // => [10, 20]
     */
    var pullAt = restParam(function(array, indexes) {
      indexes = baseFlatten(indexes);

      var result = baseAt(array, indexes);
      basePullAt(array, indexes.sort(baseCompareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate, thisArg) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getCallback(predicate, thisArg, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @alias tail
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.rest([1, 2, 3]);
     * // => [2, 3]
     */
    function rest(array) {
      return drop(array, 1);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of `Array#slice` to support node
     * lists in IE < 9 and to ensure dense arrays are returned.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value` should
     * be inserted into `array` in order to maintain its sort order. If an iteratee
     * function is provided it is invoked for `value` and each element of `array`
     * to compute their sort ranking. The iteratee is bound to `thisArg` and
     * invoked with one argument; (value).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     *
     * _.sortedIndex([4, 4, 5, 5], 5);
     * // => 2
     *
     * var dict = { 'data': { 'thirty': 30, 'forty': 40, 'fifty': 50 } };
     *
     * // using an iteratee function
     * _.sortedIndex(['thirty', 'fifty'], 'forty', function(word) {
     *   return this.data[word];
     * }, dict);
     * // => 1
     *
     * // using the `_.property` callback shorthand
     * _.sortedIndex([{ 'x': 30 }, { 'x': 50 }], { 'x': 40 }, 'x');
     * // => 1
     */
    var sortedIndex = createSortedIndex();

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 4, 5, 5], 5);
     * // => 4
     */
    var sortedLastIndex = createSortedIndex(true);

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (guard ? isIterateeCall(array, n, guard) : n == null) {
        n = 1;
      }
      n = length - (+n || 0);
      return baseSlice(array, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is bound to `thisArg`
     * and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRightWhile([1, 2, 3], function(n) {
     *   return n > 1;
     * });
     * // => [2, 3]
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeRightWhile(users, { 'user': 'pebbles', 'active': false }), 'user');
     * // => ['pebbles']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active', false), 'user');
     * // => ['fred', 'pebbles']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeRightWhile(users, 'active'), 'user');
     * // => []
     */
    function takeRightWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is bound to
     * `thisArg` and invoked with three arguments: (value, index, array).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeWhile([1, 2, 3], function(n) {
     *   return n < 3;
     * });
     * // => [1, 2]
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false},
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.takeWhile(users, { 'user': 'barney', 'active': false }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.takeWhile(users, 'active', false), 'user');
     * // => ['barney', 'fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.takeWhile(users, 'active'), 'user');
     * // => []
     */
    function takeWhile(array, predicate, thisArg) {
      return (array && array.length)
        ? baseWhile(array, getCallback(predicate, thisArg, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all of the provided arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([1, 2], [4, 2], [2, 1]);
     * // => [1, 2, 4]
     */
    var union = restParam(function(arrays) {
      return baseUniq(baseFlatten(arrays, false, true));
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurence of each element
     * is kept. Providing `true` for `isSorted` performs a faster search algorithm
     * for sorted arrays. If an iteratee function is provided it is invoked for
     * each element in the array to generate the criterion by which uniqueness
     * is computed. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, array).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias unique
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {boolean} [isSorted] Specify the array is sorted.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new duplicate-value-free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     *
     * // using `isSorted`
     * _.uniq([1, 1, 2], true);
     * // => [1, 2]
     *
     * // using an iteratee function
     * _.uniq([1, 2.5, 1.5, 2], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => [1, 2.5]
     *
     * // using the `_.property` callback shorthand
     * _.uniq([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniq(array, isSorted, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      if (isSorted != null && typeof isSorted != 'boolean') {
        thisArg = iteratee;
        iteratee = isIterateeCall(array, isSorted, thisArg) ? undefined : isSorted;
        isSorted = false;
      }
      var callback = getCallback();
      if (!(iteratee == null && callback === baseCallback)) {
        iteratee = callback(iteratee, thisArg, 3);
      }
      return (isSorted && getIndexOf() == baseIndexOf)
        ? sortedUniq(array, iteratee)
        : baseUniq(array, iteratee);
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     *
     * _.unzip(zipped);
     * // => [['fred', 'barney'], [30, 40], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var index = -1,
          length = 0;

      array = arrayFilter(array, function(group) {
        if (isArrayLike(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      var result = Array(length);
      while (++index < length) {
        result[index] = arrayMap(array, baseProperty(index));
      }
      return result;
    }

    /**
     * This method is like `_.unzip` except that it accepts an iteratee to specify
     * how regrouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee] The function to combine regrouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee, thisArg) {
      var length = array ? array.length : 0;
      if (!length) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      iteratee = bindCallback(iteratee, thisArg, 4);
      return arrayMap(result, function(group) {
        return arrayReduce(group, iteratee, undefined, true);
      });
    }

    /**
     * Creates an array excluding all provided values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {Array} array The array to filter.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.without([1, 2, 1, 3], 1, 2);
     * // => [3]
     */
    var without = restParam(function(array, values) {
      return isArrayLike(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the provided arrays.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of values.
     * @example
     *
     * _.xor([1, 2], [4, 2]);
     * // => [1, 4]
     */
    function xor() {
      var index = -1,
          length = arguments.length;

      while (++index < length) {
        var array = arguments[index];
        if (isArrayLike(array)) {
          var result = result
            ? arrayPush(baseDifference(result, array), baseDifference(array, result))
            : array;
        }
      }
      return result ? baseUniq(result) : [];
    }

    /**
     * Creates an array of grouped elements, the first of which contains the first
     * elements of the given arrays, the second of which contains the second elements
     * of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['fred', 'barney'], [30, 40], [true, false]);
     * // => [['fred', 30, true], ['barney', 40, false]]
     */
    var zip = restParam(unzip);

    /**
     * The inverse of `_.pairs`; this method returns an object composed from arrays
     * of property names and values. Provide either a single two dimensional array,
     * e.g. `[[key1, value1], [key2, value2]]` or two arrays, one of property names
     * and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @alias object
     * @category Array
     * @param {Array} props The property names.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject([['fred', 30], ['barney', 40]]);
     * // => { 'fred': 30, 'barney': 40 }
     *
     * _.zipObject(['fred', 'barney'], [30, 40]);
     * // => { 'fred': 30, 'barney': 40 }
     */
    function zipObject(props, values) {
      var index = -1,
          length = props ? props.length : 0,
          result = {};

      if (length && !values && !isArray(props[0])) {
        values = [];
      }
      while (++index < length) {
        var key = props[index];
        if (values) {
          result[key] = values[index];
        } else if (key) {
          result[key[0]] = key[1];
        }
      }
      return result;
    }

    /**
     * This method is like `_.zip` except that it accepts an iteratee to specify
     * how grouped values should be combined. The `iteratee` is bound to `thisArg`
     * and invoked with four arguments: (accumulator, value, index, group).
     *
     * @static
     * @memberOf _
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee] The function to combine grouped values.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], _.add);
     * // => [111, 222]
     */
    var zipWith = restParam(function(arrays) {
      var length = arrays.length,
          iteratee = length > 2 ? arrays[length - 2] : undefined,
          thisArg = length > 1 ? arrays[length - 1] : undefined;

      if (length > 2 && typeof iteratee == 'function') {
        length -= 2;
      } else {
        iteratee = (length > 1 && typeof thisArg == 'function') ? (--length, thisArg) : undefined;
        thisArg = undefined;
      }
      arrays.length = length;
      return unzipWith(arrays, iteratee, thisArg);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object that wraps `value` with explicit method
     * chaining enabled.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _.chain(users)
     *   .sortBy('age')
     *   .map(function(chr) {
     *     return chr.user + ' is ' + chr.age;
     *   })
     *   .first()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor is
     * bound to `thisArg` and invoked with one argument; (value). The purpose of
     * this method is to "tap into" a method chain in order to perform operations
     * on intermediate results within the chain.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor, thisArg) {
      interceptor.call(thisArg, value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     *
     * @static
     * @memberOf _
     * @category Chain
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @param {*} [thisArg] The `this` binding of `interceptor`.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor, thisArg) {
      return interceptor.call(thisArg, value);
    }

    /**
     * Enables explicit method chaining on the wrapper object.
     *
     * @name chain
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // without explicit chaining
     * _(users).first();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // with explicit chaining
     * _(users).chain()
     *   .first()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chained sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Creates a new array joining a wrapped array with any additional arrays
     * and/or values.
     *
     * @name concat
     * @memberOf _
     * @category Chain
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var wrapped = _(array).concat(2, [3], [[4]]);
     *
     * console.log(wrapped.value());
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    var wrapperConcat = restParam(function(values) {
      values = baseFlatten(values);
      return this.thru(function(array) {
        return arrayConcat(isArray(array) ? array : [toObject(array)], values);
      });
    });

    /**
     * Creates a clone of the chained sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).map(function(value) {
     *   return Math.pow(value, 2);
     * });
     *
     * var other = [3, 4];
     * var otherWrapped = wrapped.plant(other);
     *
     * otherWrapped.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * Reverses the wrapped array so the first element becomes the last, the
     * second element becomes the second to last, and so on.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @category Chain
     * @returns {Object} Returns the new reversed `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;

      var interceptor = function(value) {
        return (wrapped && wrapped.__dir__ < 0) ? value : value.reverse();
      };
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(interceptor);
    }

    /**
     * Produces the result of coercing the unwrapped value to a string.
     *
     * @name toString
     * @memberOf _
     * @category Chain
     * @returns {string} Returns the coerced string value.
     * @example
     *
     * _([1, 2, 3]).toString();
     * // => '1,2,3'
     */
    function wrapperToString() {
      return (this.value() + '');
    }

    /**
     * Executes the chained sequence to extract the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @alias run, toJSON, valueOf
     * @category Chain
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements corresponding to the given keys, or indexes,
     * of `collection`. Keys may be specified as individual arguments or as arrays
     * of keys.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(number|number[]|string|string[])} [props] The property names
     *  or indexes of elements to pick, specified individually or in arrays.
     * @returns {Array} Returns the new array of picked elements.
     * @example
     *
     * _.at(['a', 'b', 'c'], [0, 2]);
     * // => ['a', 'c']
     *
     * _.at(['barney', 'fred', 'pebbles'], 0, 2);
     * // => ['barney', 'pebbles']
     */
    var at = restParam(function(collection, props) {
      return baseAt(collection, baseFlatten(props));
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the number of times the key was returned by `iteratee`.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy([4.3, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': 1, '6': 2 }
     *
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      hasOwnProperty.call(result, key) ? ++result[key] : (result[key] = 1);
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * The predicate is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias all
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'active': false },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.every(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias select
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.filter([4, 5, 6], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [4, 6]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.filter(users, { 'age': 36, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.filter(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.filter(users, 'active'), 'user');
     * // => ['barney']
     */
    function filter(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, predicate);
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is bound to `thisArg` and
     * invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias detect
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.result(_.find(users, function(chr) {
     *   return chr.age < 40;
     * }), 'user');
     * // => 'barney'
     *
     * // using the `_.matches` callback shorthand
     * _.result(_.find(users, { 'age': 1, 'active': true }), 'user');
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.result(_.find(users, 'active', false), 'user');
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.result(_.find(users, 'active'), 'user');
     * // => 'barney'
     */
    var find = createFind(baseEach);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(baseEachRight, true);

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning the first element that has equivalent property
     * values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.result(_.findWhere(users, { 'age': 36, 'active': true }), 'user');
     * // => 'barney'
     *
     * _.result(_.findWhere(users, { 'age': 40, 'active': false }), 'user');
     * // => 'fred'
     */
    function findWhere(collection, source) {
      return find(collection, baseMatches(source));
    }

    /**
     * Iterates over elements of `collection` invoking `iteratee` for each element.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection). Iteratee functions may exit iteration early
     * by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length" property
     * are iterated like arrays. To avoid this behavior `_.forIn` or `_.forOwn`
     * may be used for object iteration.
     *
     * @static
     * @memberOf _
     * @alias each
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEach(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from left to right and returns the array
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(n, key) {
     *   console.log(n, key);
     * });
     * // => logs each value-key pair and returns the object (iteration order is not guaranteed)
     */
    var forEach = createForEach(arrayEach, baseEach);

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias eachRight
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array|Object|string} Returns `collection`.
     * @example
     *
     * _([1, 2]).forEachRight(function(n) {
     *   console.log(n);
     * }).value();
     * // => logs each value from right to left and returns the array
     */
    var forEachRight = createForEach(arrayEachRight, baseEachRight);

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is an array of the elements responsible for generating the key.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return Math.floor(n);
     * });
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * _.groupBy([4.2, 6.1, 6.4], function(n) {
     *   return this.floor(n);
     * }, Math);
     * // => { '4': [4.2], '6': [6.1, 6.4] }
     *
     * // using the `_.property` callback shorthand
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        result[key] = [value];
      }
    });

    /**
     * Checks if `value` is in `collection` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it is used as the offset
     * from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @alias contains, include
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {*} target The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {boolean} Returns `true` if a matching element is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'user': 'fred', 'age': 40 }, 'fred');
     * // => true
     *
     * _.includes('pebbles', 'eb');
     * // => true
     */
    function includes(collection, target, fromIndex, guard) {
      var length = collection ? getLength(collection) : 0;
      if (!isLength(length)) {
        collection = values(collection);
        length = collection.length;
      }
      if (typeof fromIndex != 'number' || (guard && isIterateeCall(target, fromIndex, guard))) {
        fromIndex = 0;
      } else {
        fromIndex = fromIndex < 0 ? nativeMax(length + fromIndex, 0) : (fromIndex || 0);
      }
      return (typeof collection == 'string' || !isArray(collection) && isString(collection))
        ? (fromIndex <= length && collection.indexOf(target, fromIndex) > -1)
        : (!!length && getIndexOf(collection, target, fromIndex) > -1);
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` through `iteratee`. The corresponding value
     * of each key is the last element responsible for generating the key. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var keyData = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.indexBy(keyData, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return String.fromCharCode(object.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.indexBy(keyData, function(object) {
     *   return this.fromCharCode(object.code);
     * }, String);
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     */
    var indexBy = createAggregator(function(result, value, key) {
      result[key] = value;
    });

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `methodName` is a function it is
     * invoked for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invoke([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invoke([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invoke = restParam(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          isProp = isKey(path),
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        var func = isFunc ? path : ((isProp && value != null) ? value[path] : undefined);
        result[++index] = func ? func.apply(value, args) : invokePath(value, path, args);
      });
      return result;
    });

    /**
     * Creates an array of values by running each element in `collection` through
     * `iteratee`. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `callback`, `chunk`, `clone`, `create`, `curry`, `curryRight`,
     * `drop`, `dropRight`, `every`, `fill`, `flatten`, `invert`, `max`, `min`,
     * `parseInt`, `slice`, `sortBy`, `take`, `takeRight`, `template`, `trim`,
     * `trimLeft`, `trimRight`, `trunc`, `random`, `range`, `sample`, `some`,
     * `sum`, `uniq`, and `words`
     *
     * @static
     * @memberOf _
     * @alias collect
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function timesThree(n) {
     *   return n * 3;
     * }
     *
     * _.map([1, 2], timesThree);
     * // => [3, 6]
     *
     * _.map({ 'a': 1, 'b': 2 }, timesThree);
     * // => [3, 6] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee, thisArg) {
      var func = isArray(collection) ? arrayMap : baseMap;
      iteratee = getCallback(iteratee, thisArg, 3);
      return func(collection, iteratee);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, while the second of which
     * contains elements `predicate` returns falsey for. The predicate is bound
     * to `thisArg` and invoked with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * _.partition([1, 2, 3], function(n) {
     *   return n % 2;
     * });
     * // => [[1, 3], [2]]
     *
     * _.partition([1.2, 2.3, 3.4], function(n) {
     *   return this.floor(n) % 2;
     * }, Math);
     * // => [[1.2, 3.4], [2.3]]
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * var mapper = function(array) {
     *   return _.pluck(array, 'user');
     * };
     *
     * // using the `_.matches` callback shorthand
     * _.map(_.partition(users, { 'age': 1, 'active': false }), mapper);
     * // => [['pebbles'], ['barney', 'fred']]
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.map(_.partition(users, 'active', false), mapper);
     * // => [['barney', 'pebbles'], ['fred']]
     *
     * // using the `_.property` callback shorthand
     * _.map(_.partition(users, 'active'), mapper);
     * // => [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Gets the property value of `path` from all elements in `collection`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Array|string} path The path of the property to pluck.
     * @returns {Array} Returns the property values.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.pluck(users, 'user');
     * // => ['barney', 'fred']
     *
     * var userIndex = _.indexBy(users, 'user');
     * _.pluck(userIndex, 'age');
     * // => [36, 40] (iteration order is not guaranteed)
     */
    function pluck(collection, path) {
      return map(collection, property(path));
    }

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` through `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not provided the first element of `collection` is used as the initial
     * value. The `iteratee` is bound to `thisArg` and invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `sortByAll`,
     * and `sortByOrder`
     *
     * @static
     * @memberOf _
     * @alias foldl, inject
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.reduce([1, 2], function(total, n) {
     *   return total + n;
     * });
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     *   return result;
     * }, {});
     * // => { 'a': 3, 'b': 6 } (iteration order is not guaranteed)
     */
    var reduce = createReduce(arrayReduce, baseEach);

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @alias foldr
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    var reduceRight = createReduce(arrayReduceRight, baseEachRight);

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * _.reject([1, 2, 3, 4], function(n) {
     *   return n % 2 == 0;
     * });
     * // => [1, 3]
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.pluck(_.reject(users, { 'age': 40, 'active': true }), 'user');
     * // => ['barney']
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.pluck(_.reject(users, 'active', false), 'user');
     * // => ['fred']
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.reject(users, 'active'), 'user');
     * // => ['barney']
     */
    function reject(collection, predicate, thisArg) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      predicate = getCallback(predicate, thisArg, 3);
      return func(collection, function(value, index, collection) {
        return !predicate(value, index, collection);
      });
    }

    /**
     * Gets a random element or `n` random elements from a collection.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to sample.
     * @param {number} [n] The number of elements to sample.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {*} Returns the random sample(s).
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     *
     * _.sample([1, 2, 3, 4], 2);
     * // => [3, 1]
     */
    function sample(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n == null) {
        collection = toIterable(collection);
        var length = collection.length;
        return length > 0 ? collection[baseRandom(0, length - 1)] : undefined;
      }
      var index = -1,
          result = toArray(collection),
          length = result.length,
          lastIndex = length - 1;

      n = nativeMin(n < 0 ? 0 : (+n || 0), length);
      while (++index < n) {
        var rand = baseRandom(index, lastIndex),
            value = result[rand];

        result[rand] = result[index];
        result[index] = value;
      }
      result.length = n;
      return result;
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      return sample(collection, POSITIVE_INFINITY);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable properties for objects.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the size of `collection`.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      var length = collection ? getLength(collection) : 0;
      return isLength(length) ? length : keys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * The function returns as soon as it finds a passing value and does not iterate
     * over the entire collection. The predicate is bound to `thisArg` and invoked
     * with three arguments: (value, index|key, collection).
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @alias any
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // using the `_.matches` callback shorthand
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.some(users, 'active', false);
     * // => true
     *
     * // using the `_.property` callback shorthand
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, thisArg) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (thisArg && isIterateeCall(collection, predicate, thisArg)) {
        predicate = undefined;
      }
      if (typeof predicate != 'function' || thisArg !== undefined) {
        predicate = getCallback(predicate, thisArg, 3);
      }
      return func(collection, predicate);
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection through `iteratee`. This method performs
     * a stable sort, that is, it preserves the original sort order of equal elements.
     * The `iteratee` is bound to `thisArg` and invoked with three arguments:
     * (value, index|key, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return Math.sin(n);
     * });
     * // => [3, 1, 2]
     *
     * _.sortBy([1, 2, 3], function(n) {
     *   return this.sin(n);
     * }, Math);
     * // => [3, 1, 2]
     *
     * var users = [
     *   { 'user': 'fred' },
     *   { 'user': 'pebbles' },
     *   { 'user': 'barney' }
     * ];
     *
     * // using the `_.property` callback shorthand
     * _.pluck(_.sortBy(users, 'user'), 'user');
     * // => ['barney', 'fred', 'pebbles']
     */
    function sortBy(collection, iteratee, thisArg) {
      if (collection == null) {
        return [];
      }
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      var index = -1;
      iteratee = getCallback(iteratee, thisArg, 3);

      var result = baseMap(collection, function(value, key, collection) {
        return { 'criteria': iteratee(value, key, collection), 'index': ++index, 'value': value };
      });
      return baseSortBy(result, compareAscending);
    }

    /**
     * This method is like `_.sortBy` except that it can sort by multiple iteratees
     * or property names.
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {...(Function|Function[]|Object|Object[]|string|string[])} iteratees
     *  The iteratees to sort by, specified as individual values or arrays of values.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.map(_.sortByAll(users, ['user', 'age']), _.values);
     * // => [['barney', 34], ['barney', 36], ['fred', 42], ['fred', 48]]
     *
     * _.map(_.sortByAll(users, 'user', function(chr) {
     *   return Math.floor(chr.age / 10);
     * }), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    var sortByAll = restParam(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var guard = iteratees[2];
      if (guard && isIterateeCall(iteratees[0], iteratees[1], guard)) {
        iteratees.length = 1;
      }
      return baseSortByOrder(collection, baseFlatten(iteratees), []);
    });

    /**
     * This method is like `_.sortByAll` except that it allows specifying the
     * sort orders of the iteratees to sort by. If `orders` is unspecified, all
     * values are sorted in ascending order. Otherwise, a value is sorted in
     * ascending order if its corresponding order is "asc", and descending if "desc".
     *
     * If a property name is provided for an iteratee the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If an object is provided for an iteratee the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {boolean[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 42 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // sort by `user` in ascending order and by `age` in descending order
     * _.map(_.sortByOrder(users, ['user', 'age'], ['asc', 'desc']), _.values);
     * // => [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 42]]
     */
    function sortByOrder(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (guard && isIterateeCall(iteratees, orders, guard)) {
        orders = undefined;
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseSortByOrder(collection, iteratees, orders);
    }

    /**
     * Performs a deep comparison between each element in `collection` and the
     * source object, returning an array of all elements that have equivalent
     * property values.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Collection
     * @param {Array|Object|string} collection The collection to search.
     * @param {Object} source The object of property values to match.
     * @returns {Array} Returns the new filtered array.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false, 'pets': ['hoppy'] },
     *   { 'user': 'fred',   'age': 40, 'active': true, 'pets': ['baby puss', 'dino'] }
     * ];
     *
     * _.pluck(_.where(users, { 'age': 36, 'active': false }), 'user');
     * // => ['barney']
     *
     * _.pluck(_.where(users, { 'pets': ['dino'] }), 'user');
     * // => ['fred']
     */
    function where(collection, source) {
      return filter(collection, baseMatches(source));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Gets the number of milliseconds that have elapsed since the Unix epoch
     * (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @category Date
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => logs the number of milliseconds it took for the deferred function to be invoked
     */
    var now = nativeNow || function() {
      return new Date().getTime();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it is called `n` or more times.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => logs 'done saving!' after the two async saves have completed
     */
    function after(n, func) {
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      n = nativeIsFinite(n = +n) ? n : 0;
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that accepts up to `n` arguments ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      if (guard && isIterateeCall(func, n, guard)) {
        n = undefined;
      }
      n = (func && n == null) ? func.length : nativeMax(+n || 0, 0);
      return createWrapper(func, ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it is called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery('#add').on('click', _.before(5, addContactToList));
     * // => allows adding up to 4 contacts to the list
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        if (typeof n == 'function') {
          var temp = n;
          n = func;
          func = temp;
        } else {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
      }
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and prepends any additional `_.bind` arguments to those provided to the
     * bound function.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind` this method does not set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var greet = function(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * };
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // using placeholders
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = restParam(function(func, thisArg, partials) {
      var bitmask = BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bind.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method. Method names may be specified as individual arguments or as arrays
     * of method names. If no method names are provided all enumerable function
     * properties, own and inherited, of `object` are bound.
     *
     * **Note:** This method does not set the "length" property of bound functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} [methodNames] The object method names to bind,
     *  specified as individual method names or arrays of method names.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'onClick': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view);
     * jQuery('#docs').on('click', view.onClick);
     * // => logs 'clicked docs' when the element is clicked
     */
    var bindAll = restParam(function(object, methodNames) {
      methodNames = methodNames.length ? baseFlatten(methodNames) : functions(object);

      var index = -1,
          length = methodNames.length;

      while (++index < length) {
        var key = methodNames[index];
        object[key] = createWrapper(object[key], BIND_FLAG, object);
      }
      return object;
    });

    /**
     * Creates a function that invokes the method at `object[key]` and prepends
     * any additional `_.bindKey` arguments to those provided to the bound function.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist.
     * See [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Object} object The object the method belongs to.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // using placeholders
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = restParam(function(object, key, partials) {
      var bitmask = BIND_FLAG | BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, bindKey.placeholder);
        bitmask |= PARTIAL_FLAG;
      }
      return createWrapper(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts one or more arguments of `func` that when
     * called either invokes `func` returning its result, if all `func` arguments
     * have been provided, or returns a function that accepts one or more of the
     * remaining `func` arguments, and so on. The arity of `func` may be specified
     * if `func.length` is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    var curry = createCurry(CURRY_FLAG);

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method does not set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // using placeholders
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    var curryRight = createCurry(CURRY_RIGHT_FLAG);

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed invocations. Provide an options object to indicate that `func`
     * should be invoked on the leading and/or trailing edge of the `wait` timeout.
     * Subsequent calls to the debounced function return the result of the last
     * `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the debounced function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=false] Specify invoking on the leading
     *  edge of the timeout.
     * @param {number} [options.maxWait] The maximum time `func` is allowed to be
     *  delayed before it is invoked.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // avoid costly calculations while the window size is in flux
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // invoke `sendMail` when the click event is fired, debouncing subsequent calls
     * jQuery('#postbox').on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // ensure `batchLog` is invoked once after 1 second of debounced calls
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', _.debounce(batchLog, 250, {
     *   'maxWait': 1000
     * }));
     *
     * // cancel a debounced call
     * var todoChanges = _.debounce(batchLog, 1000);
     * Object.observe(models.todo, todoChanges);
     *
     * Object.observe(models, function(changes) {
     *   if (_.find(changes, { 'user': 'todo', 'type': 'delete'})) {
     *     todoChanges.cancel();
     *   }
     * }, ['delete']);
     *
     * // ...at some point `models.todo` is changed
     * models.todo.completed = true;
     *
     * // ...before 1 second has passed `models.todo` is deleted
     * // which cancels the debounced `todoChanges` call
     * delete models.todo;
     */
    function debounce(func, wait, options) {
      var args,
          maxTimeoutId,
          result,
          stamp,
          thisArg,
          timeoutId,
          trailingCall,
          lastCalled = 0,
          maxWait = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = wait < 0 ? 0 : (+wait || 0);
      if (options === true) {
        var leading = true;
        trailing = false;
      } else if (isObject(options)) {
        leading = !!options.leading;
        maxWait = 'maxWait' in options && nativeMax(+options.maxWait || 0, wait);
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function cancel() {
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        if (maxTimeoutId) {
          clearTimeout(maxTimeoutId);
        }
        lastCalled = 0;
        maxTimeoutId = timeoutId = trailingCall = undefined;
      }

      function complete(isCalled, id) {
        if (id) {
          clearTimeout(id);
        }
        maxTimeoutId = timeoutId = trailingCall = undefined;
        if (isCalled) {
          lastCalled = now();
          result = func.apply(thisArg, args);
          if (!timeoutId && !maxTimeoutId) {
            args = thisArg = undefined;
          }
        }
      }

      function delayed() {
        var remaining = wait - (now() - stamp);
        if (remaining <= 0 || remaining > wait) {
          complete(trailingCall, maxTimeoutId);
        } else {
          timeoutId = setTimeout(delayed, remaining);
        }
      }

      function maxDelayed() {
        complete(trailing, timeoutId);
      }

      function debounced() {
        args = arguments;
        stamp = now();
        thisArg = this;
        trailingCall = trailing && (timeoutId || !leading);

        if (maxWait === false) {
          var leadingCall = leading && !timeoutId;
        } else {
          if (!maxTimeoutId && !leading) {
            lastCalled = stamp;
          }
          var remaining = maxWait - (stamp - lastCalled),
              isCalled = remaining <= 0 || remaining > maxWait;

          if (isCalled) {
            if (maxTimeoutId) {
              maxTimeoutId = clearTimeout(maxTimeoutId);
            }
            lastCalled = stamp;
            result = func.apply(thisArg, args);
          }
          else if (!maxTimeoutId) {
            maxTimeoutId = setTimeout(maxDelayed, remaining);
          }
        }
        if (isCalled && timeoutId) {
          timeoutId = clearTimeout(timeoutId);
        }
        else if (!timeoutId && wait !== maxWait) {
          timeoutId = setTimeout(delayed, wait);
        }
        if (leadingCall) {
          isCalled = true;
          result = func.apply(thisArg, args);
        }
        if (isCalled && !timeoutId && !maxTimeoutId) {
          args = thisArg = undefined;
        }
        return result;
      }
      debounced.cancel = cancel;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // logs 'deferred' after one or more milliseconds
     */
    var defer = restParam(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke the function with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => logs 'later' after one second
     */
    var delay = restParam(function(func, wait, args) {
      return baseDelay(func, wait, args);
    });

    /**
     * Creates a function that returns the result of invoking the provided
     * functions with the `this` binding of the created function, where each
     * successive invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow(_.add, square);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the provided functions from right to left.
     *
     * @static
     * @memberOf _
     * @alias backflow, compose
     * @category Function
     * @param {...Function} [funcs] Functions to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight(square, _.add);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is coerced to a string and used as the
     * cache key. The `func` is invoked with the `this` binding of the memoized
     * function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the [`Map`](http://ecma-international.org/ecma-262/6.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoizing function.
     * @example
     *
     * var upperCase = _.memoize(function(string) {
     *   return string.toUpperCase();
     * });
     *
     * upperCase('fred');
     * // => 'FRED'
     *
     * // modifying the result cache
     * upperCase.cache.set('fred', 'BARNEY');
     * upperCase('fred');
     * // => 'BARNEY'
     *
     * // replacing `_.memoize.Cache`
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'barney' };
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'fred' }
     *
     * _.memoize.Cache = WeakMap;
     * var identity = _.memoize(_.identity);
     *
     * identity(object);
     * // => { 'user': 'fred' }
     * identity(other);
     * // => { 'user': 'barney' }
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
      };
      memoized.cache = new memoize.Cache;
      return memoized;
    }

    /**
     * Creates a function that runs each argument through a corresponding
     * transform function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms] The functions to transform
     * arguments, specified as individual functions or arrays of functions.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var modded = _.modArgs(function(x, y) {
     *   return [x, y];
     * }, square, doubled);
     *
     * modded(1, 2);
     * // => [1, 4]
     *
     * modded(5, 10);
     * // => [25, 20]
     */
    var modArgs = restParam(function(func, transforms) {
      transforms = baseFlatten(transforms);
      if (typeof func != 'function' || !arrayEvery(transforms, baseIsFunction)) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = transforms.length;
      return restParam(function(args) {
        var index = nativeMin(args.length, length);
        while (index--) {
          args[index] = transforms[index](args[index]);
        }
        return func.apply(this, args);
      });
    });

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        return !predicate.apply(this, arguments);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first call. The `func` is invoked
     * with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // `initialize` invokes `createApplication` once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with `partial` arguments prepended
     * to those provided to the new function. This method is like `_.bind` except
     * it does **not** alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // using placeholders
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = createPartial(PARTIAL_FLAG);

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to those provided to the new function.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method does not set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * var greet = function(greeting, name) {
     *   return greeting + ' ' + name;
     * };
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // using placeholders
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = createPartial(PARTIAL_RIGHT_FLAG);

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified indexes where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes,
     *  specified as individual indexes or arrays of indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, 2, 0, 1);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     *
     * var map = _.rearg(_.map, [1, 0]);
     * map(function(n) {
     *   return n * 3;
     * }, [1, 2, 3]);
     * // => [3, 6, 9]
     */
    var rearg = restParam(function(func, indexes) {
      return createWrapper(func, REARG_FLAG, undefined, undefined, undefined, baseFlatten(indexes));
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as an array.
     *
     * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.restParam(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function restParam(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            rest = Array(length);

        while (++index < length) {
          rest[index] = args[start + index];
        }
        switch (start) {
          case 0: return func.call(this, rest);
          case 1: return func.call(this, args[0], rest);
          case 2: return func.call(this, args[0], args[1], rest);
        }
        var otherArgs = Array(start + 1);
        index = -1;
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = rest;
        return func.apply(this, otherArgs);
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the created
     * function and an array of arguments much like [`Function#apply`](https://es5.github.io/#x15.3.4.3).
     *
     * **Note:** This method is based on the [spread operator](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Spread_operator).
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * // with a Promise
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function(array) {
        return func.apply(this, array);
      };
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed invocations. Provide an options object to indicate
     * that `func` should be invoked on the leading and/or trailing edge of the
     * `wait` timeout. Subsequent calls to the throttled function return the
     * result of the last `func` call.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
     * on the trailing edge of the timeout only if the the throttled function is
     * invoked more than once during the `wait` timeout.
     *
     * See [David Corbacho's article](http://drupalmotion.com/article/debounce-and-throttle-visual-explanation)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.leading=true] Specify invoking on the leading
     *  edge of the timeout.
     * @param {boolean} [options.trailing=true] Specify invoking on the trailing
     *  edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // avoid excessively updating the position while scrolling
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // invoke `renewToken` when the click event is fired, but not more than once every 5 minutes
     * jQuery('.interactive').on('click', _.throttle(renewToken, 300000, {
     *   'trailing': false
     * }));
     *
     * // cancel a trailing throttled call
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (options === false) {
        leading = false;
      } else if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, { 'leading': leading, 'maxWait': +wait, 'trailing': trailing });
    }

    /**
     * Creates a function that provides `value` to the wrapper function as its
     * first argument. Any additional arguments provided to the function are
     * appended to those provided to the wrapper function. The wrapper is invoked
     * with the `this` binding of the created function.
     *
     * @static
     * @memberOf _
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} wrapper The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      wrapper = wrapper == null ? identity : wrapper;
      return createWrapper(wrapper, PARTIAL_FLAG, undefined, [value], []);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates a clone of `value`. If `isDeep` is `true` nested objects are cloned,
     * otherwise they are assigned by reference. If `customizer` is provided it is
     * invoked to produce the cloned values. If `customizer` returns `undefined`
     * cloning is handled by the method instead. The `customizer` is bound to
     * `thisArg` and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var shallow = _.clone(users);
     * shallow[0] === users[0];
     * // => true
     *
     * var deep = _.clone(users, true);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.clone(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 0
     */
    function clone(value, isDeep, customizer, thisArg) {
      if (isDeep && typeof isDeep != 'boolean' && isIterateeCall(value, isDeep, customizer)) {
        isDeep = false;
      }
      else if (typeof isDeep == 'function') {
        thisArg = customizer;
        customizer = isDeep;
        isDeep = false;
      }
      return typeof customizer == 'function'
        ? baseClone(value, isDeep, bindCallback(customizer, thisArg, 1))
        : baseClone(value, isDeep);
    }

    /**
     * Creates a deep clone of `value`. If `customizer` is provided it is invoked
     * to produce the cloned values. If `customizer` returns `undefined` cloning
     * is handled by the method instead. The `customizer` is bound to `thisArg`
     * and invoked with two argument; (value [, index|key, object]).
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](http://www.w3.org/TR/html5/infrastructure.html#internal-structured-cloning-algorithm).
     * The enumerable properties of `arguments` objects and objects created by
     * constructors other than `Object` are cloned to plain `Object` objects. An
     * empty object is returned for uncloneable values such as functions, DOM nodes,
     * Maps, Sets, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to deep clone.
     * @param {Function} [customizer] The function to customize cloning values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {*} Returns the deep cloned value.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * var deep = _.cloneDeep(users);
     * deep[0] === users[0];
     * // => false
     *
     * // using a customizer callback
     * var el = _.cloneDeep(document.body, function(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * });
     *
     * el === document.body
     * // => false
     * el.nodeName
     * // => BODY
     * el.childNodes.length;
     * // => 20
     */
    function cloneDeep(value, customizer, thisArg) {
      return typeof customizer == 'function'
        ? baseClone(value, true, bindCallback(customizer, thisArg, 1))
        : baseClone(value, true);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`, else `false`.
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    function gt(value, other) {
      return value > other;
    }

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to `other`, else `false`.
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    function gte(value, other) {
      return value >= other;
    }

    /**
     * Checks if `value` is classified as an `arguments` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    function isArguments(value) {
      return isObjectLike(value) && isArrayLike(value) &&
        hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    }

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(function() { return arguments; }());
     * // => false
     */
    var isArray = nativeIsArray || function(value) {
      return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
    };

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || (isObjectLike(value) && objToString.call(value) == boolTag);
    }

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    function isDate(value) {
      return isObjectLike(value) && objToString.call(value) == dateTag;
    }

    /**
     * Checks if `value` is a DOM element.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return !!value && value.nodeType === 1 && isObjectLike(value) && !isPlainObject(value);
    }

    /**
     * Checks if `value` is empty. A value is considered empty unless it is an
     * `arguments` object, array, string, or jQuery-like collection with a length
     * greater than `0` or an object with own enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Array|Object|string} value The value to inspect.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || isString(value) || isArguments(value) ||
          (isObjectLike(value) && isFunction(value.splice)))) {
        return !value.length;
      }
      return !keys(value).length;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent. If `customizer` is provided it is invoked to compare values.
     * If `customizer` returns `undefined` comparisons are handled by the method
     * instead. The `customizer` is bound to `thisArg` and invoked with three
     * arguments: (value, other [, index|key]).
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. Functions and DOM nodes
     * are **not** supported. Provide a customizer function to extend support
     * for comparing other values.
     *
     * @static
     * @memberOf _
     * @alias eq
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var other = { 'user': 'fred' };
     *
     * object == other;
     * // => false
     *
     * _.isEqual(object, other);
     * // => true
     *
     * // using a customizer callback
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqual(array, other, function(value, other) {
     *   if (_.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/)) {
     *     return true;
     *   }
     * });
     * // => true
     */
    function isEqual(value, other, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return  result === undefined ? baseIsEqual(value, other, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      return isObjectLike(value) && typeof value.message == 'string' && objToString.call(value) == errorTag;
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on [`Number.isFinite`](http://ecma-international.org/ecma-262/6.0/#sec-number.isfinite).
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(10);
     * // => true
     *
     * _.isFinite('10');
     * // => false
     *
     * _.isFinite(true);
     * // => false
     *
     * _.isFinite(Object(10));
     * // => false
     *
     * _.isFinite(Infinity);
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in older versions of Chrome and Safari which return 'function' for regexes
      // and Safari 8 equivalents which return 'object' for typed array constructors.
      return isObject(value) && objToString.call(value) == funcTag;
    }

    /**
     * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
     * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(1);
     * // => false
     */
    function isObject(value) {
      // Avoid a V8 JIT bug in Chrome 19-20.
      // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
      var type = typeof value;
      return !!value && (type == 'object' || type == 'function');
    }

    /**
     * Performs a deep comparison between `object` and `source` to determine if
     * `object` contains equivalent property values. If `customizer` is provided
     * it is invoked to compare values. If `customizer` returns `undefined`
     * comparisons are handled by the method instead. The `customizer` is bound
     * to `thisArg` and invoked with three arguments: (value, other, index|key).
     *
     * **Note:** This method supports comparing properties of arrays, booleans,
     * `Date` objects, numbers, `Object` objects, regexes, and strings. Functions
     * and DOM nodes are **not** supported. Provide a customizer function to extend
     * support for comparing other values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize value comparisons.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.isMatch(object, { 'age': 40 });
     * // => true
     *
     * _.isMatch(object, { 'age': 36 });
     * // => false
     *
     * // using a customizer callback
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatch(object, source, function(value, other) {
     *   return _.every([value, other], RegExp.prototype.test, /^h(?:i|ello)$/) || undefined;
     * });
     * // => true
     */
    function isMatch(object, source, customizer, thisArg) {
      customizer = typeof customizer == 'function' ? bindCallback(customizer, thisArg, 3) : undefined;
      return baseIsMatch(object, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is not the same as [`isNaN`](https://es5.github.io/#x15.1.2.4)
     * which returns `true` for `undefined` and other non-numeric values.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some host objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a native function.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (value == null) {
        return false;
      }
      if (isFunction(value)) {
        return reIsNative.test(fnToString.call(value));
      }
      return isObjectLike(value) && reIsHostCtor.test(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
     * as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isNumber(8.4);
     * // => true
     *
     * _.isNumber(NaN);
     * // => true
     *
     * _.isNumber('8.4');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || (isObjectLike(value) && objToString.call(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * **Note:** This method assumes objects created by the `Object` constructor
     * have no inherited enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      var Ctor;

      // Exit early for non `Object` objects.
      if (!(isObjectLike(value) && objToString.call(value) == objectTag && !isArguments(value)) ||
          (!hasOwnProperty.call(value, 'constructor') && (Ctor = value.constructor, typeof Ctor == 'function' && !(Ctor instanceof Ctor)))) {
        return false;
      }
      // IE < 9 iterates inherited properties before own properties. If the first
      // iterated property is an object's own property then there are no inherited
      // enumerable properties.
      var result;
      // In most environments an object's own properties are iterated before
      // its inherited properties. If the last iterated property is an object's
      // own property then there are no inherited enumerable properties.
      baseForIn(value, function(subValue, key) {
        result = key;
      });
      return result === undefined || hasOwnProperty.call(value, result);
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    function isRegExp(value) {
      return isObject(value) && objToString.call(value) == regexpTag;
    }

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || (isObjectLike(value) && objToString.call(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    function isTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objToString.call(value)];
    }

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`, else `false`.
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    function lt(value, other) {
      return value < other;
    }

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to `other`, else `false`.
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    function lte(value, other) {
      return value <= other;
    }

    /**
     * Converts `value` to an array.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * (function() {
     *   return _.toArray(arguments).slice(1);
     * }(1, 2, 3));
     * // => [2, 3]
     */
    function toArray(value) {
      var length = value ? getLength(value) : 0;
      if (!isLength(length)) {
        return values(value);
      }
      if (!length) {
        return [];
      }
      return arrayCopy(value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable
     * properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return baseCopy(value, keysIn(value));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Recursively merges own enumerable properties of the source object(s), that
     * don't resolve to `undefined` into the destination object. Subsequent sources
     * overwrite property assignments of previous sources. If `customizer` is
     * provided it is invoked to produce the merged values of the destination and
     * source properties. If `customizer` returns `undefined` merging is handled
     * by the method instead. The `customizer` is bound to `thisArg` and invoked
     * with five arguments: (objectValue, sourceValue, key, object, source).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var users = {
     *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
     * };
     *
     * var ages = {
     *   'data': [{ 'age': 36 }, { 'age': 40 }]
     * };
     *
     * _.merge(users, ages);
     * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
     *
     * // using a customizer callback
     * var object = {
     *   'fruits': ['apple'],
     *   'vegetables': ['beet']
     * };
     *
     * var other = {
     *   'fruits': ['banana'],
     *   'vegetables': ['carrot']
     * };
     *
     * _.merge(object, other, function(a, b) {
     *   if (_.isArray(a)) {
     *     return a.concat(b);
     *   }
     * });
     * // => { 'fruits': ['apple', 'banana'], 'vegetables': ['beet', 'carrot'] }
     */
    var merge = createAssigner(baseMerge);

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object. Subsequent sources overwrite property assignments of previous sources.
     * If `customizer` is provided it is invoked to produce the assigned values.
     * The `customizer` is bound to `thisArg` and invoked with five arguments:
     * (objectValue, sourceValue, key, object, source).
     *
     * **Note:** This method mutates `object` and is based on
     * [`Object.assign`](http://ecma-international.org/ecma-262/6.0/#sec-object.assign).
     *
     * @static
     * @memberOf _
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {*} [thisArg] The `this` binding of `customizer`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using a customizer callback
     * var defaults = _.partialRight(_.assign, function(value, other) {
     *   return _.isUndefined(value) ? other : value;
     * });
     *
     * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var assign = createAssigner(function(object, source, customizer) {
      return customizer
        ? assignWith(object, source, customizer)
        : baseAssign(object, source);
    });

    /**
     * Creates an object that inherits from the given `prototype` object. If a
     * `properties` object is provided its own enumerable properties are assigned
     * to the created object.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties, guard) {
      var result = baseCreate(prototype);
      if (guard && isIterateeCall(prototype, properties, guard)) {
        properties = undefined;
      }
      return properties ? baseAssign(result, properties) : result;
    }

    /**
     * Assigns own enumerable properties of source object(s) to the destination
     * object for all destination properties that resolve to `undefined`. Once a
     * property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
     * // => { 'user': 'barney', 'age': 36 }
     */
    var defaults = createDefaults(assign, assignDefaults);

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * _.defaultsDeep({ 'user': { 'name': 'barney' } }, { 'user': { 'name': 'fred', 'age': 36 } });
     * // => { 'user': { 'name': 'barney', 'age': 36 } }
     *
     */
    var defaultsDeep = createDefaults(merge, mergeDefaults);

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // using the `_.matches` callback shorthand
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    var findKey = createFindKey(baseForOwn);

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * If a property name is provided for `predicate` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `predicate` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to search.
     * @param {Function|Object|string} [predicate=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {string|undefined} Returns the key of the matched element, else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(chr) {
     *   return chr.age < 40;
     * });
     * // => returns `pebbles` assuming `_.findKey` returns `barney`
     *
     * // using the `_.matches` callback shorthand
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // using the `_.matchesProperty` callback shorthand
     * _.findLastKey(users, 'active', false);
     * // => 'fred'
     *
     * // using the `_.property` callback shorthand
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    var findLastKey = createFindKey(baseForOwnRight);

    /**
     * Iterates over own and inherited enumerable properties of an object invoking
     * `iteratee` for each property. The `iteratee` is bound to `thisArg` and invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a', 'b', and 'c' (iteration order is not guaranteed)
     */
    var forIn = createForIn(baseFor);

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'c', 'b', and 'a' assuming `_.forIn ` logs 'a', 'b', and 'c'
     */
    var forInRight = createForIn(baseForRight);

    /**
     * Iterates over own enumerable properties of an object invoking `iteratee`
     * for each property. The `iteratee` is bound to `thisArg` and invoked with
     * three arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'a' and 'b' (iteration order is not guaranteed)
     */
    var forOwn = createForOwn(baseForOwn);

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => logs 'b' and 'a' assuming `_.forOwn` logs 'a' and 'b'
     */
    var forOwnRight = createForOwn(baseForOwnRight);

    /**
     * Creates an array of function property names from all enumerable properties,
     * own and inherited, of `object`.
     *
     * @static
     * @memberOf _
     * @alias methods
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the new array of property names.
     * @example
     *
     * _.functions(_);
     * // => ['after', 'ary', 'assign', ...]
     */
    function functions(object) {
      return baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the property value at `path` of `object`. If the resolved value is
     * `undefined` the `defaultValue` is used in its place.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, toPath(path), path + '');
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` is a direct property, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': { 'c': 3 } } };
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b.c');
     * // => true
     *
     * _.has(object, ['a', 'b', 'c']);
     * // => true
     */
    function has(object, path) {
      if (object == null) {
        return false;
      }
      var result = hasOwnProperty.call(object, path);
      if (!result && !isKey(path)) {
        path = toPath(path);
        object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
        if (object == null) {
          return false;
        }
        path = last(path);
        result = hasOwnProperty.call(object, path);
      }
      return result || (isLength(object.length) && isIndex(path, object.length) &&
        (isArray(object) || isArguments(object)));
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite property
     * assignments of previous values unless `multiValue` is `true`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to invert.
     * @param {boolean} [multiValue] Allow multiple values per key.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     *
     * // with `multiValue`
     * _.invert(object, true);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function invert(object, multiValue, guard) {
      if (guard && isIterateeCall(object, multiValue, guard)) {
        multiValue = undefined;
      }
      var index = -1,
          props = keys(object),
          length = props.length,
          result = {};

      while (++index < length) {
        var key = props[index],
            value = object[key];

        if (multiValue) {
          if (hasOwnProperty.call(result, value)) {
            result[value].push(key);
          } else {
            result[value] = [key];
          }
        }
        else {
          result[value] = key;
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    var keys = !nativeKeys ? shimKeys : function(object) {
      var Ctor = object == null ? undefined : object.constructor;
      if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
          (typeof object != 'function' && isArrayLike(object))) {
        return shimKeys(object);
      }
      return isObject(object) ? nativeKeys(object) : [];
    };

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      if (object == null) {
        return [];
      }
      if (!isObject(object)) {
        object = Object(object);
      }
      var length = object.length;
      length = (length && isLength(length) &&
        (isArray(object) || isArguments(object)) && length) || 0;

      var Ctor = object.constructor,
          index = -1,
          isProto = typeof Ctor == 'function' && Ctor.prototype === object,
          result = Array(length),
          skipIndexes = length > 0;

      while (++index < length) {
        result[index] = (index + '');
      }
      for (var key in object) {
        if (!(skipIndexes && isIndex(key, length)) &&
            !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * property of `object` through `iteratee`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    var mapKeys = createObjectMapper(true);

    /**
     * Creates an object with the same keys as `object` and values generated by
     * running each own enumerable property of `object` through `iteratee`. The
     * iteratee function is bound to `thisArg` and invoked with three arguments:
     * (value, key, object).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function|Object|string} [iteratee=_.identity] The function invoked
     *  per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Object} Returns the new mapped object.
     * @example
     *
     * _.mapValues({ 'a': 1, 'b': 2 }, function(n) {
     *   return n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * // using the `_.property` callback shorthand
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    var mapValues = createObjectMapper();

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable properties of `object` that are not omitted.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to omit, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.omit(object, 'age');
     * // => { 'user': 'fred' }
     *
     * _.omit(object, _.isNumber);
     * // => { 'user': 'fred' }
     */
    var omit = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      if (typeof props[0] != 'function') {
        var props = arrayMap(baseFlatten(props), String);
        return pickByArray(object, baseDifference(keysIn(object), props));
      }
      var predicate = bindCallback(props[0], props[1], 3);
      return pickByCallback(object, function(value, key, object) {
        return !predicate(value, key, object);
      });
    });

    /**
     * Creates a two dimensional array of the key-value pairs for `object`,
     * e.g. `[[key1, value1], [key2, value2]]`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the new array of key-value pairs.
     * @example
     *
     * _.pairs({ 'barney': 36, 'fred': 40 });
     * // => [['barney', 36], ['fred', 40]] (iteration order is not guaranteed)
     */
    function pairs(object) {
      object = toObject(object);

      var index = -1,
          props = keys(object),
          length = props.length,
          result = Array(length);

      while (++index < length) {
        var key = props[index];
        result[index] = [key, object[key]];
      }
      return result;
    }

    /**
     * Creates an object composed of the picked `object` properties. Property
     * names may be specified as individual arguments or as arrays of property
     * names. If `predicate` is provided it is invoked for each property of `object`
     * picking the properties `predicate` returns truthy for. The predicate is
     * bound to `thisArg` and invoked with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {Function|...(string|string[])} [predicate] The function invoked per
     *  iteration or property names to pick, specified as individual property
     *  names or arrays of property names.
     * @param {*} [thisArg] The `this` binding of `predicate`.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'user': 'fred', 'age': 40 };
     *
     * _.pick(object, 'user');
     * // => { 'user': 'fred' }
     *
     * _.pick(object, _.isString);
     * // => { 'user': 'fred' }
     */
    var pick = restParam(function(object, props) {
      if (object == null) {
        return {};
      }
      return typeof props[0] == 'function'
        ? pickByCallback(object, bindCallback(props[0], props[1], 3))
        : pickByArray(object, baseFlatten(props));
    });

    /**
     * This method is like `_.get` except that if the resolved value is a function
     * it is invoked with the `this` binding of its parent object and its result
     * is returned.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned if the resolved value is `undefined`.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a.b.c', 'default');
     * // => 'default'
     *
     * _.result(object, 'a.b.c', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      var result = object == null ? undefined : object[path];
      if (result === undefined) {
        if (object != null && !isKey(path, object)) {
          path = toPath(path);
          object = path.length == 1 ? object : baseGet(object, baseSlice(path, 0, -1));
          result = object == null ? undefined : object[last(path)];
        }
        result = result === undefined ? defaultValue : result;
      }
      return isFunction(result) ? result.call(object) : result;
    }

    /**
     * Sets the property value of `path` on `object`. If a portion of `path`
     * does not exist it is created.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to augment.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, 'x[0].y.z', 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      if (object == null) {
        return object;
      }
      var pathKey = (path + '');
      path = (object[pathKey] != null || isKey(path, object)) ? [pathKey] : toPath(path);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = path[index];
        if (isObject(nested)) {
          if (index == lastIndex) {
            nested[key] = value;
          } else if (nested[key] == null) {
            nested[key] = isIndex(path[index + 1]) ? [] : {};
          }
        }
        nested = nested[key];
      }
      return object;
    }

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own enumerable
     * properties through `iteratee`, with each invocation potentially mutating
     * the `accumulator` object. The `iteratee` is bound to `thisArg` and invoked
     * with four arguments: (accumulator, value, key, object). Iteratee functions
     * may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Array|Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * });
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2 }, function(result, n, key) {
     *   result[key] = n * 3;
     * });
     * // => { 'a': 3, 'b': 6 }
     */
    function transform(object, iteratee, accumulator, thisArg) {
      var isArr = isArray(object) || isTypedArray(object);
      iteratee = getCallback(iteratee, thisArg, 4);

      if (accumulator == null) {
        if (isArr || isObject(object)) {
          var Ctor = object.constructor;
          if (isArr) {
            accumulator = isArray(object) ? new Ctor : [];
          } else {
            accumulator = baseCreate(isFunction(Ctor) ? Ctor.prototype : undefined);
          }
        } else {
          accumulator = {};
        }
      }
      (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Creates an array of the own enumerable property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable property values
     * of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Checks if `n` is between `start` and up to but not including, `end`. If
     * `end` is not specified it is set to `start` with `start` then set to `0`.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} n The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `n` is in the range, else `false`.
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     */
    function inRange(value, start, end) {
      start = +start || 0;
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      return value >= nativeMin(start, end) && value < nativeMax(start, end);
    }

    /**
     * Produces a random number between `min` and `max` (inclusive). If only one
     * argument is provided a number between `0` and the given number is returned.
     * If `floating` is `true`, or either `min` or `max` are floats, a floating-point
     * number is returned instead of an integer.
     *
     * @static
     * @memberOf _
     * @category Number
     * @param {number} [min=0] The minimum possible value.
     * @param {number} [max=1] The maximum possible value.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(min, max, floating) {
      if (floating && isIterateeCall(min, max, floating)) {
        max = floating = undefined;
      }
      var noMin = min == null,
          noMax = max == null;

      if (floating == null) {
        if (noMax && typeof min == 'boolean') {
          floating = min;
          min = 1;
        }
        else if (typeof max == 'boolean') {
          floating = max;
          noMax = true;
        }
      }
      if (noMin && noMax) {
        max = 1;
        noMax = false;
      }
      min = +min || 0;
      if (noMax) {
        max = min;
        min = 0;
      } else {
        max = +max || 0;
      }
      if (floating || min % 1 || max % 1) {
        var rand = nativeRandom();
        return nativeMin(min + (rand * (max - min + parseFloat('1e-' + ((rand + '').length - 1)))), max);
      }
      return baseRandom(min, max);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar');
     * // => 'fooBar'
     *
     * _.camelCase('__foo_bar__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? (word.charAt(0).toUpperCase() + word.slice(1)) : word);
    });

    /**
     * Capitalizes the first character of `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('fred');
     * // => 'Fred'
     */
    function capitalize(string) {
      string = baseToString(string);
      return string && (string.charAt(0).toUpperCase() + string.slice(1));
    }

    /**
     * Deburrs `string` by converting [latin-1 supplementary letters](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * to basic latin letters and removing [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = baseToString(string);
      return string && string.replace(reLatin1, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search from.
     * @returns {boolean} Returns `true` if `string` ends with `target`, else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = baseToString(string);
      target = (target + '');

      var length = string.length;
      position = position === undefined
        ? length
        : nativeMin(position < 0 ? 0 : (+position || 0), length);

      position -= target.length;
      return position >= 0 && string.indexOf(target, position) == position;
    }

    /**
     * Converts the characters "&", "<", ">", '"', "'", and "\`", in `string` to
     * their corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional characters
     * use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value.
     * See [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * Backticks are escaped because in Internet Explorer < 9, they can break out
     * of attribute values or HTML comments. See [#59](https://html5sec.org/#59),
     * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
     * [#133](https://html5sec.org/#133) of the [HTML5 Security Cheatsheet](https://html5sec.org/)
     * for more details.
     *
     * When working with HTML you should always [quote attribute values](http://wonko.com/post/html-escaping)
     * to reduce XSS vectors.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      // Reset `lastIndex` because in IE < 9 `String#replace` does not.
      string = baseToString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "\", "/", "^", "$", ".", "|", "?",
     * "*", "+", "(", ")", "[", "]", "{" and "}" in `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https:\/\/lodash\.com\/\)'
     */
    function escapeRegExp(string) {
      string = baseToString(string);
      return (string && reHasRegExpChars.test(string))
        ? string.replace(reRegExpChars, escapeRegExpChar)
        : (string || '(?:)');
    }

    /**
     * Converts `string` to [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__foo_bar__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = baseToString(string);
      length = +length;

      var strLength = string.length;
      if (strLength >= length || !nativeIsFinite(length)) {
        return string;
      }
      var mid = (length - strLength) / 2,
          leftLength = nativeFloor(mid),
          rightLength = nativeCeil(mid);

      chars = createPadding('', rightLength, chars);
      return chars.slice(0, leftLength) + string + chars;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padLeft('abc', 6);
     * // => '   abc'
     *
     * _.padLeft('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padLeft('abc', 3);
     * // => 'abc'
     */
    var padLeft = createPadDir();

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padRight('abc', 6);
     * // => 'abc   '
     *
     * _.padRight('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padRight('abc', 3);
     * // => 'abc'
     */
    var padRight = createPadDir(true);

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a hexadecimal,
     * in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the [ES5 implementation](https://es5.github.io/#E)
     * of `parseInt`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      // Firefox < 21 and Opera < 15 follow ES3 for `parseInt`.
      // Chrome fails to trim leading <BOM> whitespace characters.
      // See https://code.google.com/p/v8/issues/detail?id=3109 for more details.
      if (guard ? isIterateeCall(string, radix, guard) : radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      string = trim(string);
      return nativeParseInt(string, radix || (reHasHexPrefix.test(string) ? 16 : 10));
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=0] The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n) {
      var result = '';
      string = baseToString(string);
      n = +n;
      if (n < 1 || !string || !nativeIsFinite(n)) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        string += string;
      } while (n);

      return result;
    }

    /**
     * Converts `string` to [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--foo-bar');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Converts `string` to [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__foo_bar__');
     * // => 'Foo Bar'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + (word.charAt(0).toUpperCase() + word.slice(1));
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to search.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`, else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = baseToString(string);
      position = position == null
        ? 0
        : nativeMin(position < 0 ? 0 : (+position || 0), string.length);

      return string.lastIndexOf(target, position) == position;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is provided it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options] The options object.
     * @param {RegExp} [options.escape] The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate] The "evaluate" delimiter.
     * @param {Object} [options.imports] An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate] The "interpolate" delimiter.
     * @param {string} [options.sourceURL] The sourceURL of the template's compiled source.
     * @param {string} [options.variable] The data object variable name.
     * @param- {Object} [otherOptions] Enables the legacy `options` param signature.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // using the "interpolate" delimiter to create a compiled template
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // using the HTML "escape" delimiter to escape data property values
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // using the "evaluate" delimiter to execute JavaScript and generate HTML
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the internal `print` function in "evaluate" delimiters
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // using the ES delimiter as an alternative to the default "interpolate" delimiter
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // using custom template delimiters
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // using backslashes to treat delimiters as plain text
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // using the `imports` option to import `jQuery` as `jq`
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // using the `sourceURL` option to specify a custom sourceURL for the template
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector
     *
     * // using the `variable` option to ensure a with-statement isn't used in the compiled template
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // using the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and a stack trace
     * fs.writeFileSync(path.join(cwd, 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, otherOptions) {
      // Based on John Resig's `tmpl` implementation (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (otherOptions && isIterateeCall(string, options, otherOptions)) {
        options = otherOptions = undefined;
      }
      string = baseToString(string);
      options = assignWith(baseAssign({}, otherOptions || options), settings, assignOwnDefaults);

      var imports = assignWith(baseAssign({}, options.imports), settings.imports, assignOwnDefaults),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      var sourceURL = '//# sourceURL=' +
        ('sourceURL' in options
          ? options.sourceURL
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products requires returning the `match`
        // string in order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string), trimmedRightIndex(string) + 1);
      }
      chars = (chars + '');
      return string.slice(charsLeftIndex(string, chars), charsRightIndex(string, chars) + 1);
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimLeft('  abc  ');
     * // => 'abc  '
     *
     * _.trimLeft('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimLeft(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(trimmedLeftIndex(string));
      }
      return string.slice(charsLeftIndex(string, (chars + '')));
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimRight('  abc  ');
     * // => '  abc'
     *
     * _.trimRight('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimRight(string, chars, guard) {
      var value = string;
      string = baseToString(string);
      if (!string) {
        return string;
      }
      if (guard ? isIterateeCall(value, chars, guard) : chars == null) {
        return string.slice(0, trimmedRightIndex(string) + 1);
      }
      return string.slice(0, charsRightIndex(string, (chars + '')) + 1);
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object|number} [options] The options object or maximum string length.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.trunc('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', 24);
     * // => 'hi-diddly-ho there, n...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.trunc('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function trunc(string, options, guard) {
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (options != null) {
        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? (+options.length || 0) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        } else {
          length = +options || 0;
        }
      }
      string = baseToString(string);
      if (length >= string.length) {
        return string;
      }
      var end = length - omission.length;
      if (end < 1) {
        return omission;
      }
      var result = string.slice(0, end);
      if (separator == null) {
        return result + omission;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              newEnd,
              substring = string.slice(0, end);

          if (!separator.global) {
            separator = RegExp(separator.source, (reFlags.exec(separator) || '') + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            newEnd = match.index;
          }
          result = result.slice(0, newEnd == null ? end : newEnd);
        }
      } else if (string.indexOf(separator, end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, `&#39;`, and `&#96;` in `string` to their
     * corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional HTML
     * entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = baseToString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      if (guard && isIterateeCall(string, pattern, guard)) {
        pattern = undefined;
      }
      string = baseToString(string);
      return string.match(pattern || reWords) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it is invoked.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function} func The function to attempt.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // avoid throwing errors for invalid selectors
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = restParam(function(func, args) {
      try {
        return func.apply(undefined, args);
      } catch(e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and arguments of the created function. If `func` is a property name the
     * created callback returns the property value for a given element. If `func`
     * is an object the created callback returns `true` for elements that contain
     * the equivalent object properties, otherwise it returns `false`.
     *
     * @static
     * @memberOf _
     * @alias iteratee
     * @category Utility
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param- {Object} [guard] Enables use as a callback for functions like `_.map`.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // wrap to create custom callback shorthands
     * _.callback = _.wrap(_.callback, function(callback, func, thisArg) {
     *   var match = /^(.+?)__([gl]t)(.+)$/.exec(func);
     *   if (!match) {
     *     return callback(func, thisArg);
     *   }
     *   return function(object) {
     *     return match[2] == 'gt'
     *       ? object[match[1]] > match[3]
     *       : object[match[1]] < match[3];
     *   };
     * });
     *
     * _.filter(users, 'age__gt36');
     * // => [{ 'user': 'fred', 'age': 40 }]
     */
    function callback(func, thisArg, guard) {
      if (guard && isIterateeCall(func, thisArg, guard)) {
        thisArg = undefined;
      }
      return isObjectLike(func)
        ? matches(func)
        : baseCallback(func, thisArg);
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var object = { 'user': 'fred' };
     * var getter = _.constant(object);
     *
     * getter() === object;
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * This method returns the first argument provided to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.identity(object) === object;
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that performs a deep comparison between a given object
     * and `source`, returning `true` if the given object has equivalent property
     * values, else `false`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties. For comparing a single
     * own or inherited property value see `_.matchesProperty`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, _.matches({ 'age': 40, 'active': false }));
     * // => [{ 'user': 'fred', 'age': 40, 'active': false }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, true));
    }

    /**
     * Creates a function that compares the property value of `path` on a given
     * object to `value`.
     *
     * **Note:** This method supports comparing arrays, booleans, `Date` objects,
     * numbers, `Object` objects, regexes, and strings. Objects are compared by
     * their own, not inherited, enumerable properties.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * _.find(users, _.matchesProperty('user', 'fred'));
     * // => { 'user': 'fred' }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, true));
    }

    /**
     * Creates a function that invokes the method at `path` on a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': _.constant(2) } } },
     *   { 'a': { 'b': { 'c': _.constant(1) } } }
     * ];
     *
     * _.map(objects, _.method('a.b.c'));
     * // => [2, 1]
     *
     * _.invoke(_.sortBy(objects, _.method(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    var method = restParam(function(path, args) {
      return function(object) {
        return invokePath(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path on `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = restParam(function(object, args) {
      return function(path) {
        return invokePath(object, path, args);
      };
    });

    /**
     * Adds all own enumerable function properties of a source object to the
     * destination object. If `object` is a function then methods are added to
     * its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options] The options object.
     * @param {boolean} [options.chain=true] Specify whether the functions added
     *  are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      if (options == null) {
        var isObj = isObject(source),
            props = isObj ? keys(source) : undefined,
            methodNames = (props && props.length) ? baseFunctions(source, props) : undefined;

        if (!(methodNames ? methodNames.length : isObj)) {
          methodNames = false;
          options = source;
          source = object;
          object = this;
        }
      }
      if (!methodNames) {
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = true,
          index = -1,
          isFunc = isFunction(object),
          length = methodNames.length;

      if (options === false) {
        chain = false;
      } else if (isObject(options) && 'chain' in options) {
        chain = options.chain;
      }
      while (++index < length) {
        var methodName = methodNames[index],
            func = source[methodName];

        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = (function(func) {
            return function() {
              var chainAll = this.__chain__;
              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = arrayCopy(this.__actions__);

                actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
                result.__chain__ = chainAll;
                return result;
              }
              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }(func));
        }
      }
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      root._ = oldDash;
      return this;
    }

    /**
     * A no-operation function that returns `undefined` regardless of the
     * arguments it receives.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @example
     *
     * var object = { 'user': 'fred' };
     *
     * _.noop(object) === undefined;
     * // => true
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that returns the property value at `path` on a
     * given object.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': { 'c': 2 } } },
     *   { 'a': { 'b': { 'c': 1 } } }
     * ];
     *
     * _.map(objects, _.property('a.b.c'));
     * // => [2, 1]
     *
     * _.pluck(_.sortBy(objects, _.property(['a', 'b', 'c'])), 'a.b.c');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(path) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the property value at a given path on `object`.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return baseGet(object, toPath(path), path + '');
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. If `end` is not specified it is
     * set to `start` with `start` then set to `0`. If `end` is less than `start`
     * a zero-length range is created unless a negative `step` is specified.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the new array of numbers.
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    function range(start, end, step) {
      if (step && isIterateeCall(start, end, step)) {
        end = step = undefined;
      }
      start = +start || 0;
      step = step == null ? 1 : (+step || 0);

      if (end == null) {
        end = start;
        start = 0;
      } else {
        end = +end || 0;
      }
      // Use `Array(length)` so engines like Chakra and V8 avoid slower modes.
      // See https://youtu.be/XAqIpGU8ZZk#t=17m25s for more details.
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (++index < length) {
        result[index] = start;
        start += step;
      }
      return result;
    }

    /**
     * Invokes the iteratee function `n` times, returning an array of the results
     * of each invocation. The `iteratee` is bound to `thisArg` and invoked with
     * one argument; (index).
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * var diceRolls = _.times(3, _.partial(_.random, 1, 6, false));
     * // => [3, 6, 4]
     *
     * _.times(3, function(n) {
     *   mage.castSpell(n);
     * });
     * // => invokes `mage.castSpell(n)` three times with `n` of `0`, `1`, and `2`
     *
     * _.times(3, function(n) {
     *   this.cast(n);
     * }, mage);
     * // => also invokes `mage.castSpell(n)` three times
     */
    function times(n, iteratee, thisArg) {
      n = nativeFloor(n);

      // Exit early to avoid a JSC JIT bug in Safari 8
      // where `Array(0)` is treated as `Array(1)`.
      if (n < 1 || !nativeIsFinite(n)) {
        return [];
      }
      var index = -1,
          result = Array(nativeMin(n, MAX_ARRAY_LENGTH));

      iteratee = bindCallback(iteratee, thisArg, 1);
      while (++index < n) {
        if (index < MAX_ARRAY_LENGTH) {
          result[index] = iteratee(index);
        } else {
          iteratee(index);
        }
      }
      return result;
    }

    /**
     * Generates a unique ID. If `prefix` is provided the ID is appended to it.
     *
     * @static
     * @memberOf _
     * @category Utility
     * @param {string} [prefix] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return baseToString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} augend The first number to add.
     * @param {number} addend The second number to add.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    function add(augend, addend) {
      return (+augend || 0) + (+addend || 0);
    }

    /**
     * Calculates `n` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Calculates `n` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Gets the maximum value of `collection`. If `collection` is empty or falsey
     * `-Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => -Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.max(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'fred', 'age': 40 }
     *
     * // using the `_.property` callback shorthand
     * _.max(users, 'age');
     * // => { 'user': 'fred', 'age': 40 }
     */
    var max = createExtremum(gt, NEGATIVE_INFINITY);

    /**
     * Gets the minimum value of `collection`. If `collection` is empty or falsey
     * `Infinity` is returned. If an iteratee function is provided it is invoked
     * for each value in `collection` to generate the criterion by which the value
     * is ranked. The `iteratee` is bound to `thisArg` and invoked with three
     * arguments: (value, index, collection).
     *
     * If a property name is provided for `iteratee` the created `_.property`
     * style callback returns the property value of the given element.
     *
     * If a value is also provided for `thisArg` the created `_.matchesProperty`
     * style callback returns `true` for elements that have a matching property
     * value, else `false`.
     *
     * If an object is provided for `iteratee` the created `_.matches` style
     * callback returns `true` for elements that have the properties of the given
     * object, else `false`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => Infinity
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * _.min(users, function(chr) {
     *   return chr.age;
     * });
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // using the `_.property` callback shorthand
     * _.min(users, 'age');
     * // => { 'user': 'barney', 'age': 36 }
     */
    var min = createExtremum(lt, POSITIVE_INFINITY);

    /**
     * Calculates `n` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {number} n The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Gets the sum of the values in `collection`.
     *
     * @static
     * @memberOf _
     * @category Math
     * @param {Array|Object|string} collection The collection to iterate over.
     * @param {Function|Object|string} [iteratee] The function invoked per iteration.
     * @param {*} [thisArg] The `this` binding of `iteratee`.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 6]);
     * // => 10
     *
     * _.sum({ 'a': 4, 'b': 6 });
     * // => 10
     *
     * var objects = [
     *   { 'n': 4 },
     *   { 'n': 6 }
     * ];
     *
     * _.sum(objects, function(object) {
     *   return object.n;
     * });
     * // => 10
     *
     * // using the `_.property` callback shorthand
     * _.sum(objects, 'n');
     * // => 10
     */
    function sum(collection, iteratee, thisArg) {
      if (thisArg && isIterateeCall(collection, iteratee, thisArg)) {
        iteratee = undefined;
      }
      iteratee = getCallback(iteratee, thisArg, 3);
      return iteratee.length == 1
        ? arraySum(isArray(collection) ? collection : toIterable(collection), iteratee)
        : baseSum(collection, iteratee);
    }

    /*------------------------------------------------------------------------*/

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    // Add functions to the `Map` cache.
    MapCache.prototype['delete'] = mapDelete;
    MapCache.prototype.get = mapGet;
    MapCache.prototype.has = mapHas;
    MapCache.prototype.set = mapSet;

    // Add functions to the `Set` cache.
    SetCache.prototype.push = cachePush;

    // Assign cache to `_.memoize`.
    memoize.Cache = MapCache;

    // Add functions that return wrapped values when chaining.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.callback = callback;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.functions = functions;
    lodash.groupBy = groupBy;
    lodash.indexBy = indexBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.invert = invert;
    lodash.invoke = invoke;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.modArgs = modArgs;
    lodash.negate = negate;
    lodash.omit = omit;
    lodash.once = once;
    lodash.pairs = pairs;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pluck = pluck;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.restParam = restParam;
    lodash.set = set;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortByAll = sortByAll;
    lodash.sortByOrder = sortByOrder;
    lodash.spread = spread;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.times = times;
    lodash.toArray = toArray;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.union = union;
    lodash.uniq = uniq;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.where = where;
    lodash.without = without;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.backflow = flowRight;
    lodash.collect = map;
    lodash.compose = flowRight;
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.extend = assign;
    lodash.iteratee = callback;
    lodash.methods = functions;
    lodash.object = zipObject;
    lodash.select = filter;
    lodash.tail = rest;
    lodash.unique = uniq;

    // Add functions to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add functions that return unwrapped values when chaining.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.deburr = deburr;
    lodash.endsWith = endsWith;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.findWhere = findWhere;
    lodash.first = first;
    lodash.floor = floor;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isBoolean = isBoolean;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isMatch = isMatch;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isString = isString;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.min = min;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padLeft = padLeft;
    lodash.padRight = padRight;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.sum = sum;
    lodash.template = template;
    lodash.trim = trim;
    lodash.trimLeft = trimLeft;
    lodash.trimRight = trimRight;
    lodash.trunc = trunc;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.words = words;

    // Add aliases.
    lodash.all = every;
    lodash.any = some;
    lodash.contains = includes;
    lodash.eq = isEqual;
    lodash.detect = find;
    lodash.foldl = reduce;
    lodash.foldr = reduceRight;
    lodash.head = first;
    lodash.include = includes;
    lodash.inject = reduce;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!lodash.prototype[methodName]) {
          source[methodName] = func;
        }
      });
      return source;
    }()), false);

    /*------------------------------------------------------------------------*/

    // Add functions capable of returning wrapped and unwrapped values when chaining.
    lodash.sample = sample;

    lodash.prototype.sample = function(n) {
      if (!this.__chain__ && n == null) {
        return sample(this.value());
      }
      return this.thru(function(value) {
        return sample(value, n);
      });
    };

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type string
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        var filtered = this.__filtered__;
        if (filtered && !index) {
          return new LazyWrapper(this);
        }
        n = n == null ? 1 : nativeMax(nativeFloor(n) || 0, 0);

        var result = this.clone();
        if (filtered) {
          result.__takeCount__ = nativeMin(result.__takeCount__, n);
        } else {
          result.__views__.push({ 'size': n, 'type': methodName + (result.__dir__ < 0 ? 'Right' : '') });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type != LAZY_MAP_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee, thisArg) {
        var result = this.clone();
        result.__iteratees__.push({ 'iteratee': getCallback(iteratee, thisArg, 1), 'type': type });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.first` and `_.last`.
    arrayEach(['first', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.rest`.
    arrayEach(['initial', 'rest'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    // Add `LazyWrapper` methods for `_.pluck` and `_.where`.
    arrayEach(['pluck', 'where'], function(methodName, index) {
      var operationName = index ? 'filter' : 'map',
          createCallback = index ? baseMatches : property;

      LazyWrapper.prototype[methodName] = function(value) {
        return this[operationName](createCallback(value));
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.reject = function(predicate, thisArg) {
      predicate = getCallback(predicate, thisArg, 1);
      return this.filter(function(value) {
        return !predicate(value);
      });
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = start == null ? 0 : (+start || 0);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = (+end || 0);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate, thisArg) {
      return this.reverse().takeWhile(predicate, thisArg).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(POSITIVE_INFINITY);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|map|reject)|While$/.test(methodName),
          retUnwrapped = /^(?:first|last)$/.test(methodName),
          lodashFunc = lodash[retUnwrapped ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName];

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var args = retUnwrapped ? [1] : arguments,
            chainAll = this.__chain__,
            value = this.__wrapped__,
            isHybrid = !!this.__actions__.length,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var interceptor = function(value) {
          return (retUnwrapped && chainAll)
            ? lodashFunc(value, 1)[0]
            : lodashFunc.apply(undefined, arrayPush([value], args));
        };

        var action = { 'func': thru, 'args': [interceptor], 'thisArg': undefined },
            onlyLazy = isLazy && !isHybrid;

        if (retUnwrapped && !chainAll) {
          if (onlyLazy) {
            value = value.clone();
            value.__actions__.push(action);
            return func.call(value);
          }
          return lodashFunc.call(undefined, this.value())[0];
        }
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push(action);
          return new LodashWrapper(result, chainAll);
        }
        return this.thru(interceptor);
      };
    });

    // Add `Array` and `String` methods to `lodash.prototype`.
    arrayEach(['join', 'pop', 'push', 'replace', 'shift', 'sort', 'splice', 'split', 'unshift'], function(methodName) {
      var func = (/^(?:replace|split)$/.test(methodName) ? stringProto : arrayProto)[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:join|pop|replace|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          return func.apply(this.value(), args);
        }
        return this[chainName](function(value) {
          return func.apply(value, args);
        });
      };
    });

    // Map minified function names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name,
            names = realNames[key] || (realNames[key] = []);

        names.push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybridWrapper(undefined, BIND_KEY_FLAG).name] = [{ 'name': 'wrapper', 'func': undefined }];

    // Add functions to the lazy wrapper.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chaining functions to the `lodash` wrapper.
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.concat = wrapperConcat;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toString = wrapperToString;
    lodash.prototype.run = lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add function aliases to the `lodash` wrapper.
    lodash.prototype.collect = lodash.prototype.map;
    lodash.prototype.head = lodash.prototype.first;
    lodash.prototype.select = lodash.prototype.filter;
    lodash.prototype.tail = lodash.prototype.rest;

    return lodash;
  }

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers like r.js check for condition patterns like the following:
  if (typeof define == 'function' && typeof define.amd == 'object' && define.amd) {
    // Expose lodash to the global object when an AMD loader is present to avoid
    // errors in cases where lodash is loaded by a script tag and not intended
    // as an AMD module. See http://requirejs.org/docs/errors.html#mismatch for
    // more details.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function() {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds an `exports` object.
  else if (freeExports && freeModule) {
    // Export for Node.js or RingoJS.
    if (moduleExports) {
      (freeModule.exports = _)._ = _;
    }
    // Export for Rhino with CommonJS support.
    else {
      freeExports._ = _;
    }
  }
  else {
    // Export for a browser or Rhino.
    root._ = _;
  }
}.call(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],77:[function(require,module,exports){
'use strict';

module.exports = require('./lib')

},{"./lib":82}],78:[function(require,module,exports){
'use strict';

var asap = require('asap/raw');

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._40 = 0;
  this._65 = 0;
  this._55 = null;
  this._72 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._37 = null;
Promise._87 = null;
Promise._61 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._65 === 3) {
    self = self._55;
  }
  if (Promise._37) {
    Promise._37(self);
  }
  if (self._65 === 0) {
    if (self._40 === 0) {
      self._40 = 1;
      self._72 = deferred;
      return;
    }
    if (self._40 === 1) {
      self._40 = 2;
      self._72 = [self._72, deferred];
      return;
    }
    self._72.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._65 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._65 === 1) {
        resolve(deferred.promise, self._55);
      } else {
        reject(deferred.promise, self._55);
      }
      return;
    }
    var ret = tryCallOne(cb, self._55);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._65 = 3;
      self._55 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._65 = 1;
  self._55 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._65 = 2;
  self._55 = newValue;
  if (Promise._87) {
    Promise._87(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._40 === 1) {
    handle(self, self._72);
    self._72 = null;
  }
  if (self._40 === 2) {
    for (var i = 0; i < self._72.length; i++) {
      handle(self, self._72[i]);
    }
    self._72 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}

},{"asap/raw":73}],79:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype.done = function (onFulfilled, onRejected) {
  var self = arguments.length ? this.then.apply(this, arguments) : this;
  self.then(null, function (err) {
    setTimeout(function () {
      throw err;
    }, 0);
  });
};

},{"./core.js":78}],80:[function(require,module,exports){
'use strict';

//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = require('./core.js');

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._61);
  p._65 = 1;
  p._55 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._65 === 3) {
            val = val._55;
          }
          if (val._65 === 1) return res(i, val._55);
          if (val._65 === 2) reject(val._55);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};

},{"./core.js":78}],81:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.prototype['finally'] = function (f) {
  return this.then(function (value) {
    return Promise.resolve(f()).then(function () {
      return value;
    });
  }, function (err) {
    return Promise.resolve(f()).then(function () {
      throw err;
    });
  });
};

},{"./core.js":78}],82:[function(require,module,exports){
'use strict';

module.exports = require('./core.js');
require('./done.js');
require('./finally.js');
require('./es6-extensions.js');
require('./node-extensions.js');
require('./synchronous.js');

},{"./core.js":78,"./done.js":79,"./es6-extensions.js":80,"./finally.js":81,"./node-extensions.js":83,"./synchronous.js":84}],83:[function(require,module,exports){
'use strict';

// This file contains then/promise specific extensions that are only useful
// for node.js interop

var Promise = require('./core.js');
var asap = require('asap');

module.exports = Promise;

/* Static Functions */

Promise.denodeify = function (fn, argumentCount) {
  if (
    typeof argumentCount === 'number' && argumentCount !== Infinity
  ) {
    return denodeifyWithCount(fn, argumentCount);
  } else {
    return denodeifyWithoutCount(fn);
  }
};

var callbackFn = (
  'function (err, res) {' +
  'if (err) { rj(err); } else { rs(res); }' +
  '}'
);
function denodeifyWithCount(fn, argumentCount) {
  var args = [];
  for (var i = 0; i < argumentCount; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'return new Promise(function (rs, rj) {',
    'var res = fn.call(',
    ['self'].concat(args).concat([callbackFn]).join(','),
    ');',
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');
  return Function(['Promise', 'fn'], body)(Promise, fn);
}
function denodeifyWithoutCount(fn) {
  var fnLength = Math.max(fn.length - 1, 3);
  var args = [];
  for (var i = 0; i < fnLength; i++) {
    args.push('a' + i);
  }
  var body = [
    'return function (' + args.join(',') + ') {',
    'var self = this;',
    'var args;',
    'var argLength = arguments.length;',
    'if (arguments.length > ' + fnLength + ') {',
    'args = new Array(arguments.length + 1);',
    'for (var i = 0; i < arguments.length; i++) {',
    'args[i] = arguments[i];',
    '}',
    '}',
    'return new Promise(function (rs, rj) {',
    'var cb = ' + callbackFn + ';',
    'var res;',
    'switch (argLength) {',
    args.concat(['extra']).map(function (_, index) {
      return (
        'case ' + (index) + ':' +
        'res = fn.call(' + ['self'].concat(args.slice(0, index)).concat('cb').join(',') + ');' +
        'break;'
      );
    }).join(''),
    'default:',
    'args[argLength] = cb;',
    'res = fn.apply(self, args);',
    '}',
    
    'if (res &&',
    '(typeof res === "object" || typeof res === "function") &&',
    'typeof res.then === "function"',
    ') {rs(res);}',
    '});',
    '};'
  ].join('');

  return Function(
    ['Promise', 'fn'],
    body
  )(Promise, fn);
}

Promise.nodeify = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments);
    var callback =
      typeof args[args.length - 1] === 'function' ? args.pop() : null;
    var ctx = this;
    try {
      return fn.apply(this, arguments).nodeify(callback, ctx);
    } catch (ex) {
      if (callback === null || typeof callback == 'undefined') {
        return new Promise(function (resolve, reject) {
          reject(ex);
        });
      } else {
        asap(function () {
          callback.call(ctx, ex);
        })
      }
    }
  }
};

Promise.prototype.nodeify = function (callback, ctx) {
  if (typeof callback != 'function') return this;

  this.then(function (value) {
    asap(function () {
      callback.call(ctx, null, value);
    });
  }, function (err) {
    asap(function () {
      callback.call(ctx, err);
    });
  });
};

},{"./core.js":78,"asap":72}],84:[function(require,module,exports){
'use strict';

var Promise = require('./core.js');

module.exports = Promise;
Promise.enableSynchronous = function () {
  Promise.prototype.isPending = function() {
    return this.getState() == 0;
  };

  Promise.prototype.isFulfilled = function() {
    return this.getState() == 1;
  };

  Promise.prototype.isRejected = function() {
    return this.getState() == 2;
  };

  Promise.prototype.getValue = function () {
    if (this._65 === 3) {
      return this._55.getValue();
    }

    if (!this.isFulfilled()) {
      throw new Error('Cannot get a value of an unfulfilled promise.');
    }

    return this._55;
  };

  Promise.prototype.getReason = function () {
    if (this._65 === 3) {
      return this._55.getReason();
    }

    if (!this.isRejected()) {
      throw new Error('Cannot get a rejection reason of a non-rejected promise.');
    }

    return this._55;
  };

  Promise.prototype.getState = function () {
    if (this._65 === 3) {
      return this._55.getState();
    }
    if (this._65 === -1 || this._65 === -2) {
      return 0;
    }

    return this._65;
  };
};

Promise.disableSynchronous = function() {
  Promise.prototype.isPending = undefined;
  Promise.prototype.isFulfilled = undefined;
  Promise.prototype.isRejected = undefined;
  Promise.prototype.getValue = undefined;
  Promise.prototype.getReason = undefined;
  Promise.prototype.getState = undefined;
};

},{"./core.js":78}],85:[function(require,module,exports){
(function (global){
/*! https://mths.be/punycode v1.3.2 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.3.2',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		typeof define == 'function' &&
		typeof define.amd == 'object' &&
		define.amd
	) {
		define('punycode', function() {
			return punycode;
		});
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) { // in Node.js or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else { // in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else { // in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],86:[function(require,module,exports){
'use strict';

var replace = String.prototype.replace;
var percentTwenties = /%20/g;

module.exports = {
    'default': 'RFC3986',
    formatters: {
        RFC1738: function (value) {
            return replace.call(value, percentTwenties, '+');
        },
        RFC3986: function (value) {
            return value;
        }
    },
    RFC1738: 'RFC1738',
    RFC3986: 'RFC3986'
};

},{}],87:[function(require,module,exports){
'use strict';

var stringify = require('./stringify');
var parse = require('./parse');
var formats = require('./formats');

module.exports = {
    formats: formats,
    parse: parse,
    stringify: stringify
};

},{"./formats":86,"./parse":88,"./stringify":89}],88:[function(require,module,exports){
'use strict';

var utils = require('./utils');

var has = Object.prototype.hasOwnProperty;

var defaults = {
    allowDots: false,
    allowPrototypes: false,
    arrayLimit: 20,
    charset: 'utf-8',
    charsetSentinel: false,
    comma: false,
    decoder: utils.decode,
    delimiter: '&',
    depth: 5,
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictNullHandling: false
};

var interpretNumericEntities = function (str) {
    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};

// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')

// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')

var parseValues = function parseQueryStringValues(str, options) {
    var obj = {};
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;

    var charset = options.charset;
    if (options.charsetSentinel) {
        for (i = 0; i < parts.length; ++i) {
            if (parts[i].indexOf('utf8=') === 0) {
                if (parts[i] === charsetSentinel) {
                    charset = 'utf-8';
                } else if (parts[i] === isoSentinel) {
                    charset = 'iso-8859-1';
                }
                skipIndex = i;
                i = parts.length; // The eslint settings do not allow break;
            }
        }
    }

    for (i = 0; i < parts.length; ++i) {
        if (i === skipIndex) {
            continue;
        }
        var part = parts[i];

        var bracketEqualsPos = part.indexOf(']=');
        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;

        var key, val;
        if (pos === -1) {
            key = options.decoder(part, defaults.decoder, charset);
            val = options.strictNullHandling ? null : '';
        } else {
            key = options.decoder(part.slice(0, pos), defaults.decoder, charset);
            val = options.decoder(part.slice(pos + 1), defaults.decoder, charset);
        }

        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
            val = interpretNumericEntities(val);
        }

        if (val && options.comma && val.indexOf(',') > -1) {
            val = val.split(',');
        }

        if (has.call(obj, key)) {
            obj[key] = utils.combine(obj[key], val);
        } else {
            obj[key] = val;
        }
    }

    return obj;
};

var parseObject = function (chain, val, options) {
    var leaf = val;

    for (var i = chain.length - 1; i >= 0; --i) {
        var obj;
        var root = chain[i];

        if (root === '[]' && options.parseArrays) {
            obj = [].concat(leaf);
        } else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
            var index = parseInt(cleanRoot, 10);
            if (!options.parseArrays && cleanRoot === '') {
                obj = { 0: leaf };
            } else if (
                !isNaN(index)
                && root !== cleanRoot
                && String(index) === cleanRoot
                && index >= 0
                && (options.parseArrays && index <= options.arrayLimit)
            ) {
                obj = [];
                obj[index] = leaf;
            } else {
                obj[cleanRoot] = leaf;
            }
        }

        leaf = obj;
    }

    return leaf;
};

var parseKeys = function parseQueryStringKeys(givenKey, val, options) {
    if (!givenKey) {
        return;
    }

    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, '[$1]') : givenKey;

    // The regex chunks

    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;

    // Get the parent

    var segment = brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;

    // Stash the parent if it exists

    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) {
                return;
            }
        }

        keys.push(parent);
    }

    // Loop through children appending to the array until we hit depth

    var i = 0;
    while ((segment = child.exec(key)) !== null && i < options.depth) {
        i += 1;
        if (!options.plainObjects && has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) {
                return;
            }
        }
        keys.push(segment[1]);
    }

    // If there's a remainder, just add whatever is left

    if (segment) {
        keys.push('[' + key.slice(segment.index) + ']');
    }

    return parseObject(keys, val, options);
};

var normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.decoder !== null && opts.decoder !== undefined && typeof opts.decoder !== 'function') {
        throw new TypeError('Decoder has to be a function.');
    }

    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new Error('The charset option must be either utf-8, iso-8859-1, or undefined');
    }
    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;

    return {
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (str, opts) {
    var options = normalizeParseOptions(opts);

    if (str === '' || str === null || typeof str === 'undefined') {
        return options.plainObjects ? Object.create(null) : {};
    }

    var tempObj = typeof str === 'string' ? parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};

    // Iterate over the keys and setup the new object

    var keys = Object.keys(tempObj);
    for (var i = 0; i < keys.length; ++i) {
        var key = keys[i];
        var newObj = parseKeys(key, tempObj[key], options);
        obj = utils.merge(obj, newObj, options);
    }

    return utils.compact(obj);
};

},{"./utils":90}],89:[function(require,module,exports){
'use strict';

var utils = require('./utils');
var formats = require('./formats');
var has = Object.prototype.hasOwnProperty;

var arrayPrefixGenerators = {
    brackets: function brackets(prefix) { // eslint-disable-line func-name-matching
        return prefix + '[]';
    },
    comma: 'comma',
    indices: function indices(prefix, key) { // eslint-disable-line func-name-matching
        return prefix + '[' + key + ']';
    },
    repeat: function repeat(prefix) { // eslint-disable-line func-name-matching
        return prefix;
    }
};

var isArray = Array.isArray;
var push = Array.prototype.push;
var pushToArray = function (arr, valueOrArray) {
    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
};

var toISO = Date.prototype.toISOString;

var defaults = {
    addQueryPrefix: false,
    allowDots: false,
    charset: 'utf-8',
    charsetSentinel: false,
    delimiter: '&',
    encode: true,
    encoder: utils.encode,
    encodeValuesOnly: false,
    formatter: formats.formatters[formats['default']],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) { // eslint-disable-line func-name-matching
        return toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};

var stringify = function stringify( // eslint-disable-line func-name-matching
    object,
    prefix,
    generateArrayPrefix,
    strictNullHandling,
    skipNulls,
    encoder,
    filter,
    sort,
    allowDots,
    serializeDate,
    formatter,
    encodeValuesOnly,
    charset
) {
    var obj = object;
    if (typeof filter === 'function') {
        obj = filter(prefix, obj);
    } else if (obj instanceof Date) {
        obj = serializeDate(obj);
    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
        obj = obj.join(',');
    }

    if (obj === null) {
        if (strictNullHandling) {
            return encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset) : prefix;
        }

        obj = '';
    }

    if (typeof obj === 'string' || typeof obj === 'number' || typeof obj === 'boolean' || utils.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset);
            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset))];
        }
        return [formatter(prefix) + '=' + formatter(String(obj))];
    }

    var values = [];

    if (typeof obj === 'undefined') {
        return values;
    }

    var objKeys;
    if (isArray(filter)) {
        objKeys = filter;
    } else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (skipNulls && obj[key] === null) {
            continue;
        }

        if (isArray(obj)) {
            pushToArray(values, stringify(
                obj[key],
                typeof generateArrayPrefix === 'function' ? generateArrayPrefix(prefix, key) : prefix,
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        } else {
            pushToArray(values, stringify(
                obj[key],
                prefix + (allowDots ? '.' + key : '[' + key + ']'),
                generateArrayPrefix,
                strictNullHandling,
                skipNulls,
                encoder,
                filter,
                sort,
                allowDots,
                serializeDate,
                formatter,
                encodeValuesOnly,
                charset
            ));
        }
    }

    return values;
};

var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) {
        return defaults;
    }

    if (opts.encoder !== null && opts.encoder !== undefined && typeof opts.encoder !== 'function') {
        throw new TypeError('Encoder has to be a function.');
    }

    var charset = opts.charset || defaults.charset;
    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
    }

    var format = formats['default'];
    if (typeof opts.format !== 'undefined') {
        if (!has.call(formats.formatters, opts.format)) {
            throw new TypeError('Unknown format option provided.');
        }
        format = opts.format;
    }
    var formatter = formats.formatters[format];

    var filter = defaults.filter;
    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
        filter = opts.filter;
    }

    return {
        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
        allowDots: typeof opts.allowDots === 'undefined' ? defaults.allowDots : !!opts.allowDots,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
        filter: filter,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
        sort: typeof opts.sort === 'function' ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
    };
};

module.exports = function (object, opts) {
    var obj = object;
    var options = normalizeStringifyOptions(opts);

    var objKeys;
    var filter;

    if (typeof options.filter === 'function') {
        filter = options.filter;
        obj = filter('', obj);
    } else if (isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }

    var keys = [];

    if (typeof obj !== 'object' || obj === null) {
        return '';
    }

    var arrayFormat;
    if (opts && opts.arrayFormat in arrayPrefixGenerators) {
        arrayFormat = opts.arrayFormat;
    } else if (opts && 'indices' in opts) {
        arrayFormat = opts.indices ? 'indices' : 'repeat';
    } else {
        arrayFormat = 'indices';
    }

    var generateArrayPrefix = arrayPrefixGenerators[arrayFormat];

    if (!objKeys) {
        objKeys = Object.keys(obj);
    }

    if (options.sort) {
        objKeys.sort(options.sort);
    }

    for (var i = 0; i < objKeys.length; ++i) {
        var key = objKeys[i];

        if (options.skipNulls && obj[key] === null) {
            continue;
        }
        pushToArray(keys, stringify(
            obj[key],
            key,
            generateArrayPrefix,
            options.strictNullHandling,
            options.skipNulls,
            options.encode ? options.encoder : null,
            options.filter,
            options.sort,
            options.allowDots,
            options.serializeDate,
            options.formatter,
            options.encodeValuesOnly,
            options.charset
        ));
    }

    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? '?' : '';

    if (options.charsetSentinel) {
        if (options.charset === 'iso-8859-1') {
            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
            prefix += 'utf8=%26%2310003%3B&';
        } else {
            // encodeURIComponent('✓')
            prefix += 'utf8=%E2%9C%93&';
        }
    }

    return joined.length > 0 ? prefix + joined : '';
};

},{"./formats":86,"./utils":90}],90:[function(require,module,exports){
'use strict';

var has = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

var hexTable = (function () {
    var array = [];
    for (var i = 0; i < 256; ++i) {
        array.push('%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase());
    }

    return array;
}());

var compactQueue = function compactQueue(queue) {
    while (queue.length > 1) {
        var item = queue.pop();
        var obj = item.obj[item.prop];

        if (isArray(obj)) {
            var compacted = [];

            for (var j = 0; j < obj.length; ++j) {
                if (typeof obj[j] !== 'undefined') {
                    compacted.push(obj[j]);
                }
            }

            item.obj[item.prop] = compacted;
        }
    }
};

var arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for (var i = 0; i < source.length; ++i) {
        if (typeof source[i] !== 'undefined') {
            obj[i] = source[i];
        }
    }

    return obj;
};

var merge = function merge(target, source, options) {
    if (!source) {
        return target;
    }

    if (typeof source !== 'object') {
        if (isArray(target)) {
            target.push(source);
        } else if (target && typeof target === 'object') {
            if ((options && (options.plainObjects || options.allowPrototypes)) || !has.call(Object.prototype, source)) {
                target[source] = true;
            }
        } else {
            return [target, source];
        }

        return target;
    }

    if (!target || typeof target !== 'object') {
        return [target].concat(source);
    }

    var mergeTarget = target;
    if (isArray(target) && !isArray(source)) {
        mergeTarget = arrayToObject(target, options);
    }

    if (isArray(target) && isArray(source)) {
        source.forEach(function (item, i) {
            if (has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
                    target[i] = merge(targetItem, item, options);
                } else {
                    target.push(item);
                }
            } else {
                target[i] = item;
            }
        });
        return target;
    }

    return Object.keys(source).reduce(function (acc, key) {
        var value = source[key];

        if (has.call(acc, key)) {
            acc[key] = merge(acc[key], value, options);
        } else {
            acc[key] = value;
        }
        return acc;
    }, mergeTarget);
};

var assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function (acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};

var decode = function (str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, ' ');
    if (charset === 'iso-8859-1') {
        // unescape never throws, no try...catch needed:
        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    }
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};

var encode = function encode(str, defaultEncoder, charset) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) {
        return str;
    }

    var string = typeof str === 'string' ? str : String(str);

    if (charset === 'iso-8859-1') {
        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
        });
    }

    var out = '';
    for (var i = 0; i < string.length; ++i) {
        var c = string.charCodeAt(i);

        if (
            c === 0x2D // -
            || c === 0x2E // .
            || c === 0x5F // _
            || c === 0x7E // ~
            || (c >= 0x30 && c <= 0x39) // 0-9
            || (c >= 0x41 && c <= 0x5A) // a-z
            || (c >= 0x61 && c <= 0x7A) // A-Z
        ) {
            out += string.charAt(i);
            continue;
        }

        if (c < 0x80) {
            out = out + hexTable[c];
            continue;
        }

        if (c < 0x800) {
            out = out + (hexTable[0xC0 | (c >> 6)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        if (c < 0xD800 || c >= 0xE000) {
            out = out + (hexTable[0xE0 | (c >> 12)] + hexTable[0x80 | ((c >> 6) & 0x3F)] + hexTable[0x80 | (c & 0x3F)]);
            continue;
        }

        i += 1;
        c = 0x10000 + (((c & 0x3FF) << 10) | (string.charCodeAt(i) & 0x3FF));
        out += hexTable[0xF0 | (c >> 18)]
            + hexTable[0x80 | ((c >> 12) & 0x3F)]
            + hexTable[0x80 | ((c >> 6) & 0x3F)]
            + hexTable[0x80 | (c & 0x3F)];
    }

    return out;
};

var compact = function compact(value) {
    var queue = [{ obj: { o: value }, prop: 'o' }];
    var refs = [];

    for (var i = 0; i < queue.length; ++i) {
        var item = queue[i];
        var obj = item.obj[item.prop];

        var keys = Object.keys(obj);
        for (var j = 0; j < keys.length; ++j) {
            var key = keys[j];
            var val = obj[key];
            if (typeof val === 'object' && val !== null && refs.indexOf(val) === -1) {
                queue.push({ obj: obj, prop: key });
                refs.push(val);
            }
        }
    }

    compactQueue(queue);

    return value;
};

var isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === '[object RegExp]';
};

var isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== 'object') {
        return false;
    }

    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};

var combine = function combine(a, b) {
    return [].concat(a, b);
};

module.exports = {
    arrayToObject: arrayToObject,
    assign: assign,
    combine: combine,
    compact: compact,
    decode: decode,
    encode: encode,
    isBuffer: isBuffer,
    isRegExp: isRegExp,
    merge: merge
};

},{}],91:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

module.exports = function(qs, sep, eq, options) {
  sep = sep || '&';
  eq = eq || '=';
  var obj = {};

  if (typeof qs !== 'string' || qs.length === 0) {
    return obj;
  }

  var regexp = /\+/g;
  qs = qs.split(sep);

  var maxKeys = 1000;
  if (options && typeof options.maxKeys === 'number') {
    maxKeys = options.maxKeys;
  }

  var len = qs.length;
  // maxKeys <= 0 means that we should not limit keys count
  if (maxKeys > 0 && len > maxKeys) {
    len = maxKeys;
  }

  for (var i = 0; i < len; ++i) {
    var x = qs[i].replace(regexp, '%20'),
        idx = x.indexOf(eq),
        kstr, vstr, k, v;

    if (idx >= 0) {
      kstr = x.substr(0, idx);
      vstr = x.substr(idx + 1);
    } else {
      kstr = x;
      vstr = '';
    }

    k = decodeURIComponent(kstr);
    v = decodeURIComponent(vstr);

    if (!hasOwnProperty(obj, k)) {
      obj[k] = v;
    } else if (isArray(obj[k])) {
      obj[k].push(v);
    } else {
      obj[k] = [obj[k], v];
    }
  }

  return obj;
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

},{}],92:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var stringifyPrimitive = function(v) {
  switch (typeof v) {
    case 'string':
      return v;

    case 'boolean':
      return v ? 'true' : 'false';

    case 'number':
      return isFinite(v) ? v : '';

    default:
      return '';
  }
};

module.exports = function(obj, sep, eq, name) {
  sep = sep || '&';
  eq = eq || '=';
  if (obj === null) {
    obj = undefined;
  }

  if (typeof obj === 'object') {
    return map(objectKeys(obj), function(k) {
      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
      if (isArray(obj[k])) {
        return map(obj[k], function(v) {
          return ks + encodeURIComponent(stringifyPrimitive(v));
        }).join(sep);
      } else {
        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
      }
    }).join(sep);

  }

  if (!name) return '';
  return encodeURIComponent(stringifyPrimitive(name)) + eq +
         encodeURIComponent(stringifyPrimitive(obj));
};

var isArray = Array.isArray || function (xs) {
  return Object.prototype.toString.call(xs) === '[object Array]';
};

function map (xs, f) {
  if (xs.map) return xs.map(f);
  var res = [];
  for (var i = 0; i < xs.length; i++) {
    res.push(f(xs[i], i));
  }
  return res;
}

var objectKeys = Object.keys || function (obj) {
  var res = [];
  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
  }
  return res;
};

},{}],93:[function(require,module,exports){
'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');

},{"./decode":91,"./encode":92}],94:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

'use strict';

var punycode = require('punycode');
var util = require('./util');

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i,
    portPattern = /:[0-9]*$/,

    // Special case for a simple path URL
    simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,

    // RFC 2396: characters reserved for delimiting URLs.
    // We actually just auto-escape these.
    delims = ['<', '>', '"', '`', ' ', '\r', '\n', '\t'],

    // RFC 2396: characters not allowed for various reasons.
    unwise = ['{', '}', '|', '\\', '^', '`'].concat(delims),

    // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
    autoEscape = ['\''].concat(unwise),
    // Characters that are never ever allowed in a hostname.
    // Note that any invalid chars are also handled, but these
    // are the ones that are *expected* to be seen, so we fast-path
    // them.
    nonHostChars = ['%', '/', '?', ';', '#'].concat(autoEscape),
    hostEndingChars = ['/', '?', '#'],
    hostnameMaxLen = 255,
    hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
    hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
    // protocols that can allow "unsafe" and "unwise" chars.
    unsafeProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that never have a hostname.
    hostlessProtocol = {
      'javascript': true,
      'javascript:': true
    },
    // protocols that always contain a // bit.
    slashedProtocol = {
      'http': true,
      'https': true,
      'ftp': true,
      'gopher': true,
      'file': true,
      'http:': true,
      'https:': true,
      'ftp:': true,
      'gopher:': true,
      'file:': true
    },
    querystring = require('querystring');

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && util.isObject(url) && url instanceof Url) return url;

  var u = new Url;
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
  if (!util.isString(url)) {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  // Copy chrome, IE, opera backslash-handling behavior.
  // Back slashes before the query string get converted to forward slashes
  // See: https://code.google.com/p/chromium/issues/detail?id=25916
  var queryIndex = url.indexOf('?'),
      splitter =
          (queryIndex !== -1 && queryIndex < url.indexOf('#')) ? '?' : '#',
      uSplit = url.split(splitter),
      slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  // trim before proceeding.
  // This is to support parse stuff like "  http://foo.com  \n"
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  // figure out if it's got a host
  // user@server is *always* interpreted as a hostname, and url
  // resolution will treat //foo/bar as host=foo,path=bar because that's
  // how the browser resolves relative URLs.
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] &&
      (slashes || (proto && !slashedProtocol[proto]))) {

    // there's a hostname.
    // the first instance of /, ?, ;, or # ends the host.
    //
    // If there is an @ in the hostname, then non-host chars *are* allowed
    // to the left of the last @ sign, unless some host-ending character
    // comes *before* the @-sign.
    // URLs are obnoxious.
    //
    // ex:
    // http://a@b@c/ => user:a@b host:c
    // http://a@b?@c => user:a host:c path:/?@c

    // v0.12 TODO(isaacs): This is not quite how Chrome does things.
    // Review our test case against browsers more comprehensively.

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }

    // at this point, either we have an explicit point where the
    // auth portion cannot go past, or the last @ char is the decider.
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      // atSign must be in auth portion.
      // http://a@b/c@d => host:b auth:a path:/c@d
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    // Now we have a portion which is definitely the auth.
    // Pull that off.
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd))
        hostEnd = hec;
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1)
      hostEnd = rest.length;

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    // we've indicated that there is a hostname,
    // so even if it's empty, it has to be present.
    this.hostname = this.hostname || '';

    // if hostname begins with [ and ends with ]
    // assume that it's an IPv6 address.
    var ipv6Hostname = this.hostname[0] === '[' &&
        this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) continue;
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              // we replace non-ASCII char with a temporary placeholder
              // we need this to make sure size of hostname is not
              // broken by replacing non-ASCII by nothing
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      // IDNA Support: Returns a punycoded representation of "domain".
      // It only converts parts of the domain name that
      // have non-ASCII characters, i.e. it doesn't matter if
      // you call it with a domain that already is ASCII-only.
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    // strip [ and ] from the hostname
    // the host field still retains them, though
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  // now rest is set to the post-host stuff.
  // chop off any delim chars.
  if (!unsafeProtocol[lowerProto]) {

    // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1)
        continue;
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }


  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) this.pathname = rest;
  if (slashedProtocol[lowerProto] &&
      this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  //to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  // ensure it's an object, and not a string url.
  // If it's an obj, this is a no-op.
  // this way, you can call url_format() on strings
  // to clean up potentially wonky urls.
  if (util.isString(obj)) obj = urlParse(obj);
  if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
  return obj.format();
}

Url.prototype.format = function() {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
      pathname = this.pathname || '',
      hash = this.hash || '',
      host = false,
      query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ?
        this.hostname :
        '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query &&
      util.isObject(this.query) &&
      Object.keys(this.query).length) {
    query = querystring.stringify(this.query);
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') protocol += ':';

  // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
  // unless they had them to begin with.
  if (this.slashes ||
      (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') pathname = '/' + pathname;
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') hash = '#' + hash;
  if (search && search.charAt(0) !== '?') search = '?' + search;

  pathname = pathname.replace(/[?#]/g, function(match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function(relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) return relative;
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function(relative) {
  if (util.isString(relative)) {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  // hash is always overridden, no matter what.
  // even href="" will remove it.
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol')
        result[rkey] = relative[rkey];
    }

    //urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] &&
        result.hostname && !result.pathname) {
      result.path = result.pathname = '/';
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    // if it's a known url protocol, then changing
    // the protocol does weird things
    // first, if it's not file:, then we MUST have a host,
    // and if there was a path
    // to begin with, then we MUST have a path.
    // if it is file:, then the host is dropped,
    // because that's known to be hostless.
    // anything else is assumed to be absolute.
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift()));
      if (!relative.host) relative.host = '';
      if (!relative.hostname) relative.hostname = '';
      if (relPath[0] !== '') relPath.unshift('');
      if (relPath.length < 2) relPath.unshift('');
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = (result.pathname && result.pathname.charAt(0) === '/'),
      isRelAbs = (
          relative.host ||
          relative.pathname && relative.pathname.charAt(0) === '/'
      ),
      mustEndAbs = (isRelAbs || isSourceAbs ||
                    (result.host && relative.pathname)),
      removeAllDots = mustEndAbs,
      srcPath = result.pathname && result.pathname.split('/') || [],
      relPath = relative.pathname && relative.pathname.split('/') || [],
      psychotic = result.protocol && !slashedProtocol[result.protocol];

  // if the url is a non-slashed url, then relative
  // links like ../.. should be able
  // to crawl up to the hostname, as well.  This is strange.
  // result.protocol has already been set by now.
  // Later on, put the first path part into the host field.
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') srcPath[0] = result.host;
      else srcPath.unshift(result.host);
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') relPath[0] = relative.host;
        else relPath.unshift(relative.host);
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = (relative.host || relative.host === '') ?
                  relative.host : result.host;
    result.hostname = (relative.hostname || relative.hostname === '') ?
                      relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    // it's relative
    // throw away the existing file, and take the new path instead.
    if (!srcPath) srcPath = [];
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (!util.isNullOrUndefined(relative.search)) {
    // just pull out the search.
    // like href='?foo'.
    // Put this after the other two cases because it simplifies the booleans
    if (psychotic) {
      result.hostname = result.host = srcPath.shift();
      //occationaly the auth can get stuck only in host
      //this especially happens in cases like
      //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
      var authInHost = result.host && result.host.indexOf('@') > 0 ?
                       result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.host = result.hostname = authInHost.shift();
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    //to support http.request
    if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
      result.path = (result.pathname ? result.pathname : '') +
                    (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    // no path at all.  easy.
    // we've already handled the other stuff above.
    result.pathname = null;
    //to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  // if a url ENDs in . or .., then it must get a trailing slash.
  // however, if it ends in anything else non-slashy,
  // then it must NOT get a trailing slash.
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (
      (result.host || relative.host || srcPath.length > 1) &&
      (last === '.' || last === '..') || last === '');

  // strip single dots, resolve double dots to parent dir
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' &&
      (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' ||
      (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = result.host = isAbsolute ? '' :
                                    srcPath.length ? srcPath.shift() : '';
    //occationaly the auth can get stuck only in host
    //this especially happens in cases like
    //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
    var authInHost = result.host && result.host.indexOf('@') > 0 ?
                     result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.host = result.hostname = authInHost.shift();
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (!srcPath.length) {
    result.pathname = null;
    result.path = null;
  } else {
    result.pathname = srcPath.join('/');
  }

  //to support request.http
  if (!util.isNull(result.pathname) || !util.isNull(result.search)) {
    result.path = (result.pathname ? result.pathname : '') +
                  (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function() {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) this.hostname = host;
};

},{"./util":95,"punycode":85,"querystring":93}],95:[function(require,module,exports){
'use strict';

module.exports = {
  isString: function(arg) {
    return typeof(arg) === 'string';
  },
  isObject: function(arg) {
    return typeof(arg) === 'object' && arg !== null;
  },
  isNull: function(arg) {
    return arg === null;
  },
  isNullOrUndefined: function(arg) {
    return arg == null;
  }
};

},{}],96:[function(require,module,exports){
/*!
 * EventEmitter v4.2.11 - git.io/ee
 * Unlicense - http://unlicense.org/
 * Oliver Caldwell - http://oli.me.uk/
 * @preserve
 */

;(function () {
    'use strict';

    /**
     * Class for managing events.
     * Can be extended to provide event functionality in other classes.
     *
     * @class EventEmitter Manages event registering and emitting.
     */
    function EventEmitter() {}

    // Shortcuts to improve speed and size
    var proto = EventEmitter.prototype;
    var exports = this;
    var originalGlobalValue = exports.EventEmitter;

    /**
     * Finds the index of the listener for the event in its storage array.
     *
     * @param {Function[]} listeners Array of listeners to search through.
     * @param {Function} listener Method to look for.
     * @return {Number} Index of the specified listener, -1 if not found
     * @api private
     */
    function indexOfListener(listeners, listener) {
        var i = listeners.length;
        while (i--) {
            if (listeners[i].listener === listener) {
                return i;
            }
        }

        return -1;
    }

    /**
     * Alias a method while keeping the context correct, to allow for overwriting of target method.
     *
     * @param {String} name The name of the target method.
     * @return {Function} The aliased method
     * @api private
     */
    function alias(name) {
        return function aliasClosure() {
            return this[name].apply(this, arguments);
        };
    }

    /**
     * Returns the listener array for the specified event.
     * Will initialise the event object and listener arrays if required.
     * Will return an object if you use a regex search. The object contains keys for each matched event. So /ba[rz]/ might return an object containing bar and baz. But only if you have either defined them with defineEvent or added some listeners to them.
     * Each property in the object response is an array of listener functions.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Function[]|Object} All listener functions for the event.
     */
    proto.getListeners = function getListeners(evt) {
        var events = this._getEvents();
        var response;
        var key;

        // Return a concatenated array of all matching events if
        // the selector is a regular expression.
        if (evt instanceof RegExp) {
            response = {};
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    response[key] = events[key];
                }
            }
        }
        else {
            response = events[evt] || (events[evt] = []);
        }

        return response;
    };

    /**
     * Takes a list of listener objects and flattens it into a list of listener functions.
     *
     * @param {Object[]} listeners Raw listener objects.
     * @return {Function[]} Just the listener functions.
     */
    proto.flattenListeners = function flattenListeners(listeners) {
        var flatListeners = [];
        var i;

        for (i = 0; i < listeners.length; i += 1) {
            flatListeners.push(listeners[i].listener);
        }

        return flatListeners;
    };

    /**
     * Fetches the requested listeners via getListeners but will always return the results inside an object. This is mainly for internal use but others may find it useful.
     *
     * @param {String|RegExp} evt Name of the event to return the listeners from.
     * @return {Object} All listener functions for an event in an object.
     */
    proto.getListenersAsObject = function getListenersAsObject(evt) {
        var listeners = this.getListeners(evt);
        var response;

        if (listeners instanceof Array) {
            response = {};
            response[evt] = listeners;
        }

        return response || listeners;
    };

    /**
     * Adds a listener function to the specified event.
     * The listener will not be added if it is a duplicate.
     * If the listener returns true then it will be removed after it is called.
     * If you pass a regular expression as the event name then the listener will be added to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListener = function addListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var listenerIsWrapped = typeof listener === 'object';
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key) && indexOfListener(listeners[key], listener) === -1) {
                listeners[key].push(listenerIsWrapped ? listener : {
                    listener: listener,
                    once: false
                });
            }
        }

        return this;
    };

    /**
     * Alias of addListener
     */
    proto.on = alias('addListener');

    /**
     * Semi-alias of addListener. It will add a listener that will be
     * automatically removed after its first execution.
     *
     * @param {String|RegExp} evt Name of the event to attach the listener to.
     * @param {Function} listener Method to be called when the event is emitted. If the function returns true then it will be removed after calling.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addOnceListener = function addOnceListener(evt, listener) {
        return this.addListener(evt, {
            listener: listener,
            once: true
        });
    };

    /**
     * Alias of addOnceListener.
     */
    proto.once = alias('addOnceListener');

    /**
     * Defines an event name. This is required if you want to use a regex to add a listener to multiple events at once. If you don't do this then how do you expect it to know what event to add to? Should it just add to every possible match for a regex? No. That is scary and bad.
     * You need to tell it what event names should be matched by a regex.
     *
     * @param {String} evt Name of the event to create.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvent = function defineEvent(evt) {
        this.getListeners(evt);
        return this;
    };

    /**
     * Uses defineEvent to define multiple events.
     *
     * @param {String[]} evts An array of event names to define.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.defineEvents = function defineEvents(evts) {
        for (var i = 0; i < evts.length; i += 1) {
            this.defineEvent(evts[i]);
        }
        return this;
    };

    /**
     * Removes a listener function from the specified event.
     * When passed a regular expression as the event name, it will remove the listener from all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to remove the listener from.
     * @param {Function} listener Method to remove from the event.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListener = function removeListener(evt, listener) {
        var listeners = this.getListenersAsObject(evt);
        var index;
        var key;

        for (key in listeners) {
            if (listeners.hasOwnProperty(key)) {
                index = indexOfListener(listeners[key], listener);

                if (index !== -1) {
                    listeners[key].splice(index, 1);
                }
            }
        }

        return this;
    };

    /**
     * Alias of removeListener
     */
    proto.off = alias('removeListener');

    /**
     * Adds listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can add to multiple events at once. The object should contain key value pairs of events and listeners or listener arrays. You can also pass it an event name and an array of listeners to be added.
     * You can also pass it a regular expression to add the array of listeners to all events that match it.
     * Yeah, this function does quite a bit. That's probably a bad thing.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add to multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.addListeners = function addListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(false, evt, listeners);
    };

    /**
     * Removes listeners in bulk using the manipulateListeners method.
     * If you pass an object as the second argument you can remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be removed.
     * You can also pass it a regular expression to remove the listeners from all events that match it.
     *
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeListeners = function removeListeners(evt, listeners) {
        // Pass through to manipulateListeners
        return this.manipulateListeners(true, evt, listeners);
    };

    /**
     * Edits listeners in bulk. The addListeners and removeListeners methods both use this to do their job. You should really use those instead, this is a little lower level.
     * The first argument will determine if the listeners are removed (true) or added (false).
     * If you pass an object as the second argument you can add/remove from multiple events at once. The object should contain key value pairs of events and listeners or listener arrays.
     * You can also pass it an event name and an array of listeners to be added/removed.
     * You can also pass it a regular expression to manipulate the listeners of all events that match it.
     *
     * @param {Boolean} remove True if you want to remove listeners, false if you want to add.
     * @param {String|Object|RegExp} evt An event name if you will pass an array of listeners next. An object if you wish to add/remove from multiple events at once.
     * @param {Function[]} [listeners] An optional array of listener functions to add/remove.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.manipulateListeners = function manipulateListeners(remove, evt, listeners) {
        var i;
        var value;
        var single = remove ? this.removeListener : this.addListener;
        var multiple = remove ? this.removeListeners : this.addListeners;

        // If evt is an object then pass each of its properties to this method
        if (typeof evt === 'object' && !(evt instanceof RegExp)) {
            for (i in evt) {
                if (evt.hasOwnProperty(i) && (value = evt[i])) {
                    // Pass the single listener straight through to the singular method
                    if (typeof value === 'function') {
                        single.call(this, i, value);
                    }
                    else {
                        // Otherwise pass back to the multiple function
                        multiple.call(this, i, value);
                    }
                }
            }
        }
        else {
            // So evt must be a string
            // And listeners must be an array of listeners
            // Loop over it and pass each one to the multiple method
            i = listeners.length;
            while (i--) {
                single.call(this, evt, listeners[i]);
            }
        }

        return this;
    };

    /**
     * Removes all listeners from a specified event.
     * If you do not specify an event then all listeners will be removed.
     * That means every event will be emptied.
     * You can also pass a regex to remove all events that match it.
     *
     * @param {String|RegExp} [evt] Optional name of the event to remove all listeners for. Will remove from every event if not passed.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.removeEvent = function removeEvent(evt) {
        var type = typeof evt;
        var events = this._getEvents();
        var key;

        // Remove different things depending on the state of evt
        if (type === 'string') {
            // Remove all listeners for the specified event
            delete events[evt];
        }
        else if (evt instanceof RegExp) {
            // Remove all events matching the regex.
            for (key in events) {
                if (events.hasOwnProperty(key) && evt.test(key)) {
                    delete events[key];
                }
            }
        }
        else {
            // Remove all listeners in all events
            delete this._events;
        }

        return this;
    };

    /**
     * Alias of removeEvent.
     *
     * Added to mirror the node API.
     */
    proto.removeAllListeners = alias('removeEvent');

    /**
     * Emits an event of your choice.
     * When emitted, every listener attached to that event will be executed.
     * If you pass the optional argument array then those arguments will be passed to every listener upon execution.
     * Because it uses `apply`, your array of arguments will be passed as if you wrote them out separately.
     * So they will not arrive within the array on the other side, they will be separate.
     * You can also pass a regular expression to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {Array} [args] Optional array of arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emitEvent = function emitEvent(evt, args) {
        var listenersMap = this.getListenersAsObject(evt);
        var listeners;
        var listener;
        var i;
        var key;
        var response;

        for (key in listenersMap) {
            if (listenersMap.hasOwnProperty(key)) {
                listeners = listenersMap[key].slice(0);
                i = listeners.length;

                while (i--) {
                    // If the listener returns true then it shall be removed from the event
                    // The function is executed either with a basic call or an apply if there is an args array
                    listener = listeners[i];

                    if (listener.once === true) {
                        this.removeListener(evt, listener.listener);
                    }

                    response = listener.listener.apply(this, args || []);

                    if (response === this._getOnceReturnValue()) {
                        this.removeListener(evt, listener.listener);
                    }
                }
            }
        }

        return this;
    };

    /**
     * Alias of emitEvent
     */
    proto.trigger = alias('emitEvent');

    /**
     * Subtly different from emitEvent in that it will pass its arguments on to the listeners, as opposed to taking a single array of arguments to pass on.
     * As with emitEvent, you can pass a regex in place of the event name to emit to all events that match it.
     *
     * @param {String|RegExp} evt Name of the event to emit and execute listeners for.
     * @param {...*} Optional additional arguments to be passed to each listener.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.emit = function emit(evt) {
        var args = Array.prototype.slice.call(arguments, 1);
        return this.emitEvent(evt, args);
    };

    /**
     * Sets the current value to check against when executing listeners. If a
     * listeners return value matches the one set here then it will be removed
     * after execution. This value defaults to true.
     *
     * @param {*} value The new value to check for when executing listeners.
     * @return {Object} Current instance of EventEmitter for chaining.
     */
    proto.setOnceReturnValue = function setOnceReturnValue(value) {
        this._onceReturnValue = value;
        return this;
    };

    /**
     * Fetches the current value to check against when executing listeners. If
     * the listeners return value matches this one then it should be removed
     * automatically. It will return true by default.
     *
     * @return {*|Boolean} The current value to check for or the default, true.
     * @api private
     */
    proto._getOnceReturnValue = function _getOnceReturnValue() {
        if (this.hasOwnProperty('_onceReturnValue')) {
            return this._onceReturnValue;
        }
        else {
            return true;
        }
    };

    /**
     * Fetches the events object and creates one if required.
     *
     * @return {Object} The events storage object.
     * @api private
     */
    proto._getEvents = function _getEvents() {
        return this._events || (this._events = {});
    };

    /**
     * Reverts the global {@link EventEmitter} to its previous value and returns a reference to this version.
     *
     * @return {Function} Non conflicting EventEmitter class.
     */
    EventEmitter.noConflict = function noConflict() {
        exports.EventEmitter = originalGlobalValue;
        return EventEmitter;
    };

    // Expose the class either via AMD, CommonJS or the global object
    if (typeof define === 'function' && define.amd) {
        define(function () {
            return EventEmitter;
        });
    }
    else if (typeof module === 'object' && module.exports){
        module.exports = EventEmitter;
    }
    else {
        exports.EventEmitter = EventEmitter;
    }
}.call(this));

},{}]},{},[3]);
